'use strict';
angular.module("ngLocale", [], ["$provide", function($provide) {
var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
$provide.value("$locale", {
  "DATETIME_FORMATS": {
    "AMPMS": [
      "\u4e0a\u5348",
      "\u4e0b\u5348"
    ],
    "DAY": [
      "\u661f\u671f\u65e5",
      "\u661f\u671f\u4e00",
      "\u661f\u671f\u4e8c",
      "\u661f\u671f\u4e09",
      "\u661f\u671f\u56db",
      "\u661f\u671f\u4e94",
      "\u661f\u671f\u516d"
    ],
    "ERANAMES": [
      "\u516c\u5143\u524d",
      "\u516c\u5143"
    ],
    "ERAS": [
      "\u516c\u5143\u524d",
      "\u516c\u5143"
    ],
    "FIRSTDAYOFWEEK": 6,
    "MONTH": [
      "\u4e00\u6708",
      "\u4e8c\u6708",
      "\u4e09\u6708",
      "\u56db\u6708",
      "\u4e94\u6708",
      "\u516d\u6708",
      "\u4e03\u6708",
      "\u516b\u6708",
      "\u4e5d\u6708",
      "\u5341\u6708",
      "\u5341\u4e00\u6708",
      "\u5341\u4e8c\u6708"
    ],
    "SHORTDAY": [
      "\u5468\u65e5",
      "\u5468\u4e00",
      "\u5468\u4e8c",
      "\u5468\u4e09",
      "\u5468\u56db",
      "\u5468\u4e94",
      "\u5468\u516d"
    ],
    "SHORTMONTH": [
      "1\u6708",
      "2\u6708",
      "3\u6708",
      "4\u6708",
      "5\u6708",
      "6\u6708",
      "7\u6708",
      "8\u6708",
      "9\u6708",
      "10\u6708",
      "11\u6708",
      "12\u6708"
    ],
    "STANDALONEMONTH": [
      "\u4e00\u6708",
      "\u4e8c\u6708",
      "\u4e09\u6708",
      "\u56db\u6708",
      "\u4e94\u6708",
      "\u516d\u6708",
      "\u4e03\u6708",
      "\u516b\u6708",
      "\u4e5d\u6708",
      "\u5341\u6708",
      "\u5341\u4e00\u6708",
      "\u5341\u4e8c\u6708"
    ],
    "WEEKENDRANGE": [
      5,
      6
    ],
    "fullDate": "y\u5e74M\u6708d\u65e5EEEE",
    "longDate": "y\u5e74M\u6708d\u65e5",
    "medium": "y\u5e74M\u6708d\u65e5 ah:mm:ss",
    "mediumDate": "y\u5e74M\u6708d\u65e5",
    "mediumTime": "ah:mm:ss",
    "short": "yy/M/d ah:mm",
    "shortDate": "yy/M/d",
    "shortTime": "ah:mm"
  },
  "NUMBER_FORMATS": {
    "CURRENCY_SYM": "\u00a5",
    "DECIMAL_SEP": ".",
    "GROUP_SEP": ",",
    "PATTERNS": [
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 3,
        "minFrac": 0,
        "minInt": 1,
        "negPre": "-",
        "negSuf": "",
        "posPre": "",
        "posSuf": ""
      },
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 2,
        "minFrac": 2,
        "minInt": 1,
        "negPre": "-\u00a4\u00a0",
        "negSuf": "",
        "posPre": "\u00a4\u00a0",
        "posSuf": ""
      }
    ]
  },
  "id": "zh-cn",
  "localeID": "zh_CN",
  "pluralCat": function(n, opt_precision) {  return PLURAL_CATEGORY.OTHER;}
});
}]);

/**
 * @license AngularJS v1.3.10
 * (c) 2010-2014 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window, angular, undefined) {'use strict';

var $sanitizeMinErr = angular.$$minErr('$sanitize');

/**
 * @ngdoc module
 * @name ngSanitize
 * @description
 *
 * # ngSanitize
 *
 * The `ngSanitize` module provides functionality to sanitize HTML.
 *
 *
 * <div doc-module-components="ngSanitize"></div>
 *
 * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
 */

/*
 * HTML Parser By Misko Hevery (misko@hevery.com)
 * based on:  HTML Parser By John Resig (ejohn.org)
 * Original code by Erik Arvidsson, Mozilla Public License
 * http://erik.eae.net/simplehtmlparser/simplehtmlparser.js
 *
 * // Use like so:
 * htmlParser(htmlString, {
 *     start: function(tag, attrs, unary) {},
 *     end: function(tag) {},
 *     chars: function(text) {},
 *     comment: function(text) {}
 * });
 *
 */


/**
 * @ngdoc service
 * @name $sanitize
 * @kind function
 *
 * @description
 *   The input is sanitized by parsing the HTML into tokens. All safe tokens (from a whitelist) are
 *   then serialized back to properly escaped html string. This means that no unsafe input can make
 *   it into the returned string, however, since our parser is more strict than a typical browser
 *   parser, it's possible that some obscure input, which would be recognized as valid HTML by a
 *   browser, won't make it through the sanitizer. The input may also contain SVG markup.
 *   The whitelist is configured using the functions `aHrefSanitizationWhitelist` and
 *   `imgSrcSanitizationWhitelist` of {@link ng.$compileProvider `$compileProvider`}.
 *
 * @param {string} html HTML input.
 * @returns {string} Sanitized HTML.
 *
 * @example
   <example module="sanitizeExample" deps="angular-sanitize.js">
   <file name="index.html">
     <script>
         angular.module('sanitizeExample', ['ngSanitize'])
           .controller('ExampleController', ['$scope', '$sce', function($scope, $sce) {
             $scope.snippet =
               '<p style="color:blue">an html\n' +
               '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
               'snippet</p>';
             $scope.deliberatelyTrustDangerousSnippet = function() {
               return $sce.trustAsHtml($scope.snippet);
             };
           }]);
     </script>
     <div ng-controller="ExampleController">
        Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
       <table>
         <tr>
           <td>Directive</td>
           <td>How</td>
           <td>Source</td>
           <td>Rendered</td>
         </tr>
         <tr id="bind-html-with-sanitize">
           <td>ng-bind-html</td>
           <td>Automatically uses $sanitize</td>
           <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
           <td><div ng-bind-html="snippet"></div></td>
         </tr>
         <tr id="bind-html-with-trust">
           <td>ng-bind-html</td>
           <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
           <td>
           <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
&lt;/div&gt;</pre>
           </td>
           <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
         </tr>
         <tr id="bind-default">
           <td>ng-bind</td>
           <td>Automatically escapes</td>
           <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
           <td><div ng-bind="snippet"></div></td>
         </tr>
       </table>
       </div>
   </file>
   <file name="protractor.js" type="protractor">
     it('should sanitize the html snippet by default', function() {
       expect(element(by.css('#bind-html-with-sanitize div')).getInnerHtml()).
         toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
     });

     it('should inline raw snippet if bound to a trusted value', function() {
       expect(element(by.css('#bind-html-with-trust div')).getInnerHtml()).
         toBe("<p style=\"color:blue\">an html\n" +
              "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
              "snippet</p>");
     });

     it('should escape snippet without any filter', function() {
       expect(element(by.css('#bind-default div')).getInnerHtml()).
         toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
              "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
              "snippet&lt;/p&gt;");
     });

     it('should update', function() {
       element(by.model('snippet')).clear();
       element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
       expect(element(by.css('#bind-html-with-sanitize div')).getInnerHtml()).
         toBe('new <b>text</b>');
       expect(element(by.css('#bind-html-with-trust div')).getInnerHtml()).toBe(
         'new <b onclick="alert(1)">text</b>');
       expect(element(by.css('#bind-default div')).getInnerHtml()).toBe(
         "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
     });
   </file>
   </example>
 */
function $SanitizeProvider() {
  this.$get = ['$$sanitizeUri', function($$sanitizeUri) {
    return function(html) {
      if (typeof arguments[1] != 'undefined') {
        arguments[1].version = 'taSanitize';
      }
      var buf = [];
      htmlParser(html, htmlSanitizeWriter(buf, function(uri, isImage) {
        return !/^unsafe/.test($$sanitizeUri(uri, isImage));
      }));
      return buf.join('');
    };
  }];
}

function sanitizeText(chars) {
  var buf = [];
  var writer = htmlSanitizeWriter(buf, angular.noop);
  writer.chars(chars);
  return buf.join('');
}


// Regular Expressions for parsing tags and attributes
var START_TAG_REGEXP =
       /^<((?:[a-zA-Z])[\w:-]*)((?:\s+[\w:-]+(?:\s*=\s*(?:(?:"[^"]*")|(?:'[^']*')|[^>\s]+))?)*)\s*(\/?)\s*(>?)/,
  END_TAG_REGEXP = /^<\/\s*([\w:-]+)[^>]*>/,
  ATTR_REGEXP = /([\w:-]+)(?:\s*=\s*(?:(?:"((?:[^"])*)")|(?:'((?:[^'])*)')|([^>\s]+)))?/g,
  BEGIN_TAG_REGEXP = /^</,
  BEGING_END_TAGE_REGEXP = /^<\//,
  COMMENT_REGEXP = /<!--(.*?)-->/g,
  SINGLE_COMMENT_REGEXP = /(^<!--.*?-->)/,
  DOCTYPE_REGEXP = /<!DOCTYPE([^>]*?)>/i,
  CDATA_REGEXP = /<!\[CDATA\[(.*?)]]>/g,
  SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
  // Match everything outside of normal chars and " (quote character)
  NON_ALPHANUMERIC_REGEXP = /([^\#-~| |!])/g,
  WHITE_SPACE_REGEXP = /^(\s+)/;


// Good source of info about elements and attributes
// http://dev.w3.org/html5/spec/Overview.html#semantics
// http://simon.html5.org/html-elements

// Safe Void Elements - HTML5
// http://dev.w3.org/html5/spec/Overview.html#void-elements
var voidElements = makeMap("area,br,col,hr,img,wbr,input");

// Elements that you can, intentionally, leave open (and which close themselves)
// http://dev.w3.org/html5/spec/Overview.html#optional-tags
var optionalEndTagBlockElements = makeMap("colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr"),
    optionalEndTagInlineElements = makeMap("rp,rt"),
    optionalEndTagElements = angular.extend({},
                                            optionalEndTagInlineElements,
                                            optionalEndTagBlockElements);

// Safe Block Elements - HTML5
var blockElements = angular.extend({}, optionalEndTagBlockElements, makeMap("address,article," +
        "aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5," +
        "h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,script,section,table,ul"));

// Inline Elements - HTML5
var inlineElements = angular.extend({}, optionalEndTagInlineElements, makeMap("a,abbr,acronym,b," +
        "bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s," +
        "samp,small,span,strike,strong,sub,sup,time,tt,u,var"));

// SVG Elements
// https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Elements
var svgElements = makeMap("animate,animateColor,animateMotion,animateTransform,circle,defs," +
        "desc,ellipse,font-face,font-face-name,font-face-src,g,glyph,hkern,image,linearGradient," +
        "line,marker,metadata,missing-glyph,mpath,path,polygon,polyline,radialGradient,rect,set," +
        "stop,svg,switch,text,title,tspan,use");

// Special Elements (can contain anything)
var specialElements = makeMap("script,style");

var validElements = angular.extend({},
                                   voidElements,
                                   blockElements,
                                   inlineElements,
                                   optionalEndTagElements,
                                   svgElements);

//Attributes that have href and hence need to be sanitized
var uriAttrs = makeMap("background,cite,href,longdesc,src,usemap,xlink:href");

var htmlAttrs = makeMap('abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,'+
    'color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,'+
    'id,ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,'+
    'scope,scrolling,shape,size,span,start,summary,target,title,type,'+
    'valign,value,vspace,width');

// SVG attributes (without "id" and "name" attributes)
// https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Attributes
var svgAttrs = makeMap('accent-height,accumulate,additive,alphabetic,arabic-form,ascent,' +
    'attributeName,attributeType,baseProfile,bbox,begin,by,calcMode,cap-height,class,color,' +
    'color-rendering,content,cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,' +
    'font-size,font-stretch,font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,' +
    'gradientUnits,hanging,height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,' +
    'keySplines,keyTimes,lang,marker-end,marker-mid,marker-start,markerHeight,markerUnits,' +
    'markerWidth,mathematical,max,min,offset,opacity,orient,origin,overline-position,' +
    'overline-thickness,panose-1,path,pathLength,points,preserveAspectRatio,r,refX,refY,' +
    'repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,' +
    'stemv,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,stroke,' +
    'stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,' +
    'stroke-opacity,stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,' +
    'underline-position,underline-thickness,unicode,unicode-range,units-per-em,values,version,' +
    'viewBox,visibility,width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,' +
    'xlink:show,xlink:title,xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,' +
    'zoomAndPan');

var validAttrs = angular.extend({},
                                uriAttrs,
                                svgAttrs,
                                htmlAttrs);

function makeMap(str) {
  var obj = {}, items = str.split(','), i;
  for (i = 0; i < items.length; i++) obj[items[i]] = true;
  return obj;
}


/**
 * @example
 * htmlParser(htmlString, {
 *     start: function(tag, attrs, unary) {},
 *     end: function(tag) {},
 *     chars: function(text) {},
 *     comment: function(text) {}
 * });
 *
 * @param {string} html string
 * @param {object} handler
 */
function htmlParser(html, handler) {
  if (typeof html !== 'string') {
    if (html === null || typeof html === 'undefined') {
      html = '';
    } else {
      html = '' + html;
    }
  }
  var index, chars, match, stack = [], last = html, text;
  stack.last = function() { return stack[ stack.length - 1 ]; };

  while (html) {
    text = '';
    chars = true;

    // Make sure we're not in a script or style element
    if (!stack.last() || !specialElements[ stack.last() ]) {

      // White space
      if (WHITE_SPACE_REGEXP.test(html)) {
        match = html.match(WHITE_SPACE_REGEXP);

        if (match) {
          var mat = match[0];
          if (handler.whitespace) handler.whitespace(match[0]);
          html = html.replace(match[0], '');
          chars = false;
        }
      //Comment
      } else if (SINGLE_COMMENT_REGEXP.test(html)) {
        match = html.match(SINGLE_COMMENT_REGEXP);

        if (match) {
          if (handler.comment) handler.comment(match[1]);
          html = html.replace(match[0], '');
          chars = false;
        }
      // DOCTYPE
      } else if (DOCTYPE_REGEXP.test(html)) {
        match = html.match(DOCTYPE_REGEXP);

        if (match) {
          html = html.replace(match[0], '');
          chars = false;
        }
      // end tag
      } else if (BEGING_END_TAGE_REGEXP.test(html)) {
        match = html.match(END_TAG_REGEXP);

        if (match) {
          html = html.substring(match[0].length);
          match[0].replace(END_TAG_REGEXP, parseEndTag);
          chars = false;
        }

      // start tag
      } else if (BEGIN_TAG_REGEXP.test(html)) {
        match = html.match(START_TAG_REGEXP);

        if (match) {
          // We only have a valid start-tag if there is a '>'.
          if (match[4]) {
            html = html.substring(match[0].length);
            match[0].replace(START_TAG_REGEXP, parseStartTag);
          }
          chars = false;
        } else {
          // no ending tag found --- this piece should be encoded as an entity.
          text += '<';
          html = html.substring(1);
        }
      }

      if (chars) {
        index = html.indexOf("<");

        text += index < 0 ? html : html.substring(0, index);
        html = index < 0 ? "" : html.substring(index);

        if (handler.chars) handler.chars(decodeEntities(text));
      }

    } else {
      html = html.replace(new RegExp("([^]*)<\\s*\\/\\s*" + stack.last() + "[^>]*>", 'i'),
        function(all, text) {
          text = text.replace(COMMENT_REGEXP, "$1").replace(CDATA_REGEXP, "$1");

          if (handler.chars) handler.chars(decodeEntities(text));

          return "";
      });

      parseEndTag("", stack.last());
    }

    if (html == last) {
      throw $sanitizeMinErr('badparse', "The sanitizer was unable to parse the following block " +
                                        "of html: {0}", html);
    }
    last = html;
  }

  // Clean up any remaining tags
  parseEndTag();

  function parseStartTag(tag, tagName, rest, unary) {
    tagName = angular.lowercase(tagName);
    if (blockElements[ tagName ]) {
      while (stack.last() && inlineElements[ stack.last() ]) {
        parseEndTag("", stack.last());
      }
    }

    if (optionalEndTagElements[ tagName ] && stack.last() == tagName) {
      parseEndTag("", tagName);
    }

    unary = voidElements[ tagName ] || !!unary;

    if (!unary)
      stack.push(tagName);

    var attrs = {};

    rest.replace(ATTR_REGEXP,
      function(match, name, doubleQuotedValue, singleQuotedValue, unquotedValue) {
        var value = doubleQuotedValue
          || singleQuotedValue
          || unquotedValue
          || '';

        attrs[name] = decodeEntities(value);
    });
    if (handler.start) handler.start(tagName, attrs, unary);
  }

  function parseEndTag(tag, tagName) {
    var pos = 0, i;
    tagName = angular.lowercase(tagName);
    if (tagName)
      // Find the closest opened tag of the same type
      for (pos = stack.length - 1; pos >= 0; pos--)
        if (stack[ pos ] == tagName)
          break;

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (i = stack.length - 1; i >= pos; i--)
        if (handler.end) handler.end(stack[ i ]);

      // Remove the open elements from the stack
      stack.length = pos;
    }
  }
}

var hiddenPre=document.createElement("pre");
var spaceRe = /^(\s*)([\s\S]*?)(\s*)$/;
/**
 * decodes all entities into regular string
 * @param value
 * @returns {string} A string with decoded entities.
 */
function decodeEntities(value) {
  if (!value) { return ''; }

  // Note: IE8 does not preserve spaces at the start/end of innerHTML
  // so we must capture them and reattach them afterward
  var parts = spaceRe.exec(value);
  var spaceBefore = parts[1];
  var spaceAfter = parts[3];
  var content = parts[2];
  if (content) {
    hiddenPre.innerHTML=content.replace(/</g,"&lt;");
    // innerText depends on styling as it doesn't display hidden elements.
    // Therefore, it's better to use textContent not to cause unnecessary
    // reflows. However, IE<9 don't support textContent so the innerText
    // fallback is necessary.
    content = 'textContent' in hiddenPre ?
      hiddenPre.textContent : hiddenPre.innerText;
  }
  return spaceBefore + content + spaceAfter;
}

/**
 * Escapes all potentially dangerous characters, so that the
 * resulting string can be safely inserted into attribute or
 * element text.
 * @param value
 * @returns {string} escaped text
 */
function encodeEntities(value) {
  return value.
    replace(/&/g, '&amp;').
    replace(SURROGATE_PAIR_REGEXP, function(value) {
      var hi = value.charCodeAt(0);
      var low = value.charCodeAt(1);
      return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
    }).
    replace(NON_ALPHANUMERIC_REGEXP, function(value) {
      // unsafe chars are: \u0000-\u001f \u007f-\u009f \u00ad \u0600-\u0604 \u070f \u17b4 \u17b5 \u200c-\u200f \u2028-\u202f \u2060-\u206f \ufeff \ufff0-\uffff from jslint.com/lint.html
      // decimal values are: 0-31, 127-159, 173, 1536-1540, 1807, 6068, 6069, 8204-8207, 8232-8239, 8288-8303, 65279, 65520-65535
      var c = value.charCodeAt(0);
      // if unsafe character encode
      if(c <= 159 ||
        c == 173 ||
        (c >= 1536 && c <= 1540) ||
        c == 1807 ||
        c == 6068 ||
        c == 6069 ||
        (c >= 8204 && c <= 8207) ||
        (c >= 8232 && c <= 8239) ||
        (c >= 8288 && c <= 8303) ||
        c == 65279 ||
        (c >= 65520 && c <= 65535)) return '&#' + c + ';';
      return value; // avoids multilingual issues
    }).
    replace(/</g, '&lt;').
    replace(/>/g, '&gt;');
}

var trim = (function() {
  // native trim is way faster: http://jsperf.com/angular-trim-test
  // but IE doesn't have it... :-(
  // TODO: we should move this into IE/ES5 polyfill
  if (!String.prototype.trim) {
    return function(value) {
      return angular.isString(value) ? value.replace(/^\s\s*/, '').replace(/\s\s*$/, '') : value;
    };
  }
  return function(value) {
    return angular.isString(value) ? value.trim() : value;
  };
})();

// Custom logic for accepting certain style options only - textAngular
// Currently allows only the color, background-color, text-align, float, width and height attributes
// all other attributes should be easily done through classes.
function validStyles(styleAttr){
	var result = '';
	var styleArray = styleAttr.split(';');
	angular.forEach(styleArray, function(value){
		var v = value.split(':');
		if(v.length == 2){
			var key = trim(angular.lowercase(v[0]));
			var value = trim(angular.lowercase(v[1]));
			if(
				(key === 'color' || key === 'background-color') && (
					value.match(/^rgb\([0-9%,\. ]*\)$/i)
					|| value.match(/^rgba\([0-9%,\. ]*\)$/i)
					|| value.match(/^hsl\([0-9%,\. ]*\)$/i)
					|| value.match(/^hsla\([0-9%,\. ]*\)$/i)
					|| value.match(/^#[0-9a-f]{3,6}$/i)
					|| value.match(/^[a-z]*$/i)
				)
			||
				key === 'text-align' && (
					value === 'left'
					|| value === 'right'
					|| value === 'center'
					|| value === 'justify'
				)
			||
        key === 'text-decoration' && (
            value === 'underline'
            || value === 'line-through'
        )
      || 
        key === 'font-weight' && (
            value === 'bold'
        )
      ||
        key === 'font-style' && (
          value === 'italic'
        )
      ||
        key === 'float' && (
            value === 'left'
            || value === 'right'
            || value === 'none'
        )
      ||
        key === 'vertical-align' && (
            value === 'baseline'
            || value === 'sub'
            || value === 'super'
            || value === 'test-top'
            || value === 'text-bottom'
            || value === 'middle'
            || value === 'top'
            || value === 'bottom'
            || value.match(/[0-9]*(px|em)/)
            || value.match(/[0-9]+?%/)
        )
      ||
        key === 'font-size' && (
            value === 'xx-small'
            || value === 'x-small'
            || value === 'small'
            || value === 'medium'
            || value === 'large'
            || value === 'x-large'
            || value === 'xx-large'
            || value === 'larger'
            || value === 'smaller'
            || value.match(/[0-9]*\.?[0-9]*(px|em|rem|mm|q|cm|in|pt|pc|%)/)
                               )
			||
				(key === 'width' || key === 'height') && (
					value.match(/[0-9\.]*(px|em|rem|%)/)
				)
			|| // Reference #520
				(key === 'direction' && value.match(/^ltr|rtl|initial|inherit$/))
			) result += key + ': ' + value + ';';
		}
	});
	return result;
}

// this function is used to manually allow specific attributes on specific tags with certain prerequisites
function validCustomTag(tag, attrs, lkey, value){
	// catch the div placeholder for the iframe replacement
    if (tag === 'img' && attrs['ta-insert-video']){
        if(lkey === 'ta-insert-video' || lkey === 'allowfullscreen' || lkey === 'frameborder' || (lkey === 'contenteditable' && value === 'false')) return true;
    }
    return false;
}

/**
 * create an HTML/XML writer which writes to buffer
 * @param {Array} buf use buf.jain('') to get out sanitized html string
 * @returns {object} in the form of {
 *     start: function(tag, attrs, unary) {},
 *     end: function(tag) {},
 *     chars: function(text) {},
 *     comment: function(text) {}
 * }
 */
function htmlSanitizeWriter(buf, uriValidator) {
  var ignore = false;
  var out = angular.bind(buf, buf.push);
  return {
    start: function(tag, attrs, unary) {
      tag = angular.lowercase(tag);
      if (!ignore && specialElements[tag]) {
        ignore = tag;
      }
      if (!ignore && validElements[tag] === true) {
        out('<');
        out(tag);
        angular.forEach(attrs, function(value, key) {
          var lkey=angular.lowercase(key);
          var isImage=(tag === 'img' && lkey === 'src') || (lkey === 'background');
          if ((lkey === 'style' && (value = validStyles(value)) !== '') || validCustomTag(tag, attrs, lkey, value) || validAttrs[lkey] === true &&
            (uriAttrs[lkey] !== true || uriValidator(value, isImage))) {
            out(' ');
            out(key);
            out('="');
            out(encodeEntities(value));
            out('"');
          }
        });
        out(unary ? '/>' : '>');
      }
    },
    comment: function (com) {
      out(com);
    },
    whitespace: function (ws) {
      out(encodeEntities(ws));
    },
    end: function(tag) {
        tag = angular.lowercase(tag);
        if (!ignore && validElements[tag] === true) {
          out('</');
          out(tag);
          out('>');
        }
        if (tag == ignore) {
          ignore = false;
        }
      },
    chars: function(chars) {
        if (!ignore) {
          out(encodeEntities(chars));
        }
      }
  };
}


// define ngSanitize module and register $sanitize service
angular.module('ngSanitize', []).provider('$sanitize', $SanitizeProvider);

/* global sanitizeText: false */

/**
 * @ngdoc filter
 * @name linky
 * @kind function
 *
 * @description
 * Finds links in text input and turns them into html links. Supports http/https/ftp/mailto and
 * plain email address links.
 *
 * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
 *
 * @param {string} text Input text.
 * @param {string} target Window (_blank|_self|_parent|_top) or named frame to open links in.
 * @returns {string} Html-linkified text.
 *
 * @usage
   <span ng-bind-html="linky_expression | linky"></span>
 *
 * @example
   <example module="linkyExample" deps="angular-sanitize.js">
     <file name="index.html">
       <script>
         angular.module('linkyExample', ['ngSanitize'])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.snippet =
               'Pretty text with some links:\n'+
               'http://angularjs.org/,\n'+
               'mailto:us@somewhere.org,\n'+
               'another@somewhere.org,\n'+
               'and one more: ftp://127.0.0.1/.';
             $scope.snippetWithTarget = 'http://angularjs.org/';
           }]);
       </script>
       <div ng-controller="ExampleController">
       Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
       <table>
         <tr>
           <td>Filter</td>
           <td>Source</td>
           <td>Rendered</td>
         </tr>
         <tr id="linky-filter">
           <td>linky filter</td>
           <td>
             <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
           </td>
           <td>
             <div ng-bind-html="snippet | linky"></div>
           </td>
         </tr>
         <tr id="linky-target">
          <td>linky target</td>
          <td>
            <pre>&lt;div ng-bind-html="snippetWithTarget | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
          </td>
          <td>
            <div ng-bind-html="snippetWithTarget | linky:'_blank'"></div>
          </td>
         </tr>
         <tr id="escaped-html">
           <td>no filter</td>
           <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
           <td><div ng-bind="snippet"></div></td>
         </tr>
       </table>
     </file>
     <file name="protractor.js" type="protractor">
       it('should linkify the snippet with urls', function() {
         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
             toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
         expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
       });

       it('should not linkify snippet without the linky filter', function() {
         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
             toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
         expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
       });

       it('should update', function() {
         element(by.model('snippet')).clear();
         element(by.model('snippet')).sendKeys('new http://link.');
         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
             toBe('new http://link.');
         expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
             .toBe('new http://link.');
       });

       it('should work with the target property', function() {
        expect(element(by.id('linky-target')).
            element(by.binding("snippetWithTarget | linky:'_blank'")).getText()).
            toBe('http://angularjs.org/');
        expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
       });
     </file>
   </example>
 */
angular.module('ngSanitize').filter('linky', ['$sanitize', function($sanitize) {
  var LINKY_URL_REGEXP =
        /((ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"”’]/,
      MAILTO_REGEXP = /^mailto:/;

  return function(text, target) {
    if (!text) return text;
    var match;
    var raw = text;
    var html = [];
    var url;
    var i;
    while ((match = raw.match(LINKY_URL_REGEXP))) {
      // We can not end in these as they are sometimes found at the end of the sentence
      url = match[0];
      // if we did not match ftp/http/www/mailto then assume mailto
      if (!match[2] && !match[4]) {
        url = (match[3] ? 'http://' : 'mailto:') + url;
      }
      i = match.index;
      addText(raw.substr(0, i));
      addLink(url, match[0].replace(MAILTO_REGEXP, ''));
      raw = raw.substring(i + match[0].length);
    }
    addText(raw);
    return $sanitize(html.join(''));

    function addText(text) {
      if (!text) {
        return;
      }
      html.push(sanitizeText(text));
    }

    function addLink(url, text) {
      html.push('<a ');
      if (angular.isDefined(target)) {
        html.push('target="',
                  target,
                  '" ');
      }
      html.push('href="',
                url.replace(/"/g, '&quot;'),
                '">');
      addText(text);
      html.push('</a>');
    }
  };
}]);


})(window, window.angular);

/*
@license textAngular
Author : Austin Anderson
License : 2013 MIT
Version 1.5.9

See README.md or https://github.com/fraywing/textAngular/wiki for requirements and use.
*/

/*
Commonjs package manager support (eg componentjs).
*/


"use strict";// NOTE: textAngularVersion must match the Gruntfile.js 'setVersion' task.... and have format v/d+./d+./d+
var textAngularVersion = 'v1.5.9';   // This is automatically updated during the build process to the current release!


// IE version detection - http://stackoverflow.com/questions/4169160/javascript-ie-detection-why-not-use-simple-conditional-comments
// We need this as IE sometimes plays funny tricks with the contenteditable.
// ----------------------------------------------------------
// If you're not in IE (or IE version is less than 5) then:
// ie === undefined
// If you're in IE (>=5) then you can determine which version:
// ie === 7; // IE7
// Thus, to detect IE:
// if (ie) {}
// And to detect the version:
// ie === 6 // IE6
// ie > 7 // IE8, IE9, IE10 ...
// ie < 9 // Anything less than IE9
// ----------------------------------------------------------
/* istanbul ignore next: untestable browser check */
var _browserDetect = {
	ie: (function(){
		var undef,
			v = 3,
			div = document.createElement('div'),
			all = div.getElementsByTagName('i');

		while (
			div.innerHTML = '<!--[if gt IE ' + (++v) + ']><i></i><![endif]-->',
			all[0]
		);

		return v > 4 ? v : undef;
	}()),
	webkit: /AppleWebKit\/([\d.]+)/i.test(navigator.userAgent),
	isFirefox: navigator.userAgent.toLowerCase().indexOf('firefox') > -1
};

// Global to textAngular to measure performance where needed
/* istanbul ignore next: untestable browser check */
var performance = performance || {};
/* istanbul ignore next: untestable browser check */
performance.now = (function() {
	return performance.now       ||
		performance.mozNow    ||
		performance.msNow     ||
		performance.oNow      ||
		performance.webkitNow ||
		function() { return new Date().getTime(); };
})();
// usage is:
// var t0 = performance.now();
// doSomething();
// var t1 = performance.now();
// console.log('Took', (t1 - t0).toFixed(4), 'milliseconds to do something!');
//

// turn html into pure text that shows visiblity
function stripHtmlToText(html)
{
	var tmp = document.createElement("DIV");
	tmp.innerHTML = html;
	var res = tmp.textContent || tmp.innerText || '';
	res.replace('\u200B', ''); // zero width space
	res = res.trim();
	return res;
}
// get html
function getDomFromHtml(html)
{
	var tmp = document.createElement("DIV");
	tmp.innerHTML = html;
	return tmp;
}


// Global to textAngular REGEXP vars for block and list elements.

var BLOCKELEMENTS = /^(address|article|aside|audio|blockquote|canvas|center|dd|div|dl|fieldset|figcaption|figure|footer|form|h1|h2|h3|h4|h5|h6|header|hgroup|hr|noscript|ol|output|p|pre|section|table|tfoot|ul|video)$/i;
var LISTELEMENTS = /^(ul|li|ol)$/i;
var VALIDELEMENTS = /^(address|article|aside|audio|blockquote|canvas|center|dd|div|dl|fieldset|figcaption|figure|footer|form|h1|h2|h3|h4|h5|h6|header|hgroup|hr|noscript|ol|output|p|pre|section|table|tfoot|ul|video|li)$/i;

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Compatibility
/* istanbul ignore next: trim shim for older browsers */
if (!String.prototype.trim) {
	String.prototype.trim = function () {
		return this.replace(/^\s+|\s+$/g, '');
	};
}

/*
	Custom stylesheet for the placeholders rules.
	Credit to: http://davidwalsh.name/add-rules-stylesheets
*/
var sheet, addCSSRule, removeCSSRule, _addCSSRule, _removeCSSRule, _getRuleIndex;
/* istanbul ignore else: IE <8 test*/
if(_browserDetect.ie > 8 || _browserDetect.ie === undefined){
	var _sheets = document.styleSheets;
	/* istanbul ignore next: preference for stylesheet loaded externally */
	for(var i = 0; i < _sheets.length; i++){
		if(_sheets[i].media.length === 0 || _sheets[i].media.mediaText.match(/(all|screen)/ig)){
			if(_sheets[i].href){
				if(_sheets[i].href.match(/textangular\.(min\.|)css/ig)){
					sheet = _sheets[i];
					break;
				}
			}
		}
	}
	/* istanbul ignore next: preference for stylesheet loaded externally */
	if(!sheet){
		// this sheet is used for the placeholders later on.
		sheet = (function() {
			// Create the <style> tag
			var style = document.createElement("style");
			/* istanbul ignore else : WebKit hack :( */
			if(_browserDetect.webkit) style.appendChild(document.createTextNode(""));

			// Add the <style> element to the page, add as first so the styles can be overridden by custom stylesheets
			document.getElementsByTagName('head')[0].appendChild(style);

			return style.sheet;
		})();
	}

	// use as: addCSSRule("header", "float: left");
	addCSSRule = function(selector, rules) {
		return _addCSSRule(sheet, selector, rules);
	};
	_addCSSRule = function(_sheet, selector, rules){
		var insertIndex;
		var insertedRule;
		// This order is important as IE 11 has both cssRules and rules but they have different lengths - cssRules is correct, rules gives an error in IE 11
		/* istanbul ignore next: browser catches */
		if(_sheet.cssRules) insertIndex = Math.max(_sheet.cssRules.length - 1, 0);
		else if(_sheet.rules) insertIndex = Math.max(_sheet.rules.length - 1, 0);

		/* istanbul ignore else: untestable IE option */
		if(_sheet.insertRule) {
			_sheet.insertRule(selector + "{" + rules + "}", insertIndex);
		}
		else {
			_sheet.addRule(selector, rules, insertIndex);
		}
		/* istanbul ignore next: browser catches */
		if(sheet.rules) insertedRule = sheet.rules[insertIndex];
		else if(sheet.cssRules) insertedRule = sheet.cssRules[insertIndex];
		// return the inserted stylesheet rule
		return insertedRule;
	};

	_getRuleIndex = function(rule, rules) {
		var i, ruleIndex;
		for (i=0; i < rules.length; i++) {
			/* istanbul ignore else: check for correct rule */
			if (rules[i].cssText === rule.cssText) {
				ruleIndex = i;
				break;
			}
		}
		return ruleIndex;
	};

	removeCSSRule = function(rule){
		_removeCSSRule(sheet, rule);
	};
	/* istanbul ignore next: tests are browser specific */
	_removeCSSRule = function(sheet, rule){
		var rules = sheet.cssRules || sheet.rules;
		if(!rules || rules.length === 0) return;
		var ruleIndex = _getRuleIndex(rule, rules);
		if(sheet.removeRule){
			sheet.removeRule(ruleIndex);
		}else{
			sheet.deleteRule(ruleIndex);
		}
	};
}

angular.module('textAngular.factories', [])
.factory('taBrowserTag', [function(){
	return function(tag){
		/* istanbul ignore next: ie specific test */
		if(!tag) return (_browserDetect.ie <= 8)? 'P' : 'p';
		else if(tag === '') return (_browserDetect.ie === undefined)? 'div' : (_browserDetect.ie <= 8)? 'P' : 'p';
		else return (_browserDetect.ie <= 8)? tag.toUpperCase() : tag;
	};
}]).factory('taApplyCustomRenderers', ['taCustomRenderers', 'taDOM', function(taCustomRenderers, taDOM){
	return function(val){
		var element = angular.element('<div></div>');
		element[0].innerHTML = val;

		angular.forEach(taCustomRenderers, function(renderer){
			var elements = [];
			// get elements based on what is defined. If both defined do secondary filter in the forEach after using selector string
			if(renderer.selector && renderer.selector !== '')
				elements = element.find(renderer.selector);
			/* istanbul ignore else: shouldn't fire, if it does we're ignoring everything */
			else if(renderer.customAttribute && renderer.customAttribute !== '')
				elements = taDOM.getByAttribute(element, renderer.customAttribute);
			// process elements if any found
			angular.forEach(elements, function(_element){
				_element = angular.element(_element);
				if(renderer.selector && renderer.selector !== '' && renderer.customAttribute && renderer.customAttribute !== ''){
					if(_element.attr(renderer.customAttribute) !== undefined) renderer.renderLogic(_element);
				} else renderer.renderLogic(_element);
			});
		});

		return element[0].innerHTML;
	};
}]).factory('taFixChrome', function(){
	// get whaterever rubbish is inserted in chrome
	// should be passed an html string, returns an html string
	var taFixChrome = function(html){
		if(!html || !angular.isString(html) || html.length <= 0) return html;
		// grab all elements with a style attibute
		var spanMatch = /<([^>\/]+?)style=("([^\"]+)"|'([^']+)')([^>]*)>/ig;
		var appleConvertedSpaceMatch = /<span class="Apple-converted-space">([^<]+)<\/span>/ig;
		var match, styleVal, appleSpaceVal, newTag, finalHtml = '', lastIndex = 0;
		// remove all the Apple-converted-space spans and replace with the content of the span
		/* istanbul ignore next: apple-contereted-space span match */
		while(match = appleConvertedSpaceMatch.exec(html)){
			appleSpaceVal = match[1];
			appleSpaceVal = appleSpaceVal.replace(/&nbsp;/ig, ' ');
			finalHtml += html.substring(lastIndex, match.index) + appleSpaceVal;
			lastIndex = match.index + match[0].length;
		}
		/* istanbul ignore next: apple-contereted-space span has matched */
		if (lastIndex) {
			// modified....
			finalHtml += html.substring(lastIndex);
			html=finalHtml;
			finalHtml='';
			lastIndex=0;
		}
		while(match = spanMatch.exec(html)){
			// one of the quoted values ' or "
			/* istanbul ignore next: quotations match */
			styleVal = match[3] || match[4];
			// test for chrome inserted junk
			if(styleVal && styleVal.match(/line-height: 1.[0-9]{3,12};|color: inherit; line-height: 1.1;/i)){
				// replace original tag with new tag
				styleVal = styleVal.replace(/( |)font-family: inherit;|( |)line-height: 1.[0-9]{3,12};|( |)color: inherit;/ig, '');
				newTag = '<' + match[1].trim();
				if(styleVal.trim().length > 0) newTag += ' style=' + match[2].substring(0,1) + styleVal + match[2].substring(0,1);
				newTag += match[5].trim() + ">";
				finalHtml += html.substring(lastIndex, match.index) + newTag;
				lastIndex = match.index + match[0].length;
			}
		}
		finalHtml += html.substring(lastIndex);
		// only replace when something has changed, else we get focus problems on inserting lists
		if(lastIndex > 0){
			// replace all empty strings
			return finalHtml.replace(/<span\s?>(.*?)<\/span>(<br(\/|)>|)/ig, '$1');
		} else return html;
	};
	return taFixChrome;
}).factory('taSanitize', ['$sanitize', function taSanitizeFactory($sanitize){

	var convert_infos = [
		{
			property: 'font-weight',
			values: [ 'bold' ],
			tag: 'b'
		},
		{
			property: 'font-style',
			values: [ 'italic' ],
			tag: 'i'
		}
	];

	var styleMatch = [];
	for(var i = 0; i < convert_infos.length; i++){
		var _partialStyle = '(' + convert_infos[i].property + ':\\s*(';
		for(var j = 0; j < convert_infos[i].values.length; j++){
			/* istanbul ignore next: not needed to be tested yet */
			if(j > 0) _partialStyle += '|';
			_partialStyle += convert_infos[i].values[j];
		}
		_partialStyle += ');)';
		styleMatch.push(_partialStyle);
	}
	var styleRegexString = '(' + styleMatch.join('|') + ')';

	function wrapNested(html, wrapTag) {
		var depth = 0;
		var lastIndex = 0;
		var match;
		var tagRegex = /<[^>]*>/ig;
		while(match = tagRegex.exec(html)){
			lastIndex = match.index;
			if(match[0].substr(1, 1) === '/'){
				if(depth === 0) break;
				else depth--;
			}else depth++;
		}
		return wrapTag +
			html.substring(0, lastIndex) +
			// get the start tags reversed - this is safe as we construct the strings with no content except the tags
			angular.element(wrapTag)[0].outerHTML.substring(wrapTag.length) +
			html.substring(lastIndex);
	}

	function transformLegacyStyles(html){
		if(!html || !angular.isString(html) || html.length <= 0) return html;
		var i;
		var styleElementMatch = /<([^>\/]+?)style=("([^"]+)"|'([^']+)')([^>]*)>/ig;
		var match, subMatch, styleVal, newTag, lastNewTag = '', newHtml, finalHtml = '', lastIndex = 0;
		while(match = styleElementMatch.exec(html)){
			// one of the quoted values ' or "
			/* istanbul ignore next: quotations match */
			styleVal = match[3] || match[4];
			var styleRegex = new RegExp(styleRegexString, 'i');
			// test for style values to change
			if(angular.isString(styleVal) && styleRegex.test(styleVal)){
				// remove build tag list
				newTag = '';
				// init regex here for exec
				var styleRegexExec = new RegExp(styleRegexString, 'ig');
				// find relevand tags and build a string of them
				while(subMatch = styleRegexExec.exec(styleVal)){
					for(i = 0; i < convert_infos.length; i++){
						if(!!subMatch[(i*2) + 2]){
							newTag += '<' + convert_infos[i].tag + '>';
						}
					}
				}
				// recursively find more legacy styles in html before this tag and after the previous match (if any)
				newHtml = transformLegacyStyles(html.substring(lastIndex, match.index));
				// build up html
				if(lastNewTag.length > 0){
					finalHtml += wrapNested(newHtml, lastNewTag);
				}else finalHtml += newHtml;
				// grab the style val without the transformed values
				styleVal = styleVal.replace(new RegExp(styleRegexString, 'ig'), '');
				// build the html tag
				finalHtml += '<' + match[1].trim();
				if(styleVal.length > 0) finalHtml += ' style="' + styleVal + '"';
				finalHtml += match[5] + '>';
				// update the start index to after this tag
				lastIndex = match.index + match[0].length;
				lastNewTag = newTag;
			}
		}
		if(lastNewTag.length > 0){
			finalHtml += wrapNested(html.substring(lastIndex), lastNewTag);
		}
		else finalHtml += html.substring(lastIndex);
		return finalHtml;
	}

	function transformLegacyAttributes(html){
		if(!html || !angular.isString(html) || html.length <= 0) return html;
		// replace all align='...' tags with text-align attributes
		var attrElementMatch = /<([^>\/]+?)align=("([^"]+)"|'([^']+)')([^>]*)>/ig;
		var match, finalHtml = '', lastIndex = 0;
		// match all attr tags
		while(match = attrElementMatch.exec(html)){
			// add all html before this tag
			finalHtml += html.substring(lastIndex, match.index);
			// record last index after this tag
			lastIndex = match.index + match[0].length;
			// construct tag without the align attribute
			var newTag = '<' + match[1] + match[5];
			// add the style attribute
			if(/style=("([^"]+)"|'([^']+)')/ig.test(newTag)){
				/* istanbul ignore next: quotations match */
				newTag = newTag.replace(/style=("([^"]+)"|'([^']+)')/i, 'style="$2$3 text-align:' + (match[3] || match[4]) + ';"');
			}else{
				/* istanbul ignore next: quotations match */
				newTag += ' style="text-align:' + (match[3] || match[4]) + ';"';
			}
			newTag += '>';
			// add to html
			finalHtml += newTag;
		}
		// return with remaining html
		return finalHtml + html.substring(lastIndex);
	}

	// use precompiled regexp for speed
	var rsb1 = new RegExp(/<span id="selectionBoundary_\d+_\d+" class="rangySelectionBoundary">[^<>]+?<\/span>/ig);
	var rsb2 = new RegExp(/<span class="rangySelectionBoundary" id="selectionBoundary_\d+_\d+">[^<>]+?<\/span>/ig);
	var rsb3 = new RegExp(/<span id="selectionBoundary_\d+_\d+" class="rangySelectionBoundary">[^<>]+?<\/span>/ig);

	return function taSanitize(unsafe, oldsafe, ignore){
		// unsafe html should NEVER built into a DOM object via angular.element. This allows XSS to be inserted and run.
		if ( !ignore ) {
			try {
				unsafe = transformLegacyStyles(unsafe);
			} catch (e) {
			}
		}

		// unsafe and oldsafe should be valid HTML strings
		// any exceptions (lets say, color for example) should be made here but with great care
		// setup unsafe element for modification
		unsafe = transformLegacyAttributes(unsafe);

		// we had an issue in the past, where we dumped a whole bunch of <span>'s into the content...
		// so we remove them here
		// IN A FUTURE release this can be removed after all have updated through release 1.5.9
		if (unsafe) {
			unsafe = unsafe.replace(rsb1, '');
			unsafe = unsafe.replace(rsb2, '');
			unsafe = unsafe.replace(rsb1, '');
			unsafe = unsafe.replace(rsb3, '');
		}

		var safe = unsafe;
		try {
			// safe = $sanitize(unsafe);
			// do this afterwards, then the $sanitizer should still throw for bad markup
			if(ignore) safe = unsafe;
		} catch (e){
			safe = oldsafe || '';
		}

		// Do processing for <pre> tags, removing tabs and return carriages outside of them

		var _preTags = safe.match(/(<pre[^>]*>.*?<\/pre[^>]*>)/ig);
		var processedSafe = safe.replace(/(&#(9|10);)*/ig, '');
		var re = /<pre[^>]*>.*?<\/pre[^>]*>/ig;
		var index = 0;
		var lastIndex = 0;
		var origTag;
		safe = '';
		while((origTag = re.exec(processedSafe)) !== null && index < _preTags.length){
			safe += processedSafe.substring(lastIndex, origTag.index) + _preTags[index];
			lastIndex = origTag.index + origTag[0].length;
			index++;
		}
		return safe + processedSafe.substring(lastIndex);
	};
}]).factory('taToolExecuteAction', ['$q', '$log', function($q, $log){
	// this must be called on a toolScope or instance
	return function(editor){
		if(editor !== undefined) this.$editor = function(){ return editor; };
		var deferred = $q.defer(),
			promise = deferred.promise,
			_editor = this.$editor();
		// pass into the action the deferred function and also the function to reload the current selection if rangy available
		var result;
		try{
			result = this.action(deferred, _editor.startAction());
			// We set the .finally callback here to make sure it doesn't get executed before any other .then callback.
			promise['finally'](function(){
				_editor.endAction.call(_editor);
			});
		}catch(exc){
			$log.error(exc);
		}
		if(result || result === undefined){
			// if true or undefined is returned then the action has finished. Otherwise the deferred action will be resolved manually.
			deferred.resolve();
		}
	};
}]);

angular.module('textAngular.DOM', ['textAngular.factories'])
.factory('taExecCommand', ['taSelection', 'taBrowserTag', '$document', function(taSelection, taBrowserTag, $document){
	var listToDefault = function(listElement, defaultWrap){
		var $target, i;
		// if all selected then we should remove the list
		// grab all li elements and convert to taDefaultWrap tags
		var children = listElement.find('li');
		for(i = children.length - 1; i >= 0; i--){
			$target = angular.element('<' + defaultWrap + '>' + children[i].innerHTML + '</' + defaultWrap + '>');
			listElement.after($target);
		}
		listElement.remove();
		taSelection.setSelectionToElementEnd($target[0]);
	};
	var selectLi = function(liElement){
		if(/(<br(|\/)>)$/i.test(liElement.innerHTML.trim())) taSelection.setSelectionBeforeElement(angular.element(liElement).find("br")[0]);
		else taSelection.setSelectionToElementEnd(liElement);
	};
	var listToList = function(listElement, newListTag){
		var $target = angular.element('<' + newListTag + '>' + listElement[0].innerHTML + '</' + newListTag + '>');
		listElement.after($target);
		listElement.remove();
		selectLi($target.find('li')[0]);
	};
	var childElementsToList = function(elements, listElement, newListTag){
		var html = '';
		for(var i = 0; i < elements.length; i++){
			html += '<' + taBrowserTag('li') + '>' + elements[i].innerHTML + '</' + taBrowserTag('li') + '>';
		}
		var $target = angular.element('<' + newListTag + '>' + html + '</' + newListTag + '>');
		listElement.after($target);
		listElement.remove();
		selectLi($target.find('li')[0]);
	};
	var turnBlockIntoBlocks = function(element, options) {
		for(var i = 0; i<element.childNodes.length; i++) {
			var _n = element.childNodes[i];
			/* istanbul ignore next - more complex testing*/
			if (_n.tagName && _n.tagName.match(BLOCKELEMENTS)) {
				turnBlockIntoBlocks(_n, options);
			}
		}
		/* istanbul ignore next - very rare condition that we do not test*/
		if (element.parentNode === null) {
			// nothing left to do..
			return element;
		}
		var $target = angular.element(options);
		$target[0].innerHTML = element.innerHTML;
		element.parentNode.insertBefore($target[0], element);
		element.parentNode.removeChild(element);
		return $target;
	};
	return function(taDefaultWrap, topNode){
		// NOTE: here we are dealing with the html directly from the browser and not the html the user sees.
		// IF you want to modify the html the user sees, do it when the user does a switchView
		taDefaultWrap = taBrowserTag(taDefaultWrap);
		return function(command, showUI, options, defaultTagAttributes){
			var i, $target, html, _nodes, next, optionsTagName, selectedElement, ourSelection;
			var defaultWrapper = angular.element('<' + taDefaultWrap + '>');
			try{
				if (taSelection.getSelection) {
					ourSelection = taSelection.getSelection();
				}
				selectedElement = taSelection.getSelectionElement();
				// special checks and fixes when we are selecting the whole container
				var __h, _innerNode;
				/* istanbul ignore next */
                if (selectedElement.tagName !== undefined) {
                    if (selectedElement.tagName.toLowerCase() === 'div' &&
                        /taTextElement.+/.test(selectedElement.id) &&
                        ourSelection && ourSelection.start &&
                        ourSelection.start.offset === 1 &&
                        ourSelection.end.offset === 1) {
                        // opps we are actually selecting the whole container!
                        //console.log('selecting whole container!');
                        __h = selectedElement.innerHTML;
                        if (/<br>/i.test(__h)) {
                            // Firefox adds <br>'s and so we remove the <br>
                            __h = __h.replace(/<br>/i, '&#8203;');  // no space-space
                        }
                        if (/<br\/>/i.test(__h)) {
                            // Firefox adds <br/>'s and so we remove the <br/>
                            __h = __h.replace(/<br\/>/i, '&#8203;');  // no space-space
                        }
                        // remove stacked up <span>'s
                        if (/<span>(<span>)+/i.test(__h)) {
                            __h = __.replace(/<span>(<span>)+/i, '<span>');
                        }
                        // remove stacked up </span>'s
                        if (/<\/span>(<\/span>)+/i.test(__h)) {
                            __h = __.replace(/<\/span>(<\/span>)+/i, '<\/span>');
                        }
                        if (/<span><\/span>/i.test(__h)) {
                            // if we end up with a <span></span> here we remove it...
                            __h = __h.replace(/<span><\/span>/i, '');
                        }
                        //console.log('inner whole container', selectedElement.childNodes);
                        _innerNode = '<div>' + __h + '</div>';
                        selectedElement.innerHTML = _innerNode;
                        //console.log('childNodes:', selectedElement.childNodes);
                        taSelection.setSelectionToElementEnd(selectedElement.childNodes[0]);
                        selectedElement = taSelection.getSelectionElement();
                    } else if (selectedElement.tagName.toLowerCase() === 'span' &&
                        ourSelection && ourSelection.start &&
                        ourSelection.start.offset === 1 &&
                        ourSelection.end.offset === 1) {
                        // just a span -- this is a problem...
                        //console.log('selecting span!');
                        __h = selectedElement.innerHTML;
                        if (/<br>/i.test(__h)) {
                            // Firefox adds <br>'s and so we remove the <br>
                            __h = __h.replace(/<br>/i, '&#8203;');  // no space-space
                        }
                        if (/<br\/>/i.test(__h)) {
                            // Firefox adds <br/>'s and so we remove the <br/>
                            __h = __h.replace(/<br\/>/i, '&#8203;');  // no space-space
                        }
                        // remove stacked up <span>'s
                        if (/<span>(<span>)+/i.test(__h)) {
                            __h = __.replace(/<span>(<span>)+/i, '<span>');
                        }
                        // remove stacked up </span>'s
                        if (/<\/span>(<\/span>)+/i.test(__h)) {
                            __h = __.replace(/<\/span>(<\/span>)+/i, '<\/span>');
                        }
                        if (/<span><\/span>/i.test(__h)) {
                            // if we end up with a <span></span> here we remove it...
                            __h = __h.replace(/<span><\/span>/i, '');
                        }
                        //console.log('inner span', selectedElement.childNodes);
                        // we wrap this in a <div> because otherwise the browser get confused when we attempt to select the whole node
                        // and the focus is not set correctly no matter what we do
                        _innerNode = '<div>' + __h + '</div>';
                        selectedElement.innerHTML = _innerNode;
                        taSelection.setSelectionToElementEnd(selectedElement.childNodes[0]);
                        selectedElement = taSelection.getSelectionElement();
                        //console.log(selectedElement.innerHTML);
                    } else if (selectedElement.tagName.toLowerCase() === 'p' &&
                        ourSelection && ourSelection.start &&
                        ourSelection.start.offset === 1 &&
                        ourSelection.end.offset === 1) {
                        //console.log('p special');
                        // we need to remove the </br> that firefox adds!
                        __h = selectedElement.innerHTML;
                        if (/<br>/i.test(__h)) {
                            // Firefox adds <br>'s and so we remove the <br>
                            __h = __h.replace(/<br>/i, '&#8203;');  // no space-space
                        }
                        selectedElement.innerHTML = __h;
                    } else if (selectedElement.tagName.toLowerCase() === 'li' &&
                        ourSelection && ourSelection.start &&
                        ourSelection.start.offset === ourSelection.end.offset) {
                        // we need to remove the </br> that firefox adds!
                        __h = selectedElement.innerHTML;
                        if (/<br>/i.test(__h)) {
                            // Firefox adds <br>'s and so we remove the <br>
                            __h = __h.replace(/<br>/i, '');  // nothing
                        }
                        selectedElement.innerHTML = __h;
                    }
                }
            }catch(e){}
			var $selected = angular.element(selectedElement);
			//if(selectedElement !== undefined && selectedElement.tagName !== undefined){
			var tagName = selectedElement.tagName.toLowerCase();
			if(command.toLowerCase() === 'insertorderedlist' || command.toLowerCase() === 'insertunorderedlist'){
				var selfTag = taBrowserTag((command.toLowerCase() === 'insertorderedlist')? 'ol' : 'ul');
				if(tagName === selfTag){
					// if all selected then we should remove the list
					// grab all li elements and convert to taDefaultWrap tags
					return listToDefault($selected, taDefaultWrap);
				}else if(tagName === 'li' &&
					$selected.parent()[0].tagName.toLowerCase() === selfTag &&
					$selected.parent().children().length === 1){
					// catch for the previous statement if only one li exists
					return listToDefault($selected.parent(), taDefaultWrap);
				}else if(tagName === 'li' &&
					$selected.parent()[0].tagName.toLowerCase() !== selfTag &&
					$selected.parent().children().length === 1){
					// catch for the previous statement if only one li exists
					return listToList($selected.parent(), selfTag);
				}else if(tagName.match(BLOCKELEMENTS) && !$selected.hasClass('ta-bind')){
					// if it's one of those block elements we have to change the contents
					// if it's a ol/ul we are changing from one to the other
					if(tagName === 'ol' || tagName === 'ul'){
						return listToList($selected, selfTag);
					}else{
						var childBlockElements = false;
						angular.forEach($selected.children(), function(elem){
							if(elem.tagName.match(BLOCKELEMENTS)) {
								childBlockElements = true;
							}
						});
						if(childBlockElements){
							return childElementsToList($selected.children(), $selected, selfTag);
						}else{
							return childElementsToList([angular.element('<div>' + selectedElement.innerHTML + '</div>')[0]], $selected, selfTag);
						}
					}
				}else if(tagName.match(BLOCKELEMENTS)){
					// if we get here then all the contents of the ta-bind are selected
					_nodes = taSelection.getOnlySelectedElements();
					if(_nodes.length === 0){
						// here is if there is only text in ta-bind ie <div ta-bind>test content</div>
						$target = angular.element('<' + selfTag + '><li>' + selectedElement.innerHTML + '</li></' + selfTag + '>');
						$selected.html('');
						$selected.append($target);
					}else if(_nodes.length === 1 && (_nodes[0].tagName.toLowerCase() === 'ol' || _nodes[0].tagName.toLowerCase() === 'ul')){
						if(_nodes[0].tagName.toLowerCase() === selfTag){
							// remove
							return listToDefault(angular.element(_nodes[0]), taDefaultWrap);
						}else{
							return listToList(angular.element(_nodes[0]), selfTag);
						}
					}else{
						html = '';
						var $nodes = [];
						for(i = 0; i < _nodes.length; i++){
							/* istanbul ignore else: catch for real-world can't make it occur in testing */
							if(_nodes[i].nodeType !== 3){
								var $n = angular.element(_nodes[i]);
								/* istanbul ignore if: browser check only, phantomjs doesn't return children nodes but chrome at least does */
								if(_nodes[i].tagName.toLowerCase() === 'li') continue;
								else if(_nodes[i].tagName.toLowerCase() === 'ol' || _nodes[i].tagName.toLowerCase() === 'ul'){
									html += $n[0].innerHTML; // if it's a list, add all it's children
								}else if(_nodes[i].tagName.toLowerCase() === 'span' && (_nodes[i].childNodes[0].tagName.toLowerCase() === 'ol' || _nodes[i].childNodes[0].tagName.toLowerCase() === 'ul')){
									html += $n[0].childNodes[0].innerHTML; // if it's a list, add all it's children
								}else{
									html += '<' + taBrowserTag('li') + '>' + $n[0].innerHTML + '</' + taBrowserTag('li') + '>';
								}
								$nodes.unshift($n);
							}
						}
						$target = angular.element('<' + selfTag + '>' + html + '</' + selfTag + '>');
						$nodes.pop().replaceWith($target);
						angular.forEach($nodes, function($node){ $node.remove(); });
					}
					taSelection.setSelectionToElementEnd($target[0]);
					return;
				}
			}else if(command.toLowerCase() === 'formatblock'){
				optionsTagName = options.toLowerCase().replace(/[<>]/ig, '');
				if(optionsTagName.trim() === 'default') {
					optionsTagName = taDefaultWrap;
					options = '<' + taDefaultWrap + '>';
				}
				if(tagName === 'li') {
					$target = $selected.parent();
				}
				else {
					$target = $selected;
				}
				// find the first blockElement
				while(!$target[0].tagName || !$target[0].tagName.match(BLOCKELEMENTS) && !$target.parent().attr('contenteditable')){
					$target = $target.parent();
					/* istanbul ignore next */
					tagName = ($target[0].tagName || '').toLowerCase();
				}
				if(tagName === optionsTagName){
					// $target is wrap element
					_nodes = $target.children();
					var hasBlock = false;
					for(i = 0; i < _nodes.length; i++){
						hasBlock = hasBlock || _nodes[i].tagName.match(BLOCKELEMENTS);
					}
					if(hasBlock){
						$target.after(_nodes);
						next = $target.next();
						$target.remove();
						$target = next;
					}else{
						defaultWrapper.append($target[0].childNodes);
						$target.after(defaultWrapper);
						$target.remove();
						$target = defaultWrapper;
					}
				}else if($target.parent()[0].tagName.toLowerCase() === optionsTagName &&
					!$target.parent().hasClass('ta-bind')){
					//unwrap logic for parent
					var blockElement = $target.parent();
					var contents = blockElement.contents();
					for(i = 0; i < contents.length; i ++){
						/* istanbul ignore next: can't test - some wierd thing with how phantomjs works */
						if(blockElement.parent().hasClass('ta-bind') && contents[i].nodeType === 3){
							defaultWrapper = angular.element('<' + taDefaultWrap + '>');
							defaultWrapper[0].innerHTML = contents[i].outerHTML;
							contents[i] = defaultWrapper[0];
						}
						blockElement.parent()[0].insertBefore(contents[i], blockElement[0]);
					}
					blockElement.remove();
				}else if(tagName.match(LISTELEMENTS)){
					// wrapping a list element
					$target.wrap(options);
				}else{
					// default wrap behaviour
					_nodes = taSelection.getOnlySelectedElements();
					if(_nodes.length === 0) {
						// no nodes at all....
						_nodes = [$target[0]];
					}
					// find the parent block element if any of the nodes are inline or text
					for(i = 0; i < _nodes.length; i++){
						if(_nodes[i].nodeType === 3 || !_nodes[i].tagName.match(BLOCKELEMENTS)){
							while(_nodes[i].nodeType === 3 || !_nodes[i].tagName || !_nodes[i].tagName.match(BLOCKELEMENTS)){
								_nodes[i] = _nodes[i].parentNode;
							}
						}
					}
					// remove any duplicates from the array of _nodes!
					_nodes = _nodes.filter(function(value, index, self) {
						return self.indexOf(value) === index;
					});
					// remove all whole taTextElement if it is here... unless it is the only element!
					if (_nodes.length>1) {
						_nodes = _nodes.filter(function (value, index, self) {
							return !(value.nodeName.toLowerCase() === 'div' && /^taTextElement/.test(value.id));
						});
					}
					if(angular.element(_nodes[0]).hasClass('ta-bind')){
						$target = angular.element(options);
						$target[0].innerHTML = _nodes[0].innerHTML;
						_nodes[0].innerHTML = $target[0].outerHTML;
					}else if(optionsTagName === 'blockquote'){
						// blockquotes wrap other block elements
						html = '';
						for(i = 0; i < _nodes.length; i++){
							html += _nodes[i].outerHTML;
						}
						$target = angular.element(options);
						$target[0].innerHTML = html;
						_nodes[0].parentNode.insertBefore($target[0],_nodes[0]);
						for(i = _nodes.length - 1; i >= 0; i--){
							/* istanbul ignore else:  */
							if(_nodes[i].parentNode) _nodes[i].parentNode.removeChild(_nodes[i]);
						}
					}
					else {
						// regular block elements replace other block elements
						for(i = 0; i < _nodes.length; i++){
							var newBlock = turnBlockIntoBlocks(_nodes[i], options);
							if (_nodes[i] === $target[0]) {
								$target = angular.element(newBlock);
							}
						}
					}
				}
				taSelection.setSelectionToElementEnd($target[0]);
				// looses focus when we have the whole container selected and no text!
				// refocus on the shown display element, this fixes a bug when using firefox
				$target[0].focus();
				return;
			}else if(command.toLowerCase() === 'createlink'){
				/* istanbul ignore next: firefox specific fix */
				if (taSelection.getSelectionElement().tagName.toLowerCase() === 'a') {
					// already a link!!! we are just replacing it...
					taSelection.getSelectionElement().href = options;
					return;
				}

				var tagBegin = '<a href="' + options + '" target="' +
						(defaultTagAttributes.a.target ? defaultTagAttributes.a.target : '') +
						'">',
					tagEnd = '</a>',
					_selection = taSelection.getSelection();
				if(_selection.collapsed){
					// insert text at selection, then select then just let normal exec-command run
					taSelection.insertHtml(tagBegin + options + tagEnd, topNode);
				}else if(rangy.getSelection().getRangeAt(0).canSurroundContents()){
					var node = angular.element(tagBegin + tagEnd)[0];
					rangy.getSelection().getRangeAt(0).surroundContents(node);
				}
				return;
			}else if(command.toLowerCase() === 'inserthtml'){
				taSelection.insertHtml(options, topNode);
				return;
			}
			try{
				$document[0].execCommand(command, showUI, options);
			}catch(e){}
		};
	};
}]).service('taSelection', ['$document', 'taDOM', '$log',
/* istanbul ignore next: all browser specifics and PhantomJS dosen't seem to support half of it */
function($document, taDOM, $log){
	// need to dereference the document else the calls don't work correctly
	var _document = $document[0];
	var brException = function (element, offset) {
		/* check if selection is a BR element at the beginning of a container. If so, get
		* the parentNode instead.
		* offset should be zero in this case. Otherwise, return the original
		* element.
		*/
		if (element.tagName && element.tagName.match(/^br$/i) && offset === 0 && !element.previousSibling) {
            return {
                element: element.parentNode,
                offset: 0
            };
		} else {
			return {
				element: element,
				offset: offset
			};
		}
	};
	var api = {
		getSelection: function(){
			var range = rangy.getSelection().getRangeAt(0);
			var container = range.commonAncestorContainer;
            var selection = {
				start: brException(range.startContainer, range.startOffset),
				end: brException(range.endContainer, range.endOffset),
				collapsed: range.collapsed
			};
            // This has problems under Firefox.
            // On Firefox with
            // <p>Try me !</p>
            // <ul>
            // <li>line 1</li>
            // <li>line 2</li>
            // </ul>
            // <p>line 3</p>
            // <ul>
            // <li>line 4</li>
            // <li>line 5</li>
            // </ul>
            // <p>Hello textAngular</p>
            // WITH the cursor after the 3 on line 3, it gets the commonAncestorContainer as:
            // <TextNode textContent='line 3'>
            // AND Chrome gets the commonAncestorContainer as:
            // <p>line 3</p>
            //
			// Check if the container is a text node and return its parent if so
            // unless this is the whole taTextElement.  If so we return the textNode
			if (container.nodeType === 3) {
                if (container.parentNode.nodeName.toLowerCase() === 'div' &&
                    /^taTextElement/.test(container.parentNode.id)) {
                    // textNode where the parent is the whole <div>!!!
					//console.log('textNode ***************** container:', container);
                } else {
                    container = container.parentNode;
                }
            }
			if (container.nodeName.toLowerCase() === 'div' &&
				/^taTextElement/.test(container.id)) {
				//console.log('*********taTextElement************');
				//for (var i=0; i<container.childNodes.length; i++) {
				//	console.log(i, container.childNodes[i]);
				//}
				//console.log('getSelection start: end:', selection.start.offset, selection.end.offset);
				//console.log('commonAncestorContainer:', container);
				// fix this to be the <textNode>
				selection.end.element = selection.start.element = selection.container = container.childNodes[selection.start.offset];
				selection.start.offset = selection.end.offset = 0;
				selection.collapsed=true;
			} else {
				if (container.parentNode === selection.start.element ||
					container.parentNode === selection.end.element) {
					selection.container = container.parentNode;
				} else {
					selection.container = container;
				}
			}
			//console.log('***selection container:', selection.container);
			return selection;
		},
/* NOT FUNCTIONAL YET
        // under Firefox, we may have a selection that needs to be normalized
        isSelectionContainerWhole_taTextElement: function (){
            var range = rangy.getSelection().getRangeAt(0);
            var container = range.commonAncestorContainer;
            if (container.nodeName.toLowerCase() === 'div' &&
                /^taTextElement/.test(container.id)) {
                // container is the whole taTextElement
                return true;
            }
            return false;
        },
		setNormalizedSelection: function (){
			var range = rangy.getSelection().getRangeAt(0);
			var container = range.commonAncestorContainer;
			console.log(range);
			console.log(container.childNodes);
			if (range.collapsed) {
				// we know what to do...
				console.log(container.childNodes[range.startOffset]);
				api.setSelectionToElementStart(container.childNodes[range.startOffset]);
			}
		},
*/
		getOnlySelectedElements: function(){
			var range = rangy.getSelection().getRangeAt(0);
			var container = range.commonAncestorContainer;
			// Node.TEXT_NODE === 3
			// Node.ELEMENT_NODE === 1
			// Node.COMMENT_NODE === 8
			// Check if the container is a text node and return its parent if so
			container = container.nodeType === 3 ? container.parentNode : container;
			// get the nodes in the range that are ELEMENT_NODE and are children of the container
			// in this range...
			return range.getNodes([1], function(node){
				return node.parentNode === container;
			});
		},
		// this includes the container element if all children are selected
		getAllSelectedElements: function(){
			var range = rangy.getSelection().getRangeAt(0);
			var container = range.commonAncestorContainer;
			// Node.TEXT_NODE === 3
			// Node.ELEMENT_NODE === 1
			// Node.COMMENT_NODE === 8
			// Check if the container is a text node and return its parent if so
			container = container.nodeType === 3 ? container.parentNode : container;
			// get the nodes in the range that are ELEMENT_NODE and are children of the container
			// in this range...
			var selectedNodes = range.getNodes([1], function(node){
				return node.parentNode === container;
			});
			var innerHtml = container.innerHTML;
			// remove the junk that rangy has put down
			innerHtml = innerHtml.replace(/<span id=.selectionBoundary[^>]+>\ufeff?<\/span>/ig, '');
			//console.log(innerHtml);
			//console.log(range.toHtml());
			//console.log(innerHtml === range.toHtml());
			if (innerHtml === range.toHtml() &&
				// not the whole taTextElement
				(!(container.nodeName.toLowerCase() === 'div' &&  /^taTextElement/.test(container.id)))
			) {
				var arr = [];
				for(var i = selectedNodes.length; i--; arr.unshift(selectedNodes[i]));
				selectedNodes = arr;
				selectedNodes.push(container);
				//$log.debug(selectedNodes);
			}
			return selectedNodes;
		},
		// Some basic selection functions
		getSelectionElement: function () {
			return api.getSelection().container;
		},
		setSelection: function(el, start, end){
			var range = rangy.createRange();

			range.setStart(el, start);
			range.setEnd(el, end);

			rangy.getSelection().setSingleRange(range);
		},
		setSelectionBeforeElement: function (el){
			var range = rangy.createRange();

			range.selectNode(el);
			range.collapse(true);

			rangy.getSelection().setSingleRange(range);
		},
		setSelectionAfterElement: function (el){
			var range = rangy.createRange();

			range.selectNode(el);
			range.collapse(false);

			rangy.getSelection().setSingleRange(range);
		},
		setSelectionToElementStart: function (el){
			var range = rangy.createRange();

			range.selectNodeContents(el);
			range.collapse(true);

			rangy.getSelection().setSingleRange(range);
		},
		setSelectionToElementEnd: function (el){
			var range = rangy.createRange();

			range.selectNodeContents(el);
			range.collapse(false);

			if(el.childNodes && el.childNodes[el.childNodes.length - 1] && el.childNodes[el.childNodes.length - 1].nodeName === 'br'){
				range.startOffset = range.endOffset = range.startOffset - 1;
			}
			rangy.getSelection().setSingleRange(range);
		},
		// from http://stackoverflow.com/questions/6690752/insert-html-at-caret-in-a-contenteditable-div
		// topNode is the contenteditable normally, all manipulation MUST be inside this.
		insertHtml: function(html, topNode, rangeObj){
			var parent, secondParent, _childI, nodes, i, lastNode, _tempFrag;
			var element = angular.element("<div>" + html + "</div>");
			var range = rangeObj || rangy.getSelection().getRangeAt(0);
			var frag = _document.createDocumentFragment();
			var children = element[0].childNodes;
			var isInline = true;


			if(children.length > 0){
				// NOTE!! We need to do the following:
				// check for blockelements - if they exist then we have to split the current element in half (and all others up to the closest block element) and insert all children in-between.
				// If there are no block elements, or there is a mixture we need to create textNodes for the non wrapped text (we don't want them spans messing up the picture).
				nodes = [];
				for(_childI = 0; _childI < children.length; _childI++){
					if(!(
						(children[_childI].nodeName.toLowerCase() === 'p' && children[_childI].innerHTML.trim() === '') || // empty p element
						(children[_childI].nodeType === 3 && children[_childI].nodeValue.trim() === '') // empty text node
					)){
						isInline = isInline && !BLOCKELEMENTS.test(children[_childI].nodeName);
						nodes.push(children[_childI]);
					}
				}
				for(var _n = 0; _n < nodes.length; _n++) lastNode = frag.appendChild(nodes[_n]);
				if(!isInline && range.collapsed && /^(|<br(|\/)>)$/i.test(range.startContainer.innerHTML)) range.selectNode(range.startContainer);
			}else{
				isInline = true;
				// paste text of some sort
				lastNode = frag = _document.createTextNode(html);
			}

			// Other Edge case - selected data spans multiple blocks.
			if(isInline){
				range.deleteContents();
			}else{ // not inline insert
				if(range.collapsed && range.startContainer !== topNode){
					if(range.startContainer.innerHTML && range.startContainer.innerHTML.match(/^<[^>]*>$/i)){
						// this log is to catch when innerHTML is something like `<img ...>`
						parent = range.startContainer;
						if(range.startOffset === 1){
							// before single tag
							range.setStartAfter(parent);
							range.setEndAfter(parent);
						}else{
							// after single tag
							range.setStartBefore(parent);
							range.setEndBefore(parent);
						}
					}else{
						// split element into 2 and insert block element in middle
						if(range.startContainer.nodeType === 3 && range.startContainer.parentNode !== topNode){ // if text node
							parent = range.startContainer.parentNode;
							secondParent = parent.cloneNode();
							// split the nodes into two lists - before and after, splitting the node with the selection into 2 text nodes.
							taDOM.splitNodes(parent.childNodes, parent, secondParent, range.startContainer, range.startOffset);

							// Escape out of the inline tags like b
							while(!VALIDELEMENTS.test(parent.nodeName)){
								angular.element(parent).after(secondParent);
								parent = parent.parentNode;
								var _lastSecondParent = secondParent;
								secondParent = parent.cloneNode();
								// split the nodes into two lists - before and after, splitting the node with the selection into 2 text nodes.
								taDOM.splitNodes(parent.childNodes, parent, secondParent, _lastSecondParent);
							}
						}else{
							parent = range.startContainer;
							secondParent = parent.cloneNode();
							taDOM.splitNodes(parent.childNodes, parent, secondParent, undefined, undefined, range.startOffset);
						}

						angular.element(parent).after(secondParent);
						// put cursor to end of inserted content
						//console.log('setStartAfter', parent);
						range.setStartAfter(parent);
						range.setEndAfter(parent);

						if(/^(|<br(|\/)>)$/i.test(parent.innerHTML.trim())){
							range.setStartBefore(parent);
							range.setEndBefore(parent);
							angular.element(parent).remove();
						}
						if(/^(|<br(|\/)>)$/i.test(secondParent.innerHTML.trim())) angular.element(secondParent).remove();
						if(parent.nodeName.toLowerCase() === 'li'){
							_tempFrag = _document.createDocumentFragment();
							for(i = 0; i < frag.childNodes.length; i++){
								element = angular.element('<li>');
								taDOM.transferChildNodes(frag.childNodes[i], element[0]);
								taDOM.transferNodeAttributes(frag.childNodes[i], element[0]);
								_tempFrag.appendChild(element[0]);
							}
							frag = _tempFrag;
							if(lastNode){
								lastNode = frag.childNodes[frag.childNodes.length - 1];
								lastNode = lastNode.childNodes[lastNode.childNodes.length - 1];
							}
						}
					}
				}else{
					range.deleteContents();
				}
			}

			range.insertNode(frag);

			if(lastNode){
				api.setSelectionToElementEnd(lastNode);
			}
		}
	};
	return api;
}]).service('taDOM', function(){
	var taDOM = {
		// recursive function that returns an array of angular.elements that have the passed attribute set on them
		getByAttribute: function(element, attribute){
			var resultingElements = [];
			var childNodes = element.children();
			if(childNodes.length){
				angular.forEach(childNodes, function(child){
					resultingElements = resultingElements.concat(taDOM.getByAttribute(angular.element(child), attribute));
				});
			}
			if(element.attr(attribute) !== undefined) resultingElements.push(element);
			return resultingElements;
		},

		transferChildNodes: function(source, target){
			// clear out target
			target.innerHTML = '';
			while(source.childNodes.length > 0) target.appendChild(source.childNodes[0]);
			return target;
		},

		splitNodes: function(nodes, target1, target2, splitNode, subSplitIndex, splitIndex){
			if(!splitNode && isNaN(splitIndex)) throw new Error('taDOM.splitNodes requires a splitNode or splitIndex');
			var startNodes = document.createDocumentFragment();
			var endNodes = document.createDocumentFragment();
			var index = 0;

			while(nodes.length > 0 && (isNaN(splitIndex) || splitIndex !== index) && nodes[0] !== splitNode){
				startNodes.appendChild(nodes[0]); // this removes from the nodes array (if proper childNodes object.
				index++;
			}

			if(!isNaN(subSplitIndex) && subSplitIndex >= 0 && nodes[0]){
				startNodes.appendChild(document.createTextNode(nodes[0].nodeValue.substring(0, subSplitIndex)));
				nodes[0].nodeValue = nodes[0].nodeValue.substring(subSplitIndex);
			}
			while(nodes.length > 0) endNodes.appendChild(nodes[0]);

			taDOM.transferChildNodes(startNodes, target1);
			taDOM.transferChildNodes(endNodes, target2);
		},

		transferNodeAttributes: function(source, target){
			for(var i = 0; i < source.attributes.length; i++) target.setAttribute(source.attributes[i].name, source.attributes[i].value);
			return target;
		}
	};
	return taDOM;
});
angular.module('textAngular.validators', [])
.directive('taMaxText', function(){
	return {
		restrict: 'A',
		require: 'ngModel',
		link: function(scope, elem, attrs, ctrl){
			var max = parseInt(scope.$eval(attrs.taMaxText));
			if (isNaN(max)){
				throw('Max text must be an integer');
			}
			attrs.$observe('taMaxText', function(value){
				max = parseInt(value);
				if (isNaN(max)){
					throw('Max text must be an integer');
				}
				if (ctrl.$dirty){
					ctrl.$validate();
				}
			});
			ctrl.$validators.taMaxText = function(viewValue){
				var source = angular.element('<div/>');
				source.html(viewValue);
				return source.text().length <= max;
			};
		}
	};
}).directive('taMinText', function(){
	return {
		restrict: 'A',
		require: 'ngModel',
		link: function(scope, elem, attrs, ctrl){
			var min = parseInt(scope.$eval(attrs.taMinText));
			if (isNaN(min)){
				throw('Min text must be an integer');
			}
			attrs.$observe('taMinText', function(value){
				min = parseInt(value);
				if (isNaN(min)){
					throw('Min text must be an integer');
				}
				if (ctrl.$dirty){
					ctrl.$validate();
				}
			});
			ctrl.$validators.taMinText = function(viewValue){
				var source = angular.element('<div/>');
				source.html(viewValue);
				return !source.text().length || source.text().length >= min;
			};
		}
	};
});
angular.module('textAngular.taBind', ['textAngular.factories', 'textAngular.DOM'])
.service('_taBlankTest', [function(){
	return function(_blankVal){
		// we radically restructure this code.
		// what was here before was incredibly fragile.
		// What we do now is to check that the html is non-blank visually
		// which we check by looking at html->text
		if(!_blankVal) return true;
		// find first non-tag match - ie start of string or after tag that is not whitespace
		// var t0 = performance.now();
		// Takes a small fraction of a mSec to do this...
		var _text_ = stripHtmlToText(_blankVal);
		// var t1 = performance.now();
		// console.log('Took', (t1 - t0).toFixed(4), 'milliseconds to generate:');
		if (_text_=== '') {
			// img generates a visible item so it is not blank!
			if (/<img[^>]+>/.test(_blankVal)) {
				return false;
			}
			return true;
		} else {
			return false;
		}
	};
}])
.directive('taButton', [function(){
	return {
		link: function(scope, element, attrs){
			element.attr('unselectable', 'on');
			element.on('mousedown', function(e, eventData){
				/* istanbul ignore else: this is for catching the jqLite testing*/
				if(eventData) angular.extend(e, eventData);
				// this prevents focusout from firing on the editor when clicking toolbar buttons
				e.preventDefault();
				return false;
			});
		}
	};
}])
.directive('taBind', [
		'taSanitize', '$timeout', '$document', 'taFixChrome', 'taBrowserTag',
		'taSelection', 'taSelectableElements', 'taApplyCustomRenderers', 'taOptions',
		'_taBlankTest', '$parse', 'taDOM', 'textAngularManager',
		function(
			taSanitize, $timeout, $document, taFixChrome, taBrowserTag,
			taSelection, taSelectableElements, taApplyCustomRenderers, taOptions,
			_taBlankTest, $parse, taDOM, textAngularManager){
	// Uses for this are textarea or input with ng-model and ta-bind='text'
	// OR any non-form element with contenteditable="contenteditable" ta-bind="html|text" ng-model
	return {
		priority: 2, // So we override validators correctly
		require: ['ngModel','?ngModelOptions'],
		link: function(scope, element, attrs, controller){
			var ngModel = controller[0];
			var ngModelOptions = controller[1] || {};
			// the option to use taBind on an input or textarea is required as it will sanitize all input into it correctly.
			var _isContentEditable = element.attr('contenteditable') !== undefined && element.attr('contenteditable');
			var _isInputFriendly = _isContentEditable || element[0].tagName.toLowerCase() === 'textarea' || element[0].tagName.toLowerCase() === 'input';
			var _isReadonly = false;
			var _focussed = false;
			var _skipRender = false;
			var _disableSanitizer = attrs.taUnsafeSanitizer || taOptions.disableSanitizer;
			var _lastKey;
			// see http://www.javascripter.net/faq/keycodes.htm for good information
			// NOTE Mute On|Off 173 (Opera MSIE Safari Chrome) 181 (Firefox)
			// BLOCKED_KEYS are special keys...
			// Tab, pause/break, CapsLock, Esc, Page Up, End, Home,
			// Left arrow, Up arrow, Right arrow, Down arrow, Insert, Delete,
			// f1, f2, f3, f4, f5, f6, f7, f8, f9, f10, f11, f12
			// NumLock, ScrollLock
			var BLOCKED_KEYS = /^(9|19|20|27|33|34|35|36|37|38|39|40|45|112|113|114|115|116|117|118|119|120|121|122|123|144|145)$/i;
			// UNDO_TRIGGER_KEYS - spaces, enter, delete, backspace, all punctuation
			// Backspace, Enter, Space, Delete, (; :) (Firefox), (= +) (Firefox),
			// Numpad +, Numpad -, (; :), (= +),
			// (, <), (- _), (. >), (/ ?), (` ~), ([ {), (\ |), (] }), (' ")
			// NOTE - Firefox: 173 = (- _) -- adding this to UNDO_TRIGGER_KEYS
			var UNDO_TRIGGER_KEYS = /^(8|13|32|46|59|61|107|109|173|186|187|188|189|190|191|192|219|220|221|222)$/i;
			var _pasteHandler;

			// defaults to the paragraph element, but we need the line-break or it doesn't allow you to type into the empty element
			// non IE is '<p><br/></p>', ie is '<p></p>' as for once IE gets it correct...
			var _defaultVal, _defaultTest;

			var _CTRL_KEY = 0x0001;
			var _META_KEY = 0x0002;
			var _ALT_KEY = 0x0004;
			var _SHIFT_KEY = 0x0008;
			// map events to special keys...
			// mappings is an array of maps from events to specialKeys as declared in textAngularSetup
			var _keyMappings = [
				//		ctrl/command + z
				{
					specialKey: 'UndoKey',
					forbiddenModifiers: _ALT_KEY + _SHIFT_KEY,
					mustHaveModifiers: [_META_KEY + _CTRL_KEY],
					keyCode: 90
				},
				//		ctrl/command + shift + z
				{
					specialKey: 'RedoKey',
					forbiddenModifiers: _ALT_KEY,
					mustHaveModifiers: [_META_KEY + _CTRL_KEY, _SHIFT_KEY],
					keyCode: 90
				},
				//		ctrl/command + y
				{
					specialKey: 'RedoKey',
					forbiddenModifiers: _ALT_KEY + _SHIFT_KEY,
					mustHaveModifiers: [_META_KEY + _CTRL_KEY],
					keyCode: 89
				},
				//		TabKey
				{
					specialKey: 'TabKey',
					forbiddenModifiers: _META_KEY + _SHIFT_KEY + _ALT_KEY + _CTRL_KEY,
					mustHaveModifiers: [],
					keyCode: 9
				},
				//		shift + TabKey
				{
					specialKey: 'ShiftTabKey',
					forbiddenModifiers: _META_KEY + _ALT_KEY + _CTRL_KEY,
					mustHaveModifiers: [_SHIFT_KEY],
					keyCode: 9
				}
			];
			function _mapKeys(event) {
				var specialKey;
				_keyMappings.forEach(function (map){
					if (map.keyCode === event.keyCode) {
						var netModifiers = (event.metaKey ? _META_KEY: 0) +
							(event.ctrlKey ? _CTRL_KEY: 0) +
							(event.shiftKey ? _SHIFT_KEY: 0) +
							(event.altKey ? _ALT_KEY: 0);
						if (map.forbiddenModifiers & netModifiers) return;
						if (map.mustHaveModifiers.every(function (modifier) { return netModifiers & modifier; })){
							specialKey = map.specialKey;
						}
					}
				});
				return specialKey;
			}

			// set the default to be a paragraph value
			if(attrs.taDefaultWrap === undefined) attrs.taDefaultWrap = 'p';
			/* istanbul ignore next: ie specific test */
			if(attrs.taDefaultWrap === ''){
				_defaultVal = '';
				_defaultTest = (_browserDetect.ie === undefined)? '<div><br></div>' : (_browserDetect.ie >= 11)? '<p><br></p>' : (_browserDetect.ie <= 8)? '<P>&nbsp;</P>' : '<p>&nbsp;</p>';
			}else{
				_defaultVal = (_browserDetect.ie === undefined || _browserDetect.ie >= 11)?
					'<' + attrs.taDefaultWrap + '><br></' + attrs.taDefaultWrap + '>' :
					(_browserDetect.ie <= 8)?
						'<' + attrs.taDefaultWrap.toUpperCase() + '></' + attrs.taDefaultWrap.toUpperCase() + '>' :
						'<' + attrs.taDefaultWrap + '></' + attrs.taDefaultWrap + '>';
				_defaultTest = (_browserDetect.ie === undefined || _browserDetect.ie >= 11)?
					'<' + attrs.taDefaultWrap + '><br></' + attrs.taDefaultWrap + '>' :
					(_browserDetect.ie <= 8)?
						'<' + attrs.taDefaultWrap.toUpperCase() + '>&nbsp;</' + attrs.taDefaultWrap.toUpperCase() + '>' :
						'<' + attrs.taDefaultWrap + '>&nbsp;</' + attrs.taDefaultWrap + '>';
			}

			/* istanbul ignore else */
			if(!ngModelOptions.$options) ngModelOptions.$options = {}; // ng-model-options support

			var _ensureContentWrapped = function(value) {
				if (_taBlankTest(value)) return value;
				var domTest = angular.element("<div>" + value + "</div>");
				//console.log('domTest.children().length():', domTest.children().length);
				//console.log('_ensureContentWrapped', domTest.children());
				//console.log(value, attrs.taDefaultWrap);
				if (domTest.children().length === 0) {
					// if we have a <br> and the attrs.taDefaultWrap is a <p> we need to remove the <br>
					//value = value.replace(/<br>/i, '');
					value = "<" + attrs.taDefaultWrap + ">" + value + "</" + attrs.taDefaultWrap + ">";
				} else {
					var _children = domTest[0].childNodes;
					var i;
					var _foundBlockElement = false;
					for (i = 0; i < _children.length; i++) {
						if (_foundBlockElement = _children[i].nodeName.toLowerCase().match(BLOCKELEMENTS)) break;
					}
					if (!_foundBlockElement) {
						value = "<" + attrs.taDefaultWrap + ">" + value + "</" + attrs.taDefaultWrap + ">";
					}
					else{
						value = "";
						for(i = 0; i < _children.length; i++){
							var node = _children[i];
							var nodeName = node.nodeName.toLowerCase();
							//console.log('node#:', i, 'name:', nodeName);
							if(nodeName === '#comment') {
								value += '<!--' + node.nodeValue + '-->';
							} else if(nodeName === '#text') {
								// determine if this is all whitespace, if so, we will leave it as it is.
								// otherwise, we will wrap it as it is
								var text = node.textContent;
								if (!text.trim()) {
									// just whitespace
									value += text;
								} else {
									// not pure white space so wrap in <p>...</p> or whatever attrs.taDefaultWrap is set to.
									value += "<" + attrs.taDefaultWrap + ">" + text + "</" + attrs.taDefaultWrap + ">";
								}
							} else if(!nodeName.match(BLOCKELEMENTS)){
								/* istanbul ignore  next: Doesn't seem to trigger on tests */
								var _subVal = (node.outerHTML || node.nodeValue);
								/* istanbul ignore else: Doesn't seem to trigger on tests, is tested though */
								if(_subVal.trim() !== '')
									value += "<" + attrs.taDefaultWrap + ">" + _subVal + "</" + attrs.taDefaultWrap + ">";
								else value += _subVal;
							} else {
								value += node.outerHTML;
							}
							//console.log(value);
						}
					}
				}
				//console.log(value);
				return value;
			};

			if(attrs.taPaste) {
				_pasteHandler = $parse(attrs.taPaste);
			}

			element.addClass('ta-bind');

			var _undoKeyupTimeout;

			scope['$undoManager' + (attrs.id || '')] = ngModel.$undoManager = {
				_stack: [],
				_index: 0,
				_max: 1000,
				push: function(value){
					if((typeof value === "undefined" || value === null) ||
						((typeof this.current() !== "undefined" && this.current() !== null) && value === this.current())) return value;
					if(this._index < this._stack.length - 1){
						this._stack = this._stack.slice(0,this._index+1);
					}
					this._stack.push(value);
					if(_undoKeyupTimeout) $timeout.cancel(_undoKeyupTimeout);
					if(this._stack.length > this._max) this._stack.shift();
					this._index = this._stack.length - 1;
					return value;
				},
				undo: function(){
					return this.setToIndex(this._index-1);
				},
				redo: function(){
					return this.setToIndex(this._index+1);
				},
				setToIndex: function(index){
					if(index < 0 || index > this._stack.length - 1){
						return undefined;
					}
					this._index = index;
					return this.current();
				},
				current: function(){
					return this._stack[this._index];
				}
			};

			// in here we are undoing the converts used elsewhere to prevent the < > and & being displayed when they shouldn't in the code.
			var _compileHtml = function(){
				if(_isContentEditable) {
					return element[0].innerHTML;
				}
				if(_isInputFriendly) {
					return element.val();
				}
				throw ('textAngular Error: attempting to update non-editable taBind');
			};

			var selectorClickHandler = function(event){
				// emit the element-select event, pass the element
				scope.$emit('ta-element-select', this);
				event.preventDefault();
				return false;
			};

			//used for updating when inserting wrapped elements
			var _reApplyOnSelectorHandlers = scope['reApplyOnSelectorHandlers' + (attrs.id || '')] = function(){
				/* istanbul ignore else */
				if(!_isReadonly) angular.forEach(taSelectableElements, function(selector){
					// check we don't apply the handler twice
					element.find(selector)
						.off('click', selectorClickHandler)
						.on('click', selectorClickHandler);
				});
			};

			var _setViewValue = function(_val, triggerUndo, skipRender){
				_skipRender = skipRender || false;
				if(typeof triggerUndo === "undefined" || triggerUndo === null) triggerUndo = true && _isContentEditable; // if not contentEditable then the native undo/redo is fine
				if(typeof _val === "undefined" || _val === null) _val = _compileHtml();
				if(_taBlankTest(_val)){
					// this avoids us from tripping the ng-pristine flag if we click in and out with out typing
					if(ngModel.$viewValue !== '') ngModel.$setViewValue('');
					if(triggerUndo && ngModel.$undoManager.current() !== '') ngModel.$undoManager.push('');
				}else{
					_reApplyOnSelectorHandlers();
					if(ngModel.$viewValue !== _val){
						ngModel.$setViewValue(_val);
						if(triggerUndo) ngModel.$undoManager.push(_val);
					}
				}
				ngModel.$render();
			};

			var _setInnerHTML = function(newval){
				element[0].innerHTML = newval;
			};

			var _redoUndoTimeout;
			var _undo = scope['$undoTaBind' + (attrs.id || '')] = function(){
				/* istanbul ignore else: can't really test it due to all changes being ignored as well in readonly */
				if(!_isReadonly && _isContentEditable){
					var content = ngModel.$undoManager.undo();
					if(typeof content !== "undefined" && content !== null){
						_setInnerHTML(content);
						_setViewValue(content, false);
						if(_redoUndoTimeout) $timeout.cancel(_redoUndoTimeout);
						_redoUndoTimeout = $timeout(function(){
							element[0].focus();
							taSelection.setSelectionToElementEnd(element[0]);
						}, 1);
					}
				}
			};

			var _redo = scope['$redoTaBind' + (attrs.id || '')] = function(){
				/* istanbul ignore else: can't really test it due to all changes being ignored as well in readonly */
				if(!_isReadonly && _isContentEditable){
					var content = ngModel.$undoManager.redo();
					if(typeof content !== "undefined" && content !== null){
						_setInnerHTML(content);
						_setViewValue(content, false);
						/* istanbul ignore next */
						if(_redoUndoTimeout) $timeout.cancel(_redoUndoTimeout);
						_redoUndoTimeout = $timeout(function(){
							element[0].focus();
							taSelection.setSelectionToElementEnd(element[0]);
						}, 1);
					}
				}
			};

			//used for updating when inserting wrapped elements
			scope['updateTaBind' + (attrs.id || '')] = function(){
				if(!_isReadonly) _setViewValue(undefined, undefined, true);
			};

			// catch DOM XSS via taSanitize
			// Sanitizing both ways is identical
			var _sanitize = function(unsafe){
				return (ngModel.$oldViewValue = taSanitize(taFixChrome(unsafe), ngModel.$oldViewValue, _disableSanitizer));
			};

			// trigger the validation calls
			if(element.attr('required')) ngModel.$validators.required = function(modelValue, viewValue) {
				return !_taBlankTest(modelValue || viewValue);
			};
			// parsers trigger from the above keyup function or any other time that the viewValue is updated and parses it for storage in the ngModel
			ngModel.$parsers.push(_sanitize);
			ngModel.$parsers.unshift(_ensureContentWrapped);
			// because textAngular is bi-directional (which is awesome) we need to also sanitize values going in from the server
			ngModel.$formatters.push(_sanitize);
			ngModel.$formatters.unshift(_ensureContentWrapped);
			ngModel.$formatters.unshift(function(value){
				return ngModel.$undoManager.push(value || '');
			});

			//this code is used to update the models when data is entered/deleted
			if(_isInputFriendly){
				scope.events = {};
				if(!_isContentEditable){
					// if a textarea or input just add in change and blur handlers, everything else is done by angulars input directive
					element.on('change blur', scope.events.change = scope.events.blur = function(){
						if(!_isReadonly) ngModel.$setViewValue(_compileHtml());
					});

					element.on('keydown', scope.events.keydown = function(event, eventData){
						/* istanbul ignore else: this is for catching the jqLite testing*/
						if(eventData) angular.extend(event, eventData);
						// Reference to http://stackoverflow.com/questions/6140632/how-to-handle-tab-in-textarea
						/* istanbul ignore else: otherwise normal functionality */
						if(event.keyCode === 9){ // tab was pressed
							// get caret position/selection
							var start = this.selectionStart;
							var end = this.selectionEnd;

							var value = element.val();
							if(event.shiftKey){
								// find \t
								var _linebreak = value.lastIndexOf('\n', start), _tab = value.lastIndexOf('\t', start);
								if(_tab !== -1 && _tab >= _linebreak){
									// set textarea value to: text before caret + tab + text after caret
									element.val(value.substring(0, _tab) + value.substring(_tab + 1));

									// put caret at right position again (add one for the tab)
									this.selectionStart = this.selectionEnd = start - 1;
								}
							}else{
								// set textarea value to: text before caret + tab + text after caret
								element.val(value.substring(0, start) + "\t" + value.substring(end));

								// put caret at right position again (add one for the tab)
								this.selectionStart = this.selectionEnd = start + 1;
							}
							// prevent the focus lose
							event.preventDefault();
						}
					});

					var _repeat = function(string, n){
						var result = '';
						for(var _n = 0; _n < n; _n++) result += string;
						return result;
					};

					// add a forEach function that will work on a NodeList, etc..
					var forEach = function (array, callback, scope) {
						for (var i= 0; i<array.length; i++) {
							callback.call(scope, i, array[i]);
						}
					};

					// handle <ul> or <ol> nodes
					var recursiveListFormat = function(listNode, tablevel){
						var _html = '';
						var _subnodes = listNode.childNodes;
						tablevel++;
						// tab out and add the <ul> or <ol> html piece
						_html += _repeat('\t', tablevel-1) + listNode.outerHTML.substring(0, 4);
						forEach(_subnodes, function (index, node) {
							/* istanbul ignore next: browser catch */
							var nodeName = node.nodeName.toLowerCase();
							if (nodeName === '#comment') {
								_html += '<!--' + node.nodeValue + '-->';
								return;
							}
							if (nodeName === '#text') {
								_html += node.textContent;
								return;
							}
							/* istanbul ignore next: not tested, and this was original code -- so not wanting to possibly cause an issue, leaving it... */
							if(!node.outerHTML) {
								// no html to add
								return;
							}
							if(nodeName === 'ul' || nodeName === 'ol') {
								_html += '\n' + recursiveListFormat(node, tablevel);
							}
							else {
								// no reformatting within this subnode, so just do the tabing...
								_html += '\n' + _repeat('\t', tablevel) + node.outerHTML;
							}
						});
						// now add on the </ol> or </ul> piece
						_html += '\n' + _repeat('\t', tablevel-1) + listNode.outerHTML.substring(listNode.outerHTML.lastIndexOf('<'));
						return _html;
					};
					// handle formating of something like:
					// <ol><!--First comment-->
					//  <li>Test Line 1<!--comment test list 1--></li>
					//    <ul><!--comment ul-->
					//      <li>Nested Line 1</li>
					//        <!--comment between nested lines--><li>Nested Line 2</li>
					//    </ul>
					//  <li>Test Line 3</li>
					// </ol>
					ngModel.$formatters.unshift(function(htmlValue){
						// tabulate the HTML so it looks nicer
						//
						// first get a list of the nodes...
						// we do this by using the element parser...
						//
						// doing this -- which is simpiler -- breaks our tests...
						//var _nodes=angular.element(htmlValue);
						var _nodes = angular.element('<div>' + htmlValue + '</div>')[0].childNodes;
						if(_nodes.length > 0){
							// do the reformatting of the layout...
							htmlValue = '';
							forEach(_nodes, function (index, node) {
								var nodeName = node.nodeName.toLowerCase();
								if (nodeName === '#comment') {
									htmlValue += '<!--' + node.nodeValue + '-->';
									return;
								}
								if (nodeName === '#text') {
									htmlValue += node.textContent;
									return;
								}
								/* istanbul ignore next: not tested, and this was original code -- so not wanting to possibly cause an issue, leaving it... */
								if(!node.outerHTML)
								{
									// nothing to format!
									return;
								}
								if(htmlValue.length > 0) {
									// we aready have some content, so drop to a new line
									htmlValue += '\n';
								}
								if(nodeName === 'ul' || nodeName === 'ol') {
									// okay a set of list stuff we want to reformat in a nested way
									htmlValue += '' + recursiveListFormat(node, 0);
								}
								else {
									// just use the original without any additional formating
									htmlValue += '' + node.outerHTML;
								}
							});
						}
						return htmlValue;
					});
				}else{
					// all the code specific to contenteditable divs
					var _processingPaste = false;
					/* istanbul ignore next: phantom js cannot test this for some reason */
					var processpaste = function(text) {
                       var _isOneNote = text!==undefined? text.match(/content=["']*OneNote.File/i): false;
						/* istanbul ignore else: don't care if nothing pasted */
                        //console.log(text);
						if(text && text.trim().length){
							// test paste from word/microsoft product
							if(text.match(/class=["']*Mso(Normal|List)/i) || text.match(/content=["']*Word.Document/i) || text.match(/content=["']*OneNote.File/i)){
								var textFragment = text.match(/<!--StartFragment-->([\s\S]*?)<!--EndFragment-->/i);
								if(!textFragment) textFragment = text;
								else textFragment = textFragment[1];
								textFragment = textFragment.replace(/<o:p>[\s\S]*?<\/o:p>/ig, '').replace(/class=(["']|)MsoNormal(["']|)/ig, '');
								var dom = angular.element("<div>" + textFragment + "</div>");
								var targetDom = angular.element("<div></div>");
								var _list = {
									element: null,
									lastIndent: [],
									lastLi: null,
									isUl: false
								};
								_list.lastIndent.peek = function(){
									var n = this.length;
									if (n>0) return this[n-1];
								};
								var _resetList = function(isUl){
									_list.isUl = isUl;
									_list.element = angular.element(isUl ? "<ul>" : "<ol>");
									_list.lastIndent = [];
									_list.lastIndent.peek = function(){
										var n = this.length;
										if (n>0) return this[n-1];
									};
									_list.lastLevelMatch = null;
								};
								for(var i = 0; i <= dom[0].childNodes.length; i++){
									if(!dom[0].childNodes[i] || dom[0].childNodes[i].nodeName === "#text"){
										continue;
									} else {
										var tagName = dom[0].childNodes[i].tagName.toLowerCase();
										if(tagName !== "p" && tagName !== "h1" && tagName !== "h2" && tagName !== "h3" && tagName !== "h4" && tagName !== "h5" && tagName !== "h6"){
											continue;
										}
									}
									var el = angular.element(dom[0].childNodes[i]);
									var _listMatch = (el.attr('class') || '').match(/MsoList(Bullet|Number|Paragraph)(CxSp(First|Middle|Last)|)/i);

									if(_listMatch){
										if(el[0].childNodes.length < 2 || el[0].childNodes[1].childNodes.length < 1){
											continue;
										}
										var isUl = _listMatch[1].toLowerCase() === "bullet" || (_listMatch[1].toLowerCase() !== "number" && !(/^[^0-9a-z<]*[0-9a-z]+[^0-9a-z<>]</i.test(el[0].childNodes[1].innerHTML) || /^[^0-9a-z<]*[0-9a-z]+[^0-9a-z<>]</i.test(el[0].childNodes[1].childNodes[0].innerHTML)));
										var _indentMatch = (el.attr('style') || '').match(/margin-left:([\-\.0-9]*)/i);
										var indent = parseFloat((_indentMatch)?_indentMatch[1]:0);
										var _levelMatch = (el.attr('style') || '').match(/mso-list:l([0-9]+) level([0-9]+) lfo[0-9+]($|;)/i);
										// prefers the mso-list syntax

										if(_levelMatch && _levelMatch[2]) indent = parseInt(_levelMatch[2]);

										if ((_levelMatch && (!_list.lastLevelMatch || _levelMatch[1] !== _list.lastLevelMatch[1])) || !_listMatch[3] || _listMatch[3].toLowerCase() === "first" || (_list.lastIndent.peek() === null) || (_list.isUl !== isUl && _list.lastIndent.peek() === indent)) {
											_resetList(isUl);
											targetDom.append(_list.element);
										} else if (_list.lastIndent.peek() != null && _list.lastIndent.peek() < indent){
											_list.element = angular.element(isUl ? "<ul>" : "<ol>");
											_list.lastLi.append(_list.element);
										} else if (_list.lastIndent.peek() != null && _list.lastIndent.peek() > indent){
											while(_list.lastIndent.peek() != null && _list.lastIndent.peek() > indent){
												if(_list.element.parent()[0].tagName.toLowerCase() === 'li'){
													_list.element = _list.element.parent();
													continue;
												}else if(/[uo]l/i.test(_list.element.parent()[0].tagName.toLowerCase())){
													_list.element = _list.element.parent();
												}else{ // else it's it should be a sibling
													break;
												}
												_list.lastIndent.pop();
											}
											_list.isUl = _list.element[0].tagName.toLowerCase() === "ul";
											if (isUl !== _list.isUl) {
												_resetList(isUl);
												targetDom.append(_list.element);
											}
										}

										_list.lastLevelMatch = _levelMatch;
										if(indent !== _list.lastIndent.peek()) _list.lastIndent.push(indent);
										_list.lastLi = angular.element("<li>");
										_list.element.append(_list.lastLi);
										_list.lastLi.html(el.html().replace(/<!(--|)\[if !supportLists\](--|)>[\s\S]*?<!(--|)\[endif\](--|)>/ig, ''));
										el.remove();
									}else{
										_resetList(false);
										targetDom.append(el);
									}
								}
								var _unwrapElement = function(node){
									node = angular.element(node);
									for(var _n = node[0].childNodes.length - 1; _n >= 0; _n--) node.after(node[0].childNodes[_n]);
									node.remove();
								};

								angular.forEach(targetDom.find('span'), function(node){
									node.removeAttribute('lang');
									if(node.attributes.length <= 0) _unwrapElement(node);
								});
								angular.forEach(targetDom.find('font'), _unwrapElement);

                                text = targetDom.html();
                                if(_isOneNote){
                                    text = targetDom.html() || dom.html();
                                }
							}else{
								// remove unnecessary chrome insert
								text = text.replace(/<(|\/)meta[^>]*?>/ig, '');
								if(text.match(/<[^>]*?(ta-bind)[^>]*?>/)){
									// entire text-angular or ta-bind has been pasted, REMOVE AT ONCE!!
									if(text.match(/<[^>]*?(text-angular)[^>]*?>/)){
										var _el = angular.element("<div>" + text + "</div>");
										_el.find('textarea').remove();
										var binds = taDOM.getByAttribute(_el, 'ta-bind');
										for(var _b = 0; _b < binds.length; _b++){
											var _target = binds[_b][0].parentNode.parentNode;
											for(var _c = 0; _c < binds[_b][0].childNodes.length; _c++){
												_target.parentNode.insertBefore(binds[_b][0].childNodes[_c], _target);
											}
											_target.parentNode.removeChild(_target);
										}
										text = _el.html().replace('<br class="Apple-interchange-newline">', '');
									}
								}else if(text.match(/^<span/)){
									// in case of pasting only a span - chrome paste, remove them. THis is just some wierd formatting
									// if we remove the '<span class="Apple-converted-space"> </span>' here we destroy the spacing
									// on paste from even ourselves!
									if (!text.match(/<span class=(\"Apple-converted-space\"|\'Apple-converted-space\')>.<\/span>/ig)) {
										text = text.replace(/<(|\/)span[^>]*?>/ig, '');
									}
								}
								// Webkit on Apple tags
								text = text.replace(/<br class="Apple-interchange-newline"[^>]*?>/ig, '').replace(/<span class="Apple-converted-space">( |&nbsp;)<\/span>/ig, '&nbsp;');
							}

							if (/<li(\s.*)?>/i.test(text) && /(<ul(\s.*)?>|<ol(\s.*)?>).*<li(\s.*)?>/i.test(text) === false) {
								// insert missing parent of li element
								text = text.replace(/<li(\s.*)?>.*<\/li(\s.*)?>/i, '<ul>$&</ul>');
							}

							// parse whitespace from plaintext input, starting with preceding spaces that get stripped on paste
							text = text.replace(/^[ |\u00A0]+/gm, function (match) {
								var result = '';
								for (var i = 0; i < match.length; i++) {
									result += '&nbsp;';
								}
								return result;
							}).replace(/\n|\r\n|\r/g, '<br />').replace(/\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;');

							if(_pasteHandler) text = _pasteHandler(scope, {$html: text}) || text;

							text = taSanitize(text, '', _disableSanitizer);

							taSelection.insertHtml(text, element[0]);
							$timeout(function(){
								ngModel.$setViewValue(_compileHtml());
								_processingPaste = false;
								element.removeClass('processing-paste');
							}, 0);
						}else{
							_processingPaste = false;
							element.removeClass('processing-paste');
						}
					};

					element.on('paste', scope.events.paste = function(e, eventData){
						/* istanbul ignore else: this is for catching the jqLite testing*/
						if(eventData) angular.extend(e, eventData);
						if(_isReadonly || _processingPaste){
							e.stopPropagation();
							e.preventDefault();
							return false;
						}

						// Code adapted from http://stackoverflow.com/questions/2176861/javascript-get-clipboard-data-on-paste-event-cross-browser/6804718#6804718
						_processingPaste = true;
						element.addClass('processing-paste');
						var pastedContent;
						var clipboardData = (e.originalEvent || e).clipboardData;
						if (clipboardData && clipboardData.getData && clipboardData.types.length > 0) {// Webkit - get data from clipboard, put into editdiv, cleanup, then cancel event
							var _types = "";
							for(var _t = 0; _t < clipboardData.types.length; _t++){
								_types += " " + clipboardData.types[_t];
							}
							/* istanbul ignore next: browser tests */
							if (/text\/html/i.test(_types)) {
								pastedContent = clipboardData.getData('text/html');
							} else if (/text\/plain/i.test(_types)) {
								pastedContent = clipboardData.getData('text/plain');
							}

							processpaste(pastedContent);
							e.stopPropagation();
							e.preventDefault();
							return false;
						} else {// Everything else - empty editdiv and allow browser to paste content into it, then cleanup
							var _savedSelection = rangy.saveSelection(),
								_tempDiv = angular.element('<div class="ta-hidden-input" contenteditable="true"></div>');
							$document.find('body').append(_tempDiv);
							_tempDiv[0].focus();
							$timeout(function(){
								// restore selection
								rangy.restoreSelection(_savedSelection);
								processpaste(_tempDiv[0].innerHTML);
								element[0].focus();
								_tempDiv.remove();
							}, 0);
						}
					});
					element.on('cut', scope.events.cut = function(e){
						// timeout to next is needed as otherwise the paste/cut event has not finished actually changing the display
						if(!_isReadonly) $timeout(function(){
							ngModel.$setViewValue(_compileHtml());
						}, 0);
						else e.preventDefault();
					});

					element.on('keydown', scope.events.keydown = function(event, eventData){
						/* istanbul ignore else: this is for catching the jqLite testing*/
						if(eventData) angular.extend(event, eventData);
						event.specialKey = _mapKeys(event);
						var userSpecialKey;
						/* istanbul ignore next: difficult to test */
						taOptions.keyMappings.forEach(function (mapping) {
							if (event.specialKey === mapping.commandKeyCode) {
								// taOptions has remapped this binding... so
								// we disable our own
								event.specialKey = undefined;
							}
							if (mapping.testForKey(event)) {
								userSpecialKey = mapping.commandKeyCode;
							}
							if ((mapping.commandKeyCode === 'UndoKey') || (mapping.commandKeyCode === 'RedoKey')) {
								// this is necessary to fully stop the propagation.
								if (!mapping.enablePropagation) {
									event.preventDefault();
								}
							}
						});
						/* istanbul ignore next: difficult to test */
						if (typeof userSpecialKey !== 'undefined') {
							event.specialKey = userSpecialKey;
						}
						/* istanbul ignore next: difficult to test as can't seem to select */
						if ((typeof event.specialKey !== 'undefined') && (
								event.specialKey !== 'UndoKey' || event.specialKey !== 'RedoKey'
							)) {
							event.preventDefault();
							textAngularManager.sendKeyCommand(scope, event);
						}
						/* istanbul ignore else: readonly check */
						if(!_isReadonly){
							if (event.specialKey==='UndoKey') {
								_undo();
								event.preventDefault();
							}
							if (event.specialKey==='RedoKey') {
								_redo();
								event.preventDefault();
							}
							/* istanbul ignore next: difficult to test as can't seem to select */
							if(event.keyCode === 13 && !event.shiftKey){
								var contains = function(a, obj) {
									for (var i = 0; i < a.length; i++) {
										if (a[i] === obj) {
											return true;
										}
									}
									return false;
								};
								var $selection;
								var selection = taSelection.getSelectionElement();
								if(!selection.tagName.match(VALIDELEMENTS)) return;
								var _new = angular.element(_defaultVal);
								// if we are in the last element of a blockquote, or ul or ol and the element is blank
								// we need to pull the element outside of the said type
								var moveOutsideElements = ['blockquote', 'ul', 'ol'];
								if (contains(moveOutsideElements, selection.parentNode.tagName.toLowerCase())) {
									if (/^<br(|\/)>$/i.test(selection.innerHTML.trim()) && !selection.nextSibling) {
										// if last element is blank, pull element outside.
										$selection = angular.element(selection);
										var _parent = $selection.parent();
										_parent.after(_new);
										$selection.remove();
										if (_parent.children().length === 0) _parent.remove();
										taSelection.setSelectionToElementStart(_new[0]);
										event.preventDefault();
									}
									if (/^<[^>]+><br(|\/)><\/[^>]+>$/i.test(selection.innerHTML.trim())) {
										$selection = angular.element(selection);
										$selection.after(_new);
										$selection.remove();
										taSelection.setSelectionToElementStart(_new[0]);
										event.preventDefault();
									}
								}
							}
						}
					});
					var _keyupTimeout;
					element.on('keyup', scope.events.keyup = function(event, eventData){
						/* istanbul ignore else: this is for catching the jqLite testing*/
						if(eventData) angular.extend(event, eventData);
						/* istanbul ignore next: FF specific bug fix */
						if (event.keyCode === 9) {
							var _selection = taSelection.getSelection();
							if(_selection.start.element === element[0] && element.children().length) taSelection.setSelectionToElementStart(element.children()[0]);
							return;
						}
						if(_undoKeyupTimeout) $timeout.cancel(_undoKeyupTimeout);
						if(!_isReadonly && !BLOCKED_KEYS.test(event.keyCode)){
							// if enter - insert new taDefaultWrap, if shift+enter insert <br/>
							if(_defaultVal !== '' && event.keyCode === 13){
								if(!event.shiftKey){
									// new paragraph, br should be caught correctly
									var selection = taSelection.getSelectionElement();
									while(!selection.tagName.match(VALIDELEMENTS) && selection !== element[0]){
										selection = selection.parentNode;
									}

									if(selection.tagName.toLowerCase() !==
										attrs.taDefaultWrap &&
										selection.tagName.toLowerCase() !== 'li' &&
										(selection.innerHTML.trim() === '' || selection.innerHTML.trim() === '<br>')
									) {
										var _new = angular.element(_defaultVal);
										angular.element(selection).replaceWith(_new);
										taSelection.setSelectionToElementStart(_new[0]);
									}
								}
							}
							var val = _compileHtml();
							if(_defaultVal !== '' && (val.trim() === '' || val.trim() === '<br>')){
								_setInnerHTML(_defaultVal);
								taSelection.setSelectionToElementStart(element.children()[0]);
							}else if(val.substring(0, 1) !== '<' && attrs.taDefaultWrap !== ''){
								/* we no longer do this, since there can be comments here and white space
								var _savedSelection = rangy.saveSelection();
								val = _compileHtml();
								val = "<" + attrs.taDefaultWrap + ">" + val + "</" + attrs.taDefaultWrap + ">";
								_setInnerHTML(val);
								rangy.restoreSelection(_savedSelection);
								*/
							}
							var triggerUndo = _lastKey !== event.keyCode && UNDO_TRIGGER_KEYS.test(event.keyCode);
							if(_keyupTimeout) $timeout.cancel(_keyupTimeout);
							_keyupTimeout = $timeout(function() {
								_setViewValue(val, triggerUndo, true);
							}, ngModelOptions.$options.debounce || 400);
							if(!triggerUndo) _undoKeyupTimeout = $timeout(function(){ ngModel.$undoManager.push(val); }, 250);
							_lastKey = event.keyCode;
						}
					});

					element.on('blur', scope.events.blur = function(){
						_focussed = false;
						/* istanbul ignore else: if readonly don't update model */
						if(!_isReadonly){
							_setViewValue(undefined, undefined, true);
						}else{
							_skipRender = true; // don't redo the whole thing, just check the placeholder logic
							ngModel.$render();
						}
					});

					// Placeholders not supported on ie 8 and below
					if(attrs.placeholder && (_browserDetect.ie > 8 || _browserDetect.ie === undefined)){
						var rule;
						if(attrs.id) rule = addCSSRule('#' + attrs.id + '.placeholder-text:before', 'content: "' + attrs.placeholder + '"');
						else throw('textAngular Error: An unique ID is required for placeholders to work');

						scope.$on('$destroy', function(){
							removeCSSRule(rule);
						});
					}

					element.on('focus', scope.events.focus = function(){
						_focussed = true;
						element.removeClass('placeholder-text');
						_reApplyOnSelectorHandlers();
					});

					element.on('mouseup', scope.events.mouseup = function(){
						var _selection = taSelection.getSelection();
						// console.log(5555);
						if(_selection.start.element === element[0] && element.children().length) taSelection.setSelectionToElementStart(element.children()[0]);
					});

					// prevent propagation on mousedown in editor, see #206
					element.on('mousedown', scope.events.mousedown = function(event, eventData){
						/* istanbul ignore else: this is for catching the jqLite testing*/
						// console.log(66666);
						if(eventData) angular.extend(event, eventData);
						event.stopPropagation();
					});
				}
			}

			var fileDropHandler = function(event, eventData){
				/* istanbul ignore else: this is for catching the jqLite testing*/
				event.preventDefault();
				// if(eventData) angular.extend(event, eventData);
				// emit the drop event, pass the element, preventing should be done elsewhere
				// if(!dropFired && !_isReadonly){
				// 	dropFired = true;
				// 	var dataTransfer;
				// 	if(event.originalEvent) dataTransfer = event.originalEvent.dataTransfer;
				// 	else dataTransfer = event.dataTransfer;
				// 	// scope.$emit('ta-drop-event', this, event, dataTransfer);
				// 	$timeout(function(){
				// 		dropFired = false;
				// 		_setViewValue(undefined, undefined, true);
				// 	}, 100);
				// }
			};

			var _renderTimeout;
			var _renderInProgress = false;
			// changes to the model variable from outside the html/text inputs
			ngModel.$render = function(){
				/* istanbul ignore if: Catches rogue renders, hard to replicate in tests */
				if(_renderInProgress) return;
				else _renderInProgress = true;
				// catch model being null or undefined
				var val = ngModel.$viewValue || '';
				// if the editor isn't focused it needs to be updated, otherwise it's receiving user input
				if(!_skipRender){
					/* istanbul ignore else: in other cases we don't care */
					if(_isContentEditable && _focussed){
						// update while focussed
						element.removeClass('placeholder-text');
 						/* istanbul ignore next: don't know how to test this */
						if(_renderTimeout) $timeout.cancel(_renderTimeout);
						_renderTimeout = $timeout(function(){
							/* istanbul ignore if: Can't be bothered testing this... */
							if(!_focussed){
								element[0].focus();
								taSelection.setSelectionToElementEnd(element.children()[element.children().length - 1]);
							}
							_renderTimeout = undefined;
						}, 1);
					}
					if(_isContentEditable){
						// WYSIWYG Mode
						if(attrs.placeholder){
							if(val === ''){
								// blank
								_setInnerHTML(_defaultVal);
							}else{
								// not-blank
								_setInnerHTML(val);
							}
						}else{
							_setInnerHTML((val === '') ? _defaultVal : val);
						}
						// if in WYSIWYG and readOnly we kill the use of links by clicking
						if(!_isReadonly){
							_reApplyOnSelectorHandlers();
							element.on('drop', fileDropHandler);
						}else{
							element.off('drop', fileDropHandler);
						}
					}else if(element[0].tagName.toLowerCase() !== 'textarea' && element[0].tagName.toLowerCase() !== 'input'){
						// make sure the end user can SEE the html code as a display. This is a read-only display element
						_setInnerHTML(taApplyCustomRenderers(val));
					}else{
						// only for input and textarea inputs
						element.val(val);
					}
				}
				if(_isContentEditable && attrs.placeholder){
					if(val === ''){
						if(_focussed) element.removeClass('placeholder-text');
						else element.addClass('placeholder-text');
					}else{
						element.removeClass('placeholder-text');
					}
				}
				_renderInProgress = _skipRender = false;
			};

			if(attrs.taReadonly){
				//set initial value
				_isReadonly = scope.$eval(attrs.taReadonly);
				if(_isReadonly){
					element.addClass('ta-readonly');
					// we changed to readOnly mode (taReadonly='true')
					if(element[0].tagName.toLowerCase() === 'textarea' || element[0].tagName.toLowerCase() === 'input'){
						element.attr('disabled', 'disabled');
					}
					if(element.attr('contenteditable') !== undefined && element.attr('contenteditable')){
						element.removeAttr('contenteditable');
					}
				}else{
					element.removeClass('ta-readonly');
					// we changed to NOT readOnly mode (taReadonly='false')
					if(element[0].tagName.toLowerCase() === 'textarea' || element[0].tagName.toLowerCase() === 'input'){
						element.removeAttr('disabled');
					}else if(_isContentEditable){
						element.attr('contenteditable', 'true');
					}
				}
				// taReadonly only has an effect if the taBind element is an input or textarea or has contenteditable='true' on it.
				// Otherwise it is readonly by default
				scope.$watch(attrs.taReadonly, function(newVal, oldVal){
					if(oldVal === newVal) return;
					if(newVal){
						element.addClass('ta-readonly');
						// we changed to readOnly mode (taReadonly='true')
						if(element[0].tagName.toLowerCase() === 'textarea' || element[0].tagName.toLowerCase() === 'input'){
							element.attr('disabled', 'disabled');
						}
						if(element.attr('contenteditable') !== undefined && element.attr('contenteditable')){
							element.removeAttr('contenteditable');
						}
						// turn ON selector click handlers
						angular.forEach(taSelectableElements, function(selector){
							element.find(selector).on('click', selectorClickHandler);
						});
						element.off('drop', fileDropHandler);
					}else{
						element.removeClass('ta-readonly');
						// we changed to NOT readOnly mode (taReadonly='false')
						if(element[0].tagName.toLowerCase() === 'textarea' || element[0].tagName.toLowerCase() === 'input'){
							element.removeAttr('disabled');
						}else if(_isContentEditable){
							element.attr('contenteditable', 'true');
						}
						// remove the selector click handlers
						angular.forEach(taSelectableElements, function(selector){
							element.find(selector).off('click', selectorClickHandler);
						});
						element.on('drop', fileDropHandler);
					}
					_isReadonly = newVal;
				});
			}

			// Initialise the selectableElements
			// if in WYSIWYG and readOnly we kill the use of links by clicking
			if(_isContentEditable && !_isReadonly){
				angular.forEach(taSelectableElements, function(selector){
					element.find(selector).on('click', selectorClickHandler);
				});
				element.on('drop', fileDropHandler);
			}
		}
	};
}]);

// this global var is used to prevent multiple fires of the drop event. Needs to be global to the textAngular file.
var dropFired = false;
var textAngular = angular.module("textAngular", ['ngSanitize', 'textAngularSetup', 'textAngular.factories', 'textAngular.DOM', 'textAngular.validators', 'textAngular.taBind']); //This makes ngSanitize required

textAngular.config([function(){
	// clear taTools variable. Just catches testing and any other time that this config may run multiple times...
	angular.forEach(taTools, function(value, key){ delete taTools[key];	});
}]);

textAngular.directive("textAngular", [
	'$compile', '$timeout', 'taOptions', 'taSelection', 'taExecCommand',
	'textAngularManager', '$document', '$animate', '$log', '$q', '$parse',
	function($compile, $timeout, taOptions, taSelection, taExecCommand,
		textAngularManager, $document, $animate, $log, $q, $parse){
		return {
			require: '?ngModel',
			scope: {},
			restrict: "EA",
			priority: 2, // So we override validators correctly
			link: function(scope, element, attrs, ngModel){
				// all these vars should not be accessable outside this directive
				var _keydown, _keyup, _keypress, _mouseup, _focusin, _focusout,
					_originalContents, _editorFunctions,
					_serial = (attrs.serial) ? attrs.serial : Math.floor(Math.random() * 10000000000000000),
					_taExecCommand, _resizeMouseDown, _updateSelectedStylesTimeout;

				scope._name = (attrs.name) ? attrs.name : 'textAngularEditor' + _serial;

				var oneEvent = function(_element, event, action){
					$timeout(function(){
						// shim the .one till fixed
						var _func = function(){
							_element.off(event, _func);
							action.apply(this, arguments);
						};
						_element.on(event, _func);
					}, 100);
				};
				_taExecCommand = taExecCommand(attrs.taDefaultWrap);
				// get the settings from the defaults and add our specific functions that need to be on the scope
				angular.extend(scope, angular.copy(taOptions), {
					// wraps the selection in the provided tag / execCommand function. Should only be called in WYSIWYG mode.
					wrapSelection: function(command, opt, isSelectableElementTool){
						// we restore the saved selection that was saved when focus was lost
						/* NOT FUNCTIONAL YET */
						/* textAngularManager.restoreFocusSelection(scope._name, scope); */
						if(command.toLowerCase() === "undo"){
							scope['$undoTaBindtaTextElement' + _serial]();
						}else if(command.toLowerCase() === "redo"){
							scope['$redoTaBindtaTextElement' + _serial]();
						}else{
							// catch errors like FF erroring when you try to force an undo with nothing done
							_taExecCommand(command, false, opt, scope.defaultTagAttributes);
							if(isSelectableElementTool){
								// re-apply the selectable tool events
								scope['reApplyOnSelectorHandlerstaTextElement' + _serial]();
							}
							// refocus on the shown display element, this fixes a display bug when using :focus styles to outline the box.
							// You still have focus on the text/html input it just doesn't show up
							scope.displayElements.text[0].focus();
						}
					},
					showHtml: scope.$eval(attrs.taShowHtml) || false
				});
				// setup the options from the optional attributes
				if(attrs.taFocussedClass)			scope.classes.focussed = attrs.taFocussedClass;
				if(attrs.taTextEditorClass)			scope.classes.textEditor = attrs.taTextEditorClass;
				if(attrs.taHtmlEditorClass)			scope.classes.htmlEditor = attrs.taHtmlEditorClass;
				if(attrs.taDefaultTagAttributes){
					try	{
						//	TODO: This should use angular.merge to enhance functionality once angular 1.4 is required
						angular.extend(scope.defaultTagAttributes, angular.fromJson(attrs.taDefaultTagAttributes));
					} catch (error) {
						$log.error(error);
					}
				}
				// optional setup functions
				if(attrs.taTextEditorSetup)			scope.setup.textEditorSetup = scope.$parent.$eval(attrs.taTextEditorSetup);
				if(attrs.taHtmlEditorSetup)			scope.setup.htmlEditorSetup = scope.$parent.$eval(attrs.taHtmlEditorSetup);
				// optional fileDropHandler function
				if(attrs.taFileDrop)				scope.fileDropHandler = scope.$parent.$eval(attrs.taFileDrop);
				else								scope.fileDropHandler = scope.defaultFileDropHandler;

				_originalContents = element[0].innerHTML;
				// clear the original content
				element[0].innerHTML = '';

				// Setup the HTML elements as variable references for use later
				scope.displayElements = {
					// we still need the hidden input even with a textarea as the textarea may have invalid/old input in it,
					// wheras the input will ALLWAYS have the correct value.
					forminput: angular.element("<input type='hidden' tabindex='-1' style='display: none;'>"),
					html: angular.element("<textarea></textarea>"),
					text: angular.element("<div></div>"),
					// other toolbased elements
					scrollWindow: angular.element("<div class='ta-scroll-window'></div>"),
					popover: angular.element('<div class="popover fade bottom" style="max-width: none; width: 305px;"></div>'),
					popoverArrow: angular.element('<div class="arrow"></div>'),
					popoverContainer: angular.element('<div class="popover-content"></div>'),
					resize: {
						overlay: angular.element('<div class="ta-resizer-handle-overlay"></div>'),
						background: angular.element('<div class="ta-resizer-handle-background"></div>'),
						anchors: [
							angular.element('<div class="ta-resizer-handle-corner ta-resizer-handle-corner-tl"></div>'),
							angular.element('<div class="ta-resizer-handle-corner ta-resizer-handle-corner-tr"></div>'),
							angular.element('<div class="ta-resizer-handle-corner ta-resizer-handle-corner-bl"></div>'),
							angular.element('<div class="ta-resizer-handle-corner ta-resizer-handle-corner-br"></div>')
						],
						info: angular.element('<div class="ta-resizer-handle-info"></div>')
					}
				};

				// Setup the popover
				scope.displayElements.popover.append(scope.displayElements.popoverArrow);
				scope.displayElements.popover.append(scope.displayElements.popoverContainer);
				scope.displayElements.scrollWindow.append(scope.displayElements.popover);

				scope.displayElements.popover.on('mousedown', function(e, eventData){
					/* istanbul ignore else: this is for catching the jqLite testing*/
					if(eventData) angular.extend(e, eventData);
					// this prevents focusout from firing on the editor when clicking anything in the popover
					e.preventDefault();
					return false;
				});

				// define the popover show and hide functions
				scope.showPopover = function(_el){
					scope.displayElements.popover.css('display', 'block');
					scope.reflowPopover(_el);
					$animate.addClass(scope.displayElements.popover, 'in');
					oneEvent($document.find('body'), 'click keyup', function(){scope.hidePopover();});
				};
				scope.reflowPopover = function(_el){
					/* istanbul ignore if: catches only if near bottom of editor */
					if(scope.displayElements.text[0].offsetHeight - 51 > _el[0].offsetTop){
						scope.displayElements.popover.css('top', _el[0].offsetTop + _el[0].offsetHeight + scope.displayElements.scrollWindow[0].scrollTop + 'px');
						scope.displayElements.popover.removeClass('top').addClass('bottom');
					}else{
						scope.displayElements.popover.css('top', _el[0].offsetTop - 54 + scope.displayElements.scrollWindow[0].scrollTop + 'px');
						scope.displayElements.popover.removeClass('bottom').addClass('top');
					}
					var _maxLeft = scope.displayElements.text[0].offsetWidth - scope.displayElements.popover[0].offsetWidth;
					var _targetLeft = _el[0].offsetLeft + (_el[0].offsetWidth / 2.0) - (scope.displayElements.popover[0].offsetWidth / 2.0);
					scope.displayElements.popover.css('left', Math.max(0, Math.min(_maxLeft, _targetLeft)) + 'px');
					scope.displayElements.popoverArrow.css('margin-left', (Math.min(_targetLeft, (Math.max(0, _targetLeft - _maxLeft))) - 11) + 'px');
				};
				scope.hidePopover = function(){
					scope.displayElements.popover.css('display', '');
					scope.displayElements.popoverContainer.attr('style', '');
					scope.displayElements.popoverContainer.attr('class', 'popover-content');
					scope.displayElements.popover.removeClass('in');
				};

				// setup the resize overlay
				scope.displayElements.resize.overlay.append(scope.displayElements.resize.background);
				angular.forEach(scope.displayElements.resize.anchors, function(anchor){ scope.displayElements.resize.overlay.append(anchor);});
				scope.displayElements.resize.overlay.append(scope.displayElements.resize.info);
				scope.displayElements.scrollWindow.append(scope.displayElements.resize.overlay);

				// define the show and hide events
				scope.reflowResizeOverlay = function(_el){
					_el = angular.element(_el)[0];
					scope.displayElements.resize.overlay.css({
						'display': 'block',
						'left': _el.offsetLeft - 5 + 'px',
						'top': _el.offsetTop - 5 + 'px',
						'width': _el.offsetWidth + 10 + 'px',
						'height': _el.offsetHeight + 10 + 'px'
					});
					scope.displayElements.resize.info.text(_el.offsetWidth + ' x ' + _el.offsetHeight);
				};
				/* istanbul ignore next: pretty sure phantomjs won't test this */
				scope.showResizeOverlay = function(_el){
					var _body = $document.find('body');
					_resizeMouseDown = function(event){
						var startPosition = {
							width: parseInt(_el.attr('width')),
							height: parseInt(_el.attr('height')),
							x: event.clientX,
							y: event.clientY
						};
						if(startPosition.width === undefined || isNaN(startPosition.width)) startPosition.width = _el[0].offsetWidth;
						if(startPosition.height === undefined || isNaN(startPosition.height)) startPosition.height = _el[0].offsetHeight;
						scope.hidePopover();
						var ratio = startPosition.height / startPosition.width;
						var mousemove = function(event){
							// calculate new size
							var pos = {
								x: Math.max(0, startPosition.width + (event.clientX - startPosition.x)),
								y: Math.max(0, startPosition.height + (event.clientY - startPosition.y))
							};

							// DEFAULT: the aspect ratio is not locked unless the Shift key is pressed.
							//
							// attribute: ta-resize-force-aspect-ratio -- locks resize into maintaing the aspect ratio
							var bForceAspectRatio = (attrs.taResizeForceAspectRatio !== undefined);
							// attribute: ta-resize-maintain-aspect-ratio=true causes the space ratio to remain locked
							// unless the Shift key is pressed
							var bFlipKeyBinding = attrs.taResizeMaintainAspectRatio;
							var bKeepRatio =  bForceAspectRatio || (bFlipKeyBinding && !event.shiftKey);
							if(bKeepRatio) {
								var newRatio = pos.y / pos.x;
								pos.x = ratio > newRatio ? pos.x : pos.y / ratio;
								pos.y = ratio > newRatio ? pos.x * ratio : pos.y;
							}
							var el = angular.element(_el);
							function roundedMaxVal(val) {
								return Math.round(Math.max(0, val));
							}
							el.css('height', roundedMaxVal(pos.y) + 'px');
							el.css('width', roundedMaxVal(pos.x) + 'px');

							// reflow the popover tooltip
							scope.reflowResizeOverlay(_el);
						};
						_body.on('mousemove', mousemove);
						oneEvent(_body, 'mouseup', function(event){
							event.preventDefault();
							event.stopPropagation();
							_body.off('mousemove', mousemove);
							// at this point, we need to force the model to update! since the css has changed!
							// this fixes bug: #862 - we now hide the popover -- as this seems more consitent.
							// there are still issues under firefox, the window does not repaint. -- not sure
							// how best to resolve this, but clicking anywhere works.
							scope.$apply(function (){
								scope.hidePopover();
								scope.updateTaBindtaTextElement();
							}, 100);
						});
						event.stopPropagation();
						event.preventDefault();
					};

					scope.displayElements.resize.anchors[3].off('mousedown');
					scope.displayElements.resize.anchors[3].on('mousedown', _resizeMouseDown);

					scope.reflowResizeOverlay(_el);
					oneEvent(_body, 'click', function(){scope.hideResizeOverlay();});
				};
				/* istanbul ignore next: pretty sure phantomjs won't test this */
				scope.hideResizeOverlay = function(){
					scope.displayElements.resize.anchors[3].off('mousedown', _resizeMouseDown);
					scope.displayElements.resize.overlay.css('display', '');
				};

				// allow for insertion of custom directives on the textarea and div
				scope.setup.htmlEditorSetup(scope.displayElements.html);
				scope.setup.textEditorSetup(scope.displayElements.text);
				scope.displayElements.html.attr({
					'id': 'taHtmlElement' + _serial,
					'ng-show': 'showHtml',
					'ta-bind': 'ta-bind',
					'ng-model': 'html',
					'ng-model-options': element.attr('ng-model-options')
				});
				scope.displayElements.text.attr({
					'id': 'taTextElement' + _serial,
					'contentEditable': 'true',
					'ta-bind': 'ta-bind',
					'ng-model': 'html',
					'ng-model-options': element.attr('ng-model-options')
				});
				scope.displayElements.scrollWindow.attr({'ng-hide': 'showHtml'});
				if(attrs.taDefaultWrap) {
					// taDefaultWrap is only applied to the text and not the html view
					scope.displayElements.text.attr('ta-default-wrap', attrs.taDefaultWrap);
				}

				if(attrs.taUnsafeSanitizer){
					scope.displayElements.text.attr('ta-unsafe-sanitizer', attrs.taUnsafeSanitizer);
					scope.displayElements.html.attr('ta-unsafe-sanitizer', attrs.taUnsafeSanitizer);
				}

				// add the main elements to the origional element
				scope.displayElements.scrollWindow.append(scope.displayElements.text);
				element.append(scope.displayElements.scrollWindow);
				element.append(scope.displayElements.html);

				scope.displayElements.forminput.attr('name', scope._name);
				element.append(scope.displayElements.forminput);

				if(attrs.tabindex){
					element.removeAttr('tabindex');
					scope.displayElements.text.attr('tabindex', attrs.tabindex);
					scope.displayElements.html.attr('tabindex', attrs.tabindex);
				}

				if (attrs.placeholder) {
					scope.displayElements.text.attr('placeholder', attrs.placeholder);
					scope.displayElements.html.attr('placeholder', attrs.placeholder);
				}

				if(attrs.taDisabled){
					scope.displayElements.text.attr('ta-readonly', 'disabled');
					scope.displayElements.html.attr('ta-readonly', 'disabled');
					scope.disabled = scope.$parent.$eval(attrs.taDisabled);
					scope.$parent.$watch(attrs.taDisabled, function(newVal){
						scope.disabled = newVal;
						if(scope.disabled){
							element.addClass(scope.classes.disabled);
						}else{
							element.removeClass(scope.classes.disabled);
						}
					});
				}

				if(attrs.taPaste){
					scope._pasteHandler = function(_html){
						return $parse(attrs.taPaste)(scope.$parent, {$html: _html});
					};
					scope.displayElements.text.attr('ta-paste', '_pasteHandler($html)');
				}

				// compile the scope with the text and html elements only - if we do this with the main element it causes a compile loop
				$compile(scope.displayElements.scrollWindow)(scope);
				$compile(scope.displayElements.html)(scope);

				scope.updateTaBindtaTextElement = scope['updateTaBindtaTextElement' + _serial];
				scope.updateTaBindtaHtmlElement = scope['updateTaBindtaHtmlElement' + _serial];

				// add the classes manually last
				element.addClass("ta-root");
				scope.displayElements.scrollWindow.addClass("ta-text ta-editor " + scope.classes.textEditor);
				scope.displayElements.html.addClass("ta-html ta-editor " + scope.classes.htmlEditor);

				// used in the toolbar actions
				scope._actionRunning = false;
				var _savedSelection = false;
				scope.startAction = function(){
					var _beforeStateBold = false;
					var _beforeStateItalic = false;
					var _beforeStateUnderline = false;
					var _beforeStateStrikethough = false;
					scope._actionRunning = true;
					_beforeStateBold = $document[0].queryCommandState('bold');
					_beforeStateItalic = $document[0].queryCommandState('italic');
					_beforeStateUnderline = $document[0].queryCommandState('underline');
					_beforeStateStrikethough = $document[0].queryCommandState('strikeThrough');
					// if rangy library is loaded return a function to reload the current selection
					_savedSelection = rangy.saveSelection();
					// rangy.saveSelection() clear the state of bold, italic, underline, strikethrough
					// so we reset them here....!!!
					// this fixes bugs #423, #1129, #1105, #693 which are actually rangy bugs!
					/* istanbul ignore next: this only active when have bold set and it SHOULD not be necessary anyway... */
					if (_beforeStateBold && !$document[0].queryCommandState('bold')) {
						$document[0].execCommand('bold', false, null);
					}
					/* istanbul ignore next: this only active when have italic set and it SHOULD not be necessary anyway... */
					if (_beforeStateItalic && !$document[0].queryCommandState('italic')) {
						$document[0].execCommand('italic', false, null);
					}
					/* istanbul ignore next: this only active when have underline set and it SHOULD not be necessary anyway... */
					if (_beforeStateUnderline && !$document[0].queryCommandState('underline')) {
						$document[0].execCommand('underline', false, null);
					}
					/* istanbul ignore next: this only active when have strikeThrough set and it SHOULD not be necessary anyway... */
					if (_beforeStateStrikethough && !$document[0].queryCommandState('strikeThrough')) {
						$document[0].execCommand('strikeThrough', false, null);
					}
					//console.log('B', _beforeStateBold, 'I', _beforeStateItalic, '_', _beforeStateUnderline, 'S', _beforeStateStrikethough);
					return function(){
						if(_savedSelection) rangy.restoreSelection(_savedSelection);
						// perhaps if we restore the selections here, we would do better overall???
						// BUT what we do above does well in 90% of the cases...
					};
				};
				scope.endAction = function(){
					scope._actionRunning = false;
					if(_savedSelection){
						if(scope.showHtml){
							scope.displayElements.html[0].focus();
						}else{
							scope.displayElements.text[0].focus();
						}
						// rangy.restoreSelection(_savedSelection);
						rangy.removeMarkers(_savedSelection);
					}
					_savedSelection = false;
					scope.updateSelectedStyles();
					// only update if in text or WYSIWYG mode
					if(!scope.showHtml) scope['updateTaBindtaTextElement' + _serial]();
				};

				// note that focusout > focusin is called everytime we click a button - except bad support: http://www.quirksmode.org/dom/events/blurfocus.html
				// cascades to displayElements.text and displayElements.html automatically.
				_focusin = function(e){
					scope.focussed = true;
					element.addClass(scope.classes.focussed);
/*******  NOT FUNCTIONAL YET
					if (e.target.id === 'taTextElement' + _serial) {
						console.log('_focusin taTextElement');
						// we only do this if NOT focussed
						textAngularManager.restoreFocusSelection(scope._name);
					}
*******/
					_editorFunctions.focus();
					element.triggerHandler('focus');
					// we call editorScope.updateSelectedStyles() here because we want the toolbar to be focussed
					// as soon as we have focus.  Otherwise this only happens on mousedown or keydown etc...
					/* istanbul ignore else: don't run if already running */
					if(scope.updateSelectedStyles && !scope._bUpdateSelectedStyles){
						// we don't set editorScope._bUpdateSelectedStyles here, because we do not want the
						// updateSelectedStyles() to run twice which it will do after 200 msec if we have
						// set editorScope._bUpdateSelectedStyles
						//
						// WOW, normally I would do a scope.$apply here, but this causes ERRORs when doing tests!
						$timeout(function () {
							scope.updateSelectedStyles();
						}, 0);
					}
				};
				scope.displayElements.html.on('focus', _focusin);
				scope.displayElements.text.on('focus', _focusin);
				_focusout = function(e){
					/****************** NOT FUNCTIONAL YET
					try {
						var _s = rangy.getSelection();
						if (_s) {
							// we save the selection when we loose focus so that if do a wrapSelection, the
							// apropriate selection in the editor is restored before action.
							var _savedFocusRange = rangy.saveRange(_s.getRangeAt(0));
							textAngularManager.saveFocusSelection(scope._name, _savedFocusRange);
						}
					} catch(error) { }
					*****************/
					// if we are NOT runnig an action and have NOT focussed again on the text etc then fire the blur events
					if(!scope._actionRunning &&
						$document[0].activeElement !== scope.displayElements.html[0] &&
						$document[0].activeElement !== scope.displayElements.text[0])
					{
						element.removeClass(scope.classes.focussed);
						_editorFunctions.unfocus();
						// to prevent multiple apply error defer to next seems to work.
						$timeout(function(){
							scope._bUpdateSelectedStyles = false;
							element.triggerHandler('blur');
							scope.focussed = false;
						}, 0);
					}
					e.preventDefault();
					return false;
				};
				scope.displayElements.html.on('blur', _focusout);
				scope.displayElements.text.on('blur', _focusout);

				scope.displayElements.text.on('paste', function(event){
					element.triggerHandler('paste', event);
				});

				// Setup the default toolbar tools, this way allows the user to add new tools like plugins.
				// This is on the editor for future proofing if we find a better way to do this.
				scope.queryFormatBlockState = function(command){
					// $document[0].queryCommandValue('formatBlock') errors in Firefox if we call this when focussed on the textarea
					return !scope.showHtml && command.toLowerCase() === $document[0].queryCommandValue('formatBlock').toLowerCase();
				};
				scope.queryCommandState = function(command){
					// $document[0].queryCommandValue('formatBlock') errors in Firefox if we call this when focussed on the textarea
					return (!scope.showHtml) ? $document[0].queryCommandState(command) : '';
				};
				scope.switchView = function(){
					scope.showHtml = !scope.showHtml;
					$animate.enabled(false, scope.displayElements.html);
					$animate.enabled(false, scope.displayElements.text);
					//Show the HTML view
					/* istanbul ignore next: ngModel exists check */
/* THIS is not the correct thing to do, here....
   The ngModel is correct, but it is not formatted as the user as done it...
					var _model;
					if (ngModel) {
						_model = ngModel.$viewValue;
					} else {
						_model = scope.html;
					}
					var _html = scope.displayElements.html[0].value;
					if (getDomFromHtml(_html).childElementCount !== getDomFromHtml(_model).childElementCount) {
						// the model and the html do not agree
						// they can get out of sync and when they do, we correct that here...
						scope.displayElements.html.val(_model);
					}
*/
					if(scope.showHtml){
						//defer until the element is visible
						$timeout(function(){
							$animate.enabled(true, scope.displayElements.html);
							$animate.enabled(true, scope.displayElements.text);
							// [0] dereferences the DOM object from the angular.element
							return scope.displayElements.html[0].focus();
						}, 100);
					}else{
						//Show the WYSIWYG view
						//defer until the element is visible
						$timeout(function(){
							$animate.enabled(true, scope.displayElements.html);
							$animate.enabled(true, scope.displayElements.text);
							// [0] dereferences the DOM object from the angular.element
							return scope.displayElements.text[0].focus();
						}, 100);
					}
				};

				// changes to the model variable from outside the html/text inputs
				// if no ngModel, then the only input is from inside text-angular
				if(attrs.ngModel){
					var _firstRun = true;
					ngModel.$render = function(){
						if(_firstRun){
							// we need this firstRun to set the originalContents otherwise it gets overrided by the setting of ngModel to undefined from NaN
							_firstRun = false;
							// if view value is null or undefined initially and there was original content, set to the original content
							var _initialValue = scope.$parent.$eval(attrs.ngModel);
							if((_initialValue === undefined || _initialValue === null) && (_originalContents && _originalContents !== '')){
								// on passing through to taBind it will be sanitised
								ngModel.$setViewValue(_originalContents);
							}
						}
						scope.displayElements.forminput.val(ngModel.$viewValue);
						// if the editors aren't focused they need to be updated, otherwise they are doing the updating
						scope.html = ngModel.$viewValue || '';
					};
					// trigger the validation calls
					if(element.attr('required')) ngModel.$validators.required = function(modelValue, viewValue) {
						var value = modelValue || viewValue;
						return !(!value || value.trim() === '');
					};
				}else{
					// if no ngModel then update from the contents of the origional html.
					scope.displayElements.forminput.val(_originalContents);
					scope.html = _originalContents;
				}

				// changes from taBind back up to here
				scope.$watch('html', function(newValue, oldValue){
					if(newValue !== oldValue){
						if(attrs.ngModel && ngModel.$viewValue !== newValue) ngModel.$setViewValue(newValue);
						scope.displayElements.forminput.val(newValue);
					}
				});

				if(attrs.taTargetToolbars) {
					_editorFunctions = textAngularManager.registerEditor(scope._name, scope, attrs.taTargetToolbars.split(','));
				}
				else{
					var _toolbar = angular.element('<div text-angular-toolbar name="textAngularToolbar' + _serial + '">');
					// passthrough init of toolbar options
					if(attrs.taToolbar)						_toolbar.attr('ta-toolbar', attrs.taToolbar);
					if(attrs.taToolbarClass)				_toolbar.attr('ta-toolbar-class', attrs.taToolbarClass);
					if(attrs.taToolbarGroupClass)			_toolbar.attr('ta-toolbar-group-class', attrs.taToolbarGroupClass);
					if(attrs.taToolbarButtonClass)			_toolbar.attr('ta-toolbar-button-class', attrs.taToolbarButtonClass);
					if(attrs.taToolbarActiveButtonClass)	_toolbar.attr('ta-toolbar-active-button-class', attrs.taToolbarActiveButtonClass);
					if(attrs.taFocussedClass)				_toolbar.attr('ta-focussed-class', attrs.taFocussedClass);

					element.prepend(_toolbar);
					$compile(_toolbar)(scope.$parent);
					_editorFunctions = textAngularManager.registerEditor(scope._name, scope, ['textAngularToolbar' + _serial]);
				}

				scope.$on('$destroy', function(){
					textAngularManager.unregisterEditor(scope._name);
					angular.element(window).off('blur');
				});

				// catch element select event and pass to toolbar tools
				scope.$on('ta-element-select', function(event, element){
					if(_editorFunctions.triggerElementSelect(event, element)){
						scope['reApplyOnSelectorHandlerstaTextElement' + _serial]();
					}
				});

				scope.$on('ta-drop-event', function(event, element, dropEvent, dataTransfer){
					scope.displayElements.text[0].focus();
					// console.log(888);
					if(dataTransfer && dataTransfer.files && dataTransfer.files.length > 0){
						angular.forEach(dataTransfer.files, function(file){
							// taking advantage of boolean execution, if the fileDropHandler returns true, nothing else after it is executed
							// If it is false then execute the defaultFileDropHandler if the fileDropHandler is NOT the default one
							// Once one of these has been executed wrap the result as a promise, if undefined or variable update the taBind, else we should wait for the promise
							try{
								$q.when(scope.fileDropHandler(file, scope.wrapSelection) ||
									(scope.fileDropHandler !== scope.defaultFileDropHandler &&
									$q.when(scope.defaultFileDropHandler(file, scope.wrapSelection)))).then(function(){
										scope['updateTaBindtaTextElement' + _serial]();
									});
							}catch(error){
								$log.error(error);
							}
						});
						dropEvent.preventDefault();
						dropEvent.stopPropagation();
					/* istanbul ignore else, the updates if moved text */
					}else{
						$timeout(function(){
							scope['updateTaBindtaTextElement' + _serial]();
						}, 0);
					}
				});

				// the following is for applying the active states to the tools that support it
				scope._bUpdateSelectedStyles = false;
				/* istanbul ignore next: browser window/tab leave check */
				angular.element(window).on('blur', function(){
					scope._bUpdateSelectedStyles = false;
					scope.focussed = false;
				});
				// loop through all the tools polling their activeState function if it exists
				scope.updateSelectedStyles = function(){
					var _selection;
					/* istanbul ignore next: This check is to ensure multiple timeouts don't exist */
					if(_updateSelectedStylesTimeout) $timeout.cancel(_updateSelectedStylesTimeout);
					// test if the common element ISN'T the root ta-text node
					if((_selection = taSelection.getSelectionElement()) !== undefined && _selection.parentNode !== scope.displayElements.text[0]){
						_editorFunctions.updateSelectedStyles(angular.element(_selection));
					}else _editorFunctions.updateSelectedStyles();
					// used to update the active state when a key is held down, ie the left arrow
					/* istanbul ignore else: browser only check */
					if(scope._bUpdateSelectedStyles) _updateSelectedStylesTimeout = $timeout(scope.updateSelectedStyles, 200);
				};
				// start updating on keydown
				_keydown = function(){
					/* istanbul ignore next: ie catch */
					if(!scope.focussed){
						scope._bUpdateSelectedStyles = false;
						return;
					}
					/* istanbul ignore else: don't run if already running */
					if(!scope._bUpdateSelectedStyles){
						scope._bUpdateSelectedStyles = true;
						scope.$apply(function(){
							scope.updateSelectedStyles();
						});
					}
				};
				scope.displayElements.html.on('keydown', _keydown);
				scope.displayElements.text.on('keydown', _keydown);
				// stop updating on key up and update the display/model
				_keyup = function(){
					scope._bUpdateSelectedStyles = false;
				};
				scope.displayElements.html.on('keyup', _keyup);
				scope.displayElements.text.on('keyup', _keyup);
				// stop updating on key up and update the display/model
				_keypress = function(event, eventData){
					// bug fix for Firefox.  If we are selecting a <a> already, any characters will
					// be added within the <a> which is bad!
					/* istanbul ignore next: don't see how to test this... */
					if (taSelection.getSelection) {
						var _selection = taSelection.getSelection();
						if (taSelection.getSelectionElement().nodeName.toLowerCase() === 'a') {
							// check and see if we are at the edge of the <a>
							if (_selection.start.element.nodeType === 3 &&
								_selection.start.element.textContent.length === _selection.end.offset) {
								// we are at the end of the <a>!!!
								// so move the selection to after the <a>!!
								taSelection.setSelectionAfterElement(taSelection.getSelectionElement());
							}
							if (_selection.start.element.nodeType === 3 &&
								_selection.start.offset === 0) {
								// we are at the start of the <a>!!!
								// so move the selection before the <a>!!
								taSelection.setSelectionBeforeElement(taSelection.getSelectionElement());
							}
						}
					}
					/* istanbul ignore else: this is for catching the jqLite testing*/
					if(eventData) angular.extend(event, eventData);
					scope.$apply(function(){
						if(_editorFunctions.sendKeyCommand(event)){
							/* istanbul ignore else: don't run if already running */
							if(!scope._bUpdateSelectedStyles){
								scope.updateSelectedStyles();
							}
							event.preventDefault();
							return false;
						}
					});
				};
				scope.displayElements.html.on('keypress', _keypress);
				scope.displayElements.text.on('keypress', _keypress);
				// update the toolbar active states when we click somewhere in the text/html boxed
				_mouseup = function(){
					// ensure only one execution of updateSelectedStyles()
					scope._bUpdateSelectedStyles = false;
					scope.$apply(function(){
						scope.updateSelectedStyles();
					});
				};
				scope.displayElements.html.on('mouseup', _mouseup);
				scope.displayElements.text.on('mouseup', _mouseup);
			}
		};
	}
]);
textAngular.service('textAngularManager', ['taToolExecuteAction', 'taTools', 'taRegisterTool', '$interval', '$rootScope', '$log',
	function(taToolExecuteAction, taTools, taRegisterTool, $interval, $rootScope, $log){
	// this service is used to manage all textAngular editors and toolbars.
	// All publicly published functions that modify/need to access the toolbar or editor scopes should be in here
	// these contain references to all the editors and toolbars that have been initialised in this app
	var toolbars = {}, editors = {};
	// we touch the time any change occurs through register of an editor or tool so that we
	// in the future will fire and event to trigger an updateSelection
	var timeRecentModification = 0;
	var updateStyles = function(selectedElement){
		angular.forEach(editors, function(editor) {
			editor.editorFunctions.updateSelectedStyles(selectedElement);
		});
	};
	var triggerInterval = 50;
	var triggerIntervalTimer;
	var setupTriggerUpdateStyles = function() {
		timeRecentModification = Date.now();
		/* istanbul ignore next: setup a one time updateStyles() */
		triggerIntervalTimer = $interval(function() {
			updateStyles();
			triggerIntervalTimer = undefined;
		}, triggerInterval, 1); // only trigger once
	};
	/* istanbul ignore next: make sure clean up on destroy */
	$rootScope.$on('destroy', function() {
		if (triggerIntervalTimer) {
			$interval.cancel(triggerIntervalTimer);
			triggerIntervalTimer = undefined;
		}
	});
	var touchModification = function() {
		if (Math.abs(Date.now() - timeRecentModification) > triggerInterval) {
			// we have already triggered the updateStyles a long time back... so setup it again...
			setupTriggerUpdateStyles();
		}
	};
	// when we focus into a toolbar, we need to set the TOOLBAR's $parent to be the toolbars it's linked to.
	// We also need to set the tools to be updated to be the toolbars...
	return {
		// register an editor and the toolbars that it is affected by
		registerEditor: function(editorName, editorScope, targetToolbars){
			// NOTE: name === editorScope._name
			// targetToolbars is an [] of 'toolbar name's
			// targetToolbars are optional, we don't require a toolbar to function
			if(!editorName || editorName === '') throw('textAngular Error: An editor requires a name');
			if(!editorScope) throw('textAngular Error: An editor requires a scope');
			if(editors[editorName]) throw('textAngular Error: An Editor with name "' + editorName + '" already exists');
			editors[editorName] = {
				scope: editorScope,
				toolbars: targetToolbars,
				// toolbarScopes used by this editor
				toolbarScopes: [],
				_registerToolbarScope: function(toolbarScope){
					// add to the list late
					if(this.toolbars.indexOf(toolbarScope.name) >= 0) {
						// if this toolbarScope is being used by this editor we add it as one of the scopes
						this.toolbarScopes.push(toolbarScope);
					}
				},
				// this is a suite of functions the editor should use to update all it's linked toolbars
				editorFunctions: {
					disable: function(){
						// disable all linked toolbars
						angular.forEach(editors[editorName].toolbarScopes, function(toolbarScope){
							toolbarScope.disabled = true;
						});
					},
					enable: function(){
						// enable all linked toolbars
						angular.forEach(editors[editorName].toolbarScopes, function(toolbarScope){
							toolbarScope.disabled = false;
						});
					},
					focus: function(){
						// this should be called when the editor is focussed
						angular.forEach(editors[editorName].toolbarScopes, function(toolbarScope){
							toolbarScope._parent = editorScope;
							toolbarScope.disabled = false;
							toolbarScope.focussed = true;
						});
						editorScope.focussed = true;
					},
					unfocus: function(){
						// this should be called when the editor becomes unfocussed
						angular.forEach(editors[editorName].toolbarScopes, function(toolbarScope){
							toolbarScope.disabled = true;
							toolbarScope.focussed = false;
						});
						editorScope.focussed = false;
					},
					updateSelectedStyles: function(selectedElement){
						// update the active state of all buttons on liked toolbars
						angular.forEach(editors[editorName].toolbarScopes, function(toolbarScope){
							angular.forEach(toolbarScope.tools, function(toolScope){
								if(toolScope.activeState){
									toolbarScope._parent = editorScope;
									// selectedElement may be undefined if nothing selected
									toolScope.active = toolScope.activeState(selectedElement);
								}
							});
						});
					},
					sendKeyCommand: function(event){
						// we return true if we applied an action, false otherwise
						var result = false;
						if(event.ctrlKey || event.metaKey || event.specialKey) angular.forEach(taTools, function(tool, name){
							if(tool.commandKeyCode && (tool.commandKeyCode === event.which || tool.commandKeyCode === event.specialKey)){
								for(var _t = 0; _t < editors[editorName].toolbarScopes.length; _t++){
									if(editors[editorName].toolbarScopes[_t].tools[name] !== undefined){
										taToolExecuteAction.call(editors[editorName].toolbarScopes[_t].tools[name], editorScope);
										result = true;
										break;
									}
								}
							}
						});
						return result;
					},
					triggerElementSelect: function(event, element){
						// search through the taTools to see if a match for the tag is made.
						// if there is, see if the tool is on a registered toolbar and not disabled.
						// NOTE: This can trigger on MULTIPLE tools simultaneously.
						var elementHasAttrs = function(_element, attrs){
							var result = true;
							for(var i = 0; i < attrs.length; i++) result = result && _element.attr(attrs[i]);
							return result;
						};
						var workerTools = [];
						var unfilteredTools = {};
						var result = false;
						element = angular.element(element);
						// get all valid tools by element name, keep track if one matches the
						var onlyWithAttrsFilter = false;
						angular.forEach(taTools, function(tool, name){
							if(
								tool.onElementSelect &&
								tool.onElementSelect.element &&
								tool.onElementSelect.element.toLowerCase() === element[0].tagName.toLowerCase() &&
								(!tool.onElementSelect.filter || tool.onElementSelect.filter(element))
							){
								// this should only end up true if the element matches the only attributes
								onlyWithAttrsFilter = onlyWithAttrsFilter ||
									(angular.isArray(tool.onElementSelect.onlyWithAttrs) && elementHasAttrs(element, tool.onElementSelect.onlyWithAttrs));
								if(!tool.onElementSelect.onlyWithAttrs || elementHasAttrs(element, tool.onElementSelect.onlyWithAttrs)) unfilteredTools[name] = tool;
							}
						});
						// if we matched attributes to filter on, then filter, else continue
						if(onlyWithAttrsFilter){
							angular.forEach(unfilteredTools, function(tool, name){
								if(tool.onElementSelect.onlyWithAttrs && elementHasAttrs(element, tool.onElementSelect.onlyWithAttrs)) workerTools.push({'name': name, 'tool': tool});
							});
							// sort most specific (most attrs to find) first
							workerTools.sort(function(a,b){
								return b.tool.onElementSelect.onlyWithAttrs.length - a.tool.onElementSelect.onlyWithAttrs.length;
							});
						}else{
							angular.forEach(unfilteredTools, function(tool, name){
								workerTools.push({'name': name, 'tool': tool});
							});
						}
						// Run the actions on the first visible filtered tool only
						if(workerTools.length > 0){
							for(var _i = 0; _i < workerTools.length; _i++){
								var tool = workerTools[_i].tool;
								var name = workerTools[_i].name;
								for(var _t = 0; _t < editors[editorName].toolbarScopes.length; _t++){
									if(editors[editorName].toolbarScopes[_t].tools[name] !== undefined){
										tool.onElementSelect.action.call(editors[editorName].toolbarScopes[_t].tools[name], event, element, editorScope);
										result = true;
										break;
									}
								}
								if(result) break;
							}
						}
						return result;
					}
				}
			};
			angular.forEach(targetToolbars, function(_name){
				if(toolbars[_name]) {
					editors[editorName].toolbarScopes.push(toolbars[_name]);
				}
				// if it doesn't exist it may not have been compiled yet and it will be added later
			});
			touchModification();
			return editors[editorName].editorFunctions;
		},
		// retrieve editor by name, largely used by testing suites only
		retrieveEditor: function(name){
			return editors[name];
		},
		unregisterEditor: function(name){
			delete editors[name];
			touchModification();
		},
		// registers a toolbar such that it can be linked to editors
		registerToolbar: function(toolbarScope){
			if(!toolbarScope) throw('textAngular Error: A toolbar requires a scope');
			if(!toolbarScope.name || toolbarScope.name === '') throw('textAngular Error: A toolbar requires a name');
			if(toolbars[toolbarScope.name]) throw('textAngular Error: A toolbar with name "' + toolbarScope.name + '" already exists');
			toolbars[toolbarScope.name] = toolbarScope;
			// walk all the editors and connect this toolbarScope to the editors.... if we need to.  This way, it does
			// not matter if we register the editors after the toolbars or not
			// Note the editor will ignore this toolbarScope if it is not connected to it...
			angular.forEach(editors, function(_editor){
				_editor._registerToolbarScope(toolbarScope);
			});
			touchModification();
		},
		// retrieve toolbar by name, largely used by testing suites only
		retrieveToolbar: function(name){
			return toolbars[name];
		},
		// retrieve toolbars by editor name, largely used by testing suites only
		retrieveToolbarsViaEditor: function(name){
			var result = [], _this = this;
			angular.forEach(this.retrieveEditor(name).toolbars, function(name){
				result.push(_this.retrieveToolbar(name));
			});
			return result;
		},
		unregisterToolbar: function(name){
			delete toolbars[name];
			touchModification();
		},
		// functions for updating the toolbar buttons display
		updateToolsDisplay: function(newTaTools){
			// pass a partial struct of the taTools, this allows us to update the tools on the fly, will not change the defaults.
			var _this = this;
			angular.forEach(newTaTools, function(_newTool, key){
				_this.updateToolDisplay(key, _newTool);
			});
		},
		// this function resets all toolbars to their default tool definitions
		resetToolsDisplay: function(){
			var _this = this;
			angular.forEach(taTools, function(_newTool, key){
				_this.resetToolDisplay(key);
			});
			touchModification();
		},
		// update a tool on all toolbars
		updateToolDisplay: function(toolKey, _newTool){
			var _this = this;
			angular.forEach(toolbars, function(toolbarScope, toolbarKey){
				_this.updateToolbarToolDisplay(toolbarKey, toolKey, _newTool);
			});
			touchModification();
		},
		// resets a tool to the default/starting state on all toolbars
		resetToolDisplay: function(toolKey){
			var _this = this;
			angular.forEach(toolbars, function(toolbarScope, toolbarKey){
				_this.resetToolbarToolDisplay(toolbarKey, toolKey);
			});
			touchModification();
		},
		// update a tool on a specific toolbar
		updateToolbarToolDisplay: function(toolbarKey, toolKey, _newTool){
			if(toolbars[toolbarKey]) toolbars[toolbarKey].updateToolDisplay(toolKey, _newTool);
			else throw('textAngular Error: No Toolbar with name "' + toolbarKey + '" exists');
		},
		// reset a tool on a specific toolbar to it's default starting value
		resetToolbarToolDisplay: function(toolbarKey, toolKey){
			if(toolbars[toolbarKey]) toolbars[toolbarKey].updateToolDisplay(toolKey, taTools[toolKey], true);
			else throw('textAngular Error: No Toolbar with name "' + toolbarKey + '" exists');
		},
		// removes a tool from all toolbars and it's definition
		removeTool: function(toolKey){
			delete taTools[toolKey];
			angular.forEach(toolbars, function(toolbarScope){
				delete toolbarScope.tools[toolKey];
				for(var i = 0; i < toolbarScope.toolbar.length; i++){
					var toolbarIndex;
					for(var j = 0; j < toolbarScope.toolbar[i].length; j++){
						if(toolbarScope.toolbar[i][j] === toolKey){
							toolbarIndex = {
								group: i,
								index: j
							};
							break;
						}
						if(toolbarIndex !== undefined) break;
					}
					if(toolbarIndex !== undefined){
						toolbarScope.toolbar[toolbarIndex.group].slice(toolbarIndex.index, 1);
						toolbarScope._$element.children().eq(toolbarIndex.group).children().eq(toolbarIndex.index).remove();
					}
				}
			});
			touchModification();
		},
		// toolkey, toolDefinition are required. If group is not specified will pick the last group, if index isnt defined will append to group
		addTool: function(toolKey, toolDefinition, group, index){
			taRegisterTool(toolKey, toolDefinition);
			angular.forEach(toolbars, function(toolbarScope){
				toolbarScope.addTool(toolKey, toolDefinition, group, index);
			});
			touchModification();
		},
		// adds a Tool but only to one toolbar not all
		addToolToToolbar: function(toolKey, toolDefinition, toolbarKey, group, index){
			taRegisterTool(toolKey, toolDefinition);
			toolbars[toolbarKey].addTool(toolKey, toolDefinition, group, index);
			touchModification();
		},
		// this is used when externally the html of an editor has been changed and textAngular needs to be notified to update the model.
		// this will call a $digest if not already happening
		refreshEditor: function(name){
			if(editors[name]){
				editors[name].scope.updateTaBindtaTextElement();
				/* istanbul ignore else: phase catch */
				if(!editors[name].scope.$$phase) editors[name].scope.$digest();
			}else throw('textAngular Error: No Editor with name "' + name + '" exists');
			touchModification();
		},
		// this is used by taBind to send a key command in response to a special key event
		sendKeyCommand: function(scope, event){
			var _editor = editors[scope._name];
			/* istanbul ignore else: if nothing to do, do nothing */
			if (_editor && _editor.editorFunctions.sendKeyCommand(event)) {
				/* istanbul ignore else: don't run if already running */
				if(!scope._bUpdateSelectedStyles){
					scope.updateSelectedStyles();
				}
				event.preventDefault();
				return false;
			}
		},
		//
		// When a toolbar and tools are created, it isn't until there is a key event or mouse event
		// that the updateSelectedStyles() is called behind the scenes.
		// This function forces an update through the existing editors to help the application make sure
		// the inital state is correct.
		//
		updateStyles: updateStyles,
		// return the current version of textAngular in use to the user
		getVersion: function () { return textAngularVersion; },
		// for testing
		getToolbarScopes: function () {
			var tmp=[];
			angular.forEach(editors, function (_editor) {
				tmp = tmp.concat(_editor.toolbarScopes);
			});
			return tmp;
		}
/********************** not functional yet
		// save the selection ('range') for the given editor
		saveFocusSelection: function (name, range) {
			editors[name].savedFocusRange = range;
		},
		// restore the saved selection from when the focus was lost
		restoreFocusSelection: function(name, scope) {
			// we only do this if NOT focussed and saved...
			if (editors[name].savedFocusRange && !scope.focussed) {
				try {
					var _r = rangy.restoreRange(editors[name].savedFocusRange);
					var _sel = rangy.getSelection();
					_sel.addRange(_r);
				} catch(e) {}
			}
		}
*************/
	};
}]);
textAngular.directive('textAngularToolbar', [
	'$compile', 'textAngularManager', 'taOptions', 'taTools', 'taToolExecuteAction', '$window',
	function($compile, textAngularManager, taOptions, taTools, taToolExecuteAction, $window){
		return {
			scope: {
				name: '@' // a name IS required
			},
			restrict: "EA",
			link: function(scope, element, attrs){
				if(!scope.name || scope.name === '') throw('textAngular Error: A toolbar requires a name');
				angular.extend(scope, angular.copy(taOptions));
				if(attrs.taToolbar)						scope.toolbar = scope.$parent.$eval(attrs.taToolbar);
				if(attrs.taToolbarClass)				scope.classes.toolbar = attrs.taToolbarClass;
				if(attrs.taToolbarGroupClass)			scope.classes.toolbarGroup = attrs.taToolbarGroupClass;
				if(attrs.taToolbarButtonClass)			scope.classes.toolbarButton = attrs.taToolbarButtonClass;
				if(attrs.taToolbarActiveButtonClass)	scope.classes.toolbarButtonActive = attrs.taToolbarActiveButtonClass;
				if(attrs.taFocussedClass)				scope.classes.focussed = attrs.taFocussedClass;

				scope.disabled = true;
				scope.focussed = false;
				scope._$element = element;
				element[0].innerHTML = '';
				element.addClass("ta-toolbar " + scope.classes.toolbar);

				scope.$watch('focussed', function(){
					if(scope.focussed) element.addClass(scope.classes.focussed);
					else element.removeClass(scope.classes.focussed);
				});

				var setupToolElement = function(toolDefinition, toolScope){
					var toolElement;
					if(toolDefinition && toolDefinition.display){
						toolElement = angular.element(toolDefinition.display);
					}
					else toolElement = angular.element("<button type='button'>");

					if(toolDefinition && toolDefinition["class"]) toolElement.addClass(toolDefinition["class"]);
					else toolElement.addClass(scope.classes.toolbarButton);

					toolElement.attr('name', toolScope.name);
					// important to not take focus from the main text/html entry
					toolElement.attr('ta-button', 'ta-button');
					toolElement.attr('ng-disabled', 'isDisabled()');
					toolElement.attr('tabindex', '-1');
					toolElement.attr('ng-click', 'executeAction()');
					toolElement.attr('ng-class', 'displayActiveToolClass(active)');

					if (toolDefinition && toolDefinition.tooltiptext) {
						toolElement.attr('title', toolDefinition.tooltiptext);
					}
					if(toolDefinition && !toolDefinition.display && !toolScope._display){
						// first clear out the current contents if any
						toolElement[0].innerHTML = '';
						// add the buttonText
						if(toolDefinition.buttontext) toolElement[0].innerHTML = toolDefinition.buttontext;
						// add the icon to the front of the button if there is content
						if(toolDefinition.iconclass){
							var icon = angular.element('<i>'), content = toolElement[0].innerHTML;
							icon.addClass(toolDefinition.iconclass);
							toolElement[0].innerHTML = '';
							toolElement.append(icon);
							if(content && content !== '') toolElement.append('&nbsp;' + content);
						}
					}

					toolScope._lastToolDefinition = angular.copy(toolDefinition);

					return $compile(toolElement)(toolScope);
				};

				// Keep a reference for updating the active states later
				scope.tools = {};
				// create the tools in the toolbar
				// default functions and values to prevent errors in testing and on init
				scope._parent = {
					disabled: true,
					showHtml: false,
					queryFormatBlockState: function(){ return false; },
					queryCommandState: function(){ return false; }
				};
				var defaultChildScope = {
					$window: $window,
					$editor: function(){
						// dynamically gets the editor as it is set
						return scope._parent;
					},
					isDisabled: function(){
						// view selection button is always enabled since it doesn not depend on a selction!
						if (this.name === 'html' && scope._parent.startAction) {
							return false;
						}
						// to set your own disabled logic set a function or boolean on the tool called 'disabled'
						return ( // this bracket is important as without it it just returns the first bracket and ignores the rest
							// when the button's disabled function/value evaluates to true
							(typeof this.$eval('disabled') !== 'function' && this.$eval('disabled')) || this.$eval('disabled()') ||
							// all buttons except the HTML Switch button should be disabled in the showHtml (RAW html) mode
							(this.name !== 'html' && this.$editor().showHtml) ||
							// if the toolbar is disabled
							this.$parent.disabled ||
							// if the current editor is disabled
							this.$editor().disabled
						);
					},
					displayActiveToolClass: function(active){
						return (active)? scope.classes.toolbarButtonActive : '';
					},
					executeAction: taToolExecuteAction
				};

				angular.forEach(scope.toolbar, function(group){
					// setup the toolbar group
					var groupElement = angular.element("<div>");
					groupElement.addClass(scope.classes.toolbarGroup);
					angular.forEach(group, function(tool){
						// init and add the tools to the group
						// a tool name (key name from taTools struct)
						//creates a child scope of the main angularText scope and then extends the childScope with the functions of this particular tool
						// reference to the scope and element kept
						scope.tools[tool] = angular.extend(scope.$new(true), taTools[tool], defaultChildScope, {name: tool});
						scope.tools[tool].$element = setupToolElement(taTools[tool], scope.tools[tool]);
						// append the tool compiled with the childScope to the group element
						groupElement.append(scope.tools[tool].$element);
					});
					// append the group to the toolbar
					element.append(groupElement);
				});

				// update a tool
				// if a value is set to null, remove from the display
				// when forceNew is set to true it will ignore all previous settings, used to reset to taTools definition
				// to reset to defaults pass in taTools[key] as _newTool and forceNew as true, ie `updateToolDisplay(key, taTools[key], true);`
				scope.updateToolDisplay = function(key, _newTool, forceNew){
					var toolInstance = scope.tools[key];
					if(toolInstance){
						// get the last toolDefinition, then override with the new definition
						if(toolInstance._lastToolDefinition && !forceNew) _newTool = angular.extend({}, toolInstance._lastToolDefinition, _newTool);
						if(_newTool.buttontext === null && _newTool.iconclass === null && _newTool.display === null)
							throw('textAngular Error: Tool Definition for updating "' + key + '" does not have a valid display/iconclass/buttontext value');

						// if tool is defined on this toolbar, update/redo the tool
						if(_newTool.buttontext === null){
							delete _newTool.buttontext;
						}
						if(_newTool.iconclass === null){
							delete _newTool.iconclass;
						}
						if(_newTool.display === null){
							delete _newTool.display;
						}

						var toolElement = setupToolElement(_newTool, toolInstance);
						toolInstance.$element.replaceWith(toolElement);
						toolInstance.$element = toolElement;
					}
				};

				// we assume here that all values passed are valid and correct
				scope.addTool = function(key, _newTool, groupIndex, index){
					scope.tools[key] = angular.extend(scope.$new(true), taTools[key], defaultChildScope, {name: key});
					scope.tools[key].$element = setupToolElement(taTools[key], scope.tools[key]);
					var group;
					if(groupIndex === undefined) groupIndex = scope.toolbar.length - 1;
					group = angular.element(element.children()[groupIndex]);

					if(index === undefined){
						group.append(scope.tools[key].$element);
						scope.toolbar[groupIndex][scope.toolbar[groupIndex].length - 1] = key;
					}else{
						group.children().eq(index).after(scope.tools[key].$element);
						scope.toolbar[groupIndex][index] = key;
					}
				};

				textAngularManager.registerToolbar(scope);

				scope.$on('$destroy', function(){
					textAngularManager.unregisterToolbar(scope.name);
				});
			}
		};
	}
]);
textAngular.directive('textAngularVersion', ['textAngularManager',
	function(textAngularManager) {
		var version = textAngularManager.getVersion();
		return {
			restrict: "EA",
			link: function (scope, element, attrs) {
				element.html(version);
			}
		};
	}
]);


// tests against the current jqLite/jquery implementation if this can be an element
function validElementString(string){
	try{
		return angular.element(string).length !== 0;
	}catch(any){
		return false;
	}
}
// setup the global contstant functions for setting up the toolbar

// all tool definitions
var taTools = {};
/*
	A tool definition is an object with the following key/value parameters:
		action: [function(deferred, restoreSelection)]
				a function that is executed on clicking on the button - this will allways be executed using ng-click and will
				overwrite any ng-click value in the display attribute.
				The function is passed a deferred object ($q.defer()), if this is wanted to be used `return false;` from the action and
				manually call `deferred.resolve();` elsewhere to notify the editor that the action has finished.
				restoreSelection is only defined if the rangy library is included and it can be called as `restoreSelection()` to restore the users
				selection in the WYSIWYG editor.
		display: [string]?
				Optional, an HTML element to be displayed as the button. The `scope` of the button is the tool definition object with some additional functions
				If set this will cause buttontext and iconclass to be ignored
		class: [string]?
				Optional, if set will override the taOptions.classes.toolbarButton class.
		buttontext: [string]?
				if this is defined it will replace the contents of the element contained in the `display` element
		iconclass: [string]?
				if this is defined an icon (<i>) will be appended to the `display` element with this string as it's class
		tooltiptext: [string]?
				Optional, a plain text description of the action, used for the title attribute of the action button in the toolbar by default.
		activestate: [function(commonElement)]?
				this function is called on every caret movement, if it returns true then the class taOptions.classes.toolbarButtonActive
				will be applied to the `display` element, else the class will be removed
		disabled: [function()]?
				if this function returns true then the tool will have the class taOptions.classes.disabled applied to it, else it will be removed
	Other functions available on the scope are:
		name: [string]
				the name of the tool, this is the first parameter passed into taRegisterTool
		isDisabled: [function()]
				returns true if the tool is disabled, false if it isn't
		displayActiveToolClass: [function(boolean)]
				returns true if the tool is 'active' in the currently focussed toolbar
		onElementSelect: [Object]
				This object contains the following key/value pairs and is used to trigger the ta-element-select event
				element: [String]
					an element name, will only trigger the onElementSelect action if the tagName of the element matches this string
				filter: [function(element)]?
					an optional filter that returns a boolean, if true it will trigger the onElementSelect.
				action: [function(event, element, editorScope)]
					the action that should be executed if the onElementSelect function runs
*/
// name and toolDefinition to add into the tools available to be added on the toolbar
function registerTextAngularTool(name, toolDefinition){
	if(!name || name === '' || taTools.hasOwnProperty(name)) throw('textAngular Error: A unique name is required for a Tool Definition');
	if(
		(toolDefinition.display && (toolDefinition.display === '' || !validElementString(toolDefinition.display))) ||
		(!toolDefinition.display && !toolDefinition.buttontext && !toolDefinition.iconclass)
	)
		throw('textAngular Error: Tool Definition for "' + name + '" does not have a valid display/iconclass/buttontext value');
	taTools[name] = toolDefinition;
}

angular.module('textAngularSetup', [])
.constant('taRegisterTool', registerTextAngularTool)
.value('taTools', taTools)
// Here we set up the global display defaults, to set your own use a angular $provider#decorator.
.value('taOptions',  {
	//////////////////////////////////////////////////////////////////////////////////////
    // forceTextAngularSanitize
    // set false to allow the textAngular-sanitize provider to be replaced
    // with angular-sanitize or a custom provider.
	forceTextAngularSanitize: true,
	///////////////////////////////////////////////////////////////////////////////////////
	// keyMappings
	// allow customizable keyMappings for specialized key boards or languages
	//
	// keyMappings provides key mappings that are attached to a given commandKeyCode.
	// To modify a specific keyboard binding, simply provide function which returns true
	// for the event you wish to map to.
	// Or to disable a specific keyboard binding, provide a function which returns false.
	// Note: 'RedoKey' and 'UndoKey' are internally bound to the redo and undo functionality.
	// At present, the following commandKeyCodes are in use:
	// 98, 'TabKey', 'ShiftTabKey', 105, 117, 'UndoKey', 'RedoKey'
	//
	// To map to an new commandKeyCode, add a new key mapping such as:
	// {commandKeyCode: 'CustomKey', testForKey: function (event) {
	//  if (event.keyCode=57 && event.ctrlKey && !event.shiftKey && !event.altKey) return true;
	// } }
	// to the keyMappings. This example maps ctrl+9 to 'CustomKey'
	// Then where taRegisterTool(...) is called, add a commandKeyCode: 'CustomKey' and your
	// tool will be bound to ctrl+9.
	//
	// To disble one of the already bound commandKeyCodes such as 'RedoKey' or 'UndoKey' add:
	// {commandKeyCode: 'RedoKey', testForKey: function (event) { return false; } },
	// {commandKeyCode: 'UndoKey', testForKey: function (event) { return false; } },
	// to disable them.
	//
	keyMappings : [],
	toolbar: [
		['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote'],
		['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
		['justifyLeft','justifyCenter','justifyRight','justifyFull','indent','outdent'],
		['html', 'insertImage', 'insertLink', 'insertVideo', 'wordcount', 'charcount']
	],
	classes: {
		focussed: "focussed",
		toolbar: "btn-toolbar",
		toolbarGroup: "btn-group",
		toolbarButton: "btn btn-default",
		toolbarButtonActive: "active",
		disabled: "disabled",
		textEditor: 'form-control',
		htmlEditor: 'form-control'
	},
	defaultTagAttributes : {
		a: {target:""}
	},
	setup: {
		// wysiwyg mode
		textEditorSetup: function($element){ /* Do some processing here */ },
		// raw html
		htmlEditorSetup: function($element){ /* Do some processing here */ }
	},
	defaultFileDropHandler:
		/* istanbul ignore next: untestable image processing */
		function(file, insertAction){
			var reader = new FileReader();
			if(file.type.substring(0, 5) === 'image'){
				reader.onload = function() {
					if(reader.result !== '') insertAction('insertImage', reader.result, true);
				};

				reader.readAsDataURL(file);
				// NOTE: For async procedures return a promise and resolve it when the editor should update the model.
				return true;
			}
			return false;
		}
})

// This is the element selector string that is used to catch click events within a taBind, prevents the default and $emits a 'ta-element-select' event
// these are individually used in an angular.element().find() call. What can go here depends on whether you have full jQuery loaded or just jQLite with angularjs.
// div is only used as div.ta-insert-video caught in filter.
.value('taSelectableElements', ['a','img'])

// This is an array of objects with the following options:
//				selector: <string> a jqLite or jQuery selector string
//				customAttribute: <string> an attribute to search for
//				renderLogic: <function(element)>
// Both or one of selector and customAttribute must be defined.
.value('taCustomRenderers', [
	{
		// Parse back out: '<div class="ta-insert-video" ta-insert-video src="' + urlLink + '" allowfullscreen="true" width="300" frameborder="0" height="250"></div>'
		// To correct video element. For now only support youtube
		selector: 'img',
		customAttribute: 'ta-insert-video',
		renderLogic: function(element){
			var iframe = angular.element('<iframe></iframe>');
			var attributes = element.prop("attributes");
			// loop through element attributes and apply them on iframe
			angular.forEach(attributes, function(attr) {
				iframe.attr(attr.name, attr.value);
			});
			iframe.attr('src', iframe.attr('ta-insert-video'));
			element.replaceWith(iframe);
		}
	}
])

.value('taTranslations', {
	// moved to sub-elements
	//toggleHTML: "Toggle HTML",
	//insertImage: "Please enter a image URL to insert",
	//insertLink: "Please enter a URL to insert",
	//insertVideo: "Please enter a youtube URL to embed",
	html: {
		tooltip: '展示HTML'
	},
	// tooltip for heading - might be worth splitting
	heading: {
		tooltip: 'Heading '
	},
	p: {
		tooltip: '段落'
	},
	pre: {
		tooltip: 'Preformatted text'
	},
	ul: {
		tooltip: 'Unordered List'
	},
	ol: {
		tooltip: 'Ordered List'
	},
	quote: {
		tooltip: 'Quote/unquote selection or paragraph'
	},
	undo: {
		tooltip: 'Undo'
	},
	redo: {
		tooltip: 'Redo'
	},
	bold: {
		tooltip: '加粗'
	},
	italic: {
		tooltip: '斜体'
	},
	underline: {
		tooltip: '下划线'
	},
	strikeThrough:{
		tooltip: '中线'
	},
	justifyLeft: {
		tooltip: '左对齐'
	},
	justifyRight: {
		tooltip: '右对齐'
	},
	justifyFull: {
		tooltip: 'Justify text'
	},
	justifyCenter: {
		tooltip: 'Center'
	},
	indent: {
		tooltip: 'Increase indent'
	},
	outdent: {
		tooltip: 'Decrease indent'
	},
	clear: {
		tooltip: '撤销'
	},
	insertImage: {
		dialogPrompt: 'Please enter an image URL to insert',
		tooltip: 'Insert image',
		hotkey: 'the - possibly language dependent hotkey ... for some future implementation'
	},
	insertVideo: {
		tooltip: 'Insert video',
		dialogPrompt: 'Please enter a youtube URL to embed'
	},
	insertLink: {
		tooltip: 'Insert / edit link',
		dialogPrompt: "Please enter a URL to insert"
	},
	editLink: {
		reLinkButton: {
			tooltip: "Relink"
		},
		unLinkButton: {
			tooltip: "Unlink"
		},
		targetToggle: {
			buttontext: "Open in New Window"
		}
	},
	wordcount: {
		tooltip: 'Display words Count'
	},
		charcount: {
		tooltip: 'Display characters Count'
	}
})
.factory('taToolFunctions', ['$window','taTranslations', function($window, taTranslations) {
	return {
		imgOnSelectAction: function(event, $element, editorScope){
			// setup the editor toolbar
			// Credit to the work at http://hackerwins.github.io/summernote/ for this editbar logic/display
			var finishEdit = function(){
				editorScope.updateTaBindtaTextElement();
				editorScope.hidePopover();
			};
			event.preventDefault();
			editorScope.displayElements.popover.css('width', '375px');
			var container = editorScope.displayElements.popoverContainer;
			container.empty();
			var buttonGroup = angular.element('<div class="btn-group" style="padding-right: 6px;">');
			var fullButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1">100% </button>');
			fullButton.on('click', function(event){
				event.preventDefault();
				$element.css({
					'width': '100%',
					'height': ''
				});
				finishEdit();
			});
			var halfButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1">50% </button>');
			halfButton.on('click', function(event){
				event.preventDefault();
				$element.css({
					'width': '50%',
					'height': ''
				});
				finishEdit();
			});
			var quartButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1">25% </button>');
			quartButton.on('click', function(event){
				event.preventDefault();
				$element.css({
					'width': '25%',
					'height': ''
				});
				finishEdit();
			});
			var resetButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1">Reset</button>');
			resetButton.on('click', function(event){
				event.preventDefault();
				$element.css({
					width: '',
					height: ''
				});
				finishEdit();
			});
			buttonGroup.append(fullButton);
			buttonGroup.append(halfButton);
			buttonGroup.append(quartButton);
			buttonGroup.append(resetButton);
			container.append(buttonGroup);

			buttonGroup = angular.element('<div class="btn-group" style="padding-right: 6px;">');
			var floatLeft = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1"><i class="fa fa-align-left"></i></button>');
			floatLeft.on('click', function(event){
				event.preventDefault();
				// webkit
				$element.css('float', 'left');
				// firefox
				$element.css('cssFloat', 'left');
				// IE < 8
				$element.css('styleFloat', 'left');
				finishEdit();
			});
			var floatRight = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1"><i class="fa fa-align-right"></i></button>');
			floatRight.on('click', function(event){
				event.preventDefault();
				// webkit
				$element.css('float', 'right');
				// firefox
				$element.css('cssFloat', 'right');
				// IE < 8
				$element.css('styleFloat', 'right');
				finishEdit();
			});
			var floatNone = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1"><i class="fa fa-align-justify"></i></button>');
			floatNone.on('click', function(event){
				event.preventDefault();
				// webkit
				$element.css('float', '');
				// firefox
				$element.css('cssFloat', '');
				// IE < 8
				$element.css('styleFloat', '');
				finishEdit();
			});
			buttonGroup.append(floatLeft);
			buttonGroup.append(floatNone);
			buttonGroup.append(floatRight);
			container.append(buttonGroup);

			buttonGroup = angular.element('<div class="btn-group">');
			var remove = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1"><i class="fa fa-trash-o"></i></button>');
			remove.on('click', function(event){
				event.preventDefault();
				$element.remove();
				finishEdit();
			});
			buttonGroup.append(remove);
			container.append(buttonGroup);

			editorScope.showPopover($element);
			editorScope.showResizeOverlay($element);
		},
		aOnSelectAction: function(event, $element, editorScope){
			// setup the editor toolbar
			// Credit to the work at http://hackerwins.github.io/summernote/ for this editbar logic
			event.preventDefault();
			editorScope.displayElements.popover.css('width', '436px');
			var container = editorScope.displayElements.popoverContainer;
			container.empty();
			container.css('line-height', '28px');
			var link = angular.element('<a href="' + $element.attr('href') + '" target="_blank">' + $element.attr('href') + '</a>');
			link.css({
				'display': 'inline-block',
				'max-width': '200px',
				'overflow': 'hidden',
				'text-overflow': 'ellipsis',
				'white-space': 'nowrap',
				'vertical-align': 'middle'
			});
			container.append(link);
			var buttonGroup = angular.element('<div class="btn-group pull-right">');
			var reLinkButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" tabindex="-1" unselectable="on" title="' + taTranslations.editLink.reLinkButton.tooltip + '"><i class="fa fa-edit icon-edit"></i></button>');
			reLinkButton.on('click', function(event){
				event.preventDefault();
				var urlLink = $window.prompt(taTranslations.insertLink.dialogPrompt, $element.attr('href'));
				if(urlLink && urlLink !== '' && urlLink !== 'http://'){
					$element.attr('href', urlLink);
					editorScope.updateTaBindtaTextElement();
				}
				editorScope.hidePopover();
			});
			buttonGroup.append(reLinkButton);
			var unLinkButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" tabindex="-1" unselectable="on" title="' + taTranslations.editLink.unLinkButton.tooltip + '"><i class="fa fa-unlink icon-unlink"></i></button>');
			// directly before this click event is fired a digest is fired off whereby the reference to $element is orphaned off
			unLinkButton.on('click', function(event){
				event.preventDefault();
				$element.replaceWith($element.contents());
				editorScope.updateTaBindtaTextElement();
				editorScope.hidePopover();
			});
			buttonGroup.append(unLinkButton);
			var targetToggle = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" tabindex="-1" unselectable="on">' + taTranslations.editLink.targetToggle.buttontext + '</button>');
			if($element.attr('target') === '_blank'){
				targetToggle.addClass('active');
			}
			targetToggle.on('click', function(event){
				event.preventDefault();
				$element.attr('target', ($element.attr('target') === '_blank') ? '' : '_blank');
				targetToggle.toggleClass('active');
				editorScope.updateTaBindtaTextElement();
			});
			buttonGroup.append(targetToggle);
			container.append(buttonGroup);
			editorScope.showPopover($element);
		},
		extractYoutubeVideoId: function(url) {
			var re = /(?:youtube(?:-nocookie)?\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/i;
			var match = url.match(re);
			return (match && match[1]) || null;
		}
	};
}])
.run(['taRegisterTool', '$window', 'taTranslations', 'taSelection', 'taToolFunctions', '$sanitize', 'taOptions', '$log',
	function(taRegisterTool, $window, taTranslations, taSelection, taToolFunctions, $sanitize, taOptions, $log){
	// test for the version of $sanitize that is in use
	// You can disable this check by setting taOptions.textAngularSanitize == false
	var gv = {}; $sanitize('', gv);
	/* istanbul ignore next, throws error */
	if ((taOptions.forceTextAngularSanitize===true) && (gv.version !== 'taSanitize')) {
		throw angular.$$minErr('textAngular')("textAngularSetup", "The textAngular-sanitize provider has been replaced by another -- have you included angular-sanitize by mistake?");
	}
	taRegisterTool("html", {
		iconclass: 'fa fa-code',
		tooltiptext: taTranslations.html.tooltip,
		action: function(){
			this.$editor().switchView();
		},
		activeState: function(){
			return this.$editor().showHtml;
		}
	});
	// add the Header tools
	// convenience functions so that the loop works correctly
	var _retActiveStateFunction = function(q){
		return function(){ return this.$editor().queryFormatBlockState(q); };
	};
	var headerAction = function(){
		return this.$editor().wrapSelection("formatBlock", "<" + this.name.toUpperCase() +">");
	};
	angular.forEach(['h1','h2','h3','h4','h5','h6'], function(h){
		taRegisterTool(h.toLowerCase(), {
			buttontext: h.toUpperCase(),
			tooltiptext: taTranslations.heading.tooltip + h.charAt(1),
			action: headerAction,
			activeState: _retActiveStateFunction(h.toLowerCase())
		});
	});
	taRegisterTool('p', {
		buttontext: 'P',
		tooltiptext: taTranslations.p.tooltip,
		action: function(){
			return this.$editor().wrapSelection("formatBlock", "<P>");
		},
		activeState: function(){ return this.$editor().queryFormatBlockState('p'); }
	});
	// key: pre -> taTranslations[key].tooltip, taTranslations[key].buttontext
	taRegisterTool('pre', {
		buttontext: 'pre',
		tooltiptext: taTranslations.pre.tooltip,
		action: function(){
			return this.$editor().wrapSelection("formatBlock", "<PRE>");
		},
		activeState: function(){ return this.$editor().queryFormatBlockState('pre'); }
	});
	taRegisterTool('ul', {
		iconclass: 'fa fa-list-ul',
		tooltiptext: taTranslations.ul.tooltip,
		action: function(){
			return this.$editor().wrapSelection("insertUnorderedList", null);
		},
		activeState: function(){ return this.$editor().queryCommandState('insertUnorderedList'); }
	});
	taRegisterTool('ol', {
		iconclass: 'fa fa-list-ol',
		tooltiptext: taTranslations.ol.tooltip,
		action: function(){
			return this.$editor().wrapSelection("insertOrderedList", null);
		},
		activeState: function(){ return this.$editor().queryCommandState('insertOrderedList'); }
	});
	taRegisterTool('quote', {
		iconclass: 'fa fa-quote-right',
		tooltiptext: taTranslations.quote.tooltip,
		action: function(){
			return this.$editor().wrapSelection("formatBlock", "<BLOCKQUOTE>");
		},
		activeState: function(){ return this.$editor().queryFormatBlockState('blockquote'); }
	});
	taRegisterTool('undo', {
		iconclass: 'fa fa-undo',
		tooltiptext: taTranslations.undo.tooltip,
		action: function(){
			return this.$editor().wrapSelection("undo", null);
		}
	});
	taRegisterTool('redo', {
		iconclass: 'fa fa-repeat',
		tooltiptext: taTranslations.redo.tooltip,
		action: function(){
			return this.$editor().wrapSelection("redo", null);
		}
	});
	taRegisterTool('bold', {
		iconclass: 'fa fa-bold',
		tooltiptext: taTranslations.bold.tooltip,
		action: function(){
			return this.$editor().wrapSelection("bold", null);
		},
		activeState: function(){
			return this.$editor().queryCommandState('bold');
		},
		commandKeyCode: 98
	});
	taRegisterTool('justifyLeft', {
		iconclass: 'fa fa-align-left',
		tooltiptext: taTranslations.justifyLeft.tooltip,
		action: function(){
			return this.$editor().wrapSelection("justifyLeft", null);
		},
		activeState: function(commonElement){
			/* istanbul ignore next: */
			if (commonElement && commonElement.nodeName === '#document') return false;
			var result = false;
			if (commonElement)
				result =
					commonElement.css('text-align') === 'left' ||
					commonElement.attr('align') === 'left' ||
					(
						commonElement.css('text-align') !== 'right' &&
						commonElement.css('text-align') !== 'center' &&
						commonElement.css('text-align') !== 'justify' && !this.$editor().queryCommandState('justifyRight') && !this.$editor().queryCommandState('justifyCenter')
					) && !this.$editor().queryCommandState('justifyFull');
			result = result || this.$editor().queryCommandState('justifyLeft');
			return result;
		}
	});
	taRegisterTool('justifyRight', {
		iconclass: 'fa fa-align-right',
		tooltiptext: taTranslations.justifyRight.tooltip,
		action: function(){
			return this.$editor().wrapSelection("justifyRight", null);
		},
		activeState: function(commonElement){
			/* istanbul ignore next: */
			if (commonElement && commonElement.nodeName === '#document') return false;
			var result = false;
			if(commonElement) result = commonElement.css('text-align') === 'right';
			result = result || this.$editor().queryCommandState('justifyRight');
			return result;
		}
	});
	taRegisterTool('justifyFull', {
		iconclass: 'fa fa-align-justify',
		tooltiptext: taTranslations.justifyFull.tooltip,
		action: function(){
			return this.$editor().wrapSelection("justifyFull", null);
		},
		activeState: function(commonElement){
			var result = false;
			if(commonElement) result = commonElement.css('text-align') === 'justify';
			result = result || this.$editor().queryCommandState('justifyFull');
			return result;
		}
	});
	taRegisterTool('justifyCenter', {
		iconclass: 'fa fa-align-center',
		tooltiptext: taTranslations.justifyCenter.tooltip,
		action: function(){
			return this.$editor().wrapSelection("justifyCenter", null);
		},
		activeState: function(commonElement){
			/* istanbul ignore next: */
			if (commonElement && commonElement.nodeName === '#document') return false;
			var result = false;
			if(commonElement) result = commonElement.css('text-align') === 'center';
			result = result || this.$editor().queryCommandState('justifyCenter');
			return result;
		}
	});
	taRegisterTool('indent', {
		iconclass: 'fa fa-indent',
		tooltiptext: taTranslations.indent.tooltip,
		action: function(){
			return this.$editor().wrapSelection("indent", null);
		},
		activeState: function(){
			return this.$editor().queryFormatBlockState('blockquote');
		},
		commandKeyCode: 'TabKey'
	});
	taRegisterTool('outdent', {
		iconclass: 'fa fa-outdent',
		tooltiptext: taTranslations.outdent.tooltip,
		action: function(){
			return this.$editor().wrapSelection("outdent", null);
		},
		activeState: function(){
			return false;
		},
		commandKeyCode: 'ShiftTabKey'
	});
	taRegisterTool('italics', {
		iconclass: 'fa fa-italic',
		tooltiptext: taTranslations.italic.tooltip,
		action: function(){
			return this.$editor().wrapSelection("italic", null);
		},
		activeState: function(){
			return this.$editor().queryCommandState('italic');
		},
		commandKeyCode: 105
	});
	taRegisterTool('underline', {
		iconclass: 'fa fa-underline',
		tooltiptext: taTranslations.underline.tooltip,
		action: function(){
			return this.$editor().wrapSelection("underline", null);
		},
		activeState: function(){
			return this.$editor().queryCommandState('underline');
		},
		commandKeyCode: 117
	});
	taRegisterTool('strikeThrough', {
		iconclass: 'fa fa-strikethrough',
		tooltiptext: taTranslations.strikeThrough.tooltip,
		action: function(){
			return this.$editor().wrapSelection("strikeThrough", null);
		},
		activeState: function(){
			return document.queryCommandState('strikeThrough');
		}
	});
	taRegisterTool('clear', {
		// iconclass: 'fa fa-ban',
		buttontext:"清除",
		tooltiptext: taTranslations.clear.tooltip,
		action: function(deferred, restoreSelection){
			var i, selectedElements, elementsSeen;

			this.$editor().wrapSelection("removeFormat", null);
			var possibleNodes = angular.element(taSelection.getSelectionElement());
			selectedElements = taSelection.getAllSelectedElements();
			//$log.log('selectedElements:', selectedElements);
			// remove lists
			var removeListElements = function(list, pe){
				list = angular.element(list);
				var prevElement = pe;
				if (!pe) {
					prevElement = list;
				}
				angular.forEach(list.children(), function(liElem){
					if (liElem.tagName.toLowerCase() === 'ul' ||
						liElem.tagName.toLowerCase() === 'ol') {
						prevElement = removeListElements(liElem, prevElement);
					} else {
						var newElem = angular.element('<p></p>');
						newElem.html(angular.element(liElem).html());
						prevElement.after(newElem);
						prevElement = newElem;
					}
				});
				list.remove();
				return prevElement;
			};

			angular.forEach(selectedElements, function(element) {
				if (element.nodeName.toLowerCase() === 'ul' ||
					element.nodeName.toLowerCase() === 'ol') {
					//console.log('removeListElements', element);
					removeListElements(element);
				}
			});

			angular.forEach(possibleNodes.find("ul"), removeListElements);
			angular.forEach(possibleNodes.find("ol"), removeListElements);

			// clear out all class attributes. These do not seem to be cleared via removeFormat
			var $editor = this.$editor();
			var recursiveRemoveClass = function(node){
				node = angular.element(node);
				/* istanbul ignore next: this is not triggered in tests any longer since we now never select the whole displayELement */
				if(node[0] !== $editor.displayElements.text[0]) {
					node.removeAttr('class');
				}
				angular.forEach(node.children(), recursiveRemoveClass);
			};
			angular.forEach(possibleNodes, recursiveRemoveClass);
			// check if in list. If not in list then use formatBlock option
			if(possibleNodes[0] && possibleNodes[0].tagName.toLowerCase() !== 'li' &&
				possibleNodes[0].tagName.toLowerCase() !== 'ol' &&
				possibleNodes[0].tagName.toLowerCase() !== 'ul') {
				this.$editor().wrapSelection("formatBlock", "default");
			}
			restoreSelection();
		}
	});

		/* jshint -W099 */
	/****************************
	 //  we don't use this code - since the previous way CLEAR is expected to work does not clear partially selected <li>

	 var removeListElement = function(listE){
				console.log(listE);
				var _list = listE.parentNode.childNodes;
				console.log('_list', _list);
				var _preLis = [], _postLis = [], _found = false;
				for (i = 0; i < _list.length; i++) {
					if (_list[i] === listE) {
						_found = true;
					} else if (!_found) _preLis.push(_list[i]);
					else _postLis.push(_list[i]);
				}
				var _parent = angular.element(listE.parentNode);
				var newElem = angular.element('<p></p>');
				newElem.html(angular.element(listE).html());
				if (_preLis.length === 0 || _postLis.length === 0) {
					if (_postLis.length === 0) _parent.after(newElem);
					else _parent[0].parentNode.insertBefore(newElem[0], _parent[0]);

					if (_preLis.length === 0 && _postLis.length === 0) _parent.remove();
					else angular.element(listE).remove();
				} else {
					var _firstList = angular.element('<' + _parent[0].tagName + '></' + _parent[0].tagName + '>');
					var _secondList = angular.element('<' + _parent[0].tagName + '></' + _parent[0].tagName + '>');
					for (i = 0; i < _preLis.length; i++) _firstList.append(angular.element(_preLis[i]));
					for (i = 0; i < _postLis.length; i++) _secondList.append(angular.element(_postLis[i]));
					_parent.after(_secondList);
					_parent.after(newElem);
					_parent.after(_firstList);
					_parent.remove();
				}
				taSelection.setSelectionToElementEnd(newElem[0]);
			};

	 elementsSeen = [];
	 if (selectedElements.length !==0) console.log(selectedElements);
	 angular.forEach(selectedElements, function (element) {
				if (elementsSeen.indexOf(element) !== -1 || elementsSeen.indexOf(element.parentElement) !== -1) {
					return;
				}
				elementsSeen.push(element);
				if (element.nodeName.toLowerCase() === 'li') {
					console.log('removeListElement', element);
					removeListElement(element);
				}
				else if (element.parentElement && element.parentElement.nodeName.toLowerCase() === 'li') {
					console.log('removeListElement', element.parentElement);
					elementsSeen.push(element.parentElement);
					removeListElement(element.parentElement);
				}
			});
	 **********************/

	/**********************
	 if(possibleNodes[0].tagName.toLowerCase() === 'li'){
				var _list = possibleNodes[0].parentNode.childNodes;
				var _preLis = [], _postLis = [], _found = false;
				for(i = 0; i < _list.length; i++){
					if(_list[i] === possibleNodes[0]){
						_found = true;
					}else if(!_found) _preLis.push(_list[i]);
					else _postLis.push(_list[i]);
				}
				var _parent = angular.element(possibleNodes[0].parentNode);
				var newElem = angular.element('<p></p>');
				newElem.html(angular.element(possibleNodes[0]).html());
				if(_preLis.length === 0 || _postLis.length === 0){
					if(_postLis.length === 0) _parent.after(newElem);
					else _parent[0].parentNode.insertBefore(newElem[0], _parent[0]);

					if(_preLis.length === 0 && _postLis.length === 0) _parent.remove();
					else angular.element(possibleNodes[0]).remove();
				}else{
					var _firstList = angular.element('<'+_parent[0].tagName+'></'+_parent[0].tagName+'>');
					var _secondList = angular.element('<'+_parent[0].tagName+'></'+_parent[0].tagName+'>');
					for(i = 0; i < _preLis.length; i++) _firstList.append(angular.element(_preLis[i]));
					for(i = 0; i < _postLis.length; i++) _secondList.append(angular.element(_postLis[i]));
					_parent.after(_secondList);
					_parent.after(newElem);
					_parent.after(_firstList);
					_parent.remove();
				}
				taSelection.setSelectionToElementEnd(newElem[0]);
			}
	 *******************/


	/* istanbul ignore next: if it's javascript don't worry - though probably should show some kind of error message */
	var blockJavascript = function (link) {
		if (link.toLowerCase().indexOf('javascript')!==-1) {
			return true;
		}
		return false;
	};

	taRegisterTool('insertImage', {
		iconclass: 'fa fa-picture-o',
		tooltiptext: taTranslations.insertImage.tooltip,
		action: function(){
			var imageLink;
			imageLink = $window.prompt(taTranslations.insertImage.dialogPrompt, 'http://');
			if(imageLink && imageLink !== '' && imageLink !== 'http://'){
				/* istanbul ignore next: don't know how to test this... since it needs a dialogPrompt */
				// block javascript here
				if (!blockJavascript(imageLink)) {
					if (taSelection.getSelectionElement().tagName.toLowerCase() === 'a') {
						// due to differences in implementation between FireFox and Chrome, we must move the
						// insertion point past the <a> element, otherwise FireFox inserts inside the <a>
						// With this change, both FireFox and Chrome behave the same way!
						taSelection.setSelectionAfterElement(taSelection.getSelectionElement());
					}
					// In the past we used the simple statement:
					//return this.$editor().wrapSelection('insertImage', imageLink, true);
					//
					// However on Firefox only, when the content is empty this is a problem
					// See Issue #1201
					// Investigation reveals that Firefox only inserts a <p> only!!!!
					// So now we use insertHTML here and all is fine.
					// NOTE: this is what 'insertImage' is supposed to do anyway!
					var embed = '<img src="' + imageLink + '">';
					return this.$editor().wrapSelection('insertHTML', embed, true);
				}
			}
		},
		onElementSelect: {
			element: 'img',
			action: taToolFunctions.imgOnSelectAction
		}
	});
	taRegisterTool('insertVideo', {
		iconclass: 'fa fa-youtube-play',
		tooltiptext: taTranslations.insertVideo.tooltip,
		action: function(){
			var urlPrompt;
			urlPrompt = $window.prompt(taTranslations.insertVideo.dialogPrompt, 'https://');
			// block javascript here
			/* istanbul ignore else: if it's javascript don't worry - though probably should show some kind of error message */
			if (!blockJavascript(urlPrompt)) {

				if (urlPrompt && urlPrompt !== '' && urlPrompt !== 'https://') {

					videoId = taToolFunctions.extractYoutubeVideoId(urlPrompt);

					/* istanbul ignore else: if it's invalid don't worry - though probably should show some kind of error message */
					if (videoId) {
						// create the embed link
						var urlLink = "https://www.youtube.com/embed/" + videoId;
						// create the HTML
						// for all options see: http://stackoverflow.com/questions/2068344/how-do-i-get-a-youtube-video-thumbnail-from-the-youtube-api
						// maxresdefault.jpg seems to be undefined on some.
						var embed = '<img class="ta-insert-video" src="https://img.youtube.com/vi/' + videoId + '/hqdefault.jpg" ta-insert-video="' + urlLink + '" contenteditable="false" allowfullscreen="true" frameborder="0" />';
						/* istanbul ignore next: don't know how to test this... since it needs a dialogPrompt */
						if (taSelection.getSelectionElement().tagName.toLowerCase() === 'a') {
							// due to differences in implementation between FireFox and Chrome, we must move the
							// insertion point past the <a> element, otherwise FireFox inserts inside the <a>
							// With this change, both FireFox and Chrome behave the same way!
							taSelection.setSelectionAfterElement(taSelection.getSelectionElement());
						}
						// insert
						return this.$editor().wrapSelection('insertHTML', embed, true);
					}
				}
			}
		},
		onElementSelect: {
			element: 'img',
			onlyWithAttrs: ['ta-insert-video'],
			action: taToolFunctions.imgOnSelectAction
		}
	});
	taRegisterTool('insertLink', {
		tooltiptext: taTranslations.insertLink.tooltip,
		iconclass: 'fa fa-link',
		action: function(){
			var urlLink;
			// if this link has already been set, we need to just edit the existing link
			/* istanbul ignore if: we do not test this */
			if (taSelection.getSelectionElement().tagName.toLowerCase() === 'a') {
				urlLink = $window.prompt(taTranslations.insertLink.dialogPrompt, taSelection.getSelectionElement().href);
			} else {
				urlLink = $window.prompt(taTranslations.insertLink.dialogPrompt, 'http://');
			}
			if(urlLink && urlLink !== '' && urlLink !== 'http://'){
				// block javascript here
				/* istanbul ignore else: if it's javascript don't worry - though probably should show some kind of error message */
				if (!blockJavascript(urlLink)) {
					return this.$editor().wrapSelection('createLink', urlLink, true);
				}
			}
		},
		activeState: function(commonElement){
			if(commonElement) return commonElement[0].tagName === 'A';
			return false;
		},
		onElementSelect: {
			element: 'a',
			action: taToolFunctions.aOnSelectAction
		}
	});
	taRegisterTool('wordcount', {
		display: '<div id="toolbarWC" style="display:block; min-width:100px;">Words: <span ng-bind="wordcount"></span></div>',
		disabled: true,
		wordcount: 0,
		activeState: function(){ // this fires on keyup
			var textElement = this.$editor().displayElements.text;
			/* istanbul ignore next: will default to '' when undefined */
			var workingHTML = textElement[0].innerHTML || '';
			var noOfWords = 0;

			/* istanbul ignore if: will default to '' when undefined */
			if (workingHTML.replace(/\s*<[^>]*?>\s*/g, '') !== '') {
				noOfWords = workingHTML.replace(/<\/?(b|i|em|strong|span|u|strikethrough|a|img|small|sub|sup|label)( [^>*?])?>/gi, '') // remove inline tags without adding spaces
										.replace(/(<[^>]*?>\s*<[^>]*?>)/ig, ' ') // replace adjacent tags with possible space between with a space
										.replace(/(<[^>]*?>)/ig, '') // remove any singular tags
										.replace(/\s+/ig, ' ') // condense spacing
										.match(/\S+/g).length; // count remaining non-space strings
			}

			//Set current scope
			this.wordcount = noOfWords;
			//Set editor scope
			this.$editor().wordcount = noOfWords;

			return false;
		}
	});
	taRegisterTool('charcount', {
		display: '<div id="toolbarCC" style="display:block; min-width:120px;">Characters: <span ng-bind="charcount"></span></div>',
		disabled: true,
		charcount: 0,
		activeState: function(){ // this fires on keyup
			var textElement = this.$editor().displayElements.text;
			var sourceText = textElement[0].innerText || textElement[0].textContent; // to cover the non-jquery use case.

			// Caculate number of chars
			var noOfChars = sourceText.replace(/(\r\n|\n|\r)/gm,"").replace(/^\s+/g,' ').replace(/\s+$/g, ' ').length;
			//Set current scope
			this.charcount = noOfChars;
			//Set editor scope
			this.$editor().charcount = noOfChars;
			return false;
		}
	});
}]);

(function (factory) {
  if (typeof window.define === 'function') {
      if (window.define.amd) {
          // AMD模式
          window.define('wangEditor', ["jquery"], factory);
      } else if (window.define.cmd) {
          // CMD模式
          window.define(function (require, exports, module) {
              return factory;
          });
      } else {
          // 全局模式
          factory(window.jQuery);
      }
  } else if (typeof module === "object" && typeof module.exports === "object") {
      // commonjs

      // 引用 css —— webapck
      window.wangEditorCssPath ? require(window.wangEditorCssPath) : require('../css/wangEditor.css');
      module.exports = factory(
          // 传入 jquery ，支持使用 npm 方式或者自己定义jquery的路径
          window.wangEditorJQueryPath ? require(window.wangEditorJQueryPath) : require('jquery')
      );
  } else {
      // 全局模式
      factory(window.jQuery);
  }
})(function($){
  
  // 验证是否引用jquery
  if (!$ || !$.fn || !$.fn.jquery) {
      alert('在引用wangEditor.js之前，先引用jQuery，否则无法使用 wangEditor');
      return;
  }

  // 定义扩展函数
  var _e = function (fn) {
      var E = window.wangEditor;
      if (E) {
          // 执行传入的函数
          fn(E, $);
      }
  };
// 定义构造函数
(function (window, $) {
  if (window.wangEditor) {
      // 重复引用
      alert('一个页面不能重复引用 wangEditor.js 或 wangEditor.min.js ！！！');
      return;
  }

  // 编辑器（整体）构造函数
  var E = function (elem) {
      // 支持 id 和 element 两种形式
      if (typeof elem === 'string') {
          elem = '#' + elem;
      }

      // ---------------获取基本节点------------------
      var $elem = $(elem);
      if ($elem.length !== 1) {
          return;
      }
      var nodeName = $elem[0].nodeName;
      if (nodeName !== 'TEXTAREA' && nodeName !== 'DIV') {
          // 只能是 textarea 和 div ，其他类型的元素不行
          return;   
      }
      this.valueNodeName = nodeName.toLowerCase();
      this.$valueContainer = $elem;

      // 记录 elem 的 prev 和 parent（最后渲染 editor 要用到）
      this.$prev = $elem.prev();
      this.$parent = $elem.parent();

      // ------------------初始化------------------
      this.init();
  };

  E.fn = E.prototype;

  E.$body = $('body');
  E.$document = $(document);
  E.$window = $(window);
  E.userAgent = navigator.userAgent;
  E.getComputedStyle = window.getComputedStyle;
  E.w3cRange = typeof document.createRange === 'function';
  E.hostname = location.hostname.toLowerCase();
  E.websiteHost = 'wangeditor.github.io|www.wangeditor.com|wangeditor.coding.me';
  E.isOnWebsite = E.websiteHost.indexOf(E.hostname) >= 0;
  E.docsite = 'http://www.kancloud.cn/wangfupeng/wangeditor2/113961';

  // 暴露给全局对象
  window.wangEditor = E;

  // 注册 plugin 事件，用于用户自定义插件
  // 用户在引用 wangEditor.js 之后，还可以通过 E.plugin() 注入自定义函数，
  // 该函数将会在 editor.create() 方法的最后一步执行
  E.plugin = function (fn) {
      if (!E._plugins) {
          E._plugins = [];
      }

      if (typeof fn === 'function') {
          E._plugins.push(fn);
      }
  };

})(window, $);
// editor 绑定事件
_e(function (E, $) {

  E.fn.init = function () {

      // 初始化 editor 默认配置
      this.initDefaultConfig();

      // 增加container
      this.addEditorContainer();

      // 增加编辑区域
      this.addTxt();

      // 增加menuContainer
      this.addMenuContainer();

      // 初始化菜单集合
      this.menus = {};

      // 初始化commandHooks
      this.commandHooks();

  };

});
// editor api
_e(function (E, $) {

  // 预定义 ready 事件
  E.fn.ready = function (fn) {

      if (!this.readyFns) {
          this.readyFns = [];
      }

      this.readyFns.push(fn);
  };

  // 处理ready事件
  E.fn.readyHeadler = function () {
      var fns = this.readyFns;

      while (fns.length) {
          fns.shift().call(this);
      }
  };

  // 更新内容到 $valueContainer
  E.fn.updateValue = function () {
      var editor = this;
      var $valueContainer = editor.$valueContainer;
      var $txt = editor.txt.$txt;

      if ($valueContainer === $txt) {
          // 传入生成编辑器的div，即是编辑区域
          return;
      }

      var value = $txt.html();
      $valueContainer.val(value);
  };

  // 获取初始化的内容
  E.fn.getInitValue = function () {
      var editor = this;
      var $valueContainer = editor.$valueContainer;
      var currentValue = '';
      var nodeName = editor.valueNodeName;
      if (nodeName === 'div') {
          currentValue = $valueContainer.html();
      } else if (nodeName === 'textarea') {
          currentValue = $valueContainer.val();
      }

      return currentValue;
  };

  // 触发菜单updatestyle
  E.fn.updateMenuStyle = function () {
      var menus = this.menus;

      $.each(menus, function (k, menu) {
          menu.updateSelected();
      });
  };

  // 除了传入的 menuIds，其他全部启用
  E.fn.enableMenusExcept = function (menuIds) {
      if (this._disabled) {
          // 编辑器处于禁用状态，则不执行改操作
          return;
      }
      // menuIds参数：支持数组和字符串
      menuIds = menuIds || [];
      if (typeof menuIds === 'string') {
          menuIds = [menuIds];
      }

      $.each(this.menus, function (k, menu) {
          if (menuIds.indexOf(k) >= 0) {
              return;
          }
          menu.disabled(false);
      });
  };

  // 除了传入的 menuIds，其他全部禁用
  E.fn.disableMenusExcept = function (menuIds) {
      if (this._disabled) {
          // 编辑器处于禁用状态，则不执行改操作
          return;
      }
      // menuIds参数：支持数组和字符串
      menuIds = menuIds || [];
      if (typeof menuIds === 'string') {
          menuIds = [menuIds];
      }

      $.each(this.menus, function (k, menu) {
          if (menuIds.indexOf(k) >= 0) {
              return;
          }
          menu.disabled(true);
      });
  };

  // 隐藏所有 dropPanel droplist modal
  E.fn.hideDropPanelAndModal = function () {
      var menus = this.menus;

      $.each(menus, function (k, menu) {
          var m = menu.dropPanel || menu.dropList || menu.modal;
          if (m && m.hide) {
              m.hide();
          }
      });
  };

});
// selection range API
_e(function (E, $) {

  // 用到 w3c range 的函数，如果检测到浏览器不支持 w3c range，则赋值为空函数
  var ieRange = !E.w3cRange;
  function emptyFn() {}

  // 设置或读取当前的range
  E.fn.currentRange = function (cr){
      if (cr) {
          this._rangeData = cr;
      } else {
          return this._rangeData;
      }
  };

  // 将当前选区折叠
  E.fn.collapseRange = function (range, opt) {
      // opt 参数说明：'start'-折叠到开始; 'end'-折叠到结束
      opt = opt || 'end';
      opt = opt === 'start' ? true : false;

      range = range || this.currentRange();
      
      if (range) {
          // 合并，保存
          range.collapse(opt);
          this.currentRange(range);
      }
  };

  // 获取选区的文字
  E.fn.getRangeText = ieRange ? emptyFn : function (range) {
      range = range || this.currentRange();
      if (!range) {
          return;
      }
      return range.toString();
  };

  // 获取选区对应的DOM对象
  E.fn.getRangeElem = ieRange ? emptyFn : function (range) {
      range = range || this.currentRange();
      var dom = range.commonAncestorContainer;

      if (dom.nodeType === 1) {
          return dom;
      } else {
          return dom.parentNode;
      }
  };

  // 选区内容是否为空？
  E.fn.isRangeEmpty = ieRange ? emptyFn : function (range) {
      range = range || this.currentRange();

      if (range && range.startContainer) {
          if (range.startContainer === range.endContainer) {
              if (range.startOffset === range.endOffset) {
                  return true;
              }
          }
      }

      return false;
  };

  // 保存选区数据
  E.fn.saveSelection = ieRange ? emptyFn : function (range) {
      var self = this,
          _parentElem,
          selection,
          txt = self.txt.$txt.get(0);

      if (range) {
          _parentElem = range.commonAncestorContainer;
      } else {
          selection = document.getSelection();
          if (selection.getRangeAt && selection.rangeCount) {
              range = document.getSelection().getRangeAt(0);
              _parentElem = range.commonAncestorContainer;
          }
      }
      // 确定父元素一定要包含在编辑器区域内
      if (_parentElem && ($.contains(txt, _parentElem) || txt === _parentElem) ) {
          // 保存选择区域
          self.currentRange(range);
      }
  };

  // 恢复选中区域
  E.fn.restoreSelection = ieRange ? emptyFn : function (range) {
      var selection;

      range = range || this.currentRange();

      if (!range) {
          return;
      }

      // 使用 try catch 来防止 IE 某些情况报错
      try {
          selection = document.getSelection();
          selection.removeAllRanges();
          selection.addRange(range);
      } catch (ex) {
          E.error('执行 editor.restoreSelection 时，IE可能会有异常，不影响使用');
      }
  };

  // 根据elem恢复选区
  E.fn.restoreSelectionByElem = ieRange ? emptyFn : function (elem, opt) {
      // opt参数说明：'start'-折叠到开始，'end'-折叠到结束，'all'-全部选中
      if (!elem) {
          return;
      }
      opt = opt || 'end'; // 默认为折叠到结束

      // 根据elem获取选区
      this.setRangeByElem(elem);

      // 根据 opt 折叠选区
      if (opt === 'start') {
          this.collapseRange(this.currentRange(), 'start');
      }
      if (opt === 'end') {
          this.collapseRange(this.currentRange(), 'end');
      }
      
      // 恢复选区
      this.restoreSelection();
  };

  // 初始化选区
  E.fn.initSelection = ieRange ? emptyFn : function () {
      var editor = this;
      if( editor.currentRange() ){
          //如果currentRange有值，则不用再初始化
          return;
      }

      var range;
      var $txt = editor.txt.$txt;
      var $firstChild = $txt.children().first();
      
      if ($firstChild.length) {
          editor.restoreSelectionByElem($firstChild.get(0));
      }
  };

  // 根据元素创建选区
  E.fn.setRangeByElem = ieRange ? emptyFn : function (elem) {
      var editor = this;
      var txtElem = editor.txt.$txt.get(0);
      if (!elem || !$.contains(txtElem, elem)) {
          return;
      }

      // 找到elem的第一个 textNode 和 最后一个 textNode
      var firstTextNode = elem.firstChild;
      while (firstTextNode) {
          if (firstTextNode.nodeType === 3) {
              break;
          }
          // 继续向下
          firstTextNode = firstTextNode.firstChild;
      }
      var lastTextNode = elem.lastChild;
      while (lastTextNode) {
          if (lastTextNode.nodeType === 3) {
              break;
          }
          // 继续向下
          lastTextNode = lastTextNode.lastChild;
      }
      
      var range = document.createRange();
      if (firstTextNode && lastTextNode) {
          // 说明 elem 有内容，能取到子元素
          range.setStart(firstTextNode, 0);
          range.setEnd(lastTextNode, lastTextNode.textContent.length);
      } else {
          // 说明 elem 无内容
          range.setStart(elem, 0);
          range.setEnd(elem, 0);
      }

      // 保存选区
      editor.saveSelection(range);
  };

});
// selection range API - IE8及以下
_e(function (E, $) {

  if (E.w3cRange) {
      // 说明支持 W3C 的range方法
      return;
  }

  // -----------------IE8时，需要重写以下方法-------------------

  // 获取选区的文字
  E.fn.getRangeText = function (range) {
      range = range || this.currentRange();
      if (!range) {
          return;
      }
      return range.text;
  };

  // 获取选区对应的DOM对象
  E.fn.getRangeElem = function (range) {
      range = range || this.currentRange();
      if (!range) {
          return;
      }
      var dom = range.parentElement();

      if (dom.nodeType === 1) {
          return dom;
      } else {
          return dom.parentNode;
      }
  };

  // 选区内容是否为空？
  E.fn.isRangeEmpty = function (range) {
      range = range || this.currentRange();

      if (range && range.text) {
          return false;
      }

      return true;
  };

  // 保存选区数据
  E.fn.saveSelection = function (range) {
      var self = this,
          _parentElem,
          selection,
          txt = self.txt.$txt.get(0);

      if (range) {
          _parentElem = range.parentElement();
      } else {
          range = document.selection.createRange();
          if(typeof range.parentElement === 'undefined'){
              //IE6、7中，insertImage后会执行此处
              //由于找不到range.parentElement，所以干脆将_parentElem赋值为null
              _parentElem = null;
          }else{
              _parentElem = range.parentElement();
          }
      }

      // 确定父元素一定要包含在编辑器区域内
      if (_parentElem && ($.contains(txt, _parentElem) || txt === _parentElem) ) {
          // 保存选择区域
          self.currentRange(range);
      }
  };

  // 恢复选中区域
  E.fn.restoreSelection = function (currentRange){
      var editor = this,
          selection,
          range;

      currentRange = currentRange || editor.currentRange();
      if(!currentRange){
          return;
      }

      range = document.selection.createRange();
      try {
          // 此处，plupload上传上传图片时，IE8-会报一个『参数无效』的错误
          range.setEndPoint('EndToEnd', currentRange);
      } catch (ex) {

      }
      
      if(currentRange.text.length === 0){
          try {
              // IE8 插入表情会报错
              range.collapse(false);
          } catch (ex) {
              
          }
          
      }else{
          range.setEndPoint('StartToStart', currentRange);
      }
      range.select();
  };

});
// editor command hooks
_e(function (E, $) {
  
  E.fn.commandHooks = function () {
      var editor = this;
      var commandHooks = {};
      
      // insertHtml
      commandHooks.insertHtml = function (html) {
          var $elem = $(html);
          var rangeElem = editor.getRangeElem();
          var targetElem;
          
          targetElem = editor.getLegalTags(rangeElem);
          if (!targetElem) {
              return;
          }

          $(targetElem).after($elem);
      };

      // 保存到对象
      editor.commandHooks = commandHooks;
  };

});
// editor command API
_e(function (E, $) {

  // 基本命令
  E.fn.command = function (e, commandName, commandValue, callback) {
      var editor = this;
      var hooks;
      
      function commandFn() {
          if (!commandName) {
              return;
          }
          if (editor.queryCommandSupported(commandName)) {
              // 默认命令
              document.execCommand(commandName, false, commandValue);
          } else {
              // hooks 命令
              hooks = editor.commandHooks;
              if (commandName in hooks) {
                  hooks[commandName](commandValue);
              }
          }
      }

      this.customCommand(e, commandFn, callback);
  };

  // 针对一个elem对象执行基础命令
  E.fn.commandForElem = function (elemOpt, e, commandName, commandValue, callback) {
      // 取得查询elem的查询条件和验证函数
      var selector;
      var check;
      if (typeof elemOpt === 'string') {
          selector = elemOpt;
      } else {
          selector = elemOpt.selector;
          check = elemOpt.check;
      }

      // 查询elem
      var rangeElem = this.getRangeElem();
      rangeElem = this.getSelfOrParentByName(rangeElem, selector, check);

      // 根据elem设置range
      if (rangeElem) {
          this.setRangeByElem(rangeElem);
      }

      // 然后执行基础命令
      this.command(e, commandName, commandValue, callback);
  };

  // 自定义命令
  E.fn.customCommand = function (e, commandFn, callback) {
      var editor = this;
      var range = editor.currentRange();

      if (!range) {
          // 目前没有选区，则无法执行命令
          e && e.preventDefault();
          return;
      }
      // 记录内容，以便撤销（执行命令之前就要记录）
      editor.undoRecord();

      // 恢复选区（有 range 参数）
      this.restoreSelection(range);

      // 执行命令事件
      commandFn.call(editor);

      // 保存选区（无参数，要从浏览器直接获取range信息）
      this.saveSelection();
      // 重新恢复选区（无参数，要取得刚刚从浏览器得到的range信息）
      this.restoreSelection();

      // 执行 callback
      if (callback && typeof callback === 'function') {
          callback.call(editor);
      }

      // 最后插入空行
      editor.txt.insertEmptyP();

      // 包裹暴露的img和text
      editor.txt.wrapImgAndText();

      // 更新内容
      editor.updateValue();

      // 更新菜单样式
      editor.updateMenuStyle();

      // 隐藏 dropPanel dropList modal  设置 200ms 间隔
      function hidePanelAndModal() {
          editor.hideDropPanelAndModal();
      } 
      setTimeout(hidePanelAndModal, 200);

      if (e) {
          e.preventDefault();
      }
  };

  // 封装 document.queryCommandValue 函数
  // IE8 直接执行偶尔会报错，因此直接用 try catch 封装一下
  E.fn.queryCommandValue = function (commandName) {
      var result = '';
      try {
          result = document.queryCommandValue(commandName);
      } catch (ex) {

      }
      return result;
  };

  // 封装 document.queryCommandState 函数
  // IE8 直接执行偶尔会报错，因此直接用 try catch 封装一下
  E.fn.queryCommandState = function (commandName) {
      var result = false;
      try {
          result = document.queryCommandState(commandName);
      } catch (ex) {

      }
      return result;
  };

  // 封装 document.queryCommandSupported 函数
  E.fn.queryCommandSupported = function (commandName) {
      var result = false;
      try {
          result = document.queryCommandSupported(commandName);
      } catch (ex) {

      }
      return result;
  };

});
// dom selector
_e(function (E, $) {

  var matchesSelector;

  // matchesSelector hook
  function _matchesSelectorForIE(selector) {
      var elem = this;
      var $elems = $(selector);
      var result = false;

      // 用jquery查找 selector 所有对象，如果其中有一个和传入 elem 相同，则证明 elem 符合 selector
      $elems.each(function () {
          if (this === elem) {
              result = true;
              return false;
          }
      });

      return result;
  }

  // 从当前的elem，往上去查找合法标签 如 p head table blockquote ul ol 等
  E.fn.getLegalTags = function (elem) {
      var legalTags = this.config.legalTags;
      if (!legalTags) {
          E.error('配置项中缺少 legalTags 的配置');
          return;
      }
      return this.getSelfOrParentByName(elem, legalTags);
  };

  // 根据条件，查询自身或者父元素，符合即返回
  E.fn.getSelfOrParentByName = function (elem, selector, check) {

      if (!elem || !selector) {
          return;
      }

      if (!matchesSelector) {
          // 定义 matchesSelector 函数
          matchesSelector = elem.webkitMatchesSelector || 
                            elem.mozMatchesSelector ||
                            elem.oMatchesSelector || 
                            elem.matchesSelector;
      }
      if (!matchesSelector) {
          // 如果浏览器本身不支持 matchesSelector 则使用自定义的hook
          matchesSelector = _matchesSelectorForIE;
      }

      var txt = this.txt.$txt.get(0);

      while (elem && txt !== elem && $.contains(txt, elem)) {
          if (matchesSelector.call(elem, selector)) {
              // 符合 selector 查询条件

              if (!check) {
                  // 没有 check 验证函数，直接返回即可
                  return elem;
              }

              if (check(elem)) {
                  // 如果有 check 验证函数，还需 check 函数的确认
                  return elem;
              }
          }

          // 如果上一步没经过验证，则将跳转到父元素
          elem = elem.parentNode;
      }

      return;
  };

});
// undo redo
_e(function (E, $) {

  var length = 20;  // 缓存的最大长度
  function _getRedoList(editor) {
      if (editor._redoList == null) {
          editor._redoList = [];
      }
      return editor._redoList;
  }
  function _getUndoList(editor) {
      if (editor._undoList == null) {
          editor._undoList = [];
      }
      return editor._undoList;
  }

  // 数据处理
  function _handle(editor, data, type) {
      // var range = data.range;
      // var range2 = range.cloneRange && range.cloneRange();
      var val = data.val;
      var html = editor.txt.$txt.html();

      if(val == null) {
          return;
      }

      if (val === html) {
          if (type === 'redo') { 
              editor.redo();
              return;
          } else if (type === 'undo') {
              editor.undo();
              return;
          } else {
              return;
          }
      }

      // 保存数据
      editor.txt.$txt.html(val);
      // 更新数据到textarea（有必要的话）
      editor.updateValue();

      // onchange 事件
      if (editor.onchange && typeof editor.onchange === 'function') {
          editor.onchange.call(editor);
      }

      // ?????
      // 注释：$txt 被重新赋值之后，range会被重置，cloneRange() 也不好使
      // // 重置选区
      // if (range2) {
      //     editor.restoreSelection(range2);
      // }
  }

  // 记录
  E.fn.undoRecord = function () {
      var editor = this;
      var $txt = editor.txt.$txt;
      var val = $txt.html();
      var undoList = _getUndoList(editor);
      var redoList = _getRedoList(editor);
      var currentVal = undoList.length ? undoList[0] : '';

      if (val === currentVal.val) {
          return;
      }

      // 清空 redolist
      if (redoList.length) {
          redoList = [];
      }

      // 添加数据到 undoList
      undoList.unshift({
          range: editor.currentRange(),  // 将当前的range也记录下
          val: val
      });

      // 限制 undoList 长度
      if (undoList.length > length) {
          undoList.pop();
      }
  };

  // undo 操作
  E.fn.undo = function () {
      var editor = this;
      var undoList = _getUndoList(editor);
      var redoList = _getRedoList(editor);

      if (!undoList.length) {
          return;
      }

      // 取出 undolist 第一个值，加入 redolist
      var data = undoList.shift();
      redoList.unshift(data);

      // 并修改编辑器的内容
      _handle(this, data, 'undo');
  };

  // redo 操作
  E.fn.redo = function () {
      var editor = this;
      var undoList = _getUndoList(editor);
      var redoList = _getRedoList(editor);
      if (!redoList.length) {
          return;
      }

      // 取出 redolist 第一个值，加入 undolist
      var data = redoList.shift();
      undoList.unshift(data);

      // 并修改编辑器的内容
      _handle(this, data, 'redo');
  };
});
// 暴露给用户的 API
_e(function (E, $) {

  // 创建编辑器
  E.fn.create = function () {
      var editor = this;

      // 检查 E.$body 是否有值
      // 如果在 body 之前引用了 js 文件，body 尚未加载，可能没有值
      if (!E.$body || E.$body.length === 0) {
          E.$body = $('body');
          E.$document = $(document);
          E.$window = $(window);
      }

      // 执行 addMenus 之前：
      // 1. 允许用户修改 editor.UI 自定义配置UI
      // 2. 允许用户通过修改 editor.menus 来自定义配置菜单
      // 因此要在 create 时执行，而不是 init           
      editor.addMenus();

      // 渲染
      editor.renderMenus();
      editor.renderMenuContainer();
      editor.renderTxt();
      editor.renderEditorContainer();

      // 绑定事件
      editor.eventMenus();
      editor.eventMenuContainer();
      editor.eventTxt();

      // 处理ready事件
      editor.readyHeadler();

      // 初始化选区
      editor.initSelection();

      // $txt 快捷方式
      editor.$txt = editor.txt.$txt;

      // 执行用户自定义事件，通过 E.ready() 添加
      var _plugins = E._plugins;
      if (_plugins && _plugins.length) {
          $.each(_plugins, function (k, val) {
              val.call(editor);
          });
      }
  };

  // 禁用编辑器
  E.fn.disable = function () {
      this.txt.$txt.removeAttr('contenteditable');
      this.disableMenusExcept();

      // 先禁用，再记录状态
      this._disabled = true;
  };
  // 启用编辑器
  E.fn.enable = function () {
      // 先解除状态记录，再启用
      this._disabled = false;
      this.txt.$txt.attr('contenteditable', 'true');
      this.enableMenusExcept();
  };

  // 销毁编辑器
  E.fn.destroy = function () {
      var self = this;
      var $valueContainer = self.$valueContainer;
      var $editorContainer = self.$editorContainer;
      var valueNodeName = self.valueNodeName;

      if (valueNodeName === 'div') {
          // div 生成的编辑器
          $valueContainer.removeAttr('contenteditable');
          $editorContainer.after($valueContainer);
          $editorContainer.hide();
      } else {
          // textarea 生成的编辑器
          $valueContainer.show();
          $editorContainer.hide();
      }
  };

  // 撤销 销毁编辑器
  E.fn.undestroy = function () {
      var self = this;
      var $valueContainer = self.$valueContainer;
      var $editorContainer = self.$editorContainer;
      var $menuContainer = self.menuContainer.$menuContainer;
      var valueNodeName = self.valueNodeName;

      if (valueNodeName === 'div') {
          // div 生成的编辑器
          $valueContainer.attr('contenteditable', 'true');
          $menuContainer.after($valueContainer);
          $editorContainer.show();
      } else {
          // textarea 生成的编辑器
          $valueContainer.hide();
          $editorContainer.show();
      }
  };

  // 清空内容的快捷方式
  E.fn.clear = function () {
      var editor = this;
      var $txt = editor.txt.$txt;
      $txt.html('<p><br></p>');
      editor.restoreSelectionByElem($txt.find('p').get(0));
  };

});
// menuContainer 构造函数
_e(function (E, $) {

  // 定义构造函数
  var MenuContainer = function (editor) {
      this.editor = editor;
      this.init();
  };

  MenuContainer.fn = MenuContainer.prototype;

  // 暴露给 E 即 window.wangEditor
  E.MenuContainer = MenuContainer;

});
// MenuContainer.fn bind fn
_e(function (E, $) {

  var MenuContainer = E.MenuContainer;

  // 初始化
  MenuContainer.fn.init = function () {
      var self = this;
      var $menuContainer = $('<div class="wangEditor-menu-container clearfix"></div>');

      self.$menuContainer = $menuContainer;

      // change shadow
      self.changeShadow();
  };

  // 编辑区域滚动时，增加shadow
  MenuContainer.fn.changeShadow = function () {
      var $menuContainer = this.$menuContainer;
      var editor = this.editor;
      var $txt = editor.txt.$txt;

      $txt.on('scroll', function () {
          if ($txt.scrollTop() > 10) {
              $menuContainer.addClass('wangEditor-menu-shadow');
          } else {
              $menuContainer.removeClass('wangEditor-menu-shadow');
          }
      });
  };

});
// MenuContainer.fn API
_e(function (E, $) {

  var MenuContainer = E.MenuContainer;

  MenuContainer.fn.render = function () {
      var $menuContainer = this.$menuContainer;
      var $editorContainer = this.editor.$editorContainer;

      $editorContainer.append($menuContainer);
  };
  
  // 获取菜单栏的高度
  MenuContainer.fn.height = function () {
      var $menuContainer = this.$menuContainer;
      return $menuContainer.height();
  };

  // 添加菜单
  MenuContainer.fn.appendMenu = function (groupIdx, menu) {
      // 判断是否需要新增一个菜单组
      this._addGroup(groupIdx);
      // 增加菜单（返回 $menuItem）
      return this._addOneMenu(menu);
  };
  MenuContainer.fn._addGroup = function (groupIdx) {
      var $menuContainer = this.$menuContainer;
      var $menuGroup;
      if (!this.$currentGroup || this.currentGroupIdx !== groupIdx) {
          $menuGroup = $('<div class="menu-group clearfix"></div>');
          $menuContainer.append($menuGroup);

          this.$currentGroup = $menuGroup;
          this.currentGroupIdx = groupIdx;
      }
  };
  MenuContainer.fn._addOneMenu = function (menu) {
      var $menuNormal = menu.$domNormal;
      var $menuSelected = menu.$domSelected;

      var $menuGroup = this.$currentGroup;
      var $item = $('<div class="menu-item clearfix"></div>');
      $menuSelected.hide();
      $item.append($menuNormal).append($menuSelected);
      $menuGroup.append($item);

      return $item;
  };

});
// menu 构造函数
_e(function (E, $) {

  // 定义构造函数
  var Menu = function (opt) {
      this.editor = opt.editor;
      this.id = opt.id;
      this.title = opt.title;
      this.$domNormal = opt.$domNormal;
      this.$domSelected = opt.$domSelected || opt.$domNormal;

      // document.execCommand 的参数
      this.commandName = opt.commandName;
      this.commandValue = opt.commandValue;
      this.commandNameSelected = opt.commandNameSelected || opt.commandName;
      this.commandValueSelected = opt.commandValueSelected || opt.commandValue;
  };

  Menu.fn = Menu.prototype;

  // 暴露给 E 即 window.wangEditor
  E.Menu = Menu;
});
// Menu.fn 初始化绑定的事件
_e(function (E, $) {

  var Menu = E.Menu;

  // 初始化UI
  Menu.fn.initUI = function () {
      var editor = this.editor;
      var uiConfig = editor.UI.menus;
      var menuId = this.id;
      var menuUI = uiConfig[menuId];

      if (this.$domNormal && this.$domSelected) {
          // 自定义的菜单中，已经传入了 $dom 无需从配置文件中查找生成
          return;
      }

      if (menuUI == null) {
          E.warn('editor.UI配置中，没有菜单 "' + menuId + '" 的UI配置，只能取默认值');
          
          // 必须写成 uiConfig['default'];
          // 写成 uiConfig.default IE8会报错
          menuUI = uiConfig['default'];
      }

      // 正常状态
      this.$domNormal = $(menuUI.normal);

      // 选中状态
      if (/^\./.test(menuUI.selected)) {
          // 增加一个样式
          this.$domSelected = this.$domNormal.clone().addClass(menuUI.selected.slice(1));
      } else {
          // 一个新的dom对象
          this.$domSelected = $(menuUI.selected);
      }
  };

});
// Menu.fn API
_e(function (E, $) {

  var Menu = E.Menu;

  // 渲染菜单
  Menu.fn.render = function (groupIdx) {
      // 渲染UI
      this.initUI();
      
      var editor = this.editor;
      var menuContainer = editor.menuContainer;
      var $menuItem = menuContainer.appendMenu(groupIdx, this);
      var onRender = this.onRender;

      // 渲染tip
      this._renderTip($menuItem);

      // 执行 onRender 函数
      if (onRender && typeof onRender === 'function') {
          onRender.call(this);
      }
  };
  Menu.fn._renderTip = function ($menuItem) {
      var self = this;
      var editor = self.editor;
      var title = self.title;
      var $tip = $('<div class="menu-tip"></div>');
      // var $triangle = $('<i class="tip-triangle"></i>'); // 小三角

      // 计算 tip 宽度
      var $tempDiv;
      if (!self.tipWidth) {
          // 设置一个纯透明的 p（absolute;top:-10000px;不会显示在内容区域）
          // 内容赋值为 title ，为了计算tip宽度
          $tempDiv = $('<p style="opacity:0; filter:Alpha(opacity=0); position:absolute;top:-10000px;">' + title + '</p>');
          // 先添加到body，计算完再 remove
          E.$body.append($tempDiv);
          editor.ready(function () {
              var editor = this;
              var titleWidth = $tempDiv.outerWidth() + 5; // 多出 5px 的冗余
              var currentWidth = $tip.outerWidth();
              var currentMarginLeft = parseFloat($tip.css('margin-left'), 10);
              // 计算完，拿到数据，则弃用
              $tempDiv.remove();
              $tempDiv = null;

              // 重新设置样式
              $tip.css({
                  width: titleWidth,
                  'margin-left': currentMarginLeft + (currentWidth - titleWidth)/2
              });

              // 存储
              self.tipWidth = titleWidth;
          });
      }

      // $tip.append($triangle);
      $tip.append(title);
      $menuItem.append($tip);

      function show() {
          $tip.show();
      }
      function hide() {
          $tip.hide();
      }

      var timeoutId;
      $menuItem.find('a').on('mouseenter', function (e) {
          if (!self.active() && !self.disabled()) {
              timeoutId = setTimeout(show, 200);
          }
      }).on('mouseleave', function (e) {
          timeoutId && clearTimeout(timeoutId);
          hide();
      }).on('click', hide);
  };

  // 绑定事件
  Menu.fn.bindEvent = function () {
      var self = this;

      var $domNormal = self.$domNormal;
      var $domSelected = self.$domSelected;

      // 试图获取该菜单定义的事件（未selected），没有则自己定义
      var clickEvent = self.clickEvent;
      if (!clickEvent) {
          clickEvent = function (e) {
              // -----------dropPanel dropList modal-----------
              var dropObj = self.dropPanel || self.dropList || self.modal;
              if (dropObj && dropObj.show) {
                  if (dropObj.isShowing) {
                      dropObj.hide();
                  } else {
                      dropObj.show();
                  }
                  return;
              }

              // -----------command-----------
              var editor = self.editor;
              var commandName;
              var commandValue;

              var selected = self.selected;
              if (selected) {
                  commandName = self.commandNameSelected;
                  commandValue = self.commandValueSelected;
              } else {
                  commandName = self.commandName;
                  commandValue = self.commandValue;
              }

              if (commandName) {
                  // 执行命令
                  editor.command(e, commandName, commandValue);
              } else {
                  // 提示
                  E.warn('菜单 "' + self.id + '" 未定义click事件');
                  e.preventDefault();
              }
          };
      }
      // 获取菜单定义的selected情况下的点击事件
      var clickEventSelected = self.clickEventSelected || clickEvent;

      // 将事件绑定到菜单dom上
      $domNormal.click(function (e) {
          if (!self.disabled()) {
              clickEvent.call(self, e);
              self.updateSelected();
          }
          e.preventDefault();
      });
      $domSelected.click(function (e) {
          if (!self.disabled()) {
              clickEventSelected.call(self, e);
              self.updateSelected();
          }
          e.preventDefault();
      });
  };

  // 更新选中状态
  Menu.fn.updateSelected = function () {
      var self = this;
      var editor = self.editor;

      // 试图获取用户自定义的判断事件
      var updateSelectedEvent = self.updateSelectedEvent;
      if (!updateSelectedEvent) {
          // 用户未自定义，则设置默认值
          updateSelectedEvent = function () {
              var self = this;
              var editor = self.editor;
              var commandName = self.commandName;
              var commandValue = self.commandValue;

              if (commandValue) {
                  if (editor.queryCommandValue(commandName).toLowerCase() === commandValue.toLowerCase()) {
                      return true;
                  }
              } else if (editor.queryCommandState(commandName)) {
                  return true;
              }

              return false;
          };
      }

      // 获取结果
      var result = updateSelectedEvent.call(self);
      result = !!result;

      // 存储结果、显示效果
      self.changeSelectedState(result);
  };

  // 切换选中状态、显示效果
  Menu.fn.changeSelectedState = function (state) {
      var self = this;
      var selected = self.selected;

      if (state != null && typeof state === 'boolean') {
          if (selected === state) {
              // 计算结果和当前的状态一样
              return;
          }
          // 存储结果
          self.selected = state;

          // 切换菜单的显示
          if (state) {
              // 选中
              self.$domNormal.css('display','none');
              self.$domSelected.css('display','block');
          } else {
              // 未选中
              self.$domNormal.css('display','block');
              self.$domSelected.css('display','none');
          }
      } // if
  };

  // 点击菜单，显示了 dropPanel modal 时，菜单的状态 
  Menu.fn.active = function (active) {
      if (active == null) {
          return this._activeState;
      }
      this._activeState = active;
  };
  Menu.fn.activeStyle = function (active) {
      var selected = this.selected;
      var $dom = this.$domNormal;
      var $domSelected = this.$domSelected;

      if (active) {
          $dom.addClass('active');
          $domSelected.addClass('active');
      } else {
          $dom.removeClass('active');
          $domSelected.removeClass('active');
      }

      // 记录状态 （ menu hover 时会取状态用 ）
      this.active(active);
  };

  // 菜单的启用和禁用
  Menu.fn.disabled = function (opt) {
      // 参数为空，取值
      if (opt == null) {
          return !!this._disabled;
      }

      if (this._disabled === opt) {
          // 要设置的参数值和当前参数只一样，无需再次设置
          return;
      }

      var $dom = this.$domNormal;
      var $domSelected = this.$domSelected;

      // 设置样式
      if (opt) {
          $dom.addClass('disable');
          $domSelected.addClass('disable');
      } else {
          $dom.removeClass('disable');
          $domSelected.removeClass('disable');
      }

      // 存储
      this._disabled = opt;
  };

});
// dropList 构造函数
_e(function (E, $) {

  // 定义构造函数
  var DropList = function (editor, menu, opt) {
      this.editor = editor;
      this.menu = menu;

      // list 的数据源，格式 {'commandValue': 'title', ...}
      this.data = opt.data;
      // 要为每个item自定义的模板
      this.tpl = opt.tpl;
      // 为了执行 editor.commandForElem 而传入的elem查询方式
      this.selectorForELemCommand = opt.selectorForELemCommand;

      // 执行事件前后的钩子
      this.beforeEvent = opt.beforeEvent;
      this.afterEvent = opt.afterEvent;

      // 初始化
      this.init();
  };

  DropList.fn = DropList.prototype;

  // 暴露给 E 即 window.wangEditor
  E.DropList = DropList;
});
// dropList fn bind
_e(function (E, $) {

  var DropList = E.DropList;

  // init
  DropList.fn.init = function () {
      var self = this;

      // 生成dom对象
      self.initDOM();

      // 绑定command事件
      self.bindEvent();

      // 声明隐藏的事件
      self.initHideEvent();
  };

  // 初始化dom结构
  DropList.fn.initDOM = function () {
      var self = this;
      var data = self.data;
      var tpl = self.tpl || '<span>{#title}</span>';
      var $list = $('<div class="wangEditor-drop-list clearfix"></div>');

      var itemContent;
      var $item;
      $.each(data, function (commandValue, title) {
          itemContent = tpl.replace(/{#commandValue}/ig, commandValue).replace(/{#title}/ig, title);
          $item = $('<a href="#" commandValue="' + commandValue + '"></a>');
          $item.append(itemContent);
          $list.append($item);
      });

      self.$list = $list;
  };

  // 绑定事件
  DropList.fn.bindEvent = function () {
      var self = this;
      var editor = self.editor;
      var menu = self.menu;
      var commandName = menu.commandName;
      var selectorForELemCommand = self.selectorForELemCommand;
      var $list = self.$list;

      // 执行事件前后的钩子函数
      var beforeEvent = self.beforeEvent;
      var afterEvent = self.afterEvent;

      $list.on('click', 'a[commandValue]', function (e) {
          // 正式命令执行之前
          if (beforeEvent && typeof beforeEvent === 'function') {
              beforeEvent.call(e);
          }

          // 执行命令
          var commandValue = $(e.currentTarget).attr('commandValue');
          if (menu.selected && editor.isRangeEmpty() && selectorForELemCommand) {
              // 当前处于选中状态，并且选中内容为空
              editor.commandForElem(selectorForELemCommand, e, commandName, commandValue);
          } else {
              // 当前未处于选中状态，或者有选中内容。则执行默认命令
              editor.command(e, commandName, commandValue);
          }

          // 正式命令之后的钩子
          if (afterEvent && typeof afterEvent === 'function') {
              afterEvent.call(e);
          }
      });
  };

  // 点击其他地方，立即隐藏 droplist
  DropList.fn.initHideEvent = function () {
      var self = this;

      // 获取 list elem
      var thisList = self.$list.get(0);

      E.$body.on('click', function (e) {
          if (!self.isShowing) {
              return;
          }
          var trigger = e.target;

          // 获取菜单elem
          var menu = self.menu;
          var menuDom;
          if (menu.selected) {
              menuDom = menu.$domSelected.get(0);
          } else {
              menuDom = menu.$domNormal.get(0);
          }

          if (menuDom === trigger || $.contains(menuDom, trigger)) {
              // 说明由本菜单点击触发的
              return;
          }

          if (thisList === trigger || $.contains(thisList, trigger)) {
              // 说明由本list点击触发的
              return;
          }

          // 其他情况，隐藏 list
          self.hide();
      });

      E.$window.scroll(function () {
          self.hide();
      });

      E.$window.on('resize', function () {
          self.hide();
      });
  };

});
// dropListfn api
_e(function (E, $) {
  
  var DropList = E.DropList;

  // 渲染
  DropList.fn._render = function () {
      var self = this;
      var editor = self.editor;
      var $list = self.$list;

      // 渲染到页面
      editor.$editorContainer.append($list);

      // 记录状态
      self.rendered = true;
  };

  // 定位
  DropList.fn._position = function () {
      var self = this;
      var $list = self.$list;
      var editor = self.editor;
      var menu = self.menu;
      var $menuContainer = editor.menuContainer.$menuContainer;
      var $menuDom = menu.selected ? menu.$domSelected : menu.$domNormal;
      // 注意这里的 offsetParent() 要返回 .menu-item 的 position
      // 因为 .menu-item 是 position:relative
      var menuPosition = $menuDom.offsetParent().position();

      // 取得 menu 的位置、尺寸属性
      var menuTop = menuPosition.top;
      var menuLeft = menuPosition.left;
      var menuHeight = $menuDom.offsetParent().height();
      var menuWidth = $menuDom.offsetParent().width();

      // 取得 list 的尺寸属性
      var listWidth = $list.outerWidth();
      // var listHeight = $list.outerHeight();

      // 取得 $txt 的尺寸
      var txtWidth = editor.txt.$txt.outerWidth();

      // ------------开始计算-------------

      // 初步计算 list 位置属性
      var top = menuTop + menuHeight;
      var left = menuLeft + menuWidth/2;
      var marginLeft = 0 - menuWidth/2;

      // 如果超出了有边界，则要左移（且和右侧有间隙）
      var valWithTxt = (left + listWidth) - txtWidth;
      if (valWithTxt > -10) {
          marginLeft = marginLeft - valWithTxt - 10;
      }
      // 设置样式
      $list.css({
          top: top,
          left: left,
          'margin-left': marginLeft
      });

      // 如果因为向下滚动而导致菜单fixed，则再加一步处理
      if (editor._isMenufixed) {
          top = top + (($menuContainer.offset().top + $menuContainer.outerHeight()) - $list.offset().top);

          // 重新设置top
          $list.css({
              top: top
          });
      }
  };

  // 显示
  DropList.fn.show = function () {
      var self = this;
      var menu = self.menu;
      if (!self.rendered) {
          // 第一次show之前，先渲染
          self._render();
      }

      if (self.isShowing) {
          return;
      }

      var $list = self.$list;
      $list.show();

      // 定位
      self._position();

      // 记录状态
      self.isShowing = true;

      // 菜单状态
      menu.activeStyle(true);
  };

  // 隐藏
  DropList.fn.hide = function () {
      var self = this;
      var menu = self.menu;
      if (!self.isShowing) {
          return;
      }

      var $list = self.$list;
      $list.hide();

      // 记录状态
      self.isShowing = false;

      // 菜单状态
      menu.activeStyle(false);
  };
});
// dropPanel 构造函数
_e(function (E, $) {

  // 定义构造函数
  var DropPanel = function (editor, menu, opt) {
      this.editor = editor;
      this.menu = menu;
      this.$content = opt.$content;
      this.width = opt.width || 200;
      this.height = opt.height;
      this.onRender = opt.onRender;

      // init
      this.init();
  };

  DropPanel.fn = DropPanel.prototype;

  // 暴露给 E 即 window.wangEditor
  E.DropPanel = DropPanel;
});
// dropPanel fn bind
_e(function (E, $) {

  var DropPanel = E.DropPanel;

  // init
  DropPanel.fn.init = function () {
      var self = this;

      // 生成dom对象
      self.initDOM();

      // 声明隐藏的事件
      self.initHideEvent();
  };

  // init DOM
  DropPanel.fn.initDOM = function () {
      var self = this;
      var $content = self.$content;
      var width = self.width;
      var height = self.height;
      var $panel = $('<div class="wangEditor-drop-panel clearfix"></div>');
      var $triangle = $('<div class="tip-triangle"></div>');

      $panel.css({
          width: width,
          height: height ? height : 'auto'
      });
      $panel.append($triangle);
      $panel.append($content);

      // 添加对象数据
      self.$panel = $panel;
      self.$triangle = $triangle;
  };

  // 点击其他地方，立即隐藏 dropPanel
  DropPanel.fn.initHideEvent = function () {
      var self = this;

      // 获取 panel elem
      var thisPanle = self.$panel.get(0);

      E.$body.on('click', function (e) {
          if (!self.isShowing) {
              return;
          }
          var trigger = e.target;

          // 获取菜单elem
          var menu = self.menu;
          var menuDom;
          if (menu.selected) {
              menuDom = menu.$domSelected.get(0);
          } else {
              menuDom = menu.$domNormal.get(0);
          }

          if (menuDom === trigger || $.contains(menuDom, trigger)) {
              // 说明由本菜单点击触发的
              return;
          }

          if (thisPanle === trigger || $.contains(thisPanle, trigger)) {
              // 说明由本panel点击触发的
              return;
          }

          // 其他情况，隐藏 panel
          self.hide();
      });

      E.$window.scroll(function (e) {
          self.hide();
      });

      E.$window.on('resize', function () {
          self.hide();
      });
  };

});
// dropPanel fn api
_e(function (E, $) {
 
  var DropPanel = E.DropPanel;

  // 渲染
  DropPanel.fn._render = function () {
      var self = this;
      var onRender = self.onRender;
      var editor = self.editor;
      var $panel = self.$panel;

      // 渲染到页面
      editor.$editorContainer.append($panel);

      // 渲染后的回调事件
      onRender && onRender.call(self);

      // 记录状态
      self.rendered = true;
  };

  // 定位
  DropPanel.fn._position = function () {
      var self = this;
      var $panel = self.$panel;
      var $triangle = self.$triangle;
      var editor = self.editor;
      var $menuContainer = editor.menuContainer.$menuContainer;
      var menu = self.menu;
      var $menuDom = menu.selected ? menu.$domSelected : menu.$domNormal;
      // 注意这里的 offsetParent() 要返回 .menu-item 的 position
      // 因为 .menu-item 是 position:relative
      var menuPosition = $menuDom.offsetParent().position();

      // 取得 menu 的位置、尺寸属性
      var menuTop = menuPosition.top;
      var menuLeft = menuPosition.left;
      var menuHeight = $menuDom.offsetParent().height();
      var menuWidth = $menuDom.offsetParent().width();

      // 取得 panel 的尺寸属性
      var panelWidth = $panel.outerWidth();
      // var panelHeight = $panel.outerHeight();

      // 取得 $txt 的尺寸
      var txtWidth = editor.txt.$txt.outerWidth();

      // ------------开始计算-------------

      // 初步计算 panel 位置属性
      var top = menuTop + menuHeight;
      var left = menuLeft + menuWidth/2;
      var marginLeft = 0 - panelWidth/2;
      var marginLeft2 = marginLeft;  // 下文用于和 marginLeft 比较，来设置三角形tip的位置

      // 如果超出了左边界，则移动回来（要和左侧有10px间隙）
      if ((0 - marginLeft) > (left - 10)) {
          marginLeft = 0 - (left - 10);
      }

      // 如果超出了有边界，则要左移（且和右侧有10px间隙）
      var valWithTxt = (left + panelWidth + marginLeft) - txtWidth;
      if (valWithTxt > -10) {
          marginLeft = marginLeft - valWithTxt - 10;
      }

      // 设置样式
      $panel.css({
          top: top,
          left: left,
          'margin-left': marginLeft
      });

      // 如果因为向下滚动而导致菜单fixed，则再加一步处理
      if (editor._isMenufixed) {
          top = top + (($menuContainer.offset().top + $menuContainer.outerHeight()) - $panel.offset().top);

          // 重新设置top
          $panel.css({
              top: top
          });
      }

      // 设置三角形 tip 的位置
      $triangle.css({
          'margin-left': marginLeft2 - marginLeft - 5
      });
  };

  // focus 第一个 input
  DropPanel.fn.focusFirstInput = function () {
      var self = this;
      var $panel = self.$panel;
      $panel.find('input[type=text],textarea').each(function () {
          var $input = $(this);
          if ($input.attr('disabled') == null) {
              $input.focus();
              return false;
          }
      });
  };

  // 显示
  DropPanel.fn.show = function () {
      var self = this;
      var menu = self.menu;
      if (!self.rendered) {
          // 第一次show之前，先渲染
          self._render();
      }

      if (self.isShowing) {
          return;
      }

      var $panel = self.$panel;
      $panel.show();

      // 定位
      self._position();

      // 记录状态
      self.isShowing = true;

      // 菜单状态
      menu.activeStyle(true);

      if (E.w3cRange) {
          // 高级浏览器
          self.focusFirstInput();
      } else {
          // 兼容 IE8 input placeholder
          E.placeholderForIE8($panel);
      }
  };

  // 隐藏
  DropPanel.fn.hide = function () {
      var self = this;
      var menu = self.menu;
      if (!self.isShowing) {
          return;
      }

      var $panel = self.$panel;
      $panel.hide();

      // 记录状态
      self.isShowing = false;

      // 菜单状态
      menu.activeStyle(false);
  };

});
// modal 构造函数
_e(function (E, $) {

  // 定义构造函数
  var Modal = function (editor, menu, opt) {
      this.editor = editor;
      this.menu = menu;
      this.$content = opt.$content;

      this.init();
  };

  Modal.fn = Modal.prototype;

  // 暴露给 E 即 window.wangEditor
  E.Modal = Modal;
});
// modal fn bind
_e(function (E, $) {

  var Modal = E.Modal;

  Modal.fn.init = function () {
      var self = this;

      // 初始化dom
      self.initDom();

      // 初始化隐藏事件
      self.initHideEvent();
  };

  // 初始化dom
  Modal.fn.initDom = function () {
      var self = this;
      var $content = self.$content;
      var $modal = $('<div class="wangEditor-modal"></div>');
      var $close = $('<div class="wangEditor-modal-close"><i class="wangeditor-menu-img-cancel-circle"></i></div>');

      $modal.append($close);
      $modal.append($content);

      // 记录数据
      self.$modal = $modal;
      self.$close = $close;
  };

  // 初始化隐藏事件
  Modal.fn.initHideEvent = function () {
      var self = this;
      var $close = self.$close;
      var modal = self.$modal.get(0);

      // 点击 $close 按钮，隐藏
      $close.click(function () {
          self.hide();
      });

      // 点击其他部分，隐藏
      E.$body.on('click', function (e) {
          if (!self.isShowing) {
              return;
          }
          var trigger = e.target;

          // 获取菜单elem
          var menu = self.menu;
          var menuDom;
          if (menu) {
              if (menu.selected) {
                  menuDom = menu.$domSelected.get(0);
              } else {
                  menuDom = menu.$domNormal.get(0);
              }

              if (menuDom === trigger || $.contains(menuDom, trigger)) {
                  // 说明由本菜单点击触发的
                  return;
              }
          }

          if (modal === trigger || $.contains(modal, trigger)) {
              // 说明由本panel点击触发的
              return;
          }

          // 其他情况，隐藏 panel
          self.hide();
      });
  };
});
// modal fn api
_e(function (E, $) {

  var Modal = E.Modal;

  // 渲染
  Modal.fn._render = function () {
      var self = this;
      var editor = self.editor;
      var $modal = self.$modal;

      // $modal的z-index，在配置的z-index基础上再 +10
      $modal.css('z-index', editor.config.zindex + 10 + '');

      // 渲染到body最后面
      E.$body.append($modal);

      // 记录状态
      self.rendered = true;
  };

  // 定位
  Modal.fn._position = function () {
      var self = this;
      var $modal = self.$modal;
      var top = $modal.offset().top;
      var width = $modal.outerWidth();
      var height = $modal.outerHeight();
      var marginLeft = 0 - (width / 2);
      var marginTop = 0 - (height / 2);
      var sTop = E.$window.scrollTop();

      // 保证modal最顶部，不超过浏览器上边框
      if ((height / 2) > top) {
          marginTop = 0 - top;
      }

      $modal.css({
          'margin-left': marginLeft + 'px',
          'margin-top': (marginTop + sTop) + 'px'
      });
  };

  // 显示
  Modal.fn.show = function () {
      var self = this;
      var menu = self.menu;
      if (!self.rendered) {
          // 第一次show之前，先渲染
          self._render();
      }

      if (self.isShowing) {
          return;
      }
      // 记录状态
      self.isShowing = true;

      var $modal = self.$modal;
      $modal.show();

      // 定位
      self._position();

      // 激活菜单状态
      menu && menu.activeStyle(true);
  };

  // 隐藏
  Modal.fn.hide = function () {
      var self = this;
      var menu = self.menu;
      if (!self.isShowing) {
          return;
      }
      // 记录状态
      self.isShowing = false;

      // 隐藏
      var $modal = self.$modal;
      $modal.hide();

      // 菜单状态
      menu && menu.activeStyle(false);
  };
});
// txt 构造函数
_e(function (E, $) {

  // 定义构造函数
  var Txt = function (editor) {
      this.editor = editor;

      // 初始化
      this.init();
  };

  Txt.fn = Txt.prototype;

  // 暴露给 E 即 window.wangEditor
  E.Txt = Txt;
});
// Txt.fn bind fn
_e(function (E, $) {

  var Txt = E.Txt;

  // 初始化
  Txt.fn.init = function () {
      var self = this;
      var editor = self.editor;
      var $valueContainer = editor.$valueContainer;
      var currentValue = editor.getInitValue();
      var $txt;

      if ($valueContainer.get(0).nodeName === 'DIV') {
          // 如果传入生成编辑器的元素就是div，则直接使用
          $txt = $valueContainer;
          $txt.addClass("wangEditor-txt");
          $txt.attr('contentEditable', 'true');
      } else {
          // 如果不是div（是textarea），则创建一个div
          $txt = $(
              '<div class="wangEditor-txt" contentEditable="true">' +
                  currentValue +
              '</div>'
          );
      }

      // 试图最后插入一个空行，ready之后才行
      editor.ready(function () {
          self.insertEmptyP();
      });

      self.$txt = $txt;

      // 删除时，如果没有内容了，就添加一个 <p><br></p>
      self.contentEmptyHandle();

      // enter时，不能使用 div 换行
      self.bindEnterForDiv();

      // enter时，用 p 包裹 text
      self.bindEnterForText();

      // tab 插入4个空格
      self.bindTabEvent();

      // 处理粘贴内容
      self.bindPasteFilter();

      // $txt.formatText() 方法
      self.bindFormatText();

      // 定义 $txt.html() 方法
      self.bindHtml();
  };

  // 删除时，如果没有内容了，就添加一个 <p><br></p>
  Txt.fn.contentEmptyHandle = function () {
      var self = this;
      var editor = self.editor;
      var $txt = self.$txt;
      var $p;

      $txt.on('keydown', function (e) {
          if (e.keyCode !== 8) {
              return;
          }
          var txtHtml = $.trim($txt.html().toLowerCase());
          if (txtHtml === '<p><br></p>') {
              // 如果最后还剩余一个空行，就不再继续删除了
              e.preventDefault();
              return;
          }
      });

      $txt.on('keyup', function (e) {
          if (e.keyCode !== 8) {
              return;
          }
          var txtHtml = $.trim($txt.html().toLowerCase());
          // ff时用 txtHtml === '<br>' 判断，其他用 !txtHtml 判断
          if (!txtHtml || txtHtml === '<br>') {
              // 内容空了
              $p = $('<p><br/></p>');
              $txt.html(''); // 一定要先清空，否则在 ff 下有问题
              $txt.append($p);
              editor.restoreSelectionByElem($p.get(0));
          }
      });
  };

  // enter时，不能使用 div 换行
  Txt.fn.bindEnterForDiv = function () {
      var tags = E.config.legalTags; // 配置中编辑器要求的合法标签，如 p head table blockquote ul ol 等
      var self = this;
      var editor = self.editor;
      var $txt = self.$txt;

      var $keydownDivElem;
      function divHandler() {
          if (!$keydownDivElem) {
              return;
          }

          var $pElem = $('<p>' + $keydownDivElem.html() + '</p>');
          $keydownDivElem.after($pElem);
          $keydownDivElem.remove();
      }

      $txt.on('keydown keyup', function (e) {
          if (e.keyCode !== 13) {
              return;
          }
          // 查找合法标签
          var rangeElem = editor.getRangeElem();
          var targetElem = editor.getLegalTags(rangeElem);
          var $targetElem;
          var $pElem;

          if (!targetElem) {
              // 没找到合法标签，就去查找 div
              targetElem = editor.getSelfOrParentByName(rangeElem, 'div');
              if (!targetElem) {
                  return;
              }
              $targetElem = $(targetElem);

              if (e.type === 'keydown') {
                  // 异步执行（同步执行会出现问题）
                  $keydownDivElem = $targetElem;
                  setTimeout(divHandler, 0);
              }

              if (e.type === 'keyup') {
                  // 将 div 的内容移动到 p 里面，并移除 div
                  $pElem = $('<p>' + $targetElem.html() + '</p>');
                  $targetElem.after($pElem);
                  $targetElem.remove();

                  // 如果是回车结束，将选区定位到行首
                  editor.restoreSelectionByElem($pElem.get(0), 'start');
              }
          }
      });
  };

  // enter时，用 p 包裹 text
  Txt.fn.bindEnterForText = function () {
      var self = this;
      var $txt = self.$txt;
      var handle;
      $txt.on('keyup', function (e) {
          if (e.keyCode !== 13) {
              return;
          }
          if (!handle) {
              handle = function() {
                  self.wrapImgAndText();
              };
          }
          setTimeout(handle);
      });
  };

  // tab 时，插入4个空格
  Txt.fn.bindTabEvent = function () {
      var self = this;
      var editor = self.editor;
      var $txt = self.$txt;

      $txt.on('keydown', function (e) {
          if (e.keyCode !== 9) {
              // 只监听 tab 按钮
              return;
          }
          // 如果浏览器支持 insertHtml 则插入4个空格。如果不支持，就不管了
          if (editor.queryCommandSupported('insertHtml')) {
              editor.command(e, 'insertHtml', '&nbsp;&nbsp;&nbsp;&nbsp;');
          }
      });
  };

  // 处理粘贴内容
  Txt.fn.bindPasteFilter = function () {
      var self = this;
      var editor = self.editor;
      var resultHtml = '';  //存储最终的结果
      var $txt = self.$txt;
      var legalTags = editor.config.legalTags;
      var legalTagArr = legalTags.split(',');

      $txt.on('paste', function (e) {
          if (!editor.config.pasteFilter) {
              // 配置中取消了粘贴过滤
              return;
          }

          var currentNodeName = editor.getRangeElem().nodeName;
          if (currentNodeName === 'TD' || currentNodeName === 'TH') {
              // 在表格的单元格中粘贴，忽略所有内容。否则会出现异常情况
              return;
          }

          resultHtml = ''; // 先清空 resultHtml

          var pasteHtml, $paste;
          var data = e.clipboardData || e.originalEvent.clipboardData;
          var ieData = window.clipboardData;

          if (editor.config.pasteText) {
              // 只粘贴纯文本

              if (data && data.getData) {
                  // w3c
                  pasteHtml = data.getData('text/plain');
              } else if (ieData && ieData.getData) {
                  // IE
                  pasteHtml = ieData.getData('text');
              } else {
                  // 其他情况
                  return;
              }

              // 拼接为 <p> 标签
              if (pasteHtml) {
                  resultHtml = '<p>' + pasteHtml + '</p>';
              }

          } else {
              // 粘贴过滤了样式的、只有标签的 html

              if (data && data.getData) {
                  // w3c

                  // 获取粘贴过来的html
                  pasteHtml = data.getData('text/html');
                  if (pasteHtml) {
                      // 创建dom
                      $paste = $('<div>' + pasteHtml + '</div>');
                      // 处理，并将结果存储到 resultHtml 『全局』变量
                      handle($paste.get(0));
                  } else {
                      // 得不到html，试图获取text
                      pasteHtml = data.getData('text/plain');
                      if (pasteHtml) {
                          // 替换特殊字符
                          pasteHtml = pasteHtml.replace(/[ ]/g, '&nbsp;')
                                               .replace(/</g, '&lt;')
                                               .replace(/>/g, '&gt;')
                                               .replace(/\n/g, '</p><p>');
                          // 拼接
                          resultHtml = '<p>' + pasteHtml + '</p>';

                          // 查询链接
                          resultHtml = resultHtml.replace(/<p>(https?:\/\/.*?)<\/p>/ig, function (match, link) {
                              return '<p><a href="' + link + '" target="_blank">' + link + '</p>';
                          });
                      }
                  }
                  
              } else if (ieData && ieData.getData) {
                  // IE 直接从剪切板中取出纯文本格式
                  resultHtml = ieData.getData('text');
                  if (!resultHtml) {
                      return;
                  }
                  // 拼接为 <p> 标签
                  resultHtml = '<p>' + resultHtml + '</p>';
                  resultHtml = resultHtml.replace(new RegExp('\n', 'g'), '</p><p>');
              } else {
                  // 其他情况
                  return;
              }
          }

          // 执行命令
          if (resultHtml) {
              editor.command(e, 'insertHtml', resultHtml);

              // 删除内容为空的 p 和嵌套的 p
              self.clearEmptyOrNestP();
          }
      });

      // 处理粘贴的内容
      function handle(elem) {
          if (!elem || !elem.nodeType || !elem.nodeName) {
              return;
          }
          var $elem;
          var nodeName = elem.nodeName.toLowerCase();
          var nodeType = elem.nodeType;
          var childNodesClone;

          // 只处理文本和普通node标签
          if (nodeType !== 3 && nodeType !== 1) {
              return;
          }

          $elem = $(elem);

          // 如果是容器，则继续深度遍历
          if (nodeName === 'div') {
              childNodesClone = [];
              $.each(elem.childNodes, function (index, item) {
                  // elem.childNodes 可获取TEXT节点，而 $elem.children() 就获取不到
                  // 先将 elem.childNodes 拷贝一份，一面在循环递归过程中 elem 发生变化
                  childNodesClone.push(item);
              });
              // 遍历子元素，执行操作
              $.each(childNodesClone, function () {
                  handle(this);
              });
              return;
          }
          
          if (legalTagArr.indexOf(nodeName) >= 0) {
              // 如果是合法标签之内的，则根据元素类型，获取值
              resultHtml += getResult(elem);
          } else if (nodeType === 3) {
              // 如果是文本，则直接插入 p 标签
              resultHtml += '<p>' + elem.textContent + '</p>';
          } else if (nodeName === 'br') {
              // <br>保留
              resultHtml += '<br/>';
          }
          else {
              // 忽略的标签
              if (['meta', 'style', 'script', 'object', 'form', 'iframe', 'hr'].indexOf(nodeName) >= 0) {
                  return;
              }
              // 其他标签，移除属性，插入 p 标签
              $elem = $(removeAttrs(elem));
              // 注意，这里的 clone() 是必须的，否则会出错
              resultHtml += $('<div>').append($elem.clone()).html();
          }
      }

      // 获取元素的结果
      function getResult(elem) {
          var nodeName = elem.nodeName.toLowerCase();
          var $elem;
          var htmlForP = '';
          var htmlForLi = '';

          if (['blockquote'].indexOf(nodeName) >= 0) {

              // 直接取出元素text即可
              $elem = $(elem);
              return '<' + nodeName + '>' + $elem.text() + '</' + nodeName + '>';

          } else if (['p', 'h1', 'h2', 'h3', 'h4', 'h5'].indexOf(nodeName) >= 0) {

              //p head 取出 text 和链接
              elem = removeAttrs(elem);
              $elem = $(elem);
              htmlForP = $elem.html();

              // 剔除 a img 之外的元素
              htmlForP = htmlForP.replace(/<.*?>/ig, function (tag) {
                  if (tag === '</a>' || tag.indexOf('<a ') === 0 || tag.indexOf('<img ') === 0) {
                      return tag;
                  } else {
                      return '';
                  }
              });

              return '<' + nodeName + '>' + htmlForP + '</' + nodeName + '>';

          } else if (['ul', 'ol'].indexOf(nodeName) >= 0) {
              
              // ul ol元素，获取子元素（li元素）的text link img，再拼接
              $elem = $(elem);
              $elem.children().each(function () {
                  var $li = $(removeAttrs(this));
                  var html = $li.html();

                  html = html.replace(/<.*?>/ig, function (tag) {
                      if (tag === '</a>' || tag.indexOf('<a ') === 0 || tag.indexOf('<img ') === 0) {
                          return tag;
                      } else {
                          return '';
                      }
                  });

                  htmlForLi += '<li>' + html + '</li>';
              });
              return '<' + nodeName + '>' + htmlForLi + '</' + nodeName + '>';
          
          } else {
              
              // 其他元素，移除元素属性
              $elem = $(removeAttrs(elem));
              return $('<div>').append($elem).html();
          }
      }

      // 移除一个元素（子元素）的attr
      function removeAttrs(elem) {
          var attrs = elem.attributes || [];
          var attrNames = [];
          var exception = ['href', 'target', 'src', 'alt', 'rowspan', 'colspan']; //例外情况

          // 先存储下elem中所有 attr 的名称
          $.each(attrs, function (key, attr) {
              if (attr && attr.nodeType === 2) {
                  attrNames.push(attr.nodeName);
              }
          });
          // 再根据名称删除所有attr
          $.each(attrNames, function (key, attr) {
              if (exception.indexOf(attr) < 0) {
                  // 除了 exception 规定的例外情况，删除其他属性
                  elem.removeAttribute(attr);
              }
          });


          // 递归子节点
          var children = elem.childNodes;
          if (children.length) {
              $.each(children, function (key, value) {
                  removeAttrs(value);
              });
          }

          return elem;
      }
  };

  // 绑定 $txt.formatText() 方法
  Txt.fn.bindFormatText = function () {
      var self = this;
      var editor = self.editor;
      var $txt = self.$txt;
      var legalTags = E.config.legalTags;
      var legalTagArr = legalTags.split(',');
      var length = legalTagArr.length;
      var regArr = [];

      // 将 E.config.legalTags 配置的有效字符，生成正则表达式
      $.each(legalTagArr, function (k, tag) {
          var reg = '\>\\s*\<(' + tag + ')\>';
          regArr.push(new RegExp(reg, 'ig'));
      });

      // 增加 li 
      regArr.push(new RegExp('\>\\s*\<(li)\>', 'ig'));

      // 增加 tr
      regArr.push(new RegExp('\>\\s*\<(tr)\>', 'ig'));

      // 增加 code
      regArr.push(new RegExp('\>\\s*\<(code)\>', 'ig'));

      // 生成 formatText 方法
      $txt.formatText = function () {
          var $temp = $('<div>');
          var html = $txt.html();

          // 去除空格
          html = html.replace(/\s*</ig, '<');

          // 段落、表格之间换行
          $.each(regArr, function (k, reg) {
              if (!reg.test(html)) {
                  return;
              }
              html = html.replace(reg, function (matchStr, tag) {
                  return '>\n<' + tag + '>';
              });
          });

          $temp.html(html);
          return $temp.text();
      };
  };

  // 定制 $txt.html 方法
  Txt.fn.bindHtml = function () {
      var self = this;
      var editor = self.editor;
      var $txt = self.$txt;
      var $valueContainer = editor.$valueContainer;
      var valueNodeName = editor.valueNodeName;

      $txt.html = function (html) {
          var result;

          if (valueNodeName === 'div') {
              // div 生成的编辑器，取值、赋值，都直接触发jquery的html方法
              result = $.fn.html.call($txt, html);
          }

          // textarea 生成的编辑器，则需要考虑赋值时，也给textarea赋值

          if (html === undefined) {
              // 取值，直接触发jquery原生html方法
              result = $.fn.html.call($txt);

              // 替换 html 中，src和href属性中的 & 字符。
              // 因为 .html() 或者 .innerHTML 会把所有的 & 字符都改成 &amp; 但是 src 和 href 中的要保持 &
              result = result.replace(/(href|src)\=\"(.*)\"/igm, function (a, b, c) {
                  return b + '="' + c.replace('&amp;', '&') + '"';
              });
          } else {
              // 赋值，需要同时给 textarea 赋值
              result = $.fn.html.call($txt, html);
              $valueContainer.val(html);
          }

          if (html === undefined) {
              return result;
          } else {
              // 手动触发 change 事件，因为 $txt 监控了 change 事件来判断是否需要执行 editor.onchange 
              $txt.change();
          }
      };
  };
});
// Txt.fn api
_e(function (E, $) {

  var Txt = E.Txt;

  var txtChangeEventNames = 'propertychange change click keyup input paste';

  // 渲染
  Txt.fn.render = function () {
      var $txt = this.$txt;
      var $editorContainer = this.editor.$editorContainer;
      $editorContainer.append($txt);
  };

  // 计算高度
  Txt.fn.initHeight = function () {
      var editor = this.editor;
      var $txt = this.$txt;
      var valueContainerHeight = editor.$valueContainer.height();
      var menuHeight = editor.menuContainer.height();
      var txtHeight = valueContainerHeight - menuHeight;

      // 限制最小为 50px
      txtHeight = txtHeight < 50 ? 50 : txtHeight;

      $txt.height(txtHeight);

      // 记录原始高度
      editor.valueContainerHeight = valueContainerHeight;

      // 设置 max-height
      this.initMaxHeight(txtHeight, menuHeight);
  };

  // 计算最大高度
  Txt.fn.initMaxHeight = function (txtHeight, menuHeight) {
      var editor = this.editor;
      var $menuContainer = editor.menuContainer.$menuContainer;
      var $txt = this.$txt;
      var $wrap = $('<div>');

      // 需要浏览器支持 max-height，否则不管
      if (window.getComputedStyle && 'max-height'in window.getComputedStyle($txt.get(0))) {
          // 获取 max-height 并判断是否有值
          var maxHeight = parseInt(editor.$valueContainer.css('max-height'));
          if (isNaN(maxHeight)) {
              return;
          }

          // max-height 和『全屏』暂时有冲突
          if (editor.menus.fullscreen) {
              E.warn('max-height和『全屏』菜单一起使用时，会有一些问题尚未解决，请暂时不要两个同时使用');
              return;
          }

          // 标记
          editor.useMaxHeight = true;

          // 设置maxheight
          $wrap.css({
              'max-height': (maxHeight - menuHeight) + 'px',
              'overflow-y': 'auto'
          });
          $txt.css({
              'height': 'auto',
              'overflow-y': 'visible',
              'min-height': txtHeight + 'px'
          });

          // 滚动式，菜单阴影
          $wrap.on('scroll', function () {
              if ($txt.parent().scrollTop() > 10) {
                  $menuContainer.addClass('wangEditor-menu-shadow');
              } else {
                  $menuContainer.removeClass('wangEditor-menu-shadow');
              }
          });

          // 需在编辑器区域外面再包裹一层
          $txt.wrap($wrap);
      }
  };

  // 保存选区
  Txt.fn.saveSelectionEvent = function () {
      var $txt = this.$txt;
      var editor = this.editor;
      var timeoutId;
      var dt = Date.now();

      function save() {
          editor.saveSelection();
      }

      // 同步保存选区
      function saveSync() {
          // 100ms之内，不重复保存
          if (Date.now() - dt < 100) {
              return;
          }

          dt = Date.now();
          save();
      }

      // 异步保存选区
      function saveAync() {
          // 节流，防止高频率重复操作
          if (timeoutId) {
              clearTimeout(timeoutId);
          }
          timeoutId = setTimeout(save, 300);
      }

      // txt change 、focus、blur 时随时保存选区
      $txt.on(txtChangeEventNames + ' focus blur', function (e) {
          // 先同步保存选区，为了让接下来就马上要执行 editor.getRangeElem() 的程序
          // 能够获取到正确的 rangeElem
          saveSync();

          // 再异步保存选区，为了确定更加准确的选区，为后续的操作做准备
          saveAync();
      });

      // 鼠标拖拽选择时，可能会拖拽到编辑器区域外面再松手，此时 $txt 就监听不到 click事件了
      $txt.on('mousedown', function () {
          $txt.on('mouseleave.saveSelection', function (e) {
              // 先同步后异步，如上述注释
              saveSync();
              saveAync();

              // 顺道吧菜单状态也更新了
              editor.updateMenuStyle();
          });
      }).on('mouseup', function () {
          $txt.off('mouseleave.saveSelection');
      });
      
  };

  // 随时更新 value
  Txt.fn.updateValueEvent = function () {
      var $txt = this.$txt;
      var editor = this.editor;
      var timeoutId, oldValue;

      // 触发 onchange 事件
      function doOnchange() {
          var val = $txt.html();
          if (oldValue === val) {
              // 无变化
              return;
          }

          // 触发 onchange 事件
          if (editor.onchange && typeof editor.onchange === 'function') {
              editor.onchange.call(editor);
          }

          // 更新内容
          editor.updateValue();

          // 记录最新内容
          oldValue = val;
      }

      // txt change 时随时更新内容
      $txt.on(txtChangeEventNames, function (e) {
          // 初始化
          if (oldValue == null) {
              oldValue = $txt.html();
          }

          // 监控内容变化（停止操作 100ms 之后立即执行）
          if (timeoutId) {
              clearTimeout(timeoutId);
          }
          timeoutId = setTimeout(doOnchange, 100);
      });
  };

  // 随时更新 menustyle
  Txt.fn.updateMenuStyleEvent = function () {
      var $txt = this.$txt;
      var editor = this.editor;

      // txt change 时随时更新内容
      $txt.on(txtChangeEventNames, function (e) {
          editor.updateMenuStyle();
      });
  };

  // 最后插入试图插入 <p><br><p>
  Txt.fn.insertEmptyP = function () {
      var $txt = this.$txt;
      var $children = $txt.children();

      if ($children.length === 0) {
          $txt.append($('<p><br></p>'));
          return;
      }

      if ($.trim($children.last().html()).toLowerCase() !== '<br>') {
          $txt.append($('<p><br></p>'));
      }
  };

  // 将编辑器暴露出来的文字和图片，都用 p 来包裹
  Txt.fn.wrapImgAndText = function () {
      var $txt = this.$txt;
      var $imgs = $txt.children('img');
      var txt = $txt[0];
      var childNodes = txt.childNodes;
      var childrenLength = childNodes.length;
      var i, childNode, p;

      // 处理图片
      $imgs.length && $imgs.each(function () {
          $(this).wrap('<p>');
      });

      // 处理文字
      for (i = 0; i < childrenLength; i++) {
          childNode = childNodes[i];
          if (childNode.nodeType === 3 && childNode.textContent && $.trim(childNode.textContent)) {
              $(childNode).wrap('<p>');
          }
      }
  };

  // 清空内容为空的<p>，以及重复包裹的<p>（在windows下的chrome粘贴文字之后，会出现上述情况）
  Txt.fn.clearEmptyOrNestP = function () {
      var $txt = this.$txt;
      var $pList = $txt.find('p');

      $pList.each(function () {
          var $p = $(this);
          var $children = $p.children();
          var childrenLength = $children.length;
          var $firstChild;
          var content = $.trim($p.html());

          // 内容为空的p
          if (!content) {
              $p.remove();
              return;
          }

          // 嵌套的p
          if (childrenLength === 1) {
              $firstChild = $children.first();
              if ($firstChild.get(0) && $firstChild.get(0).nodeName === 'P') {
                  $p.html( $firstChild.html() );
              }
          }
      });
  };

  // 获取 scrollTop
  Txt.fn.scrollTop = function (val) {
      var self = this;
      var editor = self.editor;
      var $txt = self.$txt;

      if (editor.useMaxHeight) {
          return $txt.parent().scrollTop(val);
      } else {
          return $txt.scrollTop(val);
      }
  };

  // 鼠标hover时候，显示p、head的高度
  Txt.fn.showHeightOnHover = function () {
      var editor = this.editor;
      var $editorContainer = editor.$editorContainer;
      var menuContainer = editor.menuContainer;
      var $txt = this.$txt;
      var $tip = $('<i class="height-tip"><i>');
      var isTipInTxt = false;

      function addAndShowTip($target) {
          if (!isTipInTxt) {
              $editorContainer.append($tip);
              isTipInTxt = true;
          }

          var txtTop = $txt.position().top;
          var txtHeight = $txt.outerHeight();

          var height = $target.height();
          var top = $target.position().top;
          var marginTop = parseInt($target.css('margin-top'), 10);
          var paddingTop = parseInt($target.css('padding-top'), 10);
          var marginBottom = parseInt($target.css('margin-bottom'), 10);
          var paddingBottom = parseInt($target.css('padding-bottom'), 10);

          // 计算初步的结果
          var resultHeight = height + paddingTop + marginTop + paddingBottom + marginBottom;
          var resultTop = top + menuContainer.height();
          
          // var spaceValue;

          // // 判断是否超出下边界
          // spaceValue = (resultTop + resultHeight) - (txtTop + txtHeight);
          // if (spaceValue > 0) {
          //     resultHeight = resultHeight - spaceValue;
          // }

          // // 判断是否超出了下边界
          // spaceValue = txtTop > resultTop;
          // if (spaceValue) {
          //     resultHeight = resultHeight - spaceValue;
          //     top = top + spaceValue;
          // }

          // 按照最终结果渲染
          $tip.css({
              height: height + paddingTop + marginTop + paddingBottom + marginBottom,
              top: top + menuContainer.height()
          });
      }
      function removeTip() {
          if (!isTipInTxt) {
              return;
          }
          $tip.remove();
          isTipInTxt = false;
      }

      $txt.on('mouseenter', 'ul,ol,blockquote,p,h1,h2,h3,h4,h5,table,pre', function (e) {
          addAndShowTip($(e.currentTarget));
      }).on('mouseleave', function () {
          removeTip();
      });
  };

});
// 工具函数
_e(function (E, $) {

  // IE8 [].indexOf()
  if(!Array.prototype.indexOf){
      //IE低版本不支持 arr.indexOf 
      Array.prototype.indexOf = function(elem){
          var i = 0,
              length = this.length;
          for(; i<length; i++){
              if(this[i] === elem){
                  return i;
              }
          }
          return -1;
      };
      //IE低版本不支持 arr.lastIndexOf
      Array.prototype.lastIndexOf = function(elem){
          var length = this.length;
          for(length = length - 1; length >= 0; length--){
              if(this[length] === elem){
                  return length;
              }
          }
          return -1;
      };
  }

  // IE8 Date.now()
  if (!Date.now) {
      Date.now = function () {
          return new Date().valueOf(); 
      };
  }

  // console.log && console.warn && console.error
  var console = window.console;
  var emptyFn = function () {};
  $.each(['info', 'log', 'warn', 'error'], function (key, value) {
      if (console == null) {
          E[value] = emptyFn;
      } else {
          E[value] = function (info) {
              // 通过配置来控制打印输出
              if (E.config && E.config.printLog) {
                  console[value]('wangEditor提示: ' + info);
              }
          };
      }
  });

  // 获取随机数
  E.random = function () {
      return Math.random().toString().slice(2);
  };

  // 浏览器是否支持 placeholder
  E.placeholder = 'placeholder' in document.createElement('input');

  // 兼容IE8的 input placeholder
  E.placeholderForIE8 = function ($container) {
      if (E.placeholder) {
          return;
      }
      $container.find('input[placeholder]').each(function () {
          var $input = $(this);
          var placeholder = $input.attr('placeholder');

          if ($input.val() === '') {
              $input.css('color', '#666');
              $input.val(placeholder);

              $input.on('focus.placeholder click.placeholder', function () {
                  $input.val('');
                  $input.css('color', '#333');
                  $input.off('focus.placeholder click.placeholder');
              });
          }
      });
  };
});
// 语言包
_e(function (E, $) {
  E.langs = {};
  
  // 中文
  E.langs['zh-cn'] = {
      bold: '粗体',
      underline: '下划线',
      italic: '斜体',
      forecolor: '文字颜色',
      bgcolor: '背景色',
      strikethrough: '删除线',
      eraser: '清空格式',
      source: '源码',
      quote: '引用',
      fontfamily: '字体',
      fontsize: '字号',
      head: '标题',
      orderlist: '有序列表',
      unorderlist: '无序列表',
      alignleft: '左对齐',
      aligncenter: '居中',
      alignright: '右对齐',
      link: '链接',
      text: '文本',
      submit: '提交',
      cancel: '取消',
      unlink: '取消链接',
      table: '表格',
      emotion: '表情',
      img: '图片',
      video: '视频',
      'width': '宽',
      'height': '高',
      location: '位置',
      loading: '加载中',
      searchlocation: '搜索位置',
      dynamicMap: '动态地图',
      clearLocation: '清除位置',
      langDynamicOneLocation: '动态地图只能显示一个位置',
      insertcode: '插入代码',
      undo: '撤销',
      redo: '重做',
      fullscreen: '全屏',
      openLink: '打开链接'
  };

  // 英文
  E.langs.en = {
      bold: 'Bold',
      underline: 'Underline',
      italic: 'Italic',
      forecolor: 'Color',
      bgcolor: 'Backcolor',
      strikethrough: 'Strikethrough',
      eraser: 'Eraser',
      source: 'Codeview',
      quote: 'Quote',
      fontfamily: 'Font family',
      fontsize: 'Font size',
      head: 'Head',
      orderlist: 'Ordered list',
      unorderlist: 'Unordered list',
      alignleft: 'Align left',
      aligncenter: 'Align center',
      alignright: 'Align right',
      link: 'Insert link',
      text: 'Text',
      submit: 'Submit',
      cancel: 'Cancel',
      unlink: 'Unlink',
      table: 'Table',
      emotion: 'Emotions',
      img: 'Image',
      video: 'Video',
      'width': 'width',
      'height': 'height',
      location: 'Location',
      loading: 'Loading',
      searchlocation: 'search',
      dynamicMap: 'Dynamic',
      clearLocation: 'Clear',
      langDynamicOneLocation: 'Only one location in dynamic map',
      insertcode: 'Insert Code',
      undo: 'Undo',
      redo: 'Redo',
      fullscreen: 'Full screnn',
      openLink: 'open link'
  };
});
// 全局配置
_e(function (E, $) {

  E.config = {};

  // 全屏时的 z-index
  E.config.zindex = 10000;

  // 是否打印log
  E.config.printLog = true;

  // 菜单吸顶：false - 不吸顶；number - 吸顶，值为top值
  E.config.menuFixed = 0;

  // 编辑源码时，过滤 javascript
  E.config.jsFilter = true;

  // 编辑器允许的标签
  E.config.legalTags = 'p,h1,h2,h3,h4,h5,h6,blockquote,table,ul,ol,pre';

  // 语言包
  E.config.lang = E.langs['zh-cn'];

  // 菜单配置
  E.config.menus = [
      'source',
      '|',
      'bold',
      'underline',
      'italic',
      'strikethrough',
      'eraser',
      'forecolor',
      'bgcolor',
      '|',
      'quote',
      'fontfamily',
      'fontsize',
      'head',
      'unorderlist',
      'orderlist',
      'alignleft',
      'aligncenter',
      'alignright',
      '|',
      'link',
      'unlink',
      'table',
      'emotion',
      '|',
      'img',
      'video',
      'location',
      'insertcode',
      '|',
      'undo',
      'redo',
      'fullscreen'
  ];

  // 颜色配置
  E.config.colors = {
      // 'value': 'title'
      '#880000': '暗红色',
      '#800080': '紫色',
      '#ff0000': '红色',
      '#ff00ff': '鲜粉色',
      '#000080': '深蓝色',
      '#0000ff': '蓝色',
      '#00ffff': '湖蓝色',
      '#008080': '蓝绿色',
      '#008000': '绿色',
      '#808000': '橄榄色',
      '#00ff00': '浅绿色',
      '#ffcc00': '橙黄色',
      '#808080': '灰色',
      '#c0c0c0': '银色',
      '#000000': '黑色',
      '#ffffff': '白色'
  };

  // 字体
  E.config.familys = [
      '宋体', '黑体', '楷体', '微软雅黑',
      'Arial', 'Verdana', 'Georgia',
      'Times New Roman', 'Microsoft JhengHei',
      'Trebuchet MS', 'Courier New', 'Impact', 'Comic Sans MS', 'Consolas'
  ];

  // 字号
  E.config.fontsizes = {
      // 格式：'value': 'title'
      1: '12px',
      2: '13px',
      3: '16px',
      4: '18px',
      5: '24px',
      6: '32px',
      7: '48px'
  };

  // 表情包
  E.config.emotionsShow = 'icon'; // 显示项，默认为'icon'，也可以配置成'value'
  E.config.emotions = {
      // 'default': {
      //     title: '默认',
      //     data: './emotions.data'
      // },
      'weibo': {
          title: '微博表情',
          data: [
              {
                  icon: 'http://img.t.sinajs.cn/t35/style/images/common/face/ext/normal/7a/shenshou_thumb.gif',
                  value: '[草泥马]'    
              },
              {
                  icon: 'http://img.t.sinajs.cn/t35/style/images/common/face/ext/normal/60/horse2_thumb.gif',
                  value: '[神马]'    
              },
              {
                  icon: 'http://img.t.sinajs.cn/t35/style/images/common/face/ext/normal/bc/fuyun_thumb.gif',
                  value: '[浮云]'    
              },
              {
                  icon: 'http://img.t.sinajs.cn/t35/style/images/common/face/ext/normal/c9/geili_thumb.gif',
                  value: '[给力]'    
              },
              {
                  icon: 'http://img.t.sinajs.cn/t35/style/images/common/face/ext/normal/f2/wg_thumb.gif',
                  value: '[围观]'    
              },
              {
                  icon: 'http://img.t.sinajs.cn/t35/style/images/common/face/ext/normal/70/vw_thumb.gif',
                  value: '[威武]'
              },
              {
                  icon: 'http://img.t.sinajs.cn/t35/style/images/common/face/ext/normal/6e/panda_thumb.gif',
                  value: '[熊猫]'
              },
              {
                  icon: 'http://img.t.sinajs.cn/t35/style/images/common/face/ext/normal/81/rabbit_thumb.gif',
                  value: '[兔子]'
              },
              {
                  icon: 'http://img.t.sinajs.cn/t35/style/images/common/face/ext/normal/bc/otm_thumb.gif',
                  value: '[奥特曼]'
              },
              {
                  icon: 'http://img.t.sinajs.cn/t35/style/images/common/face/ext/normal/15/j_thumb.gif',
                  value: '[囧]'
              },
              {
                  icon: 'http://img.t.sinajs.cn/t35/style/images/common/face/ext/normal/89/hufen_thumb.gif',
                  value: '[互粉]'
              },
              {
                  icon: 'http://img.t.sinajs.cn/t35/style/images/common/face/ext/normal/c4/liwu_thumb.gif',
                  value: '[礼物]'
              },
              {
                  icon: 'http://img.t.sinajs.cn/t35/style/images/common/face/ext/normal/ac/smilea_thumb.gif',
                  value: '[呵呵]'
              },
              {
                  icon: 'http://img.t.sinajs.cn/t35/style/images/common/face/ext/normal/0b/tootha_thumb.gif',
                  value: '[哈哈]'
              }
          ]
      }
  };

  // 百度地图的key
  E.config.mapAk = 'TVhjYjq1ICT2qqL5LdS8mwas';

  // 上传图片的配置
  // server地址
  E.config.uploadImgUrl = '';
  // 超时时间
  E.config.uploadTimeout = 20 * 1000;
  // 用于存储上传回调事件
  E.config.uploadImgFns = {};
  // 自定义上传图片的filename
  // E.config.uploadImgFileName = 'customFileName';

  // 自定义上传，设置为 true 之后，显示上传图标
  E.config.customUpload = false;
  // 自定义上传的init事件
  // E.config.customUploadInit = function () {....};

  // 自定义上传时传递的参数（如 token）
  E.config.uploadParams = {
      /* token: 'abcdef12345' */
  };

  // 自定义上传是的header参数
  E.config.uploadHeaders = {
       /* 'Accept' : 'text/x-json' */
  };

  // 隐藏网络图片，默认为 false
  E.config.hideLinkImg = false;

  // 是否过滤粘贴内容
  E.config.pasteFilter = true;

  // 是否粘贴纯文本，当 editor.config.pasteFilter === false 时候，此配置将失效
  E.config.pasteText = false;

  // 插入代码时，默认的语言
  E.config.codeDefaultLang = 'javascript';

});
// 全局UI
_e(function (E, $) {

   E.UI = {};

   // 为菜单自定义配置的UI
   E.UI.menus = {
      // 这个 default 不加引号，在 IE8 会报错
      'default': {
          normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-command"></i></a>',
          selected: '.selected'
      },
      bold: {
          normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-bold"></i></a>',
          selected: '.selected'
      },
      underline: {
          normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-underline"></i></a>',
          selected: '.selected'
      },
      italic: {
          normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-italic"></i></a>',
          selected: '.selected'
      },
      forecolor: {
          normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-pencil"></i></a>',
          selected: '.selected'
      },
      bgcolor: {
          normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-brush"></i></a>',
          selected: '.selected'
      },
      strikethrough: {
          normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-strikethrough"></i></a>',
          selected: '.selected'
      },
      eraser: {
          normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-eraser"></i></a>',
          selected: '.selected'
      },
      quote: {
          normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-quotes-left"></i></a>',
          selected: '.selected'
      },
      source: {
          normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-code"></i></a>',
          selected: '.selected'
      },
      fontfamily: {
          normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-font2"></i></a>',
          selected: '.selected'
      },
      fontsize: {
          normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-text-height"></i></a>',
          selected: '.selected'
      },
      head: {
          normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-header"></i></a>',
          selected: '.selected'
      },
      orderlist: {
          normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-list-numbered"></i></a>',
          selected: '.selected'
      },
      unorderlist: {
          normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-list-bullet"></i></a>',
          selected: '.selected'
      },
      alignleft: {
          normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-align-left"></i></a>',
          selected: '.selected'
      },
      aligncenter: {
          normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-align-center"></i></a>',
          selected: '.selected'
      },
      alignright: {
          normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-align-right"></i></a>',
          selected: '.selected'
      },
      link: {
          normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-link"></i></a>',
          selected: '.selected'
      },
      unlink: {
          normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-unlink"></i></a>',
          selected: '.selected'
      },
      table: {
          normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-table"></i></a>',
          selected: '.selected'
      },
      emotion: {
          normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-happy"></i></a>',
          selected: '.selected'
      },
      img: {
          normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-picture"></i></a>',
          selected: '.selected'
      },
      video: {
          normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-play"></i></a>',
          selected: '.selected'
      },
      location: {
          normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-location"></i></a>',
          selected: '.selected'
      },
      insertcode: {
          normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-terminal"></i></a>',
          selected: '.selected'
      },
      undo: {
          normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-ccw"></i></a>',
          selected: '.selected'
      },
      redo: {
          normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-cw"></i></a>',
          selected: '.selected'
      },
      fullscreen: {
          normal: '<a href="#" tabindex="-1"><i class="wangeditor-menu-img-enlarge2"></i></a>',
          selected: '<a href="#" tabindex="-1" class="selected"><i class="wangeditor-menu-img-shrink2"></i></a>'
      }
   };
   
});
// 对象配置
_e(function (E, $) {

  E.fn.initDefaultConfig = function () {
      var editor = this;
      editor.config = $.extend({}, E.config);
      editor.UI = $.extend({}, E.UI);
  };

});
// 增加 container
_e(function (E, $) {

  E.fn.addEditorContainer = function () {
      this.$editorContainer = $('<div class="wangEditor-container"></div>');
  };

});
// 增加编辑区域对象
_e(function (E, $) {

  E.fn.addTxt = function () {
      var editor = this;
      var txt = new E.Txt(editor);

      editor.txt = txt;
  };

});
// 增加menuContainer对象
_e(function (E, $) {

  E.fn.addMenuContainer = function () {
      var editor = this;
      editor.menuContainer = new E.MenuContainer(editor);
  };

});
// 增加menus
_e(function (E, $) {

  // 存储创建菜单的函数
  E.createMenuFns = [];
  E.createMenu = function (fn) {
      E.createMenuFns.push(fn);
  };

  // 创建所有菜单
  E.fn.addMenus = function () {
      var editor = this;
      var menuIds = editor.config.menus;

      // 检验 menuId 是否在配置中存在
      function check(menuId) {
          if (menuIds.indexOf(menuId) >= 0) {
              return true;
          }
          return false;
      }

      // 遍历所有的菜单创建函数，并执行
      $.each(E.createMenuFns, function (k, createMenuFn) {
          createMenuFn.call(editor, check);
      });
  };

});
// bold菜单
_e(function (E, $) {

  E.createMenu(function (check) {
      var menuId = 'bold';
      if (!check(menuId)) {
          return;
      }

      var editor = this;
      var lang = editor.config.lang;

      // 创建 menu 对象
      var menu = new E.Menu({
          editor: editor,
          id: menuId,
          title: lang.bold,
          commandName: 'Bold'
      });

      // 定义选中状态下的click事件
      menu.clickEventSelected = function (e) {
          var isRangeEmpty = editor.isRangeEmpty();
          if (!isRangeEmpty) {
              // 如果选区有内容，则执行基础命令
              editor.command(e, 'Bold');
          } else {
              // 如果选区没有内容
              editor.commandForElem('b,strong,h1,h2,h3,h4,h5', e, 'Bold');
          }
      };

      // 增加到editor对象中
      editor.menus[menuId] = menu;
  });

});
// underline菜单
_e(function (E, $) {

  E.createMenu(function (check) {
      var menuId = 'underline';
      if (!check(menuId)) {
          return;
      }

      var editor = this;
      var lang = editor.config.lang;

      // 创建 menu 对象
      var menu = new E.Menu({
          editor: editor,
          id: menuId,
          title: lang.underline,
          commandName: 'Underline'
      });

      // 定义选中状态下的click事件
      menu.clickEventSelected = function (e) {
          var isRangeEmpty = editor.isRangeEmpty();
          if (!isRangeEmpty) {
              // 如果选区有内容，则执行基础命令
              editor.command(e, 'Underline');
          } else {
              // 如果选区没有内容
              editor.commandForElem('u,a', e, 'Underline');
          }
      };

      // 增加到editor对象中
      editor.menus[menuId] = menu;
  });

});
// italic 菜单
_e(function (E, $) {
  
  E.createMenu(function (check) {
      var menuId = 'italic';
      if (!check(menuId)) {
          return;
      }
      var editor = this;
      var lang = editor.config.lang;

      // 创建 menu 对象
      var menu = new E.Menu({
          editor: editor,
          id: menuId,
          title: lang.italic,
          commandName: 'Italic'
      });

      // 定义选中状态下的click事件
      menu.clickEventSelected = function (e) {
          var isRangeEmpty = editor.isRangeEmpty();
          if (!isRangeEmpty) {
              // 如果选区有内容，则执行基础命令
              editor.command(e, 'Italic');
          } else {
              // 如果选区没有内容
              editor.commandForElem('i', e, 'Italic');
          }
      };

      // 增加到editor对象中
      editor.menus[menuId] = menu;
  });

});
// forecolor 菜单
_e(function (E, $) {

  E.createMenu(function (check) {
      var menuId = 'forecolor';
      if (!check(menuId)) {
          return;
      }
      var editor = this;
      var lang = editor.config.lang;
      var configColors = editor.config.colors;

      // 创建 menu 对象
      var menu = new E.Menu({
          editor: editor,
          id: menuId,
          title: lang.forecolor
      });

      // 创建 dropPanel
      var $content = $('<div></div>');
      $.each(configColors, function (k, v) {
          $content.append(
              [
                  '<a href="#" class="color-item"',
                  '    title="' + v + '" commandValue="' + k + '" ',
                  '    style="color: ' + k + '" ',
                  '><i class="wangeditor-menu-img-pencil"></i></a>'
              ].join('')
          );
      });
      $content.on('click', 'a[commandValue]', function (e) {
          // 执行命令
          var $elem = $(this);
          var commandValue = $elem.attr('commandValue');

          if (menu.selected && editor.isRangeEmpty()) {
              // 当前处于选中状态，并且选中内容为空
              editor.commandForElem('font[color]', e, 'forecolor', commandValue);
          } else {
              // 当前未处于选中状态，或者有选中内容。则执行默认命令
              editor.command(e, 'forecolor', commandValue);
          }
      });
      menu.dropPanel = new E.DropPanel(editor, menu, {
          $content: $content,
          width: 125
      });

      // 定义 update selected 事件
      menu.updateSelectedEvent = function () {
          var rangeElem = editor.getRangeElem();
          rangeElem = editor.getSelfOrParentByName(rangeElem, 'font[color]');
          if (rangeElem) {
              return true;
          }
          return false;
      };

      // 增加到editor对象中
      editor.menus[menuId] = menu;
  });

});
// bgcolor 菜单
_e(function (E, $) {

  E.createMenu(function (check) {
      var menuId = 'bgcolor';
      if (!check(menuId)) {
          return;
      }
      var editor = this;
      var lang = editor.config.lang;
      var configColors = editor.config.colors;

      // 检查元素是否有 background-color: 内联样式
      function checkElemFn(elem) {
          var cssText;
          if (elem && elem.style && elem.style.cssText != null) {
              cssText = elem.style.cssText;
              if (cssText && cssText.indexOf('background-color:') >= 0) {
                  return true;
              }
          }
          return false;
      }

      // 创建 menu 对象
      var menu = new E.Menu({
          editor: editor,
          id: menuId,
          title: lang.bgcolor
      });

      // 创建 dropPanel
      var $content = $('<div></div>');
      $.each(configColors, function (k, v) {
          $content.append(
              [
                  '<a href="#" class="color-item"',
                  '    title="' + v + '" commandValue="' + k + '" ',
                  '    style="color: ' + k + '" ',
                  '><i class="wangeditor-menu-img-brush"></i></a>'
              ].join('')
          );
      });
      $content.on('click', 'a[commandValue]', function (e) {
          // 执行命令

          var $elem = $(this);
          var commandValue = $elem.attr('commandValue');

          if (menu.selected && editor.isRangeEmpty()) {
              // 当前处于选中状态，并且选中内容为空。使用 commandForElem 执行命令
              editor.commandForElem({
                  selector: 'span,font',
                  check: checkElemFn
              }, e, 'BackColor', commandValue);
          } else {
              // 当前未处于选中状态，或者有选中内容。则执行默认命令
              editor.command(e, 'BackColor', commandValue);
          }
      });
      menu.dropPanel = new E.DropPanel(editor, menu, {
          $content: $content,
          width: 125
      });

      // 定义 update selected 事件
      menu.updateSelectedEvent = function () {
          var rangeElem = editor.getRangeElem();
          rangeElem = editor.getSelfOrParentByName(rangeElem, 'span,font', checkElemFn);
          
          if (rangeElem) {
              return true;
          }
          return false;
      };

      // 增加到editor对象中
      editor.menus[menuId] = menu;
  });

});
// strikethrough 菜单
_e(function (E, $) {

  E.createMenu(function (check) {
      var menuId = 'strikethrough';
      if (!check(menuId)) {
          return;
      }
      var editor = this;
      var lang = editor.config.lang;

      // 创建 menu 对象
      var menu = new E.Menu({
          editor: editor,
          id: menuId,
          title: lang.strikethrough,
          commandName: 'StrikeThrough'
      });

      // 定义选中状态下的click事件
      menu.clickEventSelected = function (e) {
          var isRangeEmpty = editor.isRangeEmpty();
          if (!isRangeEmpty) {
              // 如果选区有内容，则执行基础命令
              editor.command(e, 'StrikeThrough');
          } else {
              // 如果选区没有内容
              editor.commandForElem('strike', e, 'StrikeThrough');
          }
      };

      // 增加到editor对象中
      editor.menus[menuId] = menu;
  });

});
// eraser 菜单
_e(function (E, $) {

  E.createMenu(function (check) {
      var menuId = 'eraser';
      if (!check(menuId)) {
          return;
      }
      var editor = this;
      var lang = editor.config.lang;

      // 创建 menu 对象
      var menu = new E.Menu({
          editor: editor,
          id: menuId,
          title: lang.eraser,
          commandName: 'RemoveFormat'
      });

      // 定义点击事件
      menu.clickEvent = function (e) {
          var isRangeEmpty = editor.isRangeEmpty();

          if (!isRangeEmpty) {
              // 选区不是空的，则执行默认命令
              editor.command(e, 'RemoveFormat');
              return;
          }

          var $clearElem;

          // 自定义的命令函数
          function commandFn() {
              var editor = this;
              var rangeElem;
              var pElem, $pElem;
              var quoteElem, $quoteElem;
              var listElem, $listElem;

              // 获取选区 elem
              rangeElem = editor.getRangeElem();
              // 第一步，获取 quote 父元素
              quoteElem = editor.getSelfOrParentByName(rangeElem, 'blockquote');
              if (quoteElem) {
                  $quoteElem = $(quoteElem);
                  $clearElem = $('<p>' + $quoteElem.text() + '</p>');
                  $quoteElem.after($clearElem).remove();
              }
              // 第二步，获取 p h 父元素
              pElem = editor.getSelfOrParentByName(rangeElem, 'p,h1,h2,h3,h4,h5');
              if (pElem) {
                  $pElem = $(pElem);
                  $clearElem = $('<p>' + $pElem.text() + '</p>');
                  $pElem.after($clearElem).remove();
              }
              // 第三步，获取list
              listElem = editor.getSelfOrParentByName(rangeElem, 'ul,ol');
              if (listElem) {
                  $listElem = $(listElem);
                  $clearElem = $('<p>' + $listElem.text() + '</p>');
                  $listElem.after($clearElem).remove();
              }
          }

          // 自定义 callback 事件
          function callback() {
              // callback中，设置range为clearElem
              var editor = this;
              if ($clearElem) {
                  editor.restoreSelectionByElem($clearElem.get(0));
              }
          }

          // 执行自定义命令
          editor.customCommand(e, commandFn, callback);
      };

      // 增加到editor对象中
      editor.menus[menuId] = menu;
  });

});
// source 菜单
_e(function (E, $) {

  E.createMenu(function (check) {
      var menuId = 'source';
      if (!check(menuId)) {
          return;
      }
      var editor = this;
      var lang = editor.config.lang;
      var txtHtml;

      // 创建 menu 对象
      var menu = new E.Menu({
          editor: editor,
          id: menuId,
          title: lang.source
      });

      menu.isShowCode = false;

      // 更新内容
      function updateValue() {
          var $code = menu.$codeTextarea;
          var $txt = editor.txt.$txt;
          var value = $.trim($code.val()); // 取值

          if (!value) {
              value = '<p><br></p>';
          }
          
          // 过滤js代码
          if (editor.config.jsFilter) {
            value = value.replace(/<script[\s\S]*?<\/script>/ig, '');
          }
          // 135editor 改https: -> http:
          // https://image2.135editor.com
          value = value.replace(/https:\/\/(.*)\.135editor.com/ig,'http://$1.135editor.com')
          value = value.replace(/<img\s/ig,'<img referrerpolicy="no-referrer"')
          // 赋值
          try {
              $txt.html(value);
          } catch (ex) {
              // 更新 html 源码出错，一般都是取消了 js 过滤之后，js报错导致的
          }
      }

      // 定义click事件
      menu.clickEvent = function (e) {
          var self = this;
          var editor = self.editor;
          var $txt = editor.txt.$txt;
          var txtOuterHeight = $txt.outerHeight();
          var txtHeight = $txt.height();

          if (!self.$codeTextarea) {
              self.$codeTextarea = $('<textarea class="code-textarea"></textarea>');
          }
          var $code = self.$codeTextarea;
          $code.css({
              height: txtHeight,
              'margin-top': txtOuterHeight - txtHeight
          });

          // 赋值
          $code.val($txt.html());

          // 监控变化
          $code.on('change', function (e) {
              updateValue();
          });

          // 渲染
          $txt.after($code).hide();
          $code.show();

          // 更新状态
          menu.isShowCode = true;

          // 执行 updateSelected 事件
          this.updateSelected();

          // 禁用其他菜单
          editor.disableMenusExcept('source');

          // 记录当前html值
          txtHtml = $txt.html();
      };

      // 定义选中状态下的click事件
      menu.clickEventSelected = function (e) {
          var self = this;
          var editor = self.editor;
          var $txt = editor.txt.$txt;
          var $code = self.$codeTextarea;
          var value;

          if (!$code) {
              return;
          }

          // 更新内容
          updateValue();

          // 渲染
          $code.after($txt).hide();
          $txt.show();

          // 更新状态
          menu.isShowCode = false;

          // 执行 updateSelected 事件
          this.updateSelected();

          // 启用其他菜单
          editor.enableMenusExcept('source');

          // 判断是否执行 onchange 事件
          if ($txt.html() !== txtHtml) {
              if (editor.onchange && typeof editor.onchange === 'function') {
                  editor.onchange.call(editor);
              }
          }
      };

      // 定义切换选中状态事件
      menu.updateSelectedEvent = function () {
          return this.isShowCode;
      };

      // 增加到editor对象中
      editor.menus[menuId] = menu;
  });

});
// quote 菜单
_e(function (E, $) {

  E.createMenu(function (check) {
      var menuId = 'quote';
      if (!check(menuId)) {
          return;
      }
      var editor = this;
      var lang = editor.config.lang;

      // 创建 menu 对象
      var menu = new E.Menu({
          editor: editor,
          id: menuId,
          title: lang.quote,
          commandName: 'formatBlock',
          commandValue: 'blockquote'
      });

      // 定义click事件
      menu.clickEvent = function (e) {
          var rangeElem = editor.getRangeElem();
          var $rangeElem;
          if (!rangeElem) {
              e.preventDefault();
              return;
          }
          var currentQuote = editor.getSelfOrParentByName(rangeElem, 'blockquote');
          var $quote;

          if (currentQuote) {
              // 说明当前在quote之内，不做任何处理
              e.preventDefault();
              return;
          }

          rangeElem = editor.getLegalTags(rangeElem);
          $rangeElem = $(rangeElem);

          // 无文字，则不允许执行引用
          if (!$rangeElem.text()) {
              return;
          }


          if (!rangeElem) {
              // 执行默认命令
              // IE8 下执行此处（不过，经测试代码无效，也不报错）
              editor.command(e, 'formatBlock', 'blockquote');
              return;
          }

          // 自定义command事件
          function commandFn() {
              $quote = $('<p>' + $rangeElem.text() + '</p>');
              $rangeElem.after($quote).remove();
              $quote.wrap('<blockquote style="display:block;border-left: 5px solid #eee;padding:5px 10px;margin:10px 0;line-height:1.4;font-size:100%;">');
          }

          // 自定义 callback 事件
          function callback() {
              // callback中，设置range为quote
              var editor = this;
              if ($quote) {
                  editor.restoreSelectionByElem($quote.get(0));
              }
          }

          // 执行自定义命令
          editor.customCommand(e, commandFn, callback);
      };

      // 定义选中状态下的click事件
      menu.clickEventSelected = function (e) {
          var rangeElem;
          var quoteElem;
          var $lastChild;

          // 获取当前选区的elem，并试图往上找 quote 元素
          rangeElem = editor.getRangeElem();
          quoteElem = editor.getSelfOrParentByName(rangeElem, 'blockquote');
          if (!quoteElem) {
              // 没找到，则返回
              e.preventDefault();
              return;
          }

          // 自定义的command事件
          function commandFn() {
              var $quoteElem;
              var $children;

              $quoteElem = $(quoteElem);
              $children = $quoteElem.children();
              if ($children.length) {
                  $children.each(function (k) {
                      var $item = $(this);
                      if ($item.get(0).nodeName === 'P') {
                          $quoteElem.after($item);
                      } else {
                          $quoteElem.after('<p>' + $item.text() + '</p>');
                      }
                      $lastChild = $item;  // 记录最后一个子元素，用于callback中的range定位
                  });
                  $quoteElem.remove();
                  return;
              }
          }

          // 自定义的callback函数
          function callback() {
              // callback中，设置range为lastChild
              var editor = this;
              if ($lastChild) {
                  editor.restoreSelectionByElem($lastChild.get(0));
              }
          }

          // 执行自定义命令
          editor.customCommand(e, commandFn, callback);
      };

      // 定义更新选中状态的事件
      menu.updateSelectedEvent = function () {
          var self = this; //菜单对象
          var editor = self.editor;
          var rangeElem;

          rangeElem = editor.getRangeElem();
          rangeElem = editor.getSelfOrParentByName(rangeElem, 'blockquote');

          if (rangeElem) {
              return true;
          }

          return false;
      };

      // 增加到editor对象中
      editor.menus[menuId] = menu;

      // --------------- 两次点击 enter 跳出引用 ---------------
      editor.ready(function () {
          var editor = this;
          var $txt = editor.txt.$txt;
          var isPrevEnter = false;  // 是不是刚刚在quote中按了 enter 键
          $txt.on('keydown', function (e) {
              if (e.keyCode !== 13) {
                  // 不是 enter 键
                  isPrevEnter = false;
                  return;
              }

              var rangeElem = editor.getRangeElem();
              rangeElem = editor.getSelfOrParentByName(rangeElem, 'blockquote');
              if (!rangeElem) {
                  // 选区不是 quote
                  isPrevEnter = false;
                  return;
              }

              if (!isPrevEnter) {
                  // 最近没有在qote中按enter键
                  isPrevEnter = true;
                  return;
              }

              var currentRangeElem = editor.getRangeElem();
              var $currentRangeElem = $(currentRangeElem);
              if ($currentRangeElem.length) {
                  $currentRangeElem.parent().after($currentRangeElem);
              }

              // 设置选区
              editor.restoreSelectionByElem(currentRangeElem, 'start');

              isPrevEnter = false;
              // 阻止默认行文
              e.preventDefault();

          });
      }); // editor.ready(

      // --------------- 处理quote中无内容时不能删除的问题 ---------------
      editor.ready(function () {
          var editor = this;
          var $txt = editor.txt.$txt;
          var $rangeElem;

          function commandFn() {
              $rangeElem && $rangeElem.remove();
          }
          function callback() {
              if (!$rangeElem) {
                  return;
              }
              var $prev = $rangeElem.prev();
              if ($prev.length) {
                  // 有 prev 则定位到 prev 最后
                  editor.restoreSelectionByElem($prev.get(0));
              } else {
                  // 无 prev 则初始化选区
                  editor.initSelection();
              }
          }

          $txt.on('keydown', function (e) {
              if (e.keyCode !== 8) {
                  // 不是 backspace 键
                  return;
              }

              var rangeElem = editor.getRangeElem();
              rangeElem = editor.getSelfOrParentByName(rangeElem, 'blockquote');
              if (!rangeElem) {
                  // 选区不是 quote
                  return;
              }
              $rangeElem = $(rangeElem);

              var text = $rangeElem.text();
              if (text) {
                  // quote 中还有内容
                  return;
              }
              editor.customCommand(e, commandFn, callback);

          }); // $txt.on
      }); // editor.ready(
  });

});
// 字体 菜单
_e(function (E, $) {

  E.createMenu(function (check) {
      var menuId = 'fontfamily';
      if (!check(menuId)) {
          return;
      }
      var editor = this;
      var lang = editor.config.lang;
      var configFamilys = editor.config.familys;

      // 创建 menu 对象
      var menu = new E.Menu({
          editor: editor,
          id: menuId,
          title: lang.fontfamily,
          commandName: 'fontName'
      });

      // 初始化数据
      var data  = {};
      /*
          data 需要的结构
          {
              'commandValue': 'title'
              ...
          }
      */
      $.each(configFamilys, function (k, v) {
          // configFamilys 是数组，data 是对象
          data[v] = v;
      });

      // 创建droplist
      var tpl = '<span style="font-family:{#commandValue};">{#title}</span>';
      menu.dropList = new E.DropList(editor, menu, {
          data: data,
          tpl: tpl,
          selectorForELemCommand: 'font[face]'  // 为了执行 editor.commandForElem 而传入的elem查询方式
      });

      // 定义 update selected 事件
      menu.updateSelectedEvent = function () {
          var rangeElem = editor.getRangeElem();
          rangeElem = editor.getSelfOrParentByName(rangeElem, 'font[face]');
          if (rangeElem) {
              return true;
          }
          return false;
      };

      // 增加到editor对象中
      editor.menus[menuId] = menu;
  });
});
// 字号 菜单
_e(function (E, $) {
  E.createMenu(function (check) {
      var menuId = 'fontsize';
      if (!check(menuId)) {
          return;
      }
      var editor = this;
      var lang = editor.config.lang;
      var configSize = editor.config.fontsizes;

      // 创建 menu 对象
      var menu = new E.Menu({
          editor: editor,
          id: menuId,
          title: lang.fontsize,
          commandName: 'fontSize'
      });

      // 初始化数据
      var data  = configSize;
      /*
          data 需要的结构
          {
              'commandValue': 'title'
              ...
          }
      */

      // 创建droplist
      var tpl = '<span style="font-size:{#title};">{#title}</span>';
      menu.dropList = new E.DropList(editor, menu, {
          data: data,
          tpl: tpl,
          selectorForELemCommand: 'font[size]'  // 为了执行 editor.commandForElem 而传入的elem查询方式
      });

      // 定义 update selected 事件
      menu.updateSelectedEvent = function () {
          var rangeElem = editor.getRangeElem();
          rangeElem = editor.getSelfOrParentByName(rangeElem, 'font[size]');
          if (rangeElem) {
              return true;
          }
          return false;
      };

      // 增加到editor对象中
      editor.menus[menuId] = menu;
  });
});
// head 菜单
_e(function (E, $) {
  E.createMenu(function (check) {
      var menuId = 'head';
      if (!check(menuId)) {
          return;
      }
      var editor = this;
      var lang = editor.config.lang;

      // 创建 menu 对象
      var menu = new E.Menu({
          editor: editor,
          id: menuId,
          title: lang.head,
          commandName: 'formatBlock'
      });

      // 初始化数据
      var data  = {
          '<h1>': '标题1',
          '<h2>': '标题2',
          '<h3>': '标题3',
          '<h4>': '标题4',
          '<h5>': '标题5'
      };
      /*
          data 需要的结构
          {
              'commandValue': 'title'
              ...
          }
      */

      var isOrderedList;
      function beforeEvent(e) {
          if (editor.queryCommandState('InsertOrderedList')) {
              isOrderedList = true;

              // 先取消有序列表
              editor.command(e, 'InsertOrderedList');
          } else {
              isOrderedList = false;
          }
      }

      function afterEvent(e) {
          if (isOrderedList) {
              // 再设置有序列表
              editor.command(e, 'InsertOrderedList');
          }
      }

      // 创建droplist
      var tpl = '{#commandValue}{#title}';
      menu.dropList = new E.DropList(editor, menu, {
          data: data,
          tpl: tpl,
          // 对 ol 直接设置 head，会出现每个 li 的 index 都变成 1 的问题，因此要先取消 ol，然后设置 head，最后再增加上 ol
          beforeEvent: beforeEvent,
          afterEvent: afterEvent
      });

      // 定义 update selected 事件
      menu.updateSelectedEvent = function () {
          var rangeElem = editor.getRangeElem();
          rangeElem = editor.getSelfOrParentByName(rangeElem, 'h1,h2,h3,h4,h5');
          if (rangeElem) {
              return true;
          }
          return false;
      };

      // 增加到editor对象中
      editor.menus[menuId] = menu;
  });
});
// unorderlist 菜单
_e(function (E, $) {

  E.createMenu(function (check) {
      var menuId = 'unorderlist';
      if (!check(menuId)) {
          return;
      }
      var editor = this;
      var lang = editor.config.lang;

      // 创建 menu 对象
      var menu = new E.Menu({
          editor: editor,
          id: menuId,
          title: lang.unorderlist,
          commandName: 'InsertUnorderedList'
      });

      // 增加到editor对象中
      editor.menus[menuId] = menu;
  });

});
// orderlist 菜单
_e(function (E, $) {

  E.createMenu(function (check) {
      var menuId = 'orderlist';
      if (!check(menuId)) {
          return;
      }
      var editor = this;
      var lang = editor.config.lang;

      // 创建 menu 对象
      var menu = new E.Menu({
          editor: editor,
          id: menuId,
          title: lang.orderlist,
          commandName: 'InsertOrderedList'
      });

      // 增加到editor对象中
      editor.menus[menuId] = menu;
  });

});
// alignleft 菜单
_e(function (E, $) {

  E.createMenu(function (check) {
      var menuId = 'alignleft';
      if (!check(menuId)) {
          return;
      }
      var editor = this;
      var lang = editor.config.lang;

      // 创建 menu 对象
      var menu = new E.Menu({
          editor: editor,
          id: menuId,
          title: lang.alignleft,
          commandName: 'JustifyLeft'
      });

      // 定义 update selected 事件
      menu.updateSelectedEvent = function () {
          var rangeElem = editor.getRangeElem();
          rangeElem = editor.getSelfOrParentByName(rangeElem, 'p,h1,h2,h3,h4,h5,li', function (elem) {
              var cssText;
              if (elem && elem.style && elem.style.cssText != null) {
                  cssText = elem.style.cssText;
                  if (cssText && /text-align:\s*left;/.test(cssText)) {
                      return true;
                  }
              }
              if ($(elem).attr('align') === 'left') {
                  // ff 中，设置align-left之后，会是 <p align="left">xxx</p>
                  return true;
              }
              return false;
          });
          if (rangeElem) {
              return true;
          }
          return false;
      };

      // 增加到editor对象中
      editor.menus[menuId] = menu;
  });

});
// aligncenter 菜单
_e(function (E, $) {

  E.createMenu(function (check) {
      var menuId = 'aligncenter';
      if (!check(menuId)) {
          return;
      }
      var editor = this;
      var lang = editor.config.lang;

      // 创建 menu 对象
      var menu = new E.Menu({
          editor: editor,
          id: menuId,
          title: lang.aligncenter,
          commandName: 'JustifyCenter'
      });

      // 定义 update selected 事件
      menu.updateSelectedEvent = function () {
          var rangeElem = editor.getRangeElem();
          rangeElem = editor.getSelfOrParentByName(rangeElem, 'p,h1,h2,h3,h4,h5,li', function (elem) {
              var cssText;
              if (elem && elem.style && elem.style.cssText != null) {
                  cssText = elem.style.cssText;
                  if (cssText && /text-align:\s*center;/.test(cssText)) {
                      return true;
                  }
              }
              if ($(elem).attr('align') === 'center') {
                  // ff 中，设置align-center之后，会是 <p align="center">xxx</p>
                  return true;
              }
              return false;
          });
          if (rangeElem) {
              return true;
          }
          return false;
      };

      // 增加到editor对象中
      editor.menus[menuId] = menu;
  });

});
// alignright 菜单
_e(function (E, $) {

  E.createMenu(function (check) {
      var menuId = 'alignright';
      if (!check(menuId)) {
          return;
      }
      var editor = this;
      var lang = editor.config.lang;

      // 创建 menu 对象
      var menu = new E.Menu({
          editor: editor,
          id: menuId,
          title: lang.alignright,
          commandName: 'JustifyRight'
      });

      // 定义 update selected 事件
      menu.updateSelectedEvent = function () {
          var rangeElem = editor.getRangeElem();
          rangeElem = editor.getSelfOrParentByName(rangeElem, 'p,h1,h2,h3,h4,h5,li', function (elem) {
              var cssText;
              if (elem && elem.style && elem.style.cssText != null) {
                  cssText = elem.style.cssText;
                  if (cssText && /text-align:\s*right;/.test(cssText)) {
                      return true;
                  }
              }
              if ($(elem).attr('align') === 'right') {
                  // ff 中，设置align-right之后，会是 <p align="right">xxx</p>
                  return true;
              }
              return false;
          });
          if (rangeElem) {
              return true;
          }
          return false;
      };

      // 增加到editor对象中
      editor.menus[menuId] = menu;
  });

});
// link 菜单
_e(function (E, $) {

  E.createMenu(function (check) {
      var menuId = 'link';
      if (!check(menuId)) {
          return;
      }
      var editor = this;
      var lang = editor.config.lang;

      // 创建 menu 对象
      var menu = new E.Menu({
          editor: editor,
          id: menuId,
          title: lang.link
      });

      // 创建 dropPanel
      var $content = $('<div></div>');
      var $div1 = $('<div style="margin:20px 10px;" class="clearfix"></div>');
      var $div2 = $div1.clone();
      var $div3 = $div1.clone().css('margin', '0 10px');
      var $textInput = $('<input type="text" class="block" placeholder="' + lang.text + '"/>');
      var $urlInput = $('<input type="text" class="block" placeholder="' + lang.link + '"/>');
      var $btnSubmit = $('<button class="right">' + lang.submit + '</button>');
      var $btnCancel = $('<button class="right gray">' + lang.cancel + '</button>');

      $div1.append($textInput);
      $div2.append($urlInput);
      $div3.append($btnSubmit).append($btnCancel);
      $content.append($div1).append($div2).append($div3);
      
      menu.dropPanel = new E.DropPanel(editor, menu, {
          $content: $content,
          width: 300
      });

      // 定义click事件
      menu.clickEvent = function (e) {
          var menu = this;
          var dropPanel = menu.dropPanel;

          // -------------隐藏----------------
          if (dropPanel.isShowing) {
              dropPanel.hide();
              return;
          }

          // -------------显示----------------

          // 重置 input
          $textInput.val('');
          $urlInput.val('http://');

          // 获取url
          var url = '';
          var rangeElem = editor.getRangeElem();
          rangeElem = editor.getSelfOrParentByName(rangeElem, 'a');
          if (rangeElem) {
              url = rangeElem.href || '';
          }

          // 获取 text
          var text = '';
          var isRangeEmpty = editor.isRangeEmpty();
          if (!isRangeEmpty) {
              // 选区不是空
              text = editor.getRangeText() || '';
          } else if (rangeElem) {
              // 如果选区空，并且在 a 标签之内
              text = rangeElem.textContent || rangeElem.innerHTML;
          }

          // 设置 url 和 text
          url && $urlInput.val(url);
          text && $textInput.val(text);

          // 如果有选区内容，textinput 不能修改
          if (!isRangeEmpty) {
              $textInput.attr('disabled', true);
          } else {
              $textInput.removeAttr('disabled');
          }

          // 显示（要设置好了所有input的值和属性之后再显示）
          dropPanel.show();
      };

      // 定义 update selected 事件
      menu.updateSelectedEvent = function () {
          var rangeElem = editor.getRangeElem();
          rangeElem = editor.getSelfOrParentByName(rangeElem, 'a');
          if (rangeElem) {
              return true;
          }
          return false;
      };

      // 『取消』 按钮
      $btnCancel.click(function (e) {
          e.preventDefault();
          menu.dropPanel.hide();
      });

      // 『确定』按钮
      $btnSubmit.click(function (e) {
          e.preventDefault();
          var rangeElem = editor.getRangeElem();
          var targetElem = editor.getSelfOrParentByName(rangeElem, 'a');
          var isRangeEmpty = editor.isRangeEmpty();

          var $linkElem, linkHtml;
          var commandFn, callback;
          var $txt = editor.txt.$txt;
          var $oldLinks, $newLinks;
          var uniqId = 'link' + E.random();

          // 获取数据
          var url = $.trim($urlInput.val());
          var text = $.trim($textInput.val());

          if (!url) {
              menu.dropPanel.focusFirstInput();
              return;
          }
          if (!text) {
              text = url;
          }

          if (!isRangeEmpty) {
              // 选中区域有内容，则执行默认命令

              // 获取目前 txt 内所有链接，并为当前链接做一个标记
              $oldLinks = $txt.find('a');
              $oldLinks.attr(uniqId, '1');

              // 执行命令 
              editor.command(e, 'createLink', url);

              // 去的没有标记的链接，即刚刚插入的链接
              $newLinks = $txt.find('a').not('[' + uniqId + ']');
              $newLinks.attr('target', '_blank'); // 增加 _blank

              // 去掉之前做的标记
              $oldLinks.removeAttr(uniqId);

          } else if (targetElem) {
              // 无选中区域，在 a 标签之内，修改该 a 标签的内容和链接
              $linkElem = $(targetElem);
              commandFn = function () {
                  $linkElem.attr('href', url);
                  $linkElem.text(text);
              };
              callback = function () {
                  var editor = this;
                  editor.restoreSelectionByElem(targetElem);
              };
              // 执行命令
              editor.customCommand(e, commandFn, callback);
          } else {
              // 无选中区域，不在 a 标签之内，插入新的链接

              linkHtml = '<a href="' + url + '" target="_blank">' + text + '</a>';
              if (E.userAgent.indexOf('Firefox') > 0) {
                  linkHtml += '<span>&nbsp;</span>';
              }
              editor.command(e, 'insertHtml', linkHtml);
          }

      });
      
      // 增加到editor对象中
      editor.menus[menuId] = menu;
  });

});
// unlink 菜单
_e(function (E, $) {

  E.createMenu(function (check) {
      var menuId = 'unlink';
      if (!check(menuId)) {
          return;
      }
      var editor = this;
      var lang = editor.config.lang;

      // 创建 menu 对象
      var menu = new E.Menu({
          editor: editor,
          id: menuId,
          title: lang.unlink,
          commandName: 'unLink'
      });

      // click 事件
      menu.clickEvent = function  (e) {
          var isRangeEmpty = editor.isRangeEmpty();
          if (!isRangeEmpty) {
              // 有选中区域，或者IE8，执行默认命令
              editor.command(e, 'unLink');
              return;
          }

          // 无选中区域...

          var rangeElem = editor.getRangeElem();
          var aElem = editor.getSelfOrParentByName(rangeElem, 'a');
          if (!aElem) {
              // 不在 a 之内，返回
              e.preventDefault();
              return;
          }

          // 在 a 之内
          var $a = $(aElem);
          var $span = $('<span>' + $a.text() + '</span>');
          function commandFn() {
              $a.after($span).remove();
          }
          function callback() {
              editor.restoreSelectionByElem($span.get(0));
          }
          editor.customCommand(e, commandFn, callback);
      };

      // 增加到editor对象中
      editor.menus[menuId] = menu;
  });

});
// table 菜单
_e(function (E, $) {

  E.createMenu(function (check) {
      var menuId = 'table';
      if (!check(menuId)) {
          return;
      }
      var editor = this;
      var lang = editor.config.lang;

      // 创建 menu 对象
      var menu = new E.Menu({
          editor: editor,
          id: menuId,
          title: lang.table
      });

      // dropPanel 内容
      var $content = $('<div style="font-size: 14px; color: #666; text-align:right;"></div>');
      var $table = $('<table class="choose-table" style="margin-bottom:10px;margin-top:5px;">');
      var $row = $('<span>0</span>');
      var $rowspan = $('<span> 行 </span>');
      var $col = $('<span>0</span>');
      var $colspan = $('<span> 列</span>');
      var $tr;
      var i, j;

      // 创建一个n行n列的表格
      for (i = 0; i < 15; i++) {
          $tr = $('<tr index="' + (i + 1) + '">');
          for (j = 0; j < 20; j++) {
              $tr.append($('<td index="' + (j + 1) + '">'));
          }
          $table.append($tr);
      }
      $content.append($table);
      $content.append($row).append($rowspan).append($col).append($colspan);

      // 定义table事件
      $table.on('mouseenter', 'td', function (e) {
          var $currentTd = $(e.currentTarget);
          var currentTdIndex = $currentTd.attr('index');
          var $currentTr = $currentTd.parent();
          var currentTrIndex = $currentTr.attr('index');

          // 显示
          $row.text(currentTrIndex);
          $col.text(currentTdIndex);

          // 遍历设置背景颜色
          $table.find('tr').each(function () {
              var $tr = $(this);
              var trIndex = $tr.attr('index');
              if (parseInt(trIndex, 10) <= parseInt(currentTrIndex, 10)) {
                  // 该行需要可能需要设置背景色
                  $tr.find('td').each(function () {
                      var $td = $(this);
                      var tdIndex = $td.attr('index');
                      if (parseInt(tdIndex, 10) <= parseInt(currentTdIndex, 10)) {
                          // 需要设置背景色
                          $td.addClass('active');
                      } else {
                          // 需要移除背景色
                          $td.removeClass('active');
                      }
                  });
              } else {
                  // 改行不需要设置背景色
                  $tr.find('td').removeClass('active');
              }
          });
      }).on('mouseleave', function (e) {
          // mouseleave 删除背景色
          $table.find('td').removeClass('active');

          $row.text(0);
          $col.text(0);
      });

      // 插入表格
      $table.on('click', 'td', function (e) {
          var $currentTd = $(e.currentTarget);
          var currentTdIndex = $currentTd.attr('index');
          var $currentTr = $currentTd.parent();
          var currentTrIndex = $currentTr.attr('index');

          var rownum = parseInt(currentTrIndex, 10);
          var colnum = parseInt(currentTdIndex, 10);

          // -------- 拼接tabel html --------

          var i, j;
          var tableHtml = '<table>';
          for (i = 0; i < rownum; i++) {
              tableHtml += '<tr>';

              for (j = 0; j < colnum; j++) {
                  tableHtml += '<td><span>&nbsp;</span></td>';
              }
              tableHtml += '</tr>';
          }
          tableHtml += '</table>';

          // -------- 执行命令 --------
          editor.command(e, 'insertHtml', tableHtml);
      });

      // 创建 panel
      menu.dropPanel = new E.DropPanel(editor, menu, {
          $content: $content,
          width: 262
      });

      // 增加到editor对象中
      editor.menus[menuId] = menu;
  });

});
// emotion 菜单
_e(function (E, $) {

  E.createMenu(function (check) {
      var menuId = 'emotion';
      if (!check(menuId)) {
          return;
      }
      var editor = this;
      var config = editor.config;
      var lang = config.lang;
      var configEmotions = config.emotions;
      var emotionsShow = config.emotionsShow;

      // 记录每一个表情图片的地址
      editor.emotionUrls = [];

      // 创建 menu 对象
      var menu = new E.Menu({
          editor: editor,
          id: menuId,
          title: lang.emotion
      });

      // 添加表情图片的函数
      function insertEmotionImgs(data, $tabContent) {
          // 添加表情图片
          $.each(data, function (k, emotion) {
              var src = emotion.icon || emotion.url;
              var value = emotion.value || emotion.title;
              // 通过配置 editor.config.emotionsShow 的值来修改插入到编辑器的内容（图片/value）
              var commandValue = emotionsShow === 'icon' ? src : value;
              var $command = $('<a href="#" commandValue="' + commandValue + '"></a>');
              var $img = $('<img>');
              $img.attr('_src', src);  // 先将 src 复制到 '_src' 属性，先不加载

              $command.append($img);
              $tabContent.append($command);

              // 记录下每一个表情图片的地址
              editor.emotionUrls.push(src);
          });
      }

      // 拼接 dropPanel 内容
      var $panelContent = $('<div class="panel-tab"></div>');
      var $tabContainer = $('<div class="tab-container"></div>');
      var $contentContainer = $('<div class="content-container emotion-content-container"></div>');
      $.each(configEmotions, function (k, emotion) {
          var title = emotion.title;
          var data = emotion.data;

          E.log('正在处理 ' + title + ' 表情的数据...');

          // 增加该组表情的tab和content
          var $tab = $('<a href="#">' + title +' </a>');
          $tabContainer.append($tab);
          var $tabContent = $('<div class="content"></div>');
          $contentContainer.append($tabContent);

          // tab 切换事件
          $tab.click(function (e) {
              $tabContainer.children().removeClass('selected');
              $contentContainer.children().removeClass('selected');
              $tabContent.addClass('selected');
              $tab.addClass('selected');
              e.preventDefault();
          });

          // 处理data
          if (typeof data === 'string') {
              // url 形式，需要通过ajax从该url获取数据
              E.log('将通过 ' + data + ' 地址ajax下载表情包');
              $.get(data, function (result) {
                  result = $.parseJSON(result);
                  E.log('下载完毕，得到 ' + result.length + ' 个表情');
                  insertEmotionImgs(result, $tabContent);
              });
              
          } else if ( Object.prototype.toString.call(data).toLowerCase().indexOf('array') > 0 ) {
              // 数组，即 data 直接就是表情包数据
              insertEmotionImgs(data, $tabContent);
          } else {
              // 其他情况，data格式不对
              E.error('data 数据格式错误，请修改为正确格式，参考文档：' + E.docsite);
              return;
          }
      });
      $panelContent.append($tabContainer).append($contentContainer);

      // 默认显示第一个tab
      $tabContainer.children().first().addClass('selected');
      $contentContainer.children().first().addClass('selected');

      // 插入表情command事件
      $contentContainer.on('click', 'a[commandValue]', function (e) {
          var $a = $(e.currentTarget);
          var commandValue = $a.attr('commandValue');
          var img;

          // commandValue 有可能是图片url，也有可能是表情的 value，需要区别对待

          if (emotionsShow === 'icon') {
              // 插入图片
              editor.command(e, 'InsertImage', commandValue);
          } else {
              // 插入value
              editor.command(e, 'insertHtml', '<span>' + commandValue + '</span>');
          }

          e.preventDefault();
      });

      // 添加panel
      menu.dropPanel = new E.DropPanel(editor, menu, {
          $content: $panelContent,
          width: 350
      });

      // 定义click事件（异步加载表情图片）
      menu.clickEvent = function (e) {
          var menu = this;
          var dropPanel = menu.dropPanel;

          // -------------隐藏-------------
          if (dropPanel.isShowing) {
              dropPanel.hide();
              return;
          }

          // -------------显示-------------
          dropPanel.show();

          // 异步加载图片
          if (menu.imgLoaded) {
              return;
          }
          $contentContainer.find('img').each(function () {
              var $img = $(this);
              var _src = $img.attr('_src');
              $img.on('error', function () {
                  E.error('加载不出表情图片 ' + _src);
              });
              $img.attr('src', _src);
              $img.removeAttr('_src');
          });
          menu.imgLoaded = true;
      };

      // 增加到editor对象中
      editor.menus[menuId] = menu;
  });

});
// img 菜单
_e(function (E, $) {

  E.createMenu(function (check) {
      var menuId = 'img';
      if (!check(menuId)) {
          return;
      }
      var editor = this;
      var lang = editor.config.lang;

      // 创建 menu 对象
      var menu = new E.Menu({
          editor: editor,
          id: menuId,
          title: lang.img
      });

      // 创建 panel content
      var $panelContent = $('<div class="panel-tab"></div>');
      var $tabContainer = $('<div class="tab-container"></div>');
      var $contentContainer = $('<div class="content-container"></div>');
      $panelContent.append($tabContainer).append($contentContainer);

      // tab
      var $uploadTab = $('<a href="#">上传图片</a>');
      var $linkTab = $('<a href="#">网络图片</a>');
      $tabContainer.append($uploadTab).append($linkTab);

      // 上传图片 content
      var $uploadContent = $('<div class="content"></div>');
      $contentContainer.append($uploadContent);

      // 网络图片 content
      var $linkContent = $('<div class="content"></div>');
      $contentContainer.append($linkContent);
      linkContentHandler(editor, menu, $linkContent);

      // 添加panel
      menu.dropPanel = new E.DropPanel(editor, menu, {
          $content: $panelContent,
          width: 400,
          onRender: function () {
              // 渲染后的回调事件，用于执行自定义上传的init
              // 因为渲染之后，上传面板的dom才会被渲染到页面，才能让第三方空间获取到
              var init = editor.config.customUploadInit;
              init && init.call(editor);
          }
      });

      // 增加到editor对象中
      editor.menus[menuId] = menu;

      // tab 切换事件
      function tabToggle() {
          $uploadTab.click(function (e) {
              $tabContainer.children().removeClass('selected');
              $contentContainer.children().removeClass('selected');
              $uploadContent.addClass('selected');
              $uploadTab.addClass('selected');
              e.preventDefault();
          });
          $linkTab.click(function (e) {
              $tabContainer.children().removeClass('selected');
              $contentContainer.children().removeClass('selected');
              $linkContent.addClass('selected');
              $linkTab.addClass('selected');
              e.preventDefault();

              // focus input
              if (E.placeholder) {
                  $linkContent.find('input[type=text]').focus();
              }
          });

          // 默认情况
          // $uploadTab.addClass('selected');
          // $uploadContent.addClass('selected');
          $uploadTab.click();
      }

      // 隐藏上传图片
      function hideUploadImg() {
          $tabContainer.remove();
          $uploadContent.remove();
          $linkContent.addClass('selected');
      }

      // 隐藏网络图片
      function hideLinkImg() {
          $tabContainer.remove();
          $linkContent.remove();
          $uploadContent.addClass('selected');
      }

      // 判断用户是否配置了上传图片
      editor.ready(function () {
          var editor = this;
          var config = editor.config;
          var uploadImgUrl = config.uploadImgUrl;
          var customUpload = config.customUpload;
          var linkImg = config.hideLinkImg;
          var $uploadImgPanel;

          if (uploadImgUrl || customUpload) {
              // 第一，暴露出 $uploadContent 以便用户自定义 ！！！重要
              editor.$uploadContent = $uploadContent;

              // 第二，绑定tab切换事件
              tabToggle();

              if (linkImg) {
                  // 隐藏网络图片
                  hideLinkImg();
              }
          } else {
              // 未配置上传图片功能
              hideUploadImg();
          }

          // 点击 $uploadContent 立即隐藏 dropPanel
          // 为了兼容IE8、9的上传，因为IE8、9使用 modal 上传
          // 这里使用异步，为了不妨碍高级浏览器通过点击 $uploadContent 选择文件
          function hidePanel() {
              menu.dropPanel.hide();
          }
          $uploadContent.click(function () {
              setTimeout(hidePanel);
          });
      });
  });

  // --------------- 处理网络图片content ---------------
  function linkContentHandler (editor, menu, $linkContent) {
      var lang = editor.config.lang;
      var $urlContainer = $('<div style="margin:20px 10px 10px 10px;"></div>');
      var $urlInput = $('<input type="text" class="block" placeholder="http://"/>');
      $urlContainer.append($urlInput);
      var $btnSubmit = $('<button class="right">' + lang.submit + '</button>');
      var $btnCancel = $('<button class="right gray">' + lang.cancel + '</button>');

      $linkContent.append($urlContainer).append($btnSubmit).append($btnCancel);

      // 取消
      $btnCancel.click(function (e) {
          e.preventDefault();
          menu.dropPanel.hide();
      });

      // callback 
      function callback() {
          $urlInput.val('');
      }

      // 确定
      $btnSubmit.click(function (e) {
          e.preventDefault();
          var url = $.trim($urlInput.val());
          if (!url) {
              // 无内容
              $urlInput.focus();
              return;
          }

          var imgHtml = '<img style="max-width:100%;" src="' + url + '"/>';
          editor.command(e, 'insertHtml', imgHtml, callback);
      });
  }

});
// video 菜单
_e(function (E, $) {

  E.createMenu(function (check) {
      var menuId = 'video';
      if (!check(menuId)) {
          return;
      }
      var editor = this;
      var lang = editor.config.lang;
      var reg = /^<(iframe)|(embed)/i;  // <iframe... 或者 <embed... 格式

      // 创建 menu 对象
      var menu = new E.Menu({
          editor: editor,
          id: menuId,
          title: lang.video
      });

      // 创建 panel 内容
      var $content = $('<div></div>');
      var $linkInputContainer = $('<div style="margin:20px 10px;"></div>');
      var $linkInput = $('<input type="text" class="block" placeholder=\'格式如：<iframe src="..." frameborder=0 allowfullscreen></iframe>\'/>');
      $linkInputContainer.append($linkInput);
      var $sizeContainer = $('<div style="margin:20px 10px;"></div>');
      var $widthInput = $('<input type="text" value="640" style="width:50px;text-align:center;"/>');
      var $heightInput = $('<input type="text" value="498" style="width:50px;text-align:center;"/>');
      $sizeContainer.append('<span> ' + lang.width + ' </span>')
                    .append($widthInput)
                    .append('<span> px &nbsp;&nbsp;&nbsp;</span>')
                    .append('<span> ' + lang.height + ' </span>')
                    .append($heightInput)
                    .append('<span> px </span>');
      var $btnContainer = $('<div></div>');
      var $howToCopy = $('<a href="http://www.kancloud.cn/wangfupeng/wangeditor2/134973" target="_blank" style="display:inline-block;margin-top:10px;margin-left:10px;color:#999;">如何复制视频链接？</a>');
      var $btnSubmit = $('<button class="right">' + lang.submit + '</button>');
      var $btnCancel = $('<button class="right gray">' + lang.cancel + '</button>');
      $btnContainer.append($howToCopy).append($btnSubmit).append($btnCancel);
      $content.append($linkInputContainer).append($sizeContainer).append($btnContainer);

      // 取消按钮
      $btnCancel.click(function (e) {
          e.preventDefault();
          $linkInput.val('');
          menu.dropPanel.hide();
      });

      // 确定按钮
      $btnSubmit.click(function (e) {
          e.preventDefault();
          var link = $.trim($linkInput.val());
          var $link;
          var width = parseInt($widthInput.val());
          var height = parseInt($heightInput.val());
          var $div = $('<div>');
          var html = '<p>{content}</p>';

          // 验证数据
          if (!link) {
              menu.dropPanel.focusFirstInput();
              return;
          }

          if (!reg.test(link)) {
              alert('视频链接格式错误！');
              menu.dropPanel.focusFirstInput();
              return;
          }

          if (isNaN(width) || isNaN(height)) {
              alert('宽度或高度不是数字！');
              return;
          }

          $link = $(link);

          // 设置高度和宽度
          $link.attr('width', width)
               .attr('height', height);

          // 拼接字符串
          html = html.replace('{content}', $div.append($link).html());

          // 执行命令
          editor.command(e, 'insertHtml', html);
          $linkInput.val('');
      });

      // 创建panel
      menu.dropPanel = new E.DropPanel(editor, menu, {
          $content: $content,
          width: 400
      });

      // 增加到editor对象中
      editor.menus[menuId] = menu;
  });

});
// location 菜单
_e(function (E, $) {

  // 判断浏览器的 input 是否支持 keyup
  var inputKeyup = (function (input) {
      return 'onkeyup' in input;
  })(document.createElement('input'));

  // 百度地图的key
  E.baiduMapAk = 'TVhjYjq1ICT2qqL5LdS8mwas';

  // 一个页面中，如果有多个编辑器，地图会出现问题。这个参数记录一下，如果超过 1 就提示
  E.numberOfLocation = 0;

  E.createMenu(function (check) {
      var menuId = 'location';
      if (!check(menuId)) {
          return;
      }

      if (++E.numberOfLocation > 1) {
          E.error('目前不支持在一个页面多个编辑器上同时使用地图，可通过自定义菜单配置去掉地图菜单');
          return;
      }

      var editor = this;
      var config = editor.config;
      var lang = config.lang;
      var ak = config.mapAk;

      // 地图的变量存储到这个地方
      editor.mapData = {};
      var mapData = editor.mapData;

      // ---------- 地图事件 ----------
      mapData.markers = [];
      mapData.mapContainerId = 'map' + E.random();

      mapData.clearLocations = function () {
          var map = mapData.map;
          if (!map) {
              return;
          }
          map.clearOverlays();

          //同时，清空marker数组
          mapData.markers = [];
      };

      mapData.searchMap = function () {
          var map = mapData.map;
          if (!map) {
              return;
          }

          var BMap = window.BMap;
          var cityName = $cityInput.val();
          var locationName = $searchInput.val();
          var myGeo, marker;

          if(cityName !== ''){
              if(!locationName || locationName === ''){
                  map.centerAndZoom(cityName, 11);
              }

              //地址解析
              if(locationName && locationName !== ''){
                  myGeo = new BMap.Geocoder();
                  // 将地址解析结果显示在地图上,并调整地图视野
                  myGeo.getPoint(locationName, function(point){
                      if (point) {
                          map.centerAndZoom(point, 13);
                          marker = new BMap.Marker(point);
                          map.addOverlay(marker);
                          marker.enableDragging();  //允许拖拽
                          mapData.markers.push(marker);  //将marker加入到数组中
                      }else{
                          // alert('未找到');
                          map.centerAndZoom(cityName, 11);  //找不到则重新定位到城市
                      }
                  }, cityName);
              }
          } // if(cityName !== '')
      };

      // load script 之后的 callback
      var hasCallback = false;
      window.baiduMapCallBack = function(){
          // 避免重复加载
          if (hasCallback) {
              return;
          } else {
              hasCallback = true;
          }

          var BMap = window.BMap;
          if (!mapData.map) {
              // 创建Map实例
              mapData.map = new BMap.Map(mapData.mapContainerId);
          }
          var map = mapData.map;

          map.centerAndZoom(new BMap.Point(116.404, 39.915), 11);  // 初始化地图,设置中心点坐标和地图级别
          map.addControl(new BMap.MapTypeControl());   //添加地图类型控件
          map.setCurrentCity("北京");          // 设置地图显示的城市 此项是必须设置的
          map.enableScrollWheelZoom(true);     //开启鼠标滚轮缩放

          //根据IP定位
          function locationFun(result){
              var cityName = result.name;
              map.setCenter(cityName);

              // 设置城市名称
              $cityInput.val(cityName);
              if (E.placeholder) {
                  $searchInput.focus();
              }
              var timeoutId, searchFn;
              if (inputKeyup) {
                 // 并绑定搜索事件 - input 支持 keyup
                 searchFn = function (e) {
                     if (e.type === 'keyup' && e.keyCode === 13) {
                         e.preventDefault();
                     }
                     if (timeoutId) {
                         clearTimeout(timeoutId);
                     }
                     timeoutId = setTimeout(mapData.searchMap, 500);
                 };
                 $cityInput.on('keyup change paste', searchFn);
                 $searchInput.on('keyup change paste', searchFn); 
              } else {
                  // 并绑定搜索事件 - input 不支持 keyup
                  searchFn = function () {
                      if (!$content.is(':visible')) {
                          // panel 不显示了，就不用再监控了
                          clearTimeout(timeoutId);
                          return;
                      }

                      var currentCity = '';
                      var currentSearch = '';
                      var city = $cityInput.val();
                      var search = $searchInput.val();

                      if (city !== currentCity || search !== currentSearch) {
                          // 刚获取的数据和之前的数据不一致，执行查询
                          mapData.searchMap();
                          // 更新数据
                          currentCity = city;
                          currentSearch = search;
                      }

                      // 继续监控
                      if (timeoutId) {
                          clearTimeout(timeoutId);
                      }
                      timeoutId = setTimeout(searchFn, 1000);
                  };
                  // 开始监控
                  timeoutId = setTimeout(searchFn, 1000);
              }
          }
          var myCity = new BMap.LocalCity();
          myCity.get(locationFun);

          //鼠标点击，创建位置
          map.addEventListener("click", function(e){
              var marker = new BMap.Marker(new BMap.Point(e.point.lng, e.point.lat)); 
              map.addOverlay(marker);  
              marker.enableDragging();
              mapData.markers.push(marker);  //加入到数组中
          }, false);
      };

      mapData.loadMapScript = function () {
          var script = document.createElement("script");
          script.type = "text/javascript";
          script.src = "https://api.map.baidu.com/api?v=2.0&ak=" + ak + "&s=1&callback=baiduMapCallBack";  // baiduMapCallBack是一个本地函数
          try {
              // IE10- 报错
              document.body.appendChild(script);
          } catch (ex) {
              E.error('加载地图过程中发生错误');
          }
      };

      // 初始化地图
      mapData.initMap = function () {
          if (window.BMap) {
              // 不是第一次，直接处理地图即可
              window.baiduMapCallBack();
          } else {
              // 第一次，先加载地图 script，再处理地图（script加载完自动执行处理）
              mapData.loadMapScript();
          }
      };

      // ---------- 创建 menu 对象 ----------

      var menu = new E.Menu({
          editor: editor,
          id: menuId,
          title: lang.location
      });

      editor.menus[menuId] = menu;

      // ---------- 构建UI ----------

      // panel content 
      var $content = $('<div></div>');

      // 搜索框
      var $inputContainer = $('<div style="margin:10px 0;"></div>');
      var $cityInput = $('<input type="text"/>');
      $cityInput.css({
          width: '80px',
          'text-align': 'center'
      });
      var $searchInput = $('<input type="text"/>');
      $searchInput.css({
          width: '300px',
          'margin-left': '10px'
      }).attr('placeholder', lang.searchlocation);
      var $clearBtn = $('<button class="right link">' + lang.clearLocation + '</button>');
      $inputContainer.append($clearBtn)
                     .append($cityInput)
                     .append($searchInput);
      $content.append($inputContainer);

      // 清除位置按钮
      $clearBtn.click(function (e) {
          $searchInput.val('');
          $searchInput.focus();
          mapData.clearLocations();
          e.preventDefault();
      });

      // 地图
      var $map = $('<div id="' + mapData.mapContainerId + '"></div>');
      $map.css({
          height: '260px',
          width: '100%',
          position: 'relative',
          'margin-top': '10px',
          border: '1px solid #f1f1f1'
      });
      var $mapLoading = $('<span>' + lang.loading + '</span>');
      $mapLoading.css({
          position: 'absolute',
          width: '100px',
          'text-align': 'center',
          top: '45%',
          left: '50%',
          'margin-left': '-50px'
      });
      $map.append($mapLoading);
      $content.append($map);

      // 按钮
      var $btnContainer = $('<div style="margin:10px 0;"></div>');
      var $btnSubmit = $('<button class="right">' + lang.submit + '</button>');
      var $btnCancel = $('<button class="right gray">' + lang.cancel + '</button>');
      var $checkLabel = $('<label style="display:inline-block;margin-top:10px;color:#666;"></label>');
      var $check = $('<input type="checkbox">');
      $checkLabel.append($check).append('<span style="display:inline-block;margin-left:5px;">  ' + lang.dynamicMap + '</span>');
      $btnContainer.append($checkLabel)
                   .append($btnSubmit)
                   .append($btnCancel);
      $content.append($btnContainer);

      function callback() {
          $searchInput.val('');
      }

      // 『取消』按钮事件
      $btnCancel.click(function (e) {
          e.preventDefault();
          callback();
          menu.dropPanel.hide();
      });

      // 『确定』按钮事件
      $btnSubmit.click(function (e) {
          e.preventDefault();
          var map = mapData.map,
              isDynamic = $check.is(':checked'),
              markers =  mapData.markers,

              center = map.getCenter(),
              centerLng = center.lng,
              centerLat = center.lat,

              zoom = map.getZoom(),

              size = map.getSize(),
              sizeWidth = size.width,
              sizeHeight = size.height,

              position,
              src,
              iframe;

          if(isDynamic){
              //动态地址
              src = 'http://ueditor.baidu.com/ueditor/dialogs/map/show.html#';
          }else{
              //静态地址
              src = 'http://api.map.baidu.com/staticimage?';
          }

          //src参数
          src = src +'center=' + centerLng + ',' + centerLat +
              '&zoom=' + zoom +
              '&width=' + sizeWidth +
              '&height=' + sizeHeight;
          if(markers.length > 0){
              src = src + '&markers=';

              //添加所有的marker
              $.each(markers, function(key, value){
                  position = value.getPosition();
                  if(key > 0){
                      src = src + '|';
                  }
                  src = src + position.lng + ',' + position.lat;
              });
          }

          if(isDynamic){
              if(markers.length > 1){
                  alert( lang.langDynamicOneLocation );
                  return;
              }

              src += '&markerStyles=l,A';

              //插入iframe
              iframe = '<iframe class="ueditor_baidumap" src="{src}" frameborder="0" width="' + sizeWidth + '" height="' + sizeHeight + '"></iframe>';
              iframe = iframe.replace('{src}', src);
              editor.command(e, 'insertHtml', iframe, callback);
          }else{
              //插入图片
              editor.command(e, 'insertHtml', '<img style="max-width:100%;" src="' + src + '"/>', callback);
          }
      });

      // 根据 UI 创建菜单 panel
      menu.dropPanel = new E.DropPanel(editor, menu, {
          $content: $content,
          width: 500
      });

      // ---------- 事件 ----------

      // render 时执行事件
      menu.onRender = function () {
          if (ak === E.baiduMapAk) {
              E.warn('建议在配置中自定义百度地图的mapAk，否则可能影响地图功能，文档：' + E.docsite);
          }
      };

      // click 事件
      menu.clickEvent = function (e) {
          var menu = this;
          var dropPanel = menu.dropPanel;
          var firstTime = false;

          // -------------隐藏-------------
          if (dropPanel.isShowing) {
              dropPanel.hide();
              return;
          }

          // -------------显示-------------
          if (!mapData.map) {
              // 第一次，先加载地图
              firstTime = true;
          }
          
          dropPanel.show();
          mapData.initMap();

          if (!firstTime) {
              $searchInput.focus();
          }
      };

  });

});
// insertcode 菜单
_e(function (E, $) {

  // 加载 highlightjs 代码
  function loadHljs() {
      if (E.userAgent.indexOf('MSIE 8') > 0) {
          // 不支持 IE8
          return;
      }
      if (window.hljs) {
          // 不要重复加载
          return;
      }
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src = "//cdn.bootcss.com/highlight.js/9.2.0/highlight.min.js";
      document.body.appendChild(script);
  }
  

  E.createMenu(function (check) {
      var menuId = 'insertcode';
      if (!check(menuId)) {
          return;
      }

      // 加载 highlightjs 代码
      setTimeout(loadHljs, 0);

      var editor = this;
      var config = editor.config;
      var lang = config.lang;
      var $txt = editor.txt.$txt;

      // 创建 menu 对象
      var menu = new E.Menu({
          editor: editor,
          id: menuId,
          title: lang.insertcode
      });

      // click 事件
      menu.clickEvent = function (e) {
          var menu = this;
          var dropPanel = menu.dropPanel;

          // 隐藏
          if (dropPanel.isShowing) {
              dropPanel.hide();
              return;
          }

          // 显示
          $textarea.val('');
          dropPanel.show();

          // highlightjs 语言列表
          var hljs = window.hljs;
          if (hljs && hljs.listLanguages) {
              if ($langSelect.children().length !== 0) {
                  return;
              }
              $langSelect.css({
                  'margin-top': '9px',
                  'margin-left': '5px'
              });
              $.each(hljs.listLanguages(), function (key, lang) {
                  if (lang === 'xml') {
                      lang = 'html';
                  }
                  if (lang === config.codeDefaultLang) {
                      $langSelect.append('<option value="' + lang + '" selected="selected">' + lang + '</option>');
                  } else {
                      $langSelect.append('<option value="' + lang + '">' + lang + '</option>');
                  }
              });
          } else {
              $langSelect.hide();
          }
      };

      // 选中状态下的 click 事件
      menu.clickEventSelected = function (e) {
          var menu = this;
          var dropPanel = menu.dropPanel;

          // 隐藏
          if (dropPanel.isShowing) {
              dropPanel.hide();
              return;
          }

          // 显示
          dropPanel.show();

          var rangeElem = editor.getRangeElem();
          var targetElem = editor.getSelfOrParentByName(rangeElem, 'pre');
          var $targetElem;
          var className;
          if (targetElem) {
              // 确定找到 pre 之后，再找 code
              targetElem = editor.getSelfOrParentByName(rangeElem, 'code');
          }
          if (!targetElem) {
              return;
          }
          $targetElem = $(targetElem);

          // 赋值内容
          $textarea.val($targetElem.text());
          if ($langSelect) {
              // 赋值语言
              className = $targetElem.attr('class');
              if (className) {
                  $langSelect.val(className.split(' ')[0]);
              }
          }
      };

      // 定义更新选中状态的事件
      menu.updateSelectedEvent = function () {
          var self = this; //菜单对象
          var editor = self.editor;
          var rangeElem;

          rangeElem = editor.getRangeElem();
          rangeElem = editor.getSelfOrParentByName(rangeElem, 'pre');

          if (rangeElem) {
              return true;
          }

          return false;
      };

      // 创建 panel
      var $content = $('<div></div>');
      var $textarea = $('<textarea></textarea>');
      var $langSelect = $('<select></select>');
      contentHandle($content);
      menu.dropPanel = new E.DropPanel(editor, menu, {
          $content: $content,
          width: 500
      });

      // 增加到editor对象中
      editor.menus[menuId] = menu;

      // ------ 增加 content 内容 ------
      function contentHandle($content) {
          // textarea 区域
          var $textareaContainer = $('<div></div>');
          $textareaContainer.css({
              margin: '15px 5px 5px 5px',
              height: '160px',
              'text-align': 'center'
          });
          $textarea.css({
              width: '100%',
              height: '100%',
              padding: '10px'
          });
          $textarea.on('keydown', function (e) {
              // 取消 tab 键默认行为
              if (e.keyCode === 9) {
                  e.preventDefault();
              }
          });
          $textareaContainer.append($textarea);
          $content.append($textareaContainer);

          // 按钮区域
          var $btnContainer = $('<div></div>');
          var $btnSubmit = $('<button class="right">' + lang.submit + '</button>');
          var $btnCancel = $('<button class="right gray">' + lang.cancel + '</button>');

          $btnContainer.append($btnSubmit).append($btnCancel).append($langSelect);
          $content.append($btnContainer);

          // 取消按钮
          $btnCancel.click(function (e) {
              e.preventDefault();
              menu.dropPanel.hide();
          });

          // 确定按钮
          var codeTpl = '<pre style="max-width:100%;overflow-x:auto;"><code{#langClass}>{#content}</code></pre>';
          $btnSubmit.click(function (e) {
              e.preventDefault();
              var val = $textarea.val();
              if (!val) {
                  // 无内容
                  $textarea.focus();
                  return;
              }

              var rangeElem = editor.getRangeElem();
              if ($.trim($(rangeElem).text()) && codeTpl.indexOf('<p><br></p>') !== 0) {
                  codeTpl = '<p><br></p>' + codeTpl;
              }

              var lang = $langSelect ? $langSelect.val() : ''; // 获取高亮语言
              var langClass = '';
              var doHightlight = function () {
                  $txt.find('pre code').each(function (i, block) {
                      var $block = $(block);
                      if ($block.attr('codemark')) {
                          // 有 codemark 标记的代码块，就不再重新格式化了
                          return;
                      } else if (window.hljs) {
                          // 新代码块，格式化之后，立即标记 codemark
                          window.hljs.highlightBlock(block);
                          $block.attr('codemark', '1');
                      }
                  });
              };

              // 语言高亮样式
              if (lang) {
                  langClass = ' class="' + lang + ' hljs"';
              }

              // 替换标签
              val = val.replace(/&/gm, '&amp;')
                       .replace(/</gm, '&lt;')
                       .replace(/>/gm, '&gt;');

              // ---- menu 未选中状态 ----
              if (!menu.selected) {
                  // 拼接html
                  var html = codeTpl.replace('{#langClass}', langClass).replace('{#content}', val);
                  editor.command(e, 'insertHtml', html, doHightlight);
                  return;
              }

              // ---- menu 选中状态 ----
              var targetElem = editor.getSelfOrParentByName(rangeElem, 'pre');
              var $targetElem;
              if (targetElem) {
                  // 确定找到 pre 之后，再找 code
                  targetElem = editor.getSelfOrParentByName(rangeElem, 'code');
              }
              if (!targetElem) {
                  return;
              }
              $targetElem = $(targetElem);

              function commandFn() {
                  var className;
                  if (lang) {
                      className = $targetElem.attr('class');
                      if (className !== lang + ' hljs') {
                          $targetElem.attr('class', lang + ' hljs');
                      }
                  }
                  $targetElem.html(val);
              }
              function callback() {
                  editor.restoreSelectionByElem(targetElem);
                  doHightlight();
              }
              editor.customCommand(e, commandFn, callback);
          });
      }

      // ------ enter 时，不另起标签，只换行 ------
      $txt.on('keydown', function (e) {
          if (e.keyCode !== 13) {
              return;
          }
          var rangeElem = editor.getRangeElem();
          var targetElem = editor.getSelfOrParentByName(rangeElem, 'code');
          if (!targetElem) {
              return;
          }

          editor.command(e, 'insertHtml', '\n');
      });

      // ------ 点击时，禁用其他标签 ------
      function updateMenu() {
          var rangeElem = editor.getRangeElem();
          var targetElem = editor.getSelfOrParentByName(rangeElem, 'code');
          if (targetElem) {
              // 在 code 之内，禁用其他菜单
              editor.disableMenusExcept('insertcode');
          } else {
              // 不是在 code 之内，启用其他菜单
              editor.enableMenusExcept('insertcode');
          }
      }
      $txt.on('keydown click', function (e) {
          // 此处必须使用 setTimeout 异步处理，否则不对
          setTimeout(updateMenu);
      });
  });

});
// undo 菜单
_e(function (E, $) {

  E.createMenu(function (check) {
      var menuId = 'undo';
      if (!check(menuId)) {
          return;
      }
      var editor = this;
      var lang = editor.config.lang;

      // 创建 menu 对象
      var menu = new E.Menu({
          editor: editor,
          id: menuId,
          title: lang.undo
      });

      // click 事件
      menu.clickEvent = function (e) {
          editor.undo();
      };

      // 增加到editor对象中
      editor.menus[menuId] = menu;


      // ------------ 初始化时、enter 时、打字中断时，做记录 ------------
      // ------------ ctrl + z 是调用记录撤销，而不是使用浏览器默认的撤销 ------------
      editor.ready(function () {
          var editor = this;
          var $txt = editor.txt.$txt;
          var timeoutId;

          // 执行undo记录
          function undo() {
              editor.undoRecord();
          }

          $txt.on('keydown', function (e) {
              var keyCode = e.keyCode;

              // 撤销 ctrl + z
              if (e.ctrlKey && keyCode === 90) {
                  editor.undo();
                  return;
              }

              if (keyCode === 13) {
                  // enter 做记录
                  undo();
              } else {
                  // keyup 之后 1s 之内不操作，则做一次记录
                  if (timeoutId) {
                      clearTimeout(timeoutId);
                  }
                  timeoutId = setTimeout(undo, 1000);
              }
          });

          // 初始化做记录
          editor.undoRecord();
      });
  });

});
// redo 菜单
_e(function (E, $) {

  E.createMenu(function (check) {
      var menuId = 'redo';
      if (!check(menuId)) {
          return;
      }
      var editor = this;
      var lang = editor.config.lang;

      // 创建 menu 对象
      var menu = new E.Menu({
          editor: editor,
          id: menuId,
          title: lang.redo
      });

      // click 事件
      menu.clickEvent = function (e) {
          editor.redo();
      };

      // 增加到editor对象中
      editor.menus[menuId] = menu;
  });

});
// 全屏 菜单
_e(function (E, $) {

  // 记录全屏时的scrollTop
  var scrollTopWhenFullScreen;

  E.createMenu(function (check) {
      var menuId = 'fullscreen';
      if (!check(menuId)) {
          return;
      }
      var editor = this;
      var $txt = editor.txt.$txt;
      var config = editor.config;
      var zIndexConfig = config.zindex || 10000;
      var lang = config.lang;

      var isSelected = false;
      var zIndex;

      var maxHeight;

      // 创建 menu 对象
      var menu = new E.Menu({
          editor: editor,
          id: menuId,
          title: lang.fullscreen
      });

      // 定义click事件
      menu.clickEvent = function (e) {
          // 增加样式
          var $editorContainer = editor.$editorContainer;
          $editorContainer.addClass('wangEditor-fullscreen');

          // （先保存当前的）再设置z-index
          zIndex = $editorContainer.css('z-index');
          $editorContainer.css('z-index', zIndexConfig);

          var $wrapper;
          var txtHeight = $txt.height();
          var txtOuterHeight = $txt.outerHeight();

          if (editor.useMaxHeight) {
              // 记录 max-height，并暂时去掉maxheight
              maxHeight = $txt.css('max-height');
              $txt.css('max-height', 'none');

              // 如果使用了maxHeight， 将$txt从它的父元素中移出来
              $wrapper = $txt.parent();
              $wrapper.after($txt);
              $wrapper.remove();
              $txt.css('overflow-y', 'auto');
          }

          // 设置高度到全屏
          var menuContainer = editor.menuContainer;
          $txt.height(
              E.$window.height() - 
              menuContainer.height() - 
              (txtOuterHeight - txtHeight)  // 去掉内边距和外边距
          );

          // 取消menuContainer的内联样式（menu吸顶时，会为 menuContainer 设置一些内联样式）
          editor.menuContainer.$menuContainer.attr('style', '');

          // 保存状态
          isSelected = true;

          // 记录编辑器是否全屏
          editor.isFullScreen = true;

          // 记录设置全屏时的高度
          scrollTopWhenFullScreen = E.$window.scrollTop();
      };

      // 定义选中状态的 click 事件
      menu.clickEventSelected = function (e) {
          // 取消样式
          var $editorContainer = editor.$editorContainer;
          $editorContainer.removeClass('wangEditor-fullscreen');
          $editorContainer.css('z-index', zIndex);

          // 还原height
          if (editor.useMaxHeight) {
              $txt.css('max-height', maxHeight);
          } else {
              // editor.valueContainerHeight 在 editor.txt.initHeight() 中事先保存了
              editor.$valueContainer.css('height', editor.valueContainerHeight);
          }

          // 重新计算高度
          editor.txt.initHeight();

          // 保存状态
          isSelected = false;

          // 记录编辑器是否全屏
          editor.isFullScreen = false;

          // 还原scrollTop
          if (scrollTopWhenFullScreen != null) {
              E.$window.scrollTop(scrollTopWhenFullScreen);
          }
      };

      // 定义选中事件
      menu.updateSelectedEvent = function (e) {
          return isSelected;
      };

      // 增加到editor对象中
      editor.menus[menuId] = menu;
  });

});
// 渲染menus
_e(function (E, $) {

  E.fn.renderMenus = function () {

      var editor = this;
      var menus = editor.menus;
      var menuIds = editor.config.menus;
      var menuContainer = editor.menuContainer;

      var menu;
      var groupIdx = 0;
      $.each(menuIds, function (k, v) {
          if (v === '|') {
              groupIdx++;
              return;
          }

          menu = menus[v];
          if (menu) {
              menu.render(groupIdx);
          }
      });
  };

});
// 渲染menus
_e(function (E, $) {

  E.fn.renderMenuContainer = function () {

      var editor = this;
      var menuContainer = editor.menuContainer;
      var $editorContainer = editor.$editorContainer;

      menuContainer.render();

  };

});
// 渲染 txt
_e(function (E, $) {

  E.fn.renderTxt = function () {

      var editor = this;
      var txt = editor.txt;

      txt.render();

      // ready 时候，计算txt的高度
      editor.ready(function () {
          txt.initHeight();
      });
  };

});
// 渲染 container
_e(function (E, $) {

  E.fn.renderEditorContainer = function () {

      var editor = this;
      var $valueContainer = editor.$valueContainer;
      var $editorContainer = editor.$editorContainer;
      var $txt = editor.txt.$txt;
      var $prev, $parent;

      // 将编辑器渲染到页面中
      if ($valueContainer === $txt) {
          $prev = editor.$prev;
          $parent = editor.$parent;

          if ($prev && $prev.length) {
              // 有前置节点，就插入到前置节点的后面
              $prev.after($editorContainer);
          } else {
              // 没有前置节点，就直接插入到父元素
              $parent.prepend($editorContainer);
          }

      } else {
          $valueContainer.after($editorContainer);
          $valueContainer.hide();
      }

      // 设置宽度（这样设置宽度有问题）
      // $editorContainer.css('width', $valueContainer.css('width'));
  };

});
// 菜单事件
_e(function (E, $) {

  // 绑定每个菜单的click事件
  E.fn.eventMenus = function () {

      var menus = this.menus;

      // 绑定菜单的点击事件
      $.each(menus, function (k, v) {
          v.bindEvent();
      });

  };

});
// 菜单container事件
_e(function (E, $) {

  E.fn.eventMenuContainer = function () {

  };

});
// 编辑区域事件
_e(function (E, $) {

  E.fn.eventTxt = function () {

      var txt = this.txt;

      // txt内容变化时，保存选区
      txt.saveSelectionEvent();

      // txt内容变化时，随时更新 value
      txt.updateValueEvent();

      // txt内容变化时，随时更新 menu style
      txt.updateMenuStyleEvent();

      // // 鼠标hover时，显示 p head 高度（暂时关闭这个功能）
      // if (!/ie/i.test(E.userAgent)) {
      //     // 暂时不支持IE
      //     txt.showHeightOnHover();
      // }
  };

});
// 上传图片事件
_e(function (E, $) {

  E.plugin(function () {
      var editor = this;
      var fns = editor.config.uploadImgFns; // editor.config.uploadImgFns = {} 在config文件中定义了

      // -------- 定义load函数 --------
      fns.onload || (fns.onload = function (resultText, xhr) {
          E.log('上传结束，返回结果为 ' + resultText);

          var editor = this;
          var originalName = editor.uploadImgOriginalName || '';  // 上传图片时，已经将图片的名字存在 editor.uploadImgOriginalName
          var img;
          if (resultText.indexOf('error|') === 0) {
              // 提示错误
              E.warn('上传失败：' + resultText.split('|')[1]);
              alert(resultText.split('|')[1]);
          } else {
              E.log('上传成功，即将插入编辑区域，结果为：' + resultText);

              // 将结果插入编辑器
              img = document.createElement('img');
              img.onload = function () {
                  var html = '<img src="' + resultText + '" alt="' + originalName + '" style="max-width:100%;"/>';
                  editor.command(null, 'insertHtml', html);

                  E.log('已插入图片，地址 ' + resultText);
                  img = null;
              };
              img.onerror = function () {
                  E.error('使用返回的结果获取图片，发生错误。请确认以下结果是否正确：' + resultText);
                  img = null;
              };
              img.src = resultText;
          }

      });

      // -------- 定义tiemout函数 --------
      fns.ontimeout || (fns.ontimeout = function (xhr) {
          E.error('上传图片超时');
          alert('上传图片超时');
      });

      // -------- 定义error函数 --------
      fns.onerror || (fns.onerror = function (xhr) {
          E.error('上传上图片发生错误');
          alert('上传上图片发生错误');
      });

  });
});
// xhr 上传图片
_e(function (E, $) {

  if (!window.FileReader || !window.FormData) {
      // 如果不支持html5的文档操作，直接返回
      return;
  }

  E.plugin(function () {

      var editor = this;
      var config = editor.config;
      var uploadImgUrl = config.uploadImgUrl;
      var uploadTimeout = config.uploadTimeout;

      // 获取配置中的上传事件
      var uploadImgFns = config.uploadImgFns;
      var onload = uploadImgFns.onload;
      var ontimeout = uploadImgFns.ontimeout;
      var onerror = uploadImgFns.onerror;

      if (!uploadImgUrl) {
          return;
      }

      // -------- 将以base64的图片url数据转换为Blob --------
      function convertBase64UrlToBlob(urlData, filetype){
          //去掉url的头，并转换为byte
          var bytes = window.atob(urlData.split(',')[1]);
          
          //处理异常,将ascii码小于0的转换为大于0
          var ab = new ArrayBuffer(bytes.length);
          var ia = new Uint8Array(ab);
          var i;
          for (i = 0; i < bytes.length; i++) {
              ia[i] = bytes.charCodeAt(i);
          }

          return new Blob([ab], {type : filetype});
      }

      // -------- 插入图片的方法 --------
      function insertImg(src, event) {
          var img = document.createElement('img');
          img.onload = function () {
              var html = '<img src="' + src + '" style="max-width:100%;"/>';
              editor.command(event, 'insertHtml', html);

              E.log('已插入图片，地址 ' + src);
              img = null;
          };
          img.onerror = function () {
              E.error('使用返回的结果获取图片，发生错误。请确认以下结果是否正确：' + src);
              img = null;
          };
          img.src = src;
      }

      // -------- onprogress 事件 --------
      function updateProgress(e) {
          if (e.lengthComputable) {
              var percentComplete = e.loaded / e.total;
              editor.showUploadProgress(percentComplete * 100);
          }
      }

      // -------- xhr 上传图片 --------
      editor.xhrUploadImg = function (opt) {
          // opt 数据
          var event = opt.event;
          var fileName = opt.filename || '';
          var base64 = opt.base64;
          var fileType = opt.fileType || 'image/png'; // 无扩展名则默认使用 png
          var name = opt.name || 'wangEditor_upload_file';
          var loadfn = opt.loadfn || onload;
          var errorfn = opt.errorfn || onerror;
          var timeoutfn = opt.timeoutfn || ontimeout;

          // 上传参数（如 token）
          var params = editor.config.uploadParams || {};

          // headers
          var headers = editor.config.uploadHeaders || {};

          // 获取文件扩展名
          var fileExt = 'png';  // 默认为 png
          if (fileName.indexOf('.') > 0) {
              // 原来的文件名有扩展名
              fileExt = fileName.slice(fileName.lastIndexOf('.') - fileName.length + 1);
          } else if (fileType.indexOf('/') > 0 && fileType.split('/')[1]) {
              // 文件名没有扩展名，通过类型获取，如从 'image/png' 取 'png'
              fileExt = fileType.split('/')[1];
          }

          // ------------ begin 预览模拟上传 ------------
          if (E.isOnWebsite) {
              E.log('预览模拟上传');
              insertImg(base64, event);
              return;
          }
          // ------------ end 预览模拟上传 ------------

          // 变量声明
          var xhr = new XMLHttpRequest();
          var timeoutId;
          var src;
          var formData = new FormData();

          // 超时处理
          function timeoutCallback() {
              if (timeoutId) {
                  clearTimeout(timeoutId);
              }
              if (xhr && xhr.abort) {
                  xhr.abort();
              }

              // 超时了就阻止默认行为
              event.preventDefault();

              // 执行回调函数，提示什么内容，都应该在回调函数中定义
              timeoutfn && timeoutfn.call(editor, xhr);

              // 隐藏进度条
              editor.hideUploadProgress();
          }

          xhr.onload = function () {
              if (timeoutId) {
                  clearTimeout(timeoutId);
              }

              // 记录文件名到 editor.uploadImgOriginalName ，插入图片时，可做 alt 属性用
              editor.uploadImgOriginalName = fileName;
              if (fileName.indexOf('.') > 0) {
                  editor.uploadImgOriginalName = fileName.split('.')[0];
              }

              // 执行load函数，任何操作，都应该在load函数中定义
              loadfn && loadfn.call(editor, xhr.responseText, xhr);

              // 隐藏进度条
              editor.hideUploadProgress();
          };
          xhr.onerror = function () {
              if (timeoutId) {
                  clearTimeout(timeoutId);
              }

              // 超时了就阻止默认行为
              event.preventDefault();

              // 执行error函数，错误提示，应该在error函数中定义
              errorfn && errorfn.call(editor, xhr);

              // 隐藏进度条
              editor.hideUploadProgress();
          };
          // xhr.onprogress = updateProgress;
          xhr.upload.onprogress = updateProgress;

          // 填充数据
          formData.append(name, convertBase64UrlToBlob(base64, fileType), E.random() + '.' + fileExt);

          // 添加参数
          $.each(params, function (key, value) {
              formData.append(key, value);
          });

          // 开始上传
          xhr.open('POST', uploadImgUrl, true);
          // xhr.setRequestHeader("Content-type","application/x-www-form-urlencoded");  // 将参数解析成传统form的方式上传

          // 修改自定义配置的headers
          $.each(headers, function (key, value) {
              xhr.setRequestHeader(key, value);
          });

          // 跨域上传时，传cookie
          xhr.withCredentials = true;

          // 发送数据
          xhr.send(formData);
          timeoutId = setTimeout(timeoutCallback, uploadTimeout);

          E.log('开始上传...并开始超时计算');
      };
  });
});
// 进度条
_e(function (E, $) {

  E.plugin(function () {

      var editor = this;
      var menuContainer = editor.menuContainer;
      var menuHeight = menuContainer.height();
      var $editorContainer = editor.$editorContainer;
      var width = $editorContainer.width();
      var $progress = $('<div class="wangEditor-upload-progress"></div>');

      // 渲染事件
      var isRender = false;
      function render() {
          if (isRender) {
              return;
          }
          isRender = true;

          $progress.css({
              top: menuHeight + 'px'
          });
          $editorContainer.append($progress);
      }

      // ------ 显示进度 ------
      editor.showUploadProgress = function (progress) {
          if (timeoutId) {
              clearTimeout(timeoutId);
          }

          // 显示之前，先判断是否渲染
          render();

          $progress.show();
          $progress.width(progress * width / 100);
      };

      // ------ 隐藏进度条 ------
      var timeoutId;
      function hideProgress() {
          $progress.hide();
          timeoutId = null;
      }
      editor.hideUploadProgress = function (time) {
          if (timeoutId) {
              clearTimeout(timeoutId);
          }
          time = time || 750;
          timeoutId = setTimeout(hideProgress, time);
      };
  });
});
// upload img 插件
_e(function (E, $) {

  E.plugin(function () {
      var editor = this;
      var config = editor.config;
      var uploadImgUrl = config.uploadImgUrl;
      var uploadTimeout = config.uploadTimeout;
      var event;

      if (!uploadImgUrl) {
          return;
      }

      // 获取editor的上传dom
      var $uploadContent = editor.$uploadContent;
      if (!$uploadContent) {
          return;
      }

      // 自定义UI，并添加到上传dom节点上
      var $uploadIcon = $('<div class="upload-icon-container"><i class="wangeditor-menu-img-upload"></i></div>');
      $uploadContent.append($uploadIcon);

      // ---------- 构建上传对象 ----------
      var upfile = new E.UploadFile({
          editor: editor,
          uploadUrl: uploadImgUrl,
          timeout: uploadTimeout,
          fileAccept: 'image/jpg,image/jpeg,image/png,image/gif,image/bmp'    // 只允许选择图片 
      });

      // 选择本地文件，上传
      $uploadIcon.click(function (e) {
          event = e;
          upfile.selectFiles();
      });
  });
});
// h5 方式上传图片
_e(function (E, $) {

  if (!window.FileReader || !window.FormData) {
      // 如果不支持html5的文档操作，直接返回
      return;
  }

  // 构造函数
  var UploadFile = function (opt) {
      this.editor = opt.editor;
      this.uploadUrl = opt.uploadUrl;
      this.timeout = opt.timeout;
      this.fileAccept = opt.fileAccept;
      this.multiple = true;
  };

  UploadFile.fn = UploadFile.prototype;

  // clear
  UploadFile.fn.clear = function () {
      this.$input.val('');
      E.log('input value 已清空');
  };

  // 渲染
  UploadFile.fn.render = function () {
      var self = this;
      if (self._hasRender) {
          // 不要重复渲染
          return;
      }

      E.log('渲染dom');

      var fileAccept = self.fileAccept;
      var acceptTpl = fileAccept ? 'accept="' + fileAccept + '"' : '';
      var multiple = self.multiple;
      var multipleTpl = multiple ? 'multiple="multiple"' : '';
      var $input = $('<input type="file" ' + acceptTpl + ' ' + multipleTpl + '/>');
      var $container = $('<div style="visibility:hidden;"></div>');

      $container.append($input);
      E.$body.append($container);

      // onchange 事件
      $input.on('change', function (e) {
          self.selected(e, $input.get(0));
      });

      // 记录对象数据
      self.$input = $input;

      // 记录
      self._hasRender = true;
  };

  // 选择
  UploadFile.fn.selectFiles = function () {
      var self = this;

      E.log('使用 html5 方式上传');

      // 先渲染
      self.render();

      // 选择
      E.log('选择文件');
      self.$input.click();
  };

  // 选中文件之后
  UploadFile.fn.selected = function (e, input) {
      var self = this;
      var files = input.files || [];
      if (files.length === 0) {
          return;
      }

      E.log('选中 ' + files.length + ' 个文件');

      // 遍历选中的文件，预览、上传
      $.each(files, function (key, value) {
          self.upload(value);
      });
  };

  // 上传单个文件
  UploadFile.fn.upload = function (file) {
      var self = this;
      var editor = self.editor;
      var filename = file.name || '';
      var fileType = file.type || '';
      var uploadImgFns = editor.config.uploadImgFns;
      var uploadFileName = editor.config.uploadImgFileName || 'wangEditorH5File';
      var onload = uploadImgFns.onload;
      var ontimeout = uploadImgFns.ontimeout;
      var onerror = uploadImgFns.onerror;
      var reader = new FileReader();

      if (!onload || !ontimeout || !onerror) {
          E.error('请为编辑器配置上传图片的 onload ontimeout onerror 回调事件');
          return;
      }


      E.log('开始执行 ' + filename + ' 文件的上传');

      // 清空 input 数据
      function clearInput() {
          self.clear();
      }

      // onload事件
      reader.onload = function (e) {
          E.log('已读取' + filename + '文件');

          var base64 = e.target.result || this.result;
          editor.xhrUploadImg({
              event: e,
              filename: filename,
              base64: base64,
              fileType: fileType,
              name: uploadFileName,
              loadfn: function (resultText, xhr) {
                  clearInput();
                  // 执行配置中的方法
                  var editor = this;
                  onload.call(editor, resultText, xhr);
              },
              errorfn: function (xhr) {
                  clearInput();
                  if (E.isOnWebsite) {
                      alert('wangEditor官网暂时没有服务端，因此报错。实际项目中不会发生');
                  }
                  // 执行配置中的方法
                  var editor = this;
                  onerror.call(editor, xhr);
              },
              timeoutfn: function (xhr) {
                  clearInput();
                  if (E.isOnWebsite) {
                      alert('wangEditor官网暂时没有服务端，因此超时。实际项目中不会发生');
                  }
                  // 执行配置中的方法
                  var editor = this;
                  ontimeout(editor, xhr);
              }
          });
      };

      // 开始取文件
      reader.readAsDataURL(file);
  };

  // 暴露给 E
  E.UploadFile = UploadFile;

});
// form方式上传图片
_e(function (E, $) {

  if (window.FileReader && window.FormData) {
      // 如果支持 html5 上传，则返回
      return;
  }
  
  // 构造函数
  var UploadFile = function (opt) {
      this.editor = opt.editor;
      this.uploadUrl = opt.uploadUrl;
      this.timeout = opt.timeout;
      this.fileAccept = opt.fileAccept;
      this.multiple = false;
  };

  UploadFile.fn = UploadFile.prototype;

  // clear
  UploadFile.fn.clear = function () {
      this.$input.val('');
      E.log('input value 已清空');
  };

  // 隐藏modal
  UploadFile.fn.hideModal = function () {
      this.modal.hide();
  };

  // 渲染
  UploadFile.fn.render = function () {
      var self = this;
      var editor = self.editor;
      var uploadFileName = editor.config.uploadImgFileName || 'wangEditorFormFile';
      if (self._hasRender) {
          // 不要重复渲染
          return;
      }

      // 服务器端路径
      var uploadUrl = self.uploadUrl;

      E.log('渲染dom');

      // 创建 form 和 iframe
      var iframeId = 'iframe' + E.random();
      var $iframe = $('<iframe name="' + iframeId + '" id="' + iframeId + '" frameborder="0" width="0" height="0"></iframe>');
      var multiple = self.multiple;
      var multipleTpl = multiple ? 'multiple="multiple"' : '';
      var $p = $('<p>选择图片并上传</p>');
      var $input = $('<input type="file" ' + multipleTpl + ' name="' + uploadFileName + '"/>');
      var $btn = $('<input type="submit" value="上传"/>');
      var $form = $('<form enctype="multipart/form-data" method="post" action="' + uploadUrl + '" target="' + iframeId + '"></form>');
      var $container = $('<div style="margin:10px 20px;"></div>');

      $form.append($p).append($input).append($btn);

      // 增加用户配置的参数，如 token
      $.each(editor.config.uploadParams, function (key, value) {
          $form.append( $('<input type="hidden" name="' + key + '" value="' + value + '"/>') );
      });

      $container.append($form);
      $container.append($iframe);

      self.$input = $input;
      self.$iframe = $iframe;

      // 生成 modal
      var modal = new E.Modal(editor, undefined, {
          $content: $container
      });
      self.modal = modal;

      // 记录
      self._hasRender = true;
  };

  // 绑定 iframe load 事件
  UploadFile.fn.bindLoadEvent = function () {
      var self = this;
      if (self._hasBindLoad) {
          // 不要重复绑定
          return;
      }

      var editor = self.editor;
      var $iframe = self.$iframe;
      var iframe = $iframe.get(0);
      var iframeWindow = iframe.contentWindow;
      var onload = editor.config.uploadImgFns.onload;

      // 定义load事件
      function onloadFn() {
          var resultText = $.trim(iframeWindow.document.body.innerHTML);
          if (!resultText) {
              return;
          }

          // 获取文件名
          var fileFullName = self.$input.val();  // 结果如 C:\folder\abc.png 格式
          var fileOriginalName = fileFullName;
          if (fileFullName.lastIndexOf('\\') >= 0) {
              // 获取 abc.png 格式
              fileOriginalName = fileFullName.slice(fileFullName.lastIndexOf('\\') + 1);
              if (fileOriginalName.indexOf('.') > 0) {
                  // 获取 abc （即不带扩展名的文件名）
                  fileOriginalName = fileOriginalName.split('.')[0];
              }
          }

          // 将文件名暂存到 editor.uploadImgOriginalName ，插入图片时，可作为 alt 属性来用
          editor.uploadImgOriginalName = fileOriginalName;

          // 执行load函数，插入图片的操作，应该在load函数中执行
          onload.call(editor, resultText);

          // 清空 input 数据
          self.clear();

          // 隐藏modal
          self.hideModal();
      }

      // 绑定 load 事件
      if (iframe.attachEvent) {
          iframe.attachEvent('onload', onloadFn);
      } else {
          iframe.onload = onloadFn;
      }

      // 记录
      self._hasBindLoad = true;
  };

  UploadFile.fn.show = function () {
      var self = this;
      var modal = self.modal;

      function show() {
          modal.show();
          self.bindLoadEvent();
      }
      setTimeout(show);
  };

  // 选择
  UploadFile.fn.selectFiles = function () {
      var self = this;

      E.log('使用 form 方式上传');

      // 先渲染
      self.render();

      // 先清空
      self.clear();

      // 显示
      self.show();
  };

  // 暴露给 E
  E.UploadFile = UploadFile;

});
// upload img 插件 粘贴图片
_e(function (E, $) {
  
  E.plugin(function () {
      var editor = this;
      var txt = editor.txt;
      var $txt = txt.$txt;
      var config = editor.config;
      var uploadImgUrl = config.uploadImgUrl;
      var uploadFileName = config.uploadImgFileName || 'wangEditorPasteFile';
      var pasteEvent;
      var $imgsBeforePaste;

      // 未配置上传图片url，则忽略
      if (!uploadImgUrl) {
          return;
      }

      // -------- 非 chrome 下，通过查找粘贴的图片的方式上传 --------
      function findPasteImgAndUpload() {
          var reg = /^data:(image\/\w+);base64/;
          var $imgs = $txt.find('img');

          E.log('粘贴后，检查到编辑器有' + $imgs.length + '个图片。开始遍历图片，试图找到刚刚粘贴过来的图片');

          $.each($imgs, function () {
              var img = this;
              var $img = $(img);
              var flag;
              var base64 = $img.attr('src');
              var type;

              // 判断当前图片是否是粘贴之前的
              $imgsBeforePaste.each(function () {
                  if (img === this) {
                      // 当前图片是粘贴之前的
                      flag = true;
                      return false;
                  }
              });

              // 当前图片是粘贴之前的，则忽略
              if (flag) {
                  return;
              }

              E.log('找到一个粘贴过来的图片');

              if (reg.test(base64)) {
                  // 得到的粘贴的图片是 base64 格式，符合要求
                  E.log('src 是 base64 格式，可以上传');
                  type = base64.match(reg)[1];
                  editor.xhrUploadImg({
                      event: pasteEvent,
                      base64: base64,
                      fileType: type,
                      name: uploadFileName
                  });
              } else {
                  E.log('src 为 ' + base64 + ' ，不是 base64 格式，暂时不支持上传');
              }

              // 最终移除原图片
              $img.remove();
          });

          E.log('遍历结束');
      }

      // 开始监控粘贴事件
      $txt.on('paste', function (e) {
          pasteEvent = e;
          var data = pasteEvent.clipboardData || pasteEvent.originalEvent.clipboardData;
          var text;
          var items;

          // -------- 试图获取剪切板中的文字，有文字的情况下，就不处理图片粘贴 --------
          if (data == null) {
              text = window.clipboardData && window.clipboardData.getData('text');
          } else {
              text = data.getData('text/plain') || data.getData('text/html');
          }
          if (text) {
              return;
          }

          items = data && data.items;
          if (items) {
              // -------- chrome 可以用 data.items 取出图片 -----
              E.log('通过 data.items 得到了数据');

              $.each(items, function (key, value) {
                  var fileType = value.type || '';
                  if(fileType.indexOf('image') < 0) {
                      // 不是图片
                      return;
                  }

                  var file = value.getAsFile();
                  var reader = new FileReader();

                  E.log('得到一个粘贴图片');

                  reader.onload = function (e) {
                      E.log('读取到粘贴的图片');

                      // 执行上传
                      var base64 = e.target.result || this.result;
                      editor.xhrUploadImg({
                          event: pasteEvent,
                          base64: base64,
                          fileType: fileType,
                          name: uploadFileName
                      });
                  };

                  //读取粘贴的文件
                  reader.readAsDataURL(file);
              });
          } else {
              // -------- 非 chrome 不能用 data.items 取图片 -----

              E.log('未从 data.items 得到数据，使用检测粘贴图片的方式');

              // 获取
              $imgsBeforePaste = $txt.find('img');
              E.log('粘贴前，检查到编辑器有' + $imgsBeforePaste.length + '个图片');

              // 异步上传找到的图片
              setTimeout(findPasteImgAndUpload, 0);
          }
      });

  });
});
// 拖拽上传图片 插件 
_e(function (E, $) {

  E.plugin(function () {

      var editor = this;
      var txt = editor.txt;
      var $txt = txt.$txt;
      var config = editor.config;
      var uploadImgUrl = config.uploadImgUrl;
      var uploadFileName = config.uploadImgFileName || 'wangEditorDragFile';

      // 未配置上传图片url，则忽略
      if (!uploadImgUrl) {
          return;
      }

      // 阻止浏览器默认行为
      E.$document.on('dragleave drop dragenter dragover', function (e) {
          e.preventDefault();
      });

      // 监控 $txt drop 事件
      $txt.on('drop', function (dragEvent) {
          dragEvent.preventDefault();

          var originalEvent = dragEvent.originalEvent;
          var files = originalEvent.dataTransfer && originalEvent.dataTransfer.files;

          if (!files || !files.length) {
              return;
          }

          $.each(files, function (k, file) {
              var type = file.type;
              var name = file.name;

              if (type.indexOf('image/') < 0) {
                  // 只接收图片
                  return;
              }

              E.log('得到图片 ' + name);

              var reader = new FileReader();
              reader.onload = function (e) {
                  E.log('读取到图片 ' + name);

                  // 执行上传
                  var base64 = e.target.result || this.result;
                  editor.xhrUploadImg({
                      event: dragEvent,
                      base64: base64,
                      fileType: type,
                      name: uploadFileName
                  });
              };

              //读取粘贴的文件
              reader.readAsDataURL(file);

          });
      });
  });

});
// 编辑器区域 table toolbar
_e(function (E, $) {

  E.plugin(function () {
      var editor = this;
      var txt = editor.txt;
      var $txt = txt.$txt;
      var html = '';
      // 说明：设置了 max-height 之后，$txt.parent() 负责滚动处理
      var $currentTxt = editor.useMaxHeight ? $txt.parent() : $txt;
      var $currentTable;

      // 用到的dom节点
      var isRendered = false;
      var $toolbar = $('<div class="txt-toolbar"></div>');
      var $triangle = $('<div class="tip-triangle"></div>');
      var $delete = $('<a href="#"><i class="wangeditor-menu-img-trash-o"></i></a>');
      var $zoomSmall = $('<a href="#"><i class="wangeditor-menu-img-search-minus"></i></a>');
      var $zoomBig = $('<a href="#"><i class="wangeditor-menu-img-search-plus"></i></a>');

      // 渲染到页面
      function render() {
          if (isRendered) {
              return;
          }
          
          // 绑定事件
          bindEvent();

          // 拼接 渲染到页面上
          $toolbar.append($triangle)
                  .append($delete)
                  .append($zoomSmall)
                  .append($zoomBig);
          editor.$editorContainer.append($toolbar);
          isRendered = true;
      }

      // 绑定事件
      function bindEvent() {
          // 统一执行命令的方法
          var commandFn;
          function command(e, callback) {
              // 执行命令之前，先存储html内容
              html = $txt.html();
              // 监控内容变化
              var cb = function  () {
                  if (callback) {
                      callback();
                  }
                  if (html !== $txt.html()) {
                      $txt.change();
                  }
              };
              // 执行命令
              if (commandFn) {
                  editor.customCommand(e, commandFn, cb);
              }
          }

          // 删除
          $delete.click(function (e) {
              commandFn = function () {
                  $currentTable.remove();
              };
              command(e, function () {
                  setTimeout(hide, 100);
              });
          });

          // 放大
          $zoomBig.click(function (e) {
              commandFn = function () {
                  $currentTable.css({
                      width: '100%'
                  });
              };
              command(e, function () {
                  setTimeout(show);
              });
          });

          // 缩小
          $zoomSmall.click(function (e) {
              commandFn = function () {
                  $currentTable.css({
                      width: 'auto'
                  });
              };
              command(e, function () {
                  setTimeout(show);
              });
          });
      }

      // 显示 toolbar
      function show() {
          if (editor._disabled) {
              // 编辑器已经被禁用，则不让显示
              return;
          }
          if ($currentTable == null) {
              return;
          }
          $currentTable.addClass('clicked');
          var tablePosition = $currentTable.position();
          var tableTop = tablePosition.top;
          var tableLeft = tablePosition.left;
          var tableHeight = $currentTable.outerHeight();
          var tableWidth = $currentTable.outerWidth();

          // --- 定位 toolbar ---

          // 计算初步结果
          var top = tableTop + tableHeight;
          var left = tableLeft;
          var marginLeft = 0;

          var txtTop = $currentTxt.position().top;
          var txtHeight = $currentTxt.outerHeight();
          if (top > (txtTop + txtHeight)) {
              // top 不得超出编辑范围
              top = txtTop + txtHeight;
          }

          // 显示（方便计算 margin）
          $toolbar.show();

          // 计算 margin
          var width = $toolbar.outerWidth();
          marginLeft = tableWidth / 2 - width / 2;

          // 定位
          $toolbar.css({
              top: top + 5,
              left: left,
              'margin-left': marginLeft
          });
          // 如果定位太靠左了
          if (marginLeft < 0) {
              // 得到三角形的margin-left
              $toolbar.css('margin-left', '0');
              $triangle.hide();
          } else {
              $triangle.show();
          }
      }
      
      // 隐藏 toolbar
      function hide() {
          if ($currentTable == null) {
              return;
          }
          $currentTable.removeClass('clicked');
          $currentTable = null;
          $toolbar.hide();
      }

      // click table 事件
      $currentTxt.on('click', 'table', function (e) {
          var $table = $(e.currentTarget);

          // 渲染
          render();

          if ($currentTable && ($currentTable.get(0) === $table.get(0))) {
              setTimeout(hide, 100);
              return;
          }

          // 显示 toolbar
          $currentTable = $table;
          show();

          // 阻止冒泡
          e.preventDefault();
          e.stopPropagation();
          
      }).on('click keydown scroll', function (e) {
          setTimeout(hide, 100);
      });
      E.$body.on('click keydown scroll', function (e) {
          setTimeout(hide, 100);
      });
  });

});
// 编辑器区域 img toolbar
_e(function (E, $) {

  if (E.userAgent.indexOf('MSIE 8') > 0) {
      return;
  }
  
  E.plugin(function () {
      var editor = this;
      var lang = editor.config.lang;
      var txt = editor.txt;
      var $txt = txt.$txt;
      var html = '';
      // 说明：设置了 max-height 之后，$txt.parent() 负责滚动处理
      var $currentTxt = editor.useMaxHeight ? $txt.parent() : $txt;
      var $editorContainer = editor.$editorContainer;
      var $currentImg;
      var currentLink = '';

      // 用到的dom节点
      var isRendered = false;
      var $dragPoint = $('<div class="img-drag-point"></div>');

      var $toolbar = $('<div class="txt-toolbar"></div>');
      var $triangle = $('<div class="tip-triangle"></div>');

      var $menuContainer = $('<div></div>');
      var $delete = $('<a href="#"><i class="wangeditor-menu-img-trash-o"></i></a>');
      var $zoomSmall = $('<a href="#"><i class="wangeditor-menu-img-search-minus"></i></a>');
      var $zoomBig = $('<a href="#"><i class="wangeditor-menu-img-search-plus"></i></a>');
      // var $floatLeft = $('<a href="#"><i class="wangeditor-menu-img-align-left"></i></a>');
      // var $noFloat = $('<a href="#"><i class="wangeditor-menu-img-align-justify"></i></a>');
      // var $floatRight = $('<a href="#"><i class="wangeditor-menu-img-align-right"></i></a>');
      var $alignLeft = $('<a href="#"><i class="wangeditor-menu-img-align-left"></i></a>');
      var $alignCenter = $('<a href="#"><i class="wangeditor-menu-img-align-center"></i></a>');
      var $alignRight = $('<a href="#"><i class="wangeditor-menu-img-align-right"></i></a>');
      var $link = $('<a href="#"><i class="wangeditor-menu-img-link"></i></a>');
      var $unLink = $('<a href="#"><i class="wangeditor-menu-img-unlink"></i></a>');

      var $linkInputContainer = $('<div style="display:none;"></div>');
      var $linkInput = $('<input type="text" style="height:26px; margin-left:10px; width:200px;"/>');
      var $linkBtnSubmit = $('<button class="right">' + lang.submit + '</button>');
      var $linkBtnCancel = $('<button class="right gray">' + lang.cancel + '</button>');

      // 记录是否正在拖拽
      var isOnDrag = false;

      // 获取 / 设置 链接
      function imgLink(e, url) {
          if (!$currentImg) {
              return;
          }
          var commandFn;
          var callback = function () {
              // 及时保存currentLink
              if (url != null) {
                  currentLink = url;
              }
              if (html !== $txt.html()) {
                  $txt.change();
              }
          };
          var $link;
          var inLink = false;
          var $parent = $currentImg.parent();
          if ($parent.get(0).nodeName.toLowerCase() === 'a') {
              // 父元素就是图片链接
              $link = $parent;
              inLink = true;
          } else {
              // 父元素不是图片链接，则重新创建一个链接
              $link = $('<a target="_blank"></a>');
          }

          if (url == null) {
              // url 无值，是获取链接
              return $link.attr('href') || '';
          } else if (url === '') {
              // url 是空字符串，是取消链接
              if (inLink) {
                  commandFn = function () {
                      $currentImg.unwrap();
                  };
              }
          } else {
              // url 有值，是设置链接
              if (url === currentLink) {
                  return;
              }
              commandFn = function () {
                  $link.attr('href', url);

                  if (!inLink) {
                      // 当前图片未包含在链接中，则包含进来
                      $currentImg.wrap($link);
                  }
              };
          }

          // 执行命令
          if (commandFn) {
              // 记录下执行命令之前的html内容
              html = $txt.html();
              // 执行命令
              editor.customCommand(e, commandFn, callback);
          }
      }

      // 渲染到页面
      function render() {
          if (isRendered) {
              return;
          }
          
          // 绑定事件
          //bindToolbarEvent();
          //bindDragEvent();

          // 菜单放入 container
          $menuContainer.append($delete)
                          .append($zoomSmall)
                          .append($zoomBig)
                          // .append($floatLeft)
                          // .append($noFloat)
                          // .append($floatRight);
                          .append($alignLeft)
                          .append($alignCenter)
                          .append($alignRight)
                          .append($link)
                          .append($unLink);

          // 链接input放入container
          $linkInputContainer.append($linkInput)
                             .append($linkBtnCancel)
                             .append($linkBtnSubmit);

          // 拼接 渲染到页面上
          $toolbar.append($triangle)
                  .append($menuContainer)
                  .append($linkInputContainer);
                  
          //editor.$editorContainer.append($toolbar).append($dragPoint);
          isRendered = true;
      }

      // 绑定toolbar事件
      function bindToolbarEvent() {
          // 统一执行命令的方法
          var commandFn;
          function customCommand(e, callback) {
              var cb;
              // 记录下执行命令之前的html内容
              html = $txt.html();
              cb = function () {
                  if (callback) {
                      callback();
                  }
                  if (html !== $txt.html()) {
                      $txt.change();
                  }
              };
              // 执行命令
              if (commandFn) {
                  editor.customCommand(e, commandFn, cb);
              }
          }

          // 删除
          $delete.click(function (e) {
              // 删除之前先unlink
              imgLink(e, '');

              // 删除图片
              commandFn = function () {
                  $currentImg.remove();
              };
              customCommand(e, function () {
                  setTimeout(hide, 100);
              });
          });

          // 放大
          $zoomBig.click(function (e) {
              commandFn = function () {
                  var img = $currentImg.get(0);
                  var width = img.width;
                  var height = img.height;
                  width = width * 1.1;
                  height = height * 1.1;

                  $currentImg.css({
                      width: width + 'px',
                      height: height + 'px'
                  });
              };
              customCommand(e, function () {
                  setTimeout(show);
              });
          });

          // 缩小
          $zoomSmall.click(function (e) {
              commandFn = function () {
                  var img = $currentImg.get(0);
                  var width = img.width;
                  var height = img.height;
                  width = width * 0.9;
                  height = height * 0.9;

                  $currentImg.css({
                      width: width + 'px',
                      height: height + 'px'
                  });
              };
              customCommand(e, function () {
                  setTimeout(show);
              });
          });

          // // 左浮动
          // $floatLeft.click(function (e) {
          //     commandFn = function () {
          //         $currentImg.css({
          //             float: 'left'
          //         });
          //     };
          //     customCommand(e, function () {
          //         setTimeout(hide, 100);
          //     });
          // });

          // alignLeft
          $alignLeft.click(function (e) {
              commandFn = function () {
                  // 如果 img 增加了链接，那么 img.parent() 就是 a 标签，设置 align 没用的，因此必须找到 P 父节点来设置 align
                  $currentImg.parents('p').css({
                      'text-align': 'left'
                  }).attr('align', 'left');
              };
              customCommand(e, function () {
                  setTimeout(hide, 100);
              });
          });

          // // 右浮动
          // $floatRight.click(function (e) {
          //     commandFn = function () {
          //         $currentImg.css({
          //             float: 'right'
          //         });
          //     };
          //     customCommand(e, function () {
          //         setTimeout(hide, 100);
          //     });
          // });

          // alignRight
          $alignRight.click(function (e) {
              commandFn = function () {
                  // 如果 img 增加了链接，那么 img.parent() 就是 a 标签，设置 align 没用的，因此必须找到 P 父节点来设置 align
                  $currentImg.parents('p').css({
                      'text-align': 'right'
                  }).attr('align', 'right');
              };
              customCommand(e, function () {
                  setTimeout(hide, 100);
              });
          });

          // // 无浮动
          // $noFloat.click(function (e) {
          //     commandFn = function () {
          //         $currentImg.css({
          //             float: 'none'
          //         });
          //     };
          //     customCommand(e, function () {
          //         setTimeout(hide, 100);
          //     });
          // });

          // alignCenter
          $alignCenter.click(function (e) {
              commandFn = function () {
                  // 如果 img 增加了链接，那么 img.parent() 就是 a 标签，设置 align 没用的，因此必须找到 P 父节点来设置 align
                  $currentImg.parents('p').css({
                      'text-align': 'center'
                  }).attr('align', 'center');
              };
              customCommand(e, function () {
                  setTimeout(hide, 100);
              });
          });

          // link
          // 显示链接input
          $link.click(function (e) {
              e.preventDefault();

              // 获取当前链接，并显示
              currentLink = imgLink(e);
              $linkInput.val(currentLink);

              $menuContainer.hide();
              $linkInputContainer.show();
          });
          // 设置链接
          $linkBtnSubmit.click(function (e) {
              e.preventDefault();

              var url = $.trim($linkInput.val());
              if (url) {
                  // 设置链接，同时会自动更新 currentLink 的值
                  imgLink(e, url);
              }

              // 隐藏 toolbar
              setTimeout(hide);
          });
          // 取消设置链接
          $linkBtnCancel.click(function (e) {
              e.preventDefault();

              // 重置链接 input
              $linkInput.val(currentLink);

              $menuContainer.show();
              $linkInputContainer.hide();
          });

          // unlink
          $unLink.click(function (e) {
              e.preventDefault();

              // 执行 unlink
              imgLink(e, '');

              // 隐藏 toolbar
              setTimeout(hide);
          });
      }

      // 绑定drag事件
      function bindDragEvent() {
          var _x, _y;
          var dragMarginLeft, dragMarginTop;
          var imgWidth, imgHeight;

          function mousemove (e) {
              var diffX, diffY;

              // 计算差额
              diffX = e.pageX - _x;
              diffY = e.pageY - _y;

              // --------- 计算拖拽点的位置 ---------
              var currentDragMarginLeft = dragMarginLeft + diffX;
              var currentDragMarginTop = dragMarginTop + diffY;
              $dragPoint.css({
                  'margin-left': currentDragMarginLeft,
                  'margin-top': currentDragMarginTop
              });

              // --------- 计算图片的大小 ---------
              var currentImgWidth = imgWidth + diffX;
              var currentImggHeight = imgHeight + diffY;
              $currentImg && $currentImg.css({
                  width: currentImgWidth,
                  height: currentImggHeight
              });
          }

          $dragPoint.on('mousedown', function(e){
              if (!$currentImg) {
                  return;
              }
              // 当前鼠标位置
              _x = e.pageX;
              _y = e.pageY;

              // 当前拖拽点的位置
              dragMarginLeft = parseFloat($dragPoint.css('margin-left'), 10);
              dragMarginTop = parseFloat($dragPoint.css('margin-top'), 10);

              // 当前图片的大小
              imgWidth = $currentImg.width();
              imgHeight = $currentImg.height();

              // 隐藏 $toolbar
              $toolbar.hide();

              // 绑定计算事件
              E.$document.on('mousemove._dragResizeImg', mousemove);
              E.$document.on('mouseup._dragResizeImg', function (e) {
                  // 取消绑定
                  E.$document.off('mousemove._dragResizeImg');
                  E.$document.off('mouseup._dragResizeImg');

                  // 隐藏，并还原拖拽点的位置
                  hide();
                  $dragPoint.css({
                      'margin-left': dragMarginLeft,
                      'margin-top': dragMarginTop
                  });

                  // 记录
                  isOnDrag = false;
              });

              // 记录
              isOnDrag = true;
          });
      }

      // 显示 toolbar
      function show() {
          if (editor._disabled) {
              // 编辑器已经被禁用，则不让显示
              return;
          }
          if ($currentImg == null) {
              return;
          }
          $currentImg.addClass('clicked');
          var imgPosition = $currentImg.position();
          var imgTop = imgPosition.top;
          var imgLeft = imgPosition.left;
          var imgHeight = $currentImg.outerHeight();
          var imgWidth = $currentImg.outerWidth();


          // --- 定位 dragpoint ---
          $dragPoint.css({
              top: imgTop + imgHeight,
              left: imgLeft + imgWidth
          });

          // --- 定位 toolbar ---

          // 计算初步结果
          var top = imgTop + imgHeight;
          var left = imgLeft;
          var marginLeft = 0;

          var txtTop = $currentTxt.position().top;
          var txtHeight = $currentTxt.outerHeight();
          if (top > (txtTop + txtHeight)) {
              // top 不得超出编辑范围
              top = txtTop + txtHeight;
          } else {
              // top 超出编辑范围，dragPoint就不显示了
              $dragPoint.show();
          }

          // 显示（方便计算 margin）
          $toolbar.show();

          // 计算 margin
          var width = $toolbar.outerWidth();
          marginLeft = imgWidth / 2 - width / 2;

          // 定位
          $toolbar.css({
              top: top + 5,
              left: left,
              'margin-left': marginLeft
          });
          // 如果定位太靠左了
          if (marginLeft < 0) {
              // 得到三角形的margin-left
              $toolbar.css('margin-left', '0');
              $triangle.hide();
          } else {
              $triangle.show();
          }

          // disable 菜单
          editor.disableMenusExcept();
      }
      
      // 隐藏 toolbar
      function hide() {
          if ($currentImg == null) {
              return;
          }
          $currentImg.removeClass('clicked');
          $currentImg = null;

          $toolbar.hide();
          $dragPoint.hide();

          // enable 菜单
          editor.enableMenusExcept();
      }

      // 判断img是否是一个表情
      function isEmotion(imgSrc) {
          var result = false;
          if (!editor.emotionUrls) {
              return result;
          }
          $.each(editor.emotionUrls, function (index, url) {
              var flag = false;
              if (imgSrc === url) {
                  result = true;
                  flag = true;
              }
              if (flag) {
                  return false;  // break 循环
              }
          });
          return result;
      }

      // click img 事件
      $currentTxt.on('mousedown', 'img', function (e) {
          e.preventDefault();
      }).on('click', 'img', function (e) {
          var $img = $(e.currentTarget);
          var src = $img.attr('src');

          if (!src || isEmotion(src)) {
              // 是一个表情图标
              return;
          }

          // ---------- 不是表情图标 ---------- 

          // 渲染
          render();

          if ($currentImg && ($currentImg.get(0) === $img.get(0))) {
              setTimeout(hide, 100);
              return;
          }

          // 显示 toolbar
          $currentImg = $img;
          show();

          // 默认显示menuContainer，其他默认隐藏
          $menuContainer.show();
          $linkInputContainer.hide();

          // 阻止冒泡
          e.preventDefault();
          e.stopPropagation();
          
      }).on('click keydown scroll', function (e) {
          if (!isOnDrag) {
              setTimeout(hide, 100);
          }
      });

  });

});
// 编辑区域 link toolbar
_e(function (E, $) {
  E.plugin(function () {
      var editor = this;
      var lang = editor.config.lang;
      var $txt = editor.txt.$txt;

      // 当前命中的链接
      var $currentLink;

      var $toolbar = $('<div class="txt-toolbar"></div>');
      var $triangle = $('<div class="tip-triangle"></div>');
      var $triggerLink = $('<a href="#" target="_blank"><i class="wangeditor-menu-img-link"></i> ' + lang.openLink + '</a>');
      var isRendered;

      // 记录当前的显示/隐藏状态
      var isShow = false;

      var showTimeoutId, hideTimeoutId;
      var showTimeoutIdByToolbar, hideTimeoutIdByToolbar;

      // 渲染 dom
      function render() {
          if (isRendered) {
              return;
          }

          //@hejia
          //$toolbar.append($triangle)
                  //.append($triggerLink);

          editor.$editorContainer.append($toolbar);

          isRendered = true;
      }

      // 定位
      function setPosition() {
          if (!$currentLink) {
              return;
          }

          var position = $currentLink.position();
          var left = position.left;
          var top = position.top;
          var height = $currentLink.height();

          // 初步计算top值
          var topResult = top + height + 5;

          // 判断 toolbar 是否超过了编辑器区域的下边界
          var menuHeight = editor.menuContainer.height();
          var txtHeight = editor.txt.$txt.outerHeight();
          if (topResult > menuHeight + txtHeight) {
              topResult = menuHeight + txtHeight + 5;
          }

          // 最终设置
          $toolbar.css({
              top: topResult,
              left: left
          });
      }

      // 显示 toolbar
      function show() {
          return;
          if (isShow) {
              return;
          }

          if (!$currentLink) {
              return;
          }

          render();

          $toolbar.show();

          // 设置链接
          var href = $currentLink.attr('href');
          $triggerLink.attr('href', href);

          // 定位
          setPosition();

          isShow = true;
      }

      // 隐藏 toolbar
      function hide() {
          if (!isShow) {
              return;
          }

          if (!$currentLink) {
              return;
          }

          $toolbar.hide();
          isShow = false;
      }

      // $txt 绑定事件
      $txt.on('mouseenter', 'a', function (e) {
          // 延时 500ms 显示toolbar
          if (showTimeoutId) {
              clearTimeout(showTimeoutId);
          }
          showTimeoutId = setTimeout(function () {
              var a = e.currentTarget;
              var $a = $(a);
              $currentLink = $a;

              var $img = $a.children('img');
              if ($img.length) {
                  // 该链接下包含一个图片

                  // 图片点击时，隐藏toolbar
                  $img.click(function (e) {
                      hide();
                  });

                  if ($img.hasClass('clicked')) {
                      // 图片还处于clicked状态，则不显示toolbar
                      return;
                  }
              }

              // 显示toolbar
              show();
          }, 500);
      }).on('mouseleave', 'a', function (e) {
          // 延时 500ms 隐藏toolbar
          if (hideTimeoutId) {
              clearTimeout(hideTimeoutId);
          }
          hideTimeoutId = setTimeout(hide, 500);
      }).on('click keydown scroll', function (e) {
          setTimeout(hide, 100);
      });
      // $toolbar 绑定事件
      $toolbar.on('mouseenter', function (e) {
          // 先中断掉 $txt.mouseleave 导致的隐藏
          if (hideTimeoutId) {
              clearTimeout(hideTimeoutId);
          }
      }).on('mouseleave', function (e) {
          // 延时 500ms 显示toolbar
          if (showTimeoutIdByToolbar) {
              clearTimeout(showTimeoutIdByToolbar);
          }
          showTimeoutIdByToolbar = setTimeout(hide, 500);
      });
  });
});
// menu吸顶
_e(function (E, $) {

  E.plugin(function () {
      var editor = this;
      var menuFixed = editor.config.menuFixed;
      if (menuFixed === false || typeof menuFixed !== 'number') {
          // 没有配置菜单吸顶
          return;
      }
      var bodyMarginTop = parseFloat(E.$body.css('margin-top'), 10);
      if (isNaN(bodyMarginTop)) {
          bodyMarginTop = 0;
      }

      var $editorContainer = editor.$editorContainer;
      var editorTop = $editorContainer.offset().top;
      var editorHeight = $editorContainer.outerHeight();
      
      var $menuContainer = editor.menuContainer.$menuContainer;
      var menuCssPosition = $menuContainer.css('position');
      var menuCssTop = $menuContainer.css('top');
      var menuTop = $menuContainer.offset().top;
      var menuHeight = $menuContainer.outerHeight();
      
      var $txt = editor.txt.$txt;

      E.$window.scroll(function () {
          //@hejia 取消吸顶
          return;
          //全屏模式不支持
          if (editor.isFullScreen) {
              return;
          }

          var sTop = E.$window.scrollTop();

          // 需要重新计算宽度，因为浏览器可能此时出现滚动条
          var menuWidth = $menuContainer.width();

          // 如果 menuTop === 0 说明此前编辑器一直隐藏，后来显示出来了，要重新计算相关数据
          if (menuTop === 0) {
              menuTop = $menuContainer.offset().top;
              editorTop = $editorContainer.offset().top;
              editorHeight = $editorContainer.outerHeight();
              menuHeight = $menuContainer.outerHeight();
          }

          if (sTop >= menuTop && sTop + menuFixed + menuHeight + 30 < editorTop + editorHeight) {
              // 吸顶
              $menuContainer.css({
                  position: 'fixed',
                  top: menuFixed
              });

              // 固定宽度
              $menuContainer.width(menuWidth);

              // 增加body margin-top
              E.$body.css({
                  'margin-top': bodyMarginTop + menuHeight
              });

              // 记录
              if (!editor._isMenufixed) {
                  editor._isMenufixed = true;
              }
          } else {
              // 取消吸顶
              $menuContainer.css({
                  position: menuCssPosition,
                  top: menuCssTop
              });

              // 取消宽度固定
              $menuContainer.css('width', '100%');

              // 还原 body margin-top
              E.$body.css({
                  'margin-top': bodyMarginTop
              });

              // 撤销记录
              if (editor._isMenufixed) {
                  editor._isMenufixed = false;
              }
          }
      });
  });

});
// 缩进 菜单插件
_e(function (E, $) {

  // 用 createMenu 方法创建菜单
  E.createMenu(function (check) {

      // 定义菜单id，不要和其他菜单id重复。编辑器自带的所有菜单id，可通过『参数配置-自定义菜单』一节查看
      var menuId = 'indent';

      // check将检查菜单配置（『参数配置-自定义菜单』一节描述）中是否该菜单id，如果没有，则忽略下面的代码。
      if (!check(menuId)) {
          return;
      }

      // this 指向 editor 对象自身
      var editor = this;

      // 创建 menu 对象
      var menu = new E.Menu({
          editor: editor,  // 编辑器对象
          id: menuId,  // 菜单id
          title: '缩进', // 菜单标题

          // 正常状态和选中装下的dom对象，样式需要自定义
          $domNormal: $('<a href="#" tabindex="-1"><i class="wangeditor-menu-img-indent-left"></i></a>'),
          $domSelected: $('<a href="#" tabindex="-1" class="selected"><i class="wangeditor-menu-img-indent-left"></i></a>')
      });

      // 菜单正常状态下，点击将触发该事件
      menu.clickEvent = function (e) {
          var elem = editor.getRangeElem();
          var p = editor.getSelfOrParentByName(elem, 'p');
          var $p;

          if (!p) {
              // 未找到 p 元素，则忽略
              return e.preventDefault();
          }
          $p = $(p);

          // 使用自定义命令
          function commandFn() {
              $p.css('text-indent', '2em');
          }
          editor.customCommand(e, commandFn);
      };

      // 菜单选中状态下，点击将触发该事件
      menu.clickEventSelected = function (e) {
          var elem = editor.getRangeElem();
          var p = editor.getSelfOrParentByName(elem, 'p');
          var $p;

          if (!p) {
              // 未找到 p 元素，则忽略
              return e.preventDefault();
          }
          $p = $(p);

          // 使用自定义命令
          function commandFn() {
              $p.css('text-indent', '0');
          }
          editor.customCommand(e, commandFn);
      };

      // 根据当前选区，自定义更新菜单的选中状态或者正常状态
      menu.updateSelectedEvent = function () {
          // 获取当前选区所在的父元素
          var elem = editor.getRangeElem();
          var p = editor.getSelfOrParentByName(elem, 'p');
          var $p;
          var indent;

          if (!p) {
              // 未找到 p 元素，则标记为未处于选中状态
              return false;
          }
          $p = $(p);
          indent = $p.css('text-indent');

          if (!indent || indent === '0px') {
              // 得到的p，text-indent 属性是 0，则标记为未处于选中状态
              return false;
          }

          // 找到 p 元素，并且 text-indent 不是 0，则标记为选中状态
          return true;
      };

      // 增加到editor对象中
      editor.menus[menuId] = menu;
  });

});
// 行高 菜单插件
_e(function (E, $) {

  // 用 createMenu 方法创建菜单
  E.createMenu(function (check) {

      // 定义菜单id，不要和其他菜单id重复。编辑器自带的所有菜单id，可通过『参数配置-自定义菜单』一节查看
      var menuId = 'lineheight';

      // check将检查菜单配置（『参数配置-自定义菜单』一节描述）中是否该菜单id，如果没有，则忽略下面的代码。
      if (!check(menuId)) {
          return;
      }

      // this 指向 editor 对象自身
      var editor = this;

      // 由于浏览器自身不支持 lineHeight 命令，因此要做一个hook
      editor.commandHooks.lineHeight = function (value) {
          var rangeElem = editor.getRangeElem();
          var targetElem = editor.getSelfOrParentByName(rangeElem, 'p,h1,h2,h3,h4,h5,pre');
          if (!targetElem) {
              return;
          }
          $(targetElem).css('line-height', value + '');
      };

      // 创建 menu 对象
      var menu = new E.Menu({
          editor: editor,  // 编辑器对象
          id: menuId,  // 菜单id
          title: '行高', // 菜单标题
          commandName: 'lineHeight', // 命令名称

          // 正常状态和选中装下的dom对象，样式需要自定义
          $domNormal: $('<a href="#" tabindex="-1"><i class="wangeditor-menu-img-arrows-v"></i></a>'),
          $domSelected: $('<a href="#" tabindex="-1" class="selected"><i class="wangeditor-menu-img-arrows-v"></i></a>')
      });

      // 数据源
      var data  = {
          // 格式： 'value' : 'title'
          '1.0': '1.0倍',
          '1.5': '1.5倍',
          '1.8': '1.8倍',
          '2.0': '2.0倍',
          '2.5': '2.5倍',
          '3.0': '3.0倍'
      };

      // 为menu创建droplist对象
      var tpl = '<span style="line-height:{#commandValue}">{#title}</span>';
      menu.dropList = new E.DropList(editor, menu, {
          data: data,  // 传入数据源
          tpl: tpl  // 传入模板
      });

      // 增加到editor对象中
      editor.menus[menuId] = menu;

  });

});
// 自定义上传
_e(function (E, $) {

  E.plugin(function () {

      var editor = this;
      var customUpload = editor.config.customUpload;
      if (!customUpload) {
          return;
      } else if (editor.config.uploadImgUrl) {
          alert('自定义上传无效，详看浏览器日志console.log');
          E.error('已经配置了 uploadImgUrl ，就不能再配置 customUpload ，两者冲突。将导致自定义上传无效。');
          return;
      }

      var $uploadContent = editor.$uploadContent;
      if (!$uploadContent) {
          E.error('自定义上传，无法获取 editor.$uploadContent');
      }

      // UI
      var $uploadIcon = $('<div class="upload-icon-container"><i class="wangeditor-menu-img-upload"></i></div>');
      $uploadContent.append($uploadIcon);

      // 设置id，并暴露
      var btnId = 'upload' + E.random();
      var containerId = 'upload' + E.random();
      $uploadIcon.attr('id', btnId);
      $uploadContent.attr('id', containerId);

      editor.customUploadBtnId = btnId;
      editor.customUploadContainerId = containerId;
  });

});
// 版权提示
_e(function (E, $) {
  E.info('本页面富文本编辑器由 wangEditor 提供 http://wangeditor.github.io/ ');
});
  
  // 最终返回wangEditor构造函数
  return window.wangEditor;
});
//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhCn = moment.defineLocale('zh-cn', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY年MMMD日',
        LL : 'YYYY年MMMD日',
        LLL : 'YYYY年MMMD日Ah点mm分',
        LLLL : 'YYYY年MMMD日ddddAh点mm分',
        l : 'YYYY年MMMD日',
        ll : 'YYYY年MMMD日',
        lll : 'YYYY年MMMD日 HH:mm',
        llll : 'YYYY年MMMD日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' ||
                meridiem === '上午') {
            return hour;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        } else {
            // '中午'
            return hour >= 11 ? hour : hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '日';
            case 'M':
                return number + '月';
            case 'w':
            case 'W':
                return number + '周';
            default:
                return number;
        }
    },
    relativeTime : {
        future : '%s内',
        past : '%s前',
        s : '几秒',
        m : '1 分钟',
        mm : '%d 分钟',
        h : '1 小时',
        hh : '%d 小时',
        d : '1 天',
        dd : '%d 天',
        M : '1 个月',
        MM : '%d 个月',
        y : '1 年',
        yy : '%d 年'
    },
    week : {
        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return zhCn;

})));

/**
 * @author lyz
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.pages', [
    'ui.router',
    'CodoonUserAdmin.pages.home',
    'CodoonUserAdmin.pages.publish',
    'CodoonUserAdmin.pages.live',
    'CodoonUserAdmin.pages.advert',
    'CodoonUserAdmin.pages.export',
    'CodoonUserAdmin.pages.activity',
    'CodoonUserAdmin.pages.training',
    'CodoonUserAdmin.pages.racelive'
  ])
  .config(routeConfig);

  /** @ngInject */
  function routeConfig($urlRouterProvider) {
    $urlRouterProvider.otherwise('/home/user');
  }

})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.theme', [
      'toastr',
      'CodoonUserAdmin.theme.components'
  ]);

})();

/**
 * @author liuyz
 * created on 2017-3-22
 */

(function () {
  'use strict';

  angular.module('CodoonUserAdmin.pages.activity', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('activity', {
        url: '/activity',
        template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: '活动管理',
        sidebarMeta: {
          order: 0,
        }
      }).state('activity.publish', {
        url: '/publish/:id',
        templateUrl: 'app/pages/activity/publish/publish.html',
        title: '发布活动',
        controller: 'activityPublishCtrl',
        controllerAs: 'vm',
        sidebarMeta: {
          order: 1,
        }
      }).state('activity.list', {
        url: '/list',
        templateUrl: 'app/pages/activity/list/index.html',
        title: '活动列表',
        controller: 'activityListCtrl',
        controllerAs: 'vm',
        sidebarMeta: {
          order: 2,
        },
      })
  }
})();

/**
 * @author liuyz
 * created on 2017-3-22
 */

(function () {
  'use strict';

  angular.module('CodoonUserAdmin.pages.advert', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('advert', {
          url: '/advert',
          templateUrl: 'app/pages/advert/index.html',
          title: '广告占位',
          controller: 'occupyPageCtrl',
          controllerAs: 'occupy',
          sidebarMeta: {
            order: 0,
          },
        })
        .state('soft-advert', {
          url: '/soft-advert',
          templateUrl: 'app/pages/soft-advert/index.html',
          title: '软广占位',
          controller: 'softOccupyPageCtrl',
          controllerAs: 'occupy',
          sidebarMeta: {
            order: 1,
          },
        })
        .state('search', {
          url: '/search',
          templateUrl: 'app/pages/search/index.html',
          title: '占位查询',
          controller: 'AdvertSearchCtrl',
          controllerAs: 'vm',
          sidebarMeta: {
            order: 2,
          },
        });
  }


})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.pages.home', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('home', {
          url: '/home',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: '首页',
          sidebarMeta: {
            order: 0,
          }
        })
        .state('home.user', {
          url: '/user',
          templateUrl: 'app/pages/home/home.html',
          title: '个人信息',
          controller: 'homePageCtrl',
          controllerAs: 'home',
          sidebarMeta: {
            icon: 'ion-android-home',
            order: 1,
          },
        })
        .state('home.article', {
          url: '/article',
          templateUrl: 'app/pages/home/article.html',
          title: '我的文章',
          controller: 'homeArctileCtrl',
          controllerAs: 'vm',
          sidebarMeta: {
            icon: 'ion-android-home',
            order: 2,
          },
        });
  }


})();

/**
 * @author lj
 * created on 20.02.2017
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.pages.live', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('live', {
        url: '/live',
        controller: 'livePageCtrl',
        controllerAs: 'vm',
        templateUrl: 'app/pages/live/live.html',
        title: '直播',
        sidebarMeta: {
          order: 2,
        },
      });
  }

})();

/**
 * @author lyz
 * 
 * http://192.168.1.205:8011/?url=http://192.168.1.205:8011/doc/live_class.json#/coach_api
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.pages.racelive', [
    'CodoonUserAdmin.pages.racelive.select',
    'CodoonUserAdmin.pages.racelive.list'
  ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('racelive', {
        url: '/racelive',
        template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: '实时赛事直播',
        sidebarMeta: {
          icon: 'ion-gear-a',
          order: 2,
        },
      });
  }

})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.pages.publish', [
    'CodoonUserAdmin.pages.publish.picture',
    'CodoonUserAdmin.pages.publish.article',
    'CodoonUserAdmin.pages.publish.video'
  ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('publish', {
        url: '/publish',
        template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: '动态发布',
        sidebarMeta: {
          icon: 'ion-gear-a',
          order: 1,
        },
      });
  }

})();

/**
 * @author liuyz
 * created on 2017-6-30
 */

(function () {
  'use strict';

  angular.module('CodoonUserAdmin.pages.export', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('export', {
          url: '/export',
          templateUrl: 'app/pages/export/index.html',
          title: '导出广告排期',
          controller: 'exportCtrl',
          controllerAs: 'export',
          sidebarMeta: {
            order: 1,
          },
        })
  }

})();

/**
 * @author lyz
 * 
 * http://192.168.1.205:8011/?url=http://192.168.1.205:8011/doc/live_class.json#/coach_api
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.pages.training', [
    'CodoonUserAdmin.pages.training.create',
    'CodoonUserAdmin.pages.training.list',
    // 'CodoonUserAdmin.pages.training.students'
  ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('training', {
        url: '/training',
        template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: '直播课程',
        sidebarMeta: {
          icon: 'ion-gear-a',
          order: 1,
        },
      });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.theme.components', []);

})();

/**
 * @author lyz
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.pages.racelive.list', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('racelive.list', {
        url: '/racelive/list/:race_id',
        params: { "race_id": null }, 
        controller: 'raceliveListPageCtrl',
        controllerAs: 'vm',
        templateUrl: 'app/pages/racelive/list/index.html',
        title: '',
        sidebarMeta: {
          order: 2,
        },
      });
  }
})();

/**
 * @author lyz
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.pages.racelive.select', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('racelive.select', {
        url: '/racelive/select',
        controller: 'racelivePageCtrl',
        controllerAs: 'vm',
        templateUrl: 'app/pages/racelive/select/index.html',
        title: '选择实时赛事',
        sidebarMeta: {
          order: 1,
        },
      });
  }

})();

/**
 * @author a.demeshko
 * created on 12.21.2015
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.pages.publish.picture', [])
    .config(routeConfig)


  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('publish.picture', {
        url: '/picture',
        controller: 'picturePageCtrl',
        controllerAs: 'picture',
        templateUrl: 'app/pages/publish/picture/picture.html',
        title: '发布图片动态',
        sidebarMeta: {
          order: 200,
        },
      });
  }

})();


(function () {
  'use strict';

  angular.module('CodoonUserAdmin.pages.publish.article', [])
    .config(routeConfig)


  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('publish.article', {
        url: '/article/:id',
        controller: 'articlePageCtrl',
        controllerAs: 'article',
        templateUrl: 'app/pages/publish/article/article.html',
        title: '发布长文章动态',
        sidebarMeta: {
          order: 202,
        },
      });
  }

})();

/**
 * @author a.demeshko
 * created on 12.21.2015
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.pages.publish.video', [])
    .config(routeConfig)


  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('publish.video', {
        url: '/video',
        controller: 'videoPageCtrl',
        controllerAs: 'video',
        templateUrl: 'app/pages/publish/video/video.html',
        title: '视频动态',
        sidebarMeta: {
          order: 201,
        },
      });
  }

})();

/**
 * @author lyz
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.pages.training.create', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('training.create', {
        url: '/training/create',
        controller: 'trainingPageCtrl',
        controllerAs: 'vm',
        templateUrl: 'app/pages/training/create/index.html',
        title: '创建',
        sidebarMeta: {
          order: 1,
        },
      });
  }

})();

/**
 * @author lyz
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.pages.training.list', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('training.list', {
        url: '/training/list',
        controller: 'trainingListPageCtrl',
        controllerAs: 'vm',
        templateUrl: 'app/pages/training/list/index.html',
        title: '我的直播课',
        sidebarMeta: {
          order: 2,
        },
      });
  }

})();

'use strict';

angular.module('CodoonUserAdmin', [
  'ngAnimate',
  'ui.bootstrap',
  'ui.router',
  'ngTouch',
  'toastr',
  'moment-picker',
  'ui.bootstrap.datetimepicker',
  'angularFileUpload',
  'textAngular',
  'CodoonUserAdmin.theme',
  'CodoonUserAdmin.pages',
  'bw.paging',
  // 'echarts'
]);

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('CodoonUserAdmin.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, $provide) {
    // $provide.decorator('$uiViewScroll', uiViewScrollDecorator);

    $provide.decorator('taOptions', ['taRegisterTool', 'taSelection', 'toastrService', '$delegate', '$uibModal', function (taRegisterTool, taSelection, toastrService, taOptions, $uibModal, $delegate) {
      taRegisterTool('insertImg', {
        display: '<label class="text-edit-upload"><i class="fa fa-picture-o"></i></label>',
        action: function (deferred, restoreSelection) {
          var editor = this.$editor();
          var sel = rangy.getSelection();
          var size = null;

          if (editor.setup.htmlEditorSetup) {
            var size = editor.setup.htmlEditorSetup();
          }
          $uibModal.open({
            templateUrl: 'app/theme/components/insertLink/image.html',
            controller: 'InsertImgCtrl',
            controllerAs: 'vm',
            animation: true,
            resolve: {
              data: function () {
                return { show_img: true, size: size }
              }
            }
          }).result.then(function (images) {
            // console.log(images);
            images.forEach(function (item) {
              insertImg(item);
            })
          });

          function insertImg(obj) {
            if (obj.href) {
              var tagBegin = '<a href="' + obj.href + '" target=' +
                (Number(obj.open_method) ? '"_blank"' : '""') + '>',
                tagEnd = '<img src="' + obj.url + '" /></a>';

              sel.collapseToEnd();
              document.execCommand('insertHTML', true, tagBegin + tagEnd);
              deferred.resolve();
            } else {
              sel.collapseToEnd();
              document.execCommand('InsertImage', false, obj.url);
              deferred.resolve();
            }
          }
        }
      })
      taRegisterTool('customLink', {
        display: '<i class="fa fa-link text-edit-link"></i>',
        action: function () {
          var selectedElement = taSelection.getSelectionElement();
          var editor = this.$editor();

          var tagName = (selectedElement && selectedElement.tagName && selectedElement.tagName.toLowerCase()) || "";
          var selection = taSelection.getSelection();
          var rangObj = rangy.getSelection().getRangeAt(0);
          var topNode;

          var size = null;

          if (editor.setup.htmlEditorSetup) {
            var size = editor.setup.htmlEditorSetup();
          }
          $uibModal.open({
            templateUrl: 'app/theme/components/insertLink/link.html',
            controller: 'InsertLinkCtrl',
            controllerAs: 'vm',
            animation: true,
            resolve: {
              data: function () {
                return { show_img: false, size: size }
              }
            }
          }).result.then(function (obj) {
            var open_method = Number(obj.open_method);
            var target = '';
            if (tagName == 'a') {
              selectedElement.href = obj.href;
              if (open_method) {
                target = '_blank';
              }
              selectedElement.target = target;
              return;
            }

            var tagBegin = '<a href="' + obj.href + '" target="' +
              (open_method == 1 ? '_blank' : '') + '">',
              tagEnd = '</a>';

            if (selection.collapsed) {
              taSelection.insertHtml(tagBegin + obj.href + tagEnd, topNode, rangObj);
            } else if (rangObj.canSurroundContents()) {
              var node = angular.element(tagBegin + tagEnd)[0];
              try {
                rangObj.surroundContents(node);
              } catch (error) {
                toastrService.openToast('error', error)
              }
            }

          })
        }
      });


      // taRegisterTool('video', {
      //   // display:'<label class="text-edit-upload" ng-click="action()" title="上传视频"><i class="glyphicon glyphicon-film"></i></label>',
      //   buttontext: "视频",
      //   class: "edit_btns",
      //   action: function (deferred, restoreSelection) {
      //     var that = this;
      //     var sel = rangy.getSelection();
      //     openService.openServiceGetAPI('get_qiniu_upload_token').then(function (response) {
      //       if (response.status == 'OK') {
      //         var token = response.data.token;
      //         $uibModal.open({
      //           templateUrl: 'app/theme/components/uploadVideo/video.html',
      //           controller: 'videoUploadCtrl',
      //           controllerAs: 'videoUpload',
      //           animation: true,
      //           resolve: {
      //             data: function () {
      //               return {
      //                 data: token,
      //               }
      //             }
      //           }
      //         }).result.then(function (data) {
      //           var videoUrl = data.src,
      //             imgUrl = data.img,
      //             // video = "<div class='zy_media'><video src=' "+videoUrl+"' poster ='"+imgUrl+"' preload='none' controls style='width:100%'><source src='"+videoUrl+"' type='video/mp4'></source></video></div><div>&nbsp</div>";
      //             video = "<div class='zy_media'><video src=' " + videoUrl + "' poster ='" + imgUrl + "' preload='none' style='width:100%'><source src='" + videoUrl + "' type='video/mp4'></source></video></div><div>&nbsp</div>";
      //           sel.collapseToEnd();
      //           document.execCommand('insertHTML', true, video)
      //           deferred.resolve();
      //           console.log(rangy.getSelection())
      //         })
      //       }
      //     });
      //   },
      // });

      //文章管理 添加卡片
      taRegisterTool('card', {
        // display:'<label class="text-edit-upload" ng-click="action()" title="上传卡片"><i class="glyphicon glyphicon-fire"></i></label>',
        buttontext: "普通卡片",
        class: "edit_btns",
        action: function (deferred, restoreSelection) {
          var that = this;
          var sel = rangy.getSelection();
          $uibModal.open({
            templateUrl: 'app/theme/components/uploadCard/card.html',
            controller: 'cardUploadCtrl',
            controllerAs: 'cardUpload',
            animation: true,
          }).result.then(function (data) {
            if (data) {
              var img = data.card_url,
                title = data.title,
                url = data.mall_url;
              var div = '<style>a:link {text-decoration:none;} a:visited {      text-decoration:none;}a:hover {text-decoration:none;} a:active {text-decoration:none;    }button{background: none;}</style>' + '<div style="width: 100%; height: 140px;margin-top: 5px;margin-bottom: 5px;  border-radius: 4px;  background-color: #ffffff;  border: solid 1px #e2e2e4;  position:relative">' + '<a style="position: absolute;z-index:3;left:0;top:0;height: 100%;width:100%" href="' + url + '" style="text-decoration: none"></a>' +
                '<div class="insert-product-iteam" style="height:143px;width:120px;position:absolute;top:0;left:10px;text-align:center;border: none;background:none  !important;line-height:143px;">' + '<img style="width: 120px;height:120px" src="' + img + '"/>' + '</div><div style="margin-left: 150px ; padding-right: 23px; height: 42px;font-size: 15px;font-weight: 400;color: #4a4a4a;             text-align:left;line-height:20px;       margin-top:20px;"><span>' + title + '</span></div><div style="margin-left: 150px ; margin-top:30px;padding-right: 23px;height: 12px;font-size: 12px;         font-weight: 400;line-height: 1;color: #bebec1;">了解详情 ></div></div><br/>'
              sel.collapseToEnd();
              document.execCommand('insertHTML', true, div)
              deferred.resolve();
            }
          })
        },
      });

      taRegisterTool('gif', {
        // display:'<label class="text-edit-upload" ng-click="action()" title="上传GIF"><i class="fa fa-credit-card"></i></label>',
        buttontext: "GIF",
        class: "edit_btns",
        action: function (deferred, restoreSelection) {
          var that = this;
          var sel = rangy.getSelection();
          $uibModal.open({
            templateUrl: 'app/theme/components/gif/gif.html',
            controller: 'gifUploadCtrl',
            controllerAs: 'gifUpload',
            animation: true,
          }).result.then(function (data) {
            var gifImg_one = data.gifImg_one,
              gifImg_two = data.gifImg_two;
            if (!gifImg_one) {
              var video = "<a href='" + gifImg_two + "'><img src='" + gifImg_two + "'/></a>";
            } else {
              var video = "<a href='" + gifImg_two + "'><img src='" + gifImg_one + "'/></a>";
            }

            sel.collapseToEnd();
            document.execCommand('insertHTML', true, video)
            deferred.resolve();
          })
          //this.$editor().wrapSelection('forecolor', 'red');
        },
      });

      taRegisterTool('pTag', {
        iconclass: "fa fa-font",
        action: function () {
          this.$editor().wrapSelection('formatBlock', "<span style='font-size:14px;'>");
        }
      });
      //背景颜色
      taRegisterTool('backgroundColor', {
        // display: "<span class='bar-btn-dropdown' style='padding:0;border:none'><button type='button' colorpicker colorpicker-text-editor='true' colorpicker-parent='true' class='btn btn-default' ng-disabled='showHtml()'> <i class='fa fa-magic'></i><i class='fa fa-caret-down'></i></button></span>",
        // display: "<div class='fa fa-magic' colorpicker colorpicker-text-editor='true' colorpicker-parent='true' ng-disabled='showHtml()'></div>",
        display: "<span class='bar-btn-dropdown' style='padding:0;border:none' color-picker><button type='button' class='btn btn-default''><i class='fa fa-magic'></i><i class='fa fa-caret-down'></i></button></span>",
        action: function (color) {
          if (color !== '') {
            return this.$editor().wrapSelection('backColor', color);
          }
        }
      });
      //文字颜色额
      taRegisterTool('fontColor', {
        display: "<span class='bar-btn-dropdown' style='padding:0;border:none' color-picker><button type='button' class='btn btn-default''><i class='glyphicon glyphicon-text-width'></i><i class='fa fa-caret-down'></i></button></span>",
        // display: "<span class='bar-btn-dropdown' style='padding:0;border:none' data-color = {{colors}} tool-color><span></span></span>",
        //  display:"<span class='bar-btn-dropdown' style='padding:0;border:none' ><tool-color></tool-color></span>",
        action: function (color) {
          if (color != '') {
            return this.$editor().wrapSelection('forecolor', color);
          }
        }
      });
      //文字种类
      taRegisterTool('fontName', {
        display: "<span class='bar-btn-dropdown dropdown' style='padding:0;border:none'>" +
        "<button class='btn btn-default dropdown-toggle' type='button' ng-disabled='showHtml()'><span>{{active}} </span></button>" +
        "<ul class='dropdown-menu' id='txtList'><li ng-repeat='o in options'><button class='checked-dropdown' style='font-family: {{o.css}}' type='button' ng-click='action(o.css)'><i ng-if='o.active' class='fa fa-check'></i>{{o.name}}</button></li></ul></span>",
        action: function (font) {
          if (font !== '') {
            this.$editor().wrapSelection('fontName', font);
          }
        },
        options: [
          { name: 'Sans-Serif', css: 'Arial, Helvetica, sans-serif' },
          { name: 'Serif', css: "'times new roman', serif" },
          { name: 'Wide', css: "'arial black', sans-serif" },
          { name: 'Narrow', css: "'arial narrow', sans-serif" },
          { name: 'Comic Sans MS', css: "'comic sans ms', sans-serif" },
          { name: 'Courier New', css: "'courier new', monospace" },
          { name: 'Garamond', css: 'garamond, serif' },
          { name: 'Georgia', css: 'georgia, serif' },
          { name: 'Tahoma', css: 'tahoma, sans-serif' },
          { name: 'Trebuchet MS', css: "'trebuchet ms', sans-serif" },
          { name: "Helvetica", css: "'Helvetica Neue', Helvetica, Arial, sans-serif" },
          { name: 'Verdana', css: 'verdana, sans-serif' },
          { name: 'Proxima Nova', css: 'proxima_nova_rgregular' }
        ],
        active: 'Font Family',
        setActive: function (font) {
          angular.forEach(this.options, function (option) {
            if (font === option.css) {
              this.active = option.name;
              option['active'] = true;
            } else {
              option['active'] = false;
            }
          });
        },
        getActive: function () {
          var font = document.queryCommandValue('fontName');
          if (font === '') {
            return 'Arial, Helvetica, sans-serif';
          } else {
            return font;
          }
        }
      });
      //上传图片设置超链接
      taRegisterTool('imgUrl', {
        display: '<label class="text-edit-upload" ng-click="action()" title="上传图片"><i class="fa fa-picture-o"></i></label>',
        action: function (deferred, restoreSelection) {
          var that = this;
          var sel = rangy.getSelection();
          $uibModal.open({
            templateUrl: 'app/theme/components/imgUrl/imgurl.html',
            controller: 'uploadImgCtrl',
            controllerAs: 'uploadImg',
            animation: true,
          }).result.then(function (data) {
            if (data) {
              var img = data.img,
                urlHref = data.href || "javascript:void(0)";
              var img = "<a href='" + urlHref + "'><img src='" + img + "'/></a>";
              sel.collapseToEnd();
              document.execCommand('insertHTML', true, img);
              //that.$editor().wrapSelection('CreateLink', url);
              deferred.resolve();
            }
          })
        }
      })

      taRegisterTool('copyHtml', {
        display: '<label class="text-edit-upload" ng-click="action()">复制html</label>',
        action: function (deferred, restoreSelection) {
          var editor = this.$editor();
          var html = editor.html;
          
          copyText(html || '');
          function copyText (text, context) {
            var node = createNode(text, context);
            document.body.appendChild(node);
            copyNode(node);
            document.body.removeChild(node);
          }
  
          function copyNode(node) {
            try {
              document.body.style.webkitUserSelect = 'initial';
  
              var selection = document.getSelection();
              selection.removeAllRanges();
  
              node.select();
              if (!document.execCommand('copy')) {
                throw('failure copy');
              } else {
                toastrService.openToast('info','复制成功');
              }
  
              selection.removeAllRanges();
            } finally {
              document.body.style.webkitUserSelect = '';
            }
          }
  
          function createNode(text, context) {
            var node = document.createElement('textarea');
            node.style.position = 'absolute';
            node.textContent = text;
            node.style.left = '-10000px';
            node.style.top = (window.pageYOffset || document.documentElement.scrollTop) + 'px';
            return node;
          }
        }
      })

      //控制文字大小
      taRegisterTool('fontSize', {
        display: "<span class='bar-btn-dropdown dropdown' style='padding:0;border:none'>" +
        "<button class='btn btn-default dropdown-toggle' type='button' ng-disabled='showHtml()'><i class='fa fa-font'></i><i class='fa fa-caret-down'></i></button>" +
        "<ul class='dropdown-menu'><li ng-repeat='o in options'><button class='checked-dropdown' style='font-size: {{o.css}}' type='button' ng-click='action(o.value)'><i ng-if='o.active' class='fa fa-check'></i> {{o.name}}</button></li></ul>" +
        "</span>",
        action: function (size, deferred, restoreSelection) {
          if (size !== '') {
            return this.$editor().wrapSelection('fontSize', size);
          }

          if (size == '') {
            return document.execCommand('removeFormat', true);
          }
        },
        options: [
          { name: '撤销', css: 'remove', value: '' },
          { name: '极小 12px', css: 'xx-small', value: '1' },
          { name: '小 13px', css: 'x-small', value: '2' },
          { name: '中 16px', css: 'small', value: '3' },
          { name: '大 18px', css: 'medium', value: '4' },
          { name: '特大 24px', css: 'large', value: '5' },
          { name: '极大 32px', css: 'x-large', value: '6' },
        ],
        setActive: function (font) {
          // Convert to string if not already
          if (typeof font !== 'string') {
            font = String(font)
          }
          ;

          angular.forEach(this.options, function (option) {
            option['active'] = font === option.value ? true : false;
          });
        },
        getActive: function () {
          var font = document.queryCommandValue('fontSize');
          if (font === '') {
            return 3;
          } else {
            return font;
          }
        }
      });

      taRegisterTool('lineSpacing', {
        display: '<span class="bar-btn-dropdown dropdown" style="padding:0;border:none">' +
        '<button class="btn btn-default dropdown-toggle" type="button" ng-disabled="showHtml()">' +
        '<i class="fa fa-arrows-v" aria-hidden="true"></i>' +
        '<i class="fa fa-bars" aria-hidden="true"></i></button>' +
        '<ul class="dropdown-menu dropdown-spacing-menu"><li ng-repeat="item in options" ng-click="action(item.name)">{{ item.name }}</li></ul>' +
        '</span>',
        action: function (height, deferred, restoreSelection) {
          var tags = ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'li', 'div'];
          var sel = rangy.getSelection();
          var range = sel.getRangeAt(0);
          var node = range.startContainer;

          if (parseFloat(height)) {
            var elem = parentUtil(node);
            
            if (elem.length) {
              elem[0].style.lineHeight = height;
            }
          } else {
            // node.style.lineHeight
          }

          
          function parentUtil(el) {
            var result = [];

            do {
              if (el.nodeType == 1 && tags.indexOf(el.tagName.toLowerCase()) != -1) {
                result.push(el);
              } else {
                el = el.parentElement;

                if (el.nodeType == 1 && tags.indexOf(el.tagName.toLowerCase()) != -1) {
                  result.push(el);
                }
              }
            }
            while (el.nodeType != 1 || (el.nodeType == 1 && tags.indexOf(el.tagName.toLowerCase()) == -1 ));

            return result;
          }

        },
        options: [
          { name: '撤销', value: '' },
          { name: '1', value: 0 },
          { name: '1.5', value: 1 },
          { name: '1.75', value: 2 },
          { name: '2', value: 3 },
          { name: '3', value: 4 },
          { name: '4', value: 5 }
        ],
      });


      // add the button to the default toolbar definition
      taOptions.toolbar[1].push('insertImg');
      taOptions.toolbar[1].push('customLink');
      taOptions.toolbar[1].push('video');
      taOptions.toolbar[1].push('card');
      taOptions.toolbar[1].push('pTag');
      taOptions.toolbar[1].push('gif');
      taOptions.toolbar[1].push('backgroundColor');
      taOptions.toolbar[1].push('fontColor');
      taOptions.toolbar[1].push('fontName');
      taOptions.toolbar[1].push('imgUrl');
      taOptions.toolbar[1].push('fontSize');
      taOptions.toolbar[1].push('lineSpacing');
      taOptions.toolbar[1].push('copyHtml');
      
      return taOptions;
    }]);
  }

  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
    return function (uiViewElement) {
      if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
        $anchorScroll();
      } else {
        $delegate(uiViewElement);
      }
    };
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('CodoonUserAdmin.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider() {
    var conf = {
      theme: {
        blur: false,
      },
      // colors: {
      //   default: basic.default,
      //   defaultText: basic.defaultText,
      //   border: basic.border,
      //   borderDark: basic.borderDark,
      //
      //   primary: colorScheme.primary,
      //   info: colorScheme.info,
      //   success: colorScheme.success,
      //   warning: colorScheme.warning,
      //   danger: colorScheme.danger,
      //
      //   primaryLight: colorHelper.tint(colorScheme.primary, 30),
      //   infoLight: colorHelper.tint(colorScheme.info, 30),
      //   successLight: colorHelper.tint(colorScheme.success, 30),
      //   warningLight: colorHelper.tint(colorScheme.warning, 30),
      //   dangerLight: colorHelper.tint(colorScheme.danger, 30),
      //
      //   primaryDark: colorHelper.shade(colorScheme.primary, 15),
      //   infoDark: colorHelper.shade(colorScheme.info, 15),
      //   successDark: colorHelper.shade(colorScheme.success, 15),
      //   warningDark: colorHelper.shade(colorScheme.warning, 15),
      //   dangerDark: colorHelper.shade(colorScheme.danger, 15),
      //
      //   dashboard: {
      //     blueStone: dashboardColors.blueStone,
      //     surfieGreen: dashboardColors.surfieGreen,
      //     silverTree: dashboardColors.silverTree,
      //     gossip: dashboardColors.gossip,
      //     white: dashboardColors.white,
      //   },
      // }
    };

    // conf.changeTheme = function(theme) {
    //   angular.merge(conf.theme, theme)
    // };
    //
    // conf.changeColors = function(colors) {
    //   angular.merge(conf.colors, colors)
    // };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('CodoonUserAdmin.theme')
    // .constant('layoutSizes', {
    //   resWidthCollapseSidebar: 1200,
    //   resWidthHideSidebar: 500
    // })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
      }
    })
    .constant('uiDatetimePickerConfig', {
      dateFormat: 'yyyy-MM-dd HH:mm',
      defaultTime: '00:00:00',
      html5Types: {
        date: 'yyyy-MM-dd',
        'datetime-local': 'yyyy-MM-ddTHH:mm:ss.sss',
        'month': 'yyyy-MM'
      },
      initialPicker: 'date',
      reOpenDefault: false,
      enableDate: true,
      enableTime: true,
      buttonBar: {
        show: true,
        now: {
          show: true,
          text: '今天'
        },
        today: {
          show: true,
          text: '今天'
        },
        clear: {
          show: true,
          text: '清除'
        },
        date: {
          show: true,
          text: '日期'
        },
        time: {
          show: true,
          text: '时间'
        },
        close: {
          show: true,
          text: '关闭'
        },
        cancel: {
          show: false,
          text: '取消'
        }
      },
      closeOnDateSelection: true,
      closeOnTimeNow: true,
      appendToBody: false,
      altInputFormats: [],
      ngModelOptions: {},
      saveAs: false,
      readAs: false
    });
  // .constant('colorHelper', {
  //   tint: function(color, weight) {
  //     return mix('#ffffff', color, weight);
  //   },
  //   shade: function(color, weight) {
  //     return mix('#000000', color, weight);
  //   },
  // });

  // function shade(color, weight) {
  //   return mix('#000000', color, weight);
  // }
  //
  // function tint(color, weight) {
  //   return mix('#ffffff', color, weight);
  // }
  //
  // //SASS mix function
  // function mix(color1, color2, weight) {
  //   // convert a decimal value to hex
  //   function d2h(d) {
  //     return d.toString(16);
  //   }
  //   // convert a hex value to decimal
  //   function h2d(h) {
  //     return parseInt(h, 16);
  //   }
  //
  //   var result = "#";
  //   for(var i = 1; i < 7; i += 2) {
  //     var color1Part = h2d(color1.substr(i, 2));
  //     var color2Part = h2d(color2.substr(i, 2));
  //     var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
  //     result += ('0' + resultPart).slice(-2);
  //   }
  //   return result;
  // }

})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  "use strict";

  angular.module("CodoonUserAdmin.theme").run(themeRun);

  /** @ngInject */
  function themeRun(
    $timeout,
    $rootScope,
    $q,
    themeLayoutSettings,
    adminApi,
    cacheService
  ) {
    var userInfo = {};
    var whatToWait = [
      adminApi.userInfo.getAll({}).then(function (response) {
        userInfo = angular.extend(userInfo, response);
      }),
      adminApi.activity.checkUgcAuth({}).then(function (response) {
        userInfo = angular.extend(userInfo, response);
      }),
      adminApi.activity.checkRaceCommitteeAuth({}).then(function (response) {
        userInfo = angular.extend(userInfo, response);
      }),
    ];

    var theme = themeLayoutSettings;

    $q.all(whatToWait).then(function () {
      $rootScope.$pageFinishedLoading = true;
      cacheService.setUser(userInfo);
    });

    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 1000);
  }
})();

/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('CodoonUserAdmin.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();

/**
 * @author liuyz
 * created on 2017-3-22
 */

(function () {
  'use strict';

  angular.module('CodoonUserAdmin.pages.advert')
    .controller('occupyPageCtrl', occupyPageCtrl);

  /** @ngInject */
  function occupyPageCtrl($scope, $state, $q, $uibModal, $timeout,$sce, toastrService, $window, adBootstrap, adminApi, cacheService) {

    var vm = this;
    var _current;
    var currentUser = cacheService.getUser();

    vm.adPostionOptions = angular.copy(adBootstrap.getAdPosition());
    vm.ad_position = vm.adPostionOptions[0];

    vm.adModuleOptions = angular.copy(adBootstrap.getAdModules().filter(function(item,key){
      return  item.id != 16;
    }));
    vm.ad_module = vm.adModuleOptions[0];

    adminApi.advert.get_city_info({})
      .then(function (response) {
        cacheService.setCities(response.list);
        vm.provinces = [];
        var cities = angular.copy(response.list);
        for (var i = 0; i < cities.length; i++) {
          vm.provinces.push(cities[i]);
        }
        vm.province = vm.provinces[0];
        _current = moment();;
        vm.query = {
            "year": _current.format('YYYY'),
            "month": _current.format('M'),
            "province_code": vm.province.code,
            "ad_position": vm.ad_position.id,
        };
        vm.monthStart = moment().startOf('month');
        vm.currentMonth = _current.format('MMMM') + ' ' + _current.format('YYYY');
        vm.months = [];
        var _currentMonthLength = moment().daysInMonth();
        var _day;
        var weekend;
        for (var i = 0; i < _currentMonthLength; i++) {
          _day = moment(vm.monthStart).add(i,'d').format('YYYY-MM-DD');
          weekend = moment(_day).isoWeekday();
          vm.months.push({
            id:i+1,
            title:'-',
            day:_day,
            before:!moment(_day).add(1,'d').isAfter(),
            weekend:weekend == 6 || weekend == 7,
            weekday:(i+1) + ' / ' +  moment(_day).format('ddd')
          });
        }

        $timeout(function () {
          var day = _current.format('D')
          angular.element('#scrollTable').scrollLeft(day * 45);
        }, 10);

        vm.adModuleChange();

      }).catch(function (err_res) {
        console.log(err_res)
      })
      //UGC释放占位管理员 (只能释放商务人员)
      var admins = [
        // '1498458761653@new_codoon.com',
        '1501076442957@new_codoon.com',
        'liuyz@newcodoon.com',
      ]
      //商务人员
      var commerceUser = [
        'liaowl@codoon.com',
        '1463730972861@new_codoon.com',
        '18825646240@codoon_auto_regist.com',
        '1474706911755@new_codoon.com',
        '233@123.com',
        '1492431341493@new_codoon.com',
        'randomaqac9e3w@codoon_auto_regist.com',
        '1494218152242@new_codoon.com',
        '1493354820611@new_codoon.com',
        '1496232521054@new_codoon.com',
        '1439378158745@new_codoon.com',
        '1498458761653@new_codoon.com',
        '1497200112578@new_codoon.com',
        '1501076442957@new_codoon.com',
        '1502244524085@new_codoon.com',
        '1511321740902608479m4vn@new_codoon.com',
        '1523596761991749018ps5j@new_codoon.com',
        'andong.lin@codoon.com',
        'randomuvufv4cc@codoon_auto_regist.com',
        '1558083518823277314kynj@new_codoon.com',
      ]

      vm.provinceChange = function() {
          vm.query.province_code = vm.province.code;
          getData();
      }

      vm.adPositionChange = function() {
        vm.principal = adBootstrap.getPrincipalByPostionId(vm.ad_position.id);

        //LOADING 3条  运动弹层  乐活动图文链接
        if ([1].indexOf(vm.ad_position.id) >= 0) {
          vm.assembleData = [
            {id:0,index:1,title:null,num:1},
            {id:1,index:2,title:null,num:2},
            {id:2,index:3,title:null,num:3},
            {id:3,index:4,title:null,num:4}
          ]
        }
        if ([3,40,49,50].indexOf(vm.ad_position.id) >= 0) {
          vm.assembleData = [
            {id:0,index:1,title:null,num:1},
            {id:1,index:2,title:null,num:2},
            {id:2,index:3,title:null,num:3}
          ]
        }
        if ([2].indexOf(vm.ad_position.id) >= 0) {
          vm.assembleData = [
            {id:0,index:0,title:'健走',num:1},
            {id:1,index:1,title:'跑步',num:1},
            {id:2,index:2,title:'骑行',num:1},
            {id:3,index:5,title:'登山',num:1},
            {id:3,index:7,title:'游泳',num:1}
          ]
        }

        // 乐活动图文链接 语音播报 电商弹层
        if ([21,28,30,32,33,34,41,46,47,53,55,56,64,70].indexOf(vm.ad_position.id) >= 0) {
          vm.assembleData = [
            {id:0,index:1,title:null,num:1}
          ]
        }

        //运动记录-BUTTON
        if ([4].indexOf(vm.ad_position.id) >= 0) {
          vm.assembleData = [
            {id:0,index:0,title:'健走',num:1},
            {id:1,index:1,title:'跑步',num:1},
            {id:2,index:2,title:'骑行',num:1}
          ]
        }

        //运动记录页-运动结束图片广告
        if ([35].indexOf(vm.ad_position.id) >= 0) {
          vm.assembleData = [
            {id:0,index:0,title:'健走',num:1},
            {id:1,index:1,title:'跑步',num:1},
            {id:2,index:2,title:'骑行',num:1},
            {id:3,index:3,title:'登山',num:1}
          ]
        }
        //训练计划
        if ([37].indexOf(vm.ad_position.id) >= 0) {
          vm.assembleData = [
            {id:0,index:1,title:null,num:1},
            {id:1,index:2,title:null,num:2},
          ]
        }

        //FEED
        if ([27].indexOf(vm.ad_position.id) >= 0) {
          vm.assembleData = [
            {id:0,index:1,title:null,num:1},
            {id:1,index:2,title:null,num:2},
            {id:2,index:3,title:null,num:3}
          ]
        }
        if ([6].indexOf(vm.ad_position.id) >= 0) {
          vm.assembleData = [
            {id:3,index:1,title:null,num:1},
            {id:4,index:2,title:null,num:2},
            {id:5,index:3,title:null,num:3}
          ]
        }

        //俱乐部、电商、直播
        if ([13,18,22,23,24,25,29,31,36,38,39].indexOf(vm.ad_position.id) >= 0) {
          vm.assembleData = [
            {id:0,index:1,title:null,num:1},
            {id:1,index:2,title:null,num:2},
            {id:2,index:3,title:null,num:3},
            {id:3,index:4,title:null,num:4},
            {id:4,index:5,title:null,num:5}
          ]
        }

        //banner
        if ([8, 9, 10, 11, 12, 14, 15, 16, 17, 19, 20, 42, 43, 44, 45].indexOf(vm.ad_position.id) >= 0) {
            vm.assembleData = [
              {id:0,index:1,title:null,num:1},
              {id:1,index:2,title:null,num:2},
              {id:2,index:3,title:null,num:3},
              {id:3,index:4,title:null,num:4},
              {id:4,index:5,title:null,num:5},
              {id:5,index:6,title:null,num:6}
            ]
        }

        vm.query.ad_position = vm.ad_position.id;
        getData();
      }

      /**
       * 广告模块选择
       */
      vm.adModuleChange = function() {
        vm.adPostionOptions = adBootstrap.getAdPostionOptionByModuleIdInSearch(vm.ad_module.id);
        vm.ad_position = vm.adPostionOptions[0];
        vm.adPositionChange(vm.ad_position.id);
      }
      // vm.adModuleChange();

      vm.changePosition = function(count) {
        vm.count = count.id;
        for (var i = 0, len = vm.times.length; i < len; i++) {
          if (vm.times[i].index === count.id) {
              vm.timeRanges = vm.times[i];
              return;
          }
        }
        vm.timeRanges = { time_range: angular.copy(adBootstrap.getTimeRanges()) };
      }

      vm.changeMonth = function (action) {
        if (action == 'next') {
          _current = _current.add(1,'M');
          vm.currentMonth = _current.format('MMMM') + ' ' + _current.format('YYYY');
        }else if (action == 'pre') {
          _current = _current.add(-1,'M');
          vm.currentMonth = _current.format('MMMM') + ' ' + _current.format('YYYY');
        }else {
          _current = moment();
          vm.currentMonth = _current.format('MMMM') + ' ' + _current.format('YYYY');
        }

        vm.months = [];
        vm.query.year = _current.format('YYYY');
        vm.query.month = _current.format('M');
        var _currentMonthLength = _current.daysInMonth();
        vm.monthStart = _current.startOf('month');
        var _day;
        var weekend;
        for (var i = 0; i < _currentMonthLength; i++) {
          _day = moment(vm.monthStart).add(i,'d').format('YYYY-MM-DD');
          weekend = moment(_day).isoWeekday();
          vm.months.push({
            id:i+1,
            title:'-',
            day:_day,
            before:!moment(_day).add(1,'d').isAfter(),
            weekend:weekend == 6 || weekend == 7,
            weekday:(i+1) + ' / ' +  moment(_day).format('ddd')
          });
        };
        getData();
      }

      /**
       * getTaskList
       * @return {[type]} [description]
       * 9预约占位，10确定占位，  11释放占位
       * task_status ：占位类型，9预留占位排期，10确认占位排期。非商务人员只能为确认占位排期，商务人员位预留
       * 其他已执行（非占用排期方式占位）
       */
      function getData() {

        // vm.query.time = angular.isObject(vm.query.time) ? JSON.stringify(vm.query.time) : vm.query.time;
        // vm.query.index = angular.isObject(vm.query.index) ? JSON.stringify(vm.query.index) : vm.query.index;

        adminApi.advert.query_occupy_list(vm.query)
          .then(function (response) {
              assembling(response.list);
          }).catch(function (err_res) {
            console.log(err_res)
        })

      }

      function assembling (list) {
        var _months = [];
        list.sort(function(a,b){
          return a.index - b.index;
        }).map(function(list){
          _months = angular.copy(vm.months);
          for (var i = 0; i < _months.length; i++) {
            for (var j = 0; j < list.day_info.length; j++) {
              if (list.day_info[j].day == _months[i].day) {
                _months[i].name = list.day_info[j].name;
                _months[i].submit_auther = list.day_info[j].submit_auther;
                _months[i].info = '创建人:'+list.day_info[j].submit_auther + "<br>";
                _months[i].info += '需求人:'+ (list.day_info[j].record ? list.day_info[j].record.real_occupier || '' : '') + "<br>";
                if (list.day_info[j].desc) {
                  _months[i].info += '说明:'+ list.day_info[j].desc + "<br>";
                }
                _months[i].info += '创建时间:' + list.day_info[j].update_time || '';
                _months[i].info = $sce.trustAsHtml(_months[i].info);
                _months[i].user_type = commerceUser.indexOf(list.day_info[j].submit_auther) >= 0 ? 1 : 0;
                _months[i].group_id = list.day_info[j].group_id;
                _months[i].task_status = list.day_info[j].task_status;
                _months[i].my_self = list.day_info[j].submit_auther == currentUser.email ? true :false;
                if (list.day_info[j].task_status != 9 && list.day_info[j].task_status != 10) {
                  // _months[i].title = '已执行';
                  _months[i].occupy_class = 'done';
                }
                if (list.day_info[j].task_status == 10 && _months[i].user_type == 0) {
                  // _months[i].title = '非商占';
                  _months[i].occupy_class = 'non-business';
                }
                if (list.day_info[j].task_status == 10 && _months[i].user_type == 1) {
                  // _months[i].title = '商占';
                  _months[i].occupy_class = 'business';
                }
                if (list.day_info[j].task_status == 9) {
                  // _months[i].title = '预留';
                  _months[i].occupy_class = 'reservation';
                }
                _months[i].title = list.day_info[j].desc ? list.day_info[j].desc.substring(0,4) : "";
                break;
              }
            }
          }

          // LOADING,BANNER
          if([1, 3, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 22, 23, 24, 25,
             28, 29, 30, 31, 32, 33, 34, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47,
             49, 50, 53, 55, 56].indexOf(vm.ad_position.id) >= 0) {
            vm.assembleData.forEach(function(item,key){
              if (item.num == list.index) {
                item.days = _months;
              }
            })
            }

          // 运动记录-BUTTON、FEED、赛事
          if([2,4,27,6,21,35,64,70].indexOf(vm.ad_position.id) >= 0) {
            vm.assembleData.forEach(function(item,key){
              if (item.index == list.index) {
                item.days = _months;
              }
            })
           }

          vm.assembleData.forEach(function(item,key){
            if (!item.days) {
              item.days = angular.copy(vm.months);
            }
          })
        })
      }

      vm.modal = function (item,day) {
        if (day.before) return; //历史日期返回
        if (day.task_status && day.task_status != 10 && day.task_status != 9) return; //已执行 不显示详情
        if (admins.indexOf(currentUser.email) === -1) {

          if (!day.group_id && day.before) return; //无占位 且 历史日期返回

          if (day.submit_auther && day.submit_auther != currentUser.email) return //不是自己建的返回 | 不是自己但是有创建权限可以点开
        }
        else if (day.submit_auther&&currentUser.email !==day.submit_auther&&commerceUser.indexOf(day.submit_auther) === -1) {
          return; // 非商务人员的占位，不能释放
        }

        var params = {
          admin_release_ad:admins.indexOf(currentUser.email) > -1,
          day:day,
          group_id:day.group_id || '',
          province_code:vm.province.code,
          position:vm.ad_position.id,
          index: item.index,
          user_type:1
        }
        // return console.log(params);
        $uibModal.open({
          animation: true,
          resolve: {
            data: function() {
              return params;
            }
          },
          controller: 'advertModalCtrl',
          controllerAs:'vm',
          templateUrl: 'app/pages/advert/modal.html'
        }).result.then(function() {
          getData();
        });
      }

  }
})();

/**
 * @author liuyz
 * created on 2017-3-22
 */

(function () {
  'use strict';

  angular.module('CodoonUserAdmin.pages.advert')
    .controller('advertModalCtrl', advertModalCtrl);

  /** @ngInject */
  function advertModalCtrl($scope, $state, $uibModalInstance, cacheService, adminApi, adBootstrap, toastrService, data) {

        var vm = this;

        vm.data = data;
        vm.user_type = data.user_type;

        var currentUser = cacheService.getUser();

        vm._data = {
          task_status:9
        }
        vm.task_status = 9;
        vm.reasons = [
          {id:0,title:"请选择释放原因"},
          {id:1,title:"素材未提供"},
          {id:2,title:"内容质量不过关"},
          {id:3,title:"主动放弃"},
          {id:4,title:"合作取消"},
          {id:5,title:"周期变更"},
          {id:6,title:"其它"}
        ]
        vm.reason = vm.reasons[0];

        vm.data.begin_time = moment(data.day.day).format('YYYY-MM-DD HH:mm:ss');
        vm.data.end_time = moment(data.day.day).format('YYYY-MM-DD') + ' 23:59:59';

        if (data.day.group_id) {
          adminApi.advert.get_task_info({group_id:data.day.group_id})
            .then(function (response) {
                vm.data = response;
                vm.data.before = data.day.before;
                vm.data.my_self = data.day.my_self;
                vm.data.real_occupier = response.record.real_occupier;
                vm._data = angular.copy(response);
                vm.task_status = response.task_status;
                vm._data.begin_time = moment(vm._data.begin_time).format('YYYY-MM-DD HH:mm:ss');
                vm._data.end_time = moment(vm._data.end_time).format('YYYY-MM-DD HH:mm:ss');
                // vm.uploadMaterial = (vm._data.task_status == 10) && (vm.action['/backend/advert/admin/seg/' + vm.data.ad_position + '/create_ad_task'].grant
                // || vm.action['/backend/advert/admin/seg/' + vm.data.ad_position + '/save_to_draft'].grant);
                vm.uploadMaterial = vm._data.task_status == 10;
                vm.admin_release_ad = data.admin_release_ad;//超管占位释放
            }).catch(function (err_res) {
              console.log(err_res)
            })
        } else {
          vm.data.real_occupier = currentUser.nick + ' ' + currentUser.email;
        }

        vm.taskStatusChange = function (val) {
          vm.task_status = val;
          // vm.uploadMaterial = vm._data.task_status == 10;
          // vm.uploadMaterial = (vm._data.task_status == 10) && (vm.action['/backend/advert/admin/seg/' + vm.data.ad_position + '/create_ad_task'].grant
          // || vm.action['/backend/advert/admin/seg/' + vm.data.ad_position + '/save_to_draft'].grant);
        }

        vm.save = function () {
          var params = {
            task_status:10,//占位类型，int，9预留占位排期，10确认占位排期。非商务人员只能为确认占位排期 10
            ad_position:data.position,
            desc:vm.data.desc || '',
            begin_time:moment(vm.data.begin_time).format('YYYY-MM-DD HH:mm:ss'),
            end_time:moment(vm.data.end_time).format('YYYY-MM-DD') + ' 23:59:59',
            province_code:[data.province_code],
            index:data.index,
            purpose:'b',
            real_occupier:vm.data.real_occupier
          }

          if (!params.real_occupier) {
            return toastrService.openToast('error','请填写实际需求人');
          }
          // 开始时间大于昨天
          var yesterday = moment().add(-1,'d').format('YYYY-MM-DD') + ' 23:59:59';
          if (moment(params.begin_time) < moment(yesterday)) {
            toastrService.openToast('error','开始时间应大于今天凌晨');
            return;
          }

          if (moment(params.begin_time) > moment(params.end_time)) {
            toastrService.openToast('error','开始日期不能大于结束日期');
            return;
          }

          if (data.user_type === 1 && vm.task_status === 9) {
            params.task_status = 9;
          }else if (data.user_type === 1 && vm.task_status === 10) {
            params.task_status = 10;
          }

          if (data.province_code == '00') {
              var _cities = angular.copy(cacheService.getCities());
              data.province_code = [];
              params.province_code = [];
              angular.forEach(_cities,function(item){
                if (item.code.length == 2) {
                  params.province_code.push(item.code);
                }
              });
          }

          params.province_code = JSON.stringify(params.province_code);

          adminApi.advert.create_occupy_place(params)
            .then(function (response) {
              if (response.err_code=='1001') {
                toastrService.openToast('error','时间冲突');
              }
              $uibModalInstance.close();
            }).catch(function (err_res) {
              toastrService.openToast('error','时间冲突');
            })
        }

        vm.modify = function () {

          var params = {
            group_id:data.day.group_id,
            ad_position:data.position,
            task_status:vm.task_status,
            desc:vm.data.desc || '',
            begin_time:moment(vm.data.begin_time).format('YYYY-MM-DD HH:mm:ss'),
            end_time:moment(vm.data.end_time).format('YYYY-MM-DD'),
            modify_type:1, //调用入口类型，1表示在占位页面调用
            index:data.index,
            real_occupier:vm.data.real_occupier
          }

          // 开始时间大于昨天
          var yesterday = moment().add(-1,'d').format('YYYY-MM-DD') + ' 23:59:59';
          if (moment(params.begin_time) < moment(yesterday)) {
            toastrService.openToast('error','开始时间应大于今天凌晨');
            return;
          }

          if (moment(params.begin_time) > moment(params.end_time)) {
            toastrService.openToast('error','开始日期不能大于结束日期');
            return;
          }

          if (!params.real_occupier) {
            return toastrService.openToast('error','请填写实际需求人');
          }

          params.end_time = params.end_time + ' 23:59:59';

          adminApi.advert.modify_occupy_place(params)
            .then(function (response) {
              $uibModalInstance.close();
            }).catch(function (err_res) {
              toastrService.openToast('error',err_res);
            })

        }

        vm.submit = function () {
          if (vm.reason.id == 0) {
            toastrService.openToast('error','请选择释放原因');
            return;
          }

          var params = {
            group_id:data.day.group_id,
            reason:vm.reason.title
          }

          adminApi.advert.release_occupy_place(params)
            .then(function (response) {
              $uibModalInstance.close();
            }).catch(function (err_res) {
              toastrService.openToast('error',err_res);
            })
        }

  }
})();

(function () {
  'use strict';

  angular.module('CodoonUserAdmin.pages.home')
    .controller('homeArctileCtrl', homeArctileCtrl);

  /** @ngInject */
  function homeArctileCtrl($scope,adminApi,toastrService) {
    var vm = this;

    vm.totalItems = 0;
    vm.data = [];
    vm.orderBy = [
      {label: '时间顺序', is_time: true},
      {label: '浏览量排序', is_time: false}
    ];
    vm.query = {
      page: 1,
      limit: 10,
      is_time: true
    };

    vm.getArticleList = getArticleList;
    vm.getArticleList();
    
    function getArticleList(page) {
      adminApi.publishList.get_article_list(angular.extend(vm.query, {
        page: page || vm.query.page
      })).then(function (data) {
        getCheckStatus(data.list);
        vm.totalItems = data.num;
      })
    }

    vm.handleDropMenu = function (item) {
      vm.query.is_time = item.is_time;
      vm.getArticleList(1);
    }

    function getCheckStatus(data) {
      adminApi.publishList.get_check_status({
        old_id: data.map(function (item) {
          return item.id
        })
      }).then(function (checkData) {
        console.log(checkData);
        vm.fetched = true;
        loopData(checkData, data);
      })
    }

    function loopData(checkData, data) {
      checkData.map(function(checkItem) {
        data.map(function(item) {
          if (checkItem.data.old_id == item.id) {
            item.status = checkItem.status;
          }
        }) 
      })
      vm.data = data;
    }

  }
})();

/**
 * @author liujuan
 * created on 2017-2-22
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.pages.home')
    .controller('homePageCtrl', homePageCtrl);

  /** @ngInject */
  function homePageCtrl($scope,adminApi,toastrService) {

    $scope.homeInfo = {};

    //$scope.
    adminApi.userInfo.getAll({})
      .then(function (response) {

        $scope.homeInfo.brand_user = response.brand_user;             // 是否显示品牌号
        $scope.homeInfo.portrait = response.portrait;                 // 用户头像
        $scope.homeInfo.nick = response.nick;
        $scope.homeInfo.descroption = response.descroption;           // 用户签名
        $scope.homeInfo.follower_count = response.follower_count;     // 获取粉丝数量
        $scope.homeInfo.following_count = response.following_count;   // 关注的数量
        $scope.homeInfo.official_note = response.vip_label.official_note;     //    认证说明
      }).catch(function (err_res) {
        console.log(err_res)
    });


  }
})();

/**
 * @author liujuan
 * created on 2017-2-22
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.pages.live')
    .controller('livePageCtrl', livePageCtrl);

  /** @ngInject */
  function livePageCtrl($scope,userApi,adminApi,toastrService) {

    $scope.valueLength = 0;       // 监听字数
    $scope.isStausFb = false;
    $scope.cover_img = "";

    // 话题组件可以继承父级的这些scope
    $scope.label_id = 0;
    $scope.checkTitle = "";

    $scope.isMenu = 1;            // 显示第几个步骤
    $scope.key = "";
    $scope.url = "";
    $scope.location = "";

    var clipboard = new Clipboard('.copyUrl');

    clipboard.on('success', function(e) {
      toastrService.openToast('success','复制成功~');
      e.clearSelection();
    });

    clipboard.on('error', function(e) {
      toastrService.clearToasts();
      toastrService.openToast('error',  '复制失败~')
    });

    //获取城市名称
    userApi.getCityName(function (data) {
      $scope.location = data.city;
    })

    // 获取基础设置参数
    adminApi.liveAll.getParam({})
      .then(function (response) {

        $scope.key = response.rtmp_param.key;
        $scope.url = response.rtmp_param.url;
        $scope.cover_img = response.cover_img;
        $scope.checkTitle = response.label;
        $scope.label_id = response.label_id;

        if($scope.location == "") {
          $scope.location = response.location;
        }

      }).catch(function (err_res) {
      console.log(err_res)
    })

    //回到基础设置页面
    $scope.clickMenu = function () {
      $scope.isMenu = 1;
    }

    //监听上传图片
    var unWatchImg = userApi.watchImg($scope, 'vm.img', 5, function (file) {
      userApi.openUploadImg(file, function (data) {

        $scope.cover_img = data.ref;

      })
    });


    //发布按钮高亮
    $scope.$watch('cover_img',function () {
      if($scope.cover_img != "") {
        $scope.isStausFb = true;
      }else {
        $scope.isStausFb = false;
      }

    },true)


    // 下一步
    $scope.save = function () {

      var cover_img =  $scope.cover_img,
        checkTitle =  userApi.trim($scope.checkTitle) || "",
        label_id = $scope.label_id;

      if(!$scope.live_title) {
        toastrService.clearToasts();
        return toastrService.openToast('error', '标题不能为空~');
      }

      if(cover_img.length < 1) {
        toastrService.clearToasts();
        return toastrService.openToast('error', '必填项不能为空~');
      }

      var data = {
        'title':$scope.live_title,
        'cover_img':cover_img,
        'location':$scope.location,
        'label_id':label_id,
        'label':checkTitle
      }

      if(label_id == undefined) {
        data.label_id = 0;
      }

      adminApi.liveAll.setParam(data)
        .then(function (response) {

          $scope.isMenu = 2;

          $scope.key = response.rtmp_param.key;
          $scope.url = response.rtmp_param.url;

        }).catch(function (err_res) {
        console.log(err_res)
      })
    }

    //更新设置
    $scope.update_room = function () {

      adminApi.liveAll.updateParam({})
        .then(function (response) {

          $scope.key = response.rtmp_param.key;
          $scope.url = response.rtmp_param.url;

        }).catch(function (err_res) {
        console.log(err_res)
      })
    }

  }
})();

/**
 * @author liuyz
 * created on 8.15.2016
 */
(function() {
    'use strict';

    angular.module('CodoonUserAdmin.pages.advert')
        .controller('AdvertSearchCtrl', AdvertSearchCtrl);

    /** @ngInject */
    function AdvertSearchCtrl($uibModal,$sce,toastrService, cacheService, adBootstrap, adminApi) {

      var vm = this;
      vm.loading = false;
      var adInfo = adBootstrap.getAdInfo();
      var softAdInfo = adBootstrap.getSoftAdInfo();

      vm.datas = [];
      vm.navActive = 'search';
      var currentUser = cacheService.getUser();
      //UGC释放占位管理员 (只能释放商务人员)
      var admins = [
        '1498458761653@new_codoon.com',
        'liuyz@newcodoon.com',
      ]
      var commerceUser = [
        'liaowl@codoon.com',
        '1463730972861@new_codoon.com',
        '18825646240@codoon_auto_regist.com',
        '1474706911755@new_codoon.com',
        '233@123.com',
        '1492431341493@new_codoon.com',
        'randomaqac9e3w@codoon_auto_regist.com',
        '1494218152242@new_codoon.com',
        '1493354820611@new_codoon.com',
        '1496232521054@new_codoon.com',
        '1439378158745@new_codoon.com',
        '1498458761653@new_codoon.com',
        '1497200112578@new_codoon.com',
        '1501076442957@new_codoon.com',
        '1502244524085@new_codoon.com',
        '1511321740902608479m4vn@new_codoon.com',
        '1523596761991749018ps5j@new_codoon.com',
        'andong.lin@codoon.com',
        'randomuvufv4cc@codoon_auto_regist.com',
        '1558083518823277314kynj@new_codoon.com',
      ]

      var _current = moment();
      vm.months = [];
      var _currentMonthLength = moment().daysInMonth();
      vm.monthStart = _current.startOf('month');
      var _day;
      var weekend;
      for (var i = 0; i < _currentMonthLength; i++) {
        _day = moment(vm.monthStart).add(i,'d').format('YYYY-MM-DD');
        weekend = moment(_day).isoWeekday();
        vm.months.push({
          id:i+1,
          title:'-',
          day:_day,
          before:!moment(_day).add(1,'d').isAfter(),
          weekend:weekend == 6 || weekend == 7,
          weekday:(i+1) + ' / ' +  moment(_day).format('ddd')
        });
      }

      vm.currentMonth = _current.format('MMMM') + ' ' + _current.format('YYYY');
      vm.query = {
        "des": '',
        "year": _current.format('YYYY'),
        "month": _current.format('M'),
      };

      vm.nav = function (tab) {
        vm.navActive = tab;
        vm.datas = [];
      }

      vm.changeMonth = function (action) {
        if (action == 'next') {
          _current = _current.add(1,'M');
        }else if (action == 'pre') {
          _current = _current.add(-1,'M');
        }else {
          _current = moment();
        }
        vm.currentMonth = _current.format('MMMM') + ' ' + _current.format('YYYY');

        vm.query.year = _current.format('YYYY');
        vm.query.month = _current.format('M');

        vm.months = [];
        var _currentMonthLength = moment().daysInMonth();
        vm.monthStart = _current.startOf('month');
        var _day;
        var weekend;
        for (var i = 0; i < _currentMonthLength; i++) {
          _day = moment(vm.monthStart).add(i,'d').format('YYYY-MM-DD');
          weekend = moment(_day).isoWeekday();
          vm.months.push({
            id:i+1,
            title:'-',
            day:_day,
            before:!moment(_day).add(1,'d').isAfter(),
            weekend:weekend == 6 || weekend == 7,
            weekday:(i+1) + ' / ' +  moment(_day).format('ddd')
          });
        }

        vm.getData();
      }

      function getSoftAssembleData(ad_position) {
        var ad_position = parseInt(ad_position.split('-')[1]);
        //条数为1条
        if ([17].indexOf(ad_position) >= 0) {
            return [
              {id:0,index:1,title:null,num:1}
            ]
        }
        //条数为2条
        if ([7,8,9,11,12,13,14,18].indexOf(ad_position) >= 0) {
            return [
              {id:0,index:1,title:null,num:1},
              {id:1,index:2,title:null,num:2}
            ]
        }
        //条数为3条
        if ([16].indexOf(ad_position) >= 0) {
            return [
              {id:0,index:1,title:null,num:1},
              {id:1,index:2,title:null,num:2},
              {id:2,index:3,title:null,num:3},
            ]
        }
        //条数为4条
        if ([1,2,3,4,5,10,15].indexOf(ad_position) >= 0) {
            return [
              {id:0,index:1,title:null,num:1},
              {id:1,index:2,title:null,num:2},
              {id:2,index:3,title:null,num:3},
              {id:3,index:4,title:null,num:4}
            ]
        }
        //条数为6条
        if ([6].indexOf(ad_position) >= 0) {
            return [
              {id:0,index:1,title:null,num:1},
              {id:1,index:2,title:null,num:2},
              {id:2,index:3,title:null,num:3},
              {id:3,index:4,title:null,num:4},
              {id:4,index:5,title:null,num:5},
              {id:5,index:6,title:null,num:6}
            ]
        }
      }

      function getAssembleData(ad_position) {
        //LOADING 3条  运动弹层  乐活动图文链接
        if ([1,2,3,40,49,50].indexOf(ad_position) >= 0) {
          return [
            {id:0,index:1,title:null,num:1},
            {id:1,index:2,title:null,num:2},
            {id:2,index:3,title:null,num:3}
          ]
        }

        // 乐活动图文链接 语音播报 电商弹层
        if ([21,28,30,32,33,34,41,46,47,53,55,56,64].indexOf(ad_position) >= 0) {
          return [
            {id:0,index:1,title:null,num:1}
          ]
        }

        //运动记录页-BUTTON
        if ([4].indexOf(ad_position) >= 0) {
          return [
            {id:0,index:0,title:'健走',num:1},
            {id:1,index:1,title:'跑步',num:1},
            {id:2,index:2,title:'骑行',num:1}
          ]
        }
        //运动记录页-运动结束图片广告
        if ([35].indexOf(ad_position) >= 0) {
          return [
            {id:0,index:0,title:'健走',num:1},
            {id:1,index:1,title:'跑步',num:1},
            {id:2,index:2,title:'骑行',num:1},
            {id:3,index:3,title:'登山',num:1}
          ]
        }
        //训练计划
        if ([37].indexOf(ad_position) >= 0) {
          return [
            {id:0,index:1,title:null,num:1},
            {id:1,index:2,title:null,num:2},
          ]
        }

        //FEED
        if ([27].indexOf(ad_position) >= 0) {
          return [
            {id:0,index:1,title:null,num:1},
            {id:1,index:2,title:null,num:2},
            {id:2,index:3,title:null,num:3}
          ]
        }
        if ([6].indexOf(ad_position) >= 0) {
          return [
            {id:3,index:1,title:null,num:1},
            {id:4,index:2,title:null,num:2},
            {id:5,index:3,title:null,num:3}
          ]
        }

        //俱乐部、电商、直播
        if ([13,18,22,23,24,25,29,31,36,38,39].indexOf(ad_position) >= 0) {
          return [
            {id:0,index:1,title:null,num:1},
            {id:1,index:2,title:null,num:2},
            {id:2,index:3,title:null,num:3},
            {id:3,index:4,title:null,num:4},
            {id:4,index:5,title:null,num:5}
          ]
        }

        //banner
        if ([8, 9, 10, 11, 12, 14, 15, 16, 17, 19, 20, 42, 43, 44, 45].indexOf(ad_position) >= 0) {
          return [
            {id:0,index:1,title:null,num:1},
            {id:1,index:2,title:null,num:2},
            {id:2,index:3,title:null,num:3},
            {id:3,index:4,title:null,num:4},
            {id:4,index:5,title:null,num:5},
            {id:5,index:6,title:null,num:6}
          ]
        }
      }

      function assembling (ad_position,list,targetList) {
        var _months = [];
        list.sort(function(a,b){
          return a.index - b.index;
        }).map(function(list){
          _months = angular.copy(vm.months);
          for (var i = 0; i < _months.length; i++) {
            for (var j = 0; j < list.day_info.length; j++) {
              if (list.day_info[j].day == _months[i].day) {
                _months[i].name = list.day_info[j].name;
                _months[i].submit_auther = list.day_info[j].submit_auther;
                _months[i].info = '创建人:'+list.day_info[j].submit_auther + "<br>";
                // _months[i].info += '需求人:'+ (list.day_info[j].record.real_occupier || '') + "<br>";
                if (list.day_info[j].desc) {
                  _months[i].info += '说明:'+ list.day_info[j].desc;
                }
                _months[i].info = $sce.trustAsHtml(_months[i].info);
                _months[i].user_type = commerceUser.indexOf(list.day_info[j].submit_auther) >=0 ? 1 : 0;
                _months[i].group_id = list.day_info[j].group_id;
                _months[i].task_status = list.day_info[j].task_status;
                _months[i].my_self = list.day_info[j].submit_auther == currentUser.email ? true :false;
                if (list.day_info[j].task_status != 9 && list.day_info[j].task_status != 10) {
                  _months[i].occupy_class = 'done';
                }
                if (list.day_info[j].task_status == 10 && _months[i].user_type == 0) {
                  _months[i].occupy_class = 'non-business';
                }
                if (list.day_info[j].task_status == 10 && _months[i].user_type == 1) {
                  _months[i].occupy_class = 'business';
                }
                if (list.day_info[j].task_status == 9) {
                  _months[i].occupy_class = 'reservation';
                }
                _months[i].title = list.day_info[j].desc.substring(0,4);
                break;
              }
            }
          }

          if (vm.navActive === 'soft-search') {
            targetList.forEach(function(item,key){
              if (item.index == list.index) {
                item.days = _months;
              }
            })
            targetList.forEach(function(item,key){
              if (!item.days) {
                item.days = angular.copy(vm.months);
              }
            })
            return targetList;
          }

          // LOADING,BANNER
          if([1, 2, 3, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 22, 23, 24, 25,
             28, 29, 30, 31, 32, 33, 34, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47,
             49, 50, 53, 55, 56].indexOf(ad_position) >= 0) {
              targetList.forEach(function(item,key){
              if (item.num == list.index) {
                item.days = _months;
              }
            })
            }

          // 运动记录-BUTTON、FEED、赛事
          if([4,27,6,21,35,64].indexOf(ad_position) >= 0) {
            targetList.forEach(function(item,key){
              if (item.index == list.index) {
                item.days = _months;
              }
            })
            }

            targetList.forEach(function(item,key){
            if (!item.days) {
              item.days = angular.copy(vm.months);
            }
          })
        })
        return targetList;
      }

      vm.getData = function() {
        if (!vm.query.des) {
          return toastrService.openToast('error','输入说明查询');
        }
        vm.loading = true;
        var url = vm.navActive === 'search' ? 'query_occupy_by_des' : 'query_soft_occupy_by_des';
        adminApi.advert[url](vm.query).then(function(response) {
          vm.loading = false;
            if (response.length === 0) {
              vm.datas = []
              return toastrService.openToast('info','无满足查询条件广告');
            }
            if (vm.navActive === 'search') {
              vm.datas = response.map(function(item){
                item.principal = adBootstrap.getPrincipalByPostionId(item.ad_position);
                item.module_name = adInfo[item.ad_position][1];
                item.position_name = adInfo[item.ad_position][0];
                item.assembleData = getAssembleData(item.ad_position);
                item.assembleData = assembling(item.ad_position,item.list,item.assembleData);
                return item;
              });
            } else {
              vm.datas = response.map(function(item){
                item.module_name = softAdInfo[item.ad_position][0];
                item.position_name = softAdInfo[item.ad_position][1];
                item.assembleData = getSoftAssembleData(item.ad_position);
                item.assembleData = assembling(item.ad_position,item.list,item.assembleData);
                return item;
              });
            }
        })
      }

      vm.modal = function (ad_position,item,day) {
        if (!day.group_id) return; //新建返回
        if (day.before) return; //历史日期返回
        if (day.task_status && day.task_status != 10 && day.task_status != 9) return; //已执行 不显示详情
        if (admins.indexOf(currentUser.email) === -1) {

          if (!day.group_id && day.before) return; //无占位 且 历史日期返回

          if (day.submit_auther && day.submit_auther != currentUser.email) return //不是自己建的返回 | 不是自己但是有创建权限可以点开
        }
        else if (day.submit_auther&&currentUser.email !==day.submit_auther&&commerceUser.indexOf(day.submit_auther) === -1) {
          return; // 非商务人员的占位，不能释放
        }

        var params = {
          admin_release_ad:admins.indexOf(currentUser.email) > -1,
          day:day,
          group_id:day.group_id || '',
          position:ad_position,
          index: item.index,
          user_type:commerceUser.indexOf(currentUser.email) >=0 ? 1 : 0
        }
        $uibModal.open({
          animation: true,
          resolve: {
            data: function() {
              return params;
            }
          },
          controller: 'advertModalCtrl',
          controllerAs:'vm',
          templateUrl: 'app/pages/advert/modal.html'
        }).result.then(function() {
          getData();
        });
      }

    }
  })();

/**
 * @author lyz
 * created on 23.09.2016
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.pages.advert')
    .controller('softOccupyModalCtrl', softOccupyModalCtrl);

  /** @ngInject */
  function softOccupyModalCtrl($scope, $state, $uibModalInstance, cacheService, adminApi, adBootstrap, toastrService, data) {

    var vm = this;

    vm.data = data;
    vm.user_type = data.user_type;

    var currentUser = cacheService.getUser();

    vm._data = {
      task_status:9
    }
    vm.task_status = 9;
    vm.reasons = [
      {id:0,title:"请选择释放原因"},
      {id:1,title:"素材未提供"},
      {id:2,title:"内容质量不过关"},
      {id:3,title:"主动放弃"},
      {id:4,title:"合作取消"},
      {id:5,title:"周期变更"},
      {id:6,title:"其它"}
    ]
    vm.reason = vm.reasons[0];

    vm.data.begin_time = moment(data.day.day).format('YYYY-MM-DD HH:mm:ss');
    vm.data.end_time = moment(data.day.day).format('YYYY-MM-DD') + ' 23:59:59';

    if (data.day.group_id) {
      adminApi.advert.get_soft_task_info({id:data.day.group_id})
        .then(function (response) {
          vm.data = response;
          vm.data.position = response.ad_position;
          vm.data.before = data.day.before;
          vm.data.my_self = data.day.my_self;
          vm.data.real_occupier = response.record.real_occupier;
          vm._data = angular.copy(response);
          vm.task_status = response.task_status;
          vm._data.begin_time = moment(vm._data.begin_time).format('YYYY-MM-DD HH:mm:ss');
          vm._data.end_time = moment(vm._data.end_time).format('YYYY-MM-DD HH:mm:ss');
          vm.admin_release_soft_ad = data.admin_release_soft_ad;//超管占位释放
        }).catch(function (err_res) {
          console.log(err_res)
        })
    } else {
      vm.data.real_occupier = currentUser.nick + ' ' + currentUser.email;
      delete data.id;
    }

    // $scope.$watch('vm.data.end_time',function(newD,oldD){
    //   if (moment(newD).format('YYYY-MM-DD') != moment(oldD).format('YYYY-MM-DD')) {
    //     vm.data.end_time = moment(newD).format('YYYY-MM-DD') + ' 23:59:59';
    //   }
    // });

    vm.taskStatusChange = function (val) {
      vm.task_status=val;
    }

    vm.go = function () {
      $uibModalInstance.close();
      $state.go('advert.create-new',{group_id: vm.data.group_id});
    }

    vm.save = function () {
      var params = {
        task_status:10,//占位类型，int，9预留占位排期，10确认占位排期。非商务人员只能为确认占位排期 10
        ad_position:data.position,
        desc:vm.data.desc || '',
        begin_time:moment(vm.data.begin_time).format('YYYY-MM-DD HH:mm:ss'),
        end_time:moment(vm.data.end_time).format('YYYY-MM-DD') + ' 23:59:59',
        // province_code:[data.province_code]
        index:data.index,
        real_occupier:vm.data.real_occupier
      }

      if (!params.real_occupier) {
        return toastrService.openToast('error','请填写实际需求人');
      }

      // 开始时间大于昨天
      var yesterday = moment().add(-1,'d').format('YYYY-MM-DD') + ' 23:59:59';
      if (moment(params.begin_time) < moment(yesterday)) {
        toastrService.openToast('error','开始时间应大于今天凌晨');
        return;
      }

      if (moment(params.begin_time) > moment(params.end_time)) {
        toastrService.openToast('error','开始日期不能大于结束日期');
        return;
      }

      if (data.user_type === 1 && vm.task_status === 9) {
        params.task_status = 9;
      }else if (data.user_type === 1 && vm.task_status === 10) {
        params.task_status = 10;
      }

      // if (data.province_code == '00') {
      //   var _cities = angular.copy(cacheService.getCities());
      //   params.province_code = [];
      //   angular.forEach(_cities,function(item){
      //     if (item.code.length == 2) {
      //       params.province_code.push(item.code);
      //     }
      //   });
      // }
      //
      // params.province_code = JSON.stringify(params.province_code);

      adminApi.advert.create_soft_occupy_place(params)
        .then(function (response) {
          if (response.err_code=='1001') {
          return  toastrService.openToast('error','时间冲突');
          }
          $uibModalInstance.close();
        }).catch(function (err_res) {
          toastrService.openToast('error','时间冲突');
        })
    };

    vm.modify = function () {

      var params = {
        id:data.day.group_id,
        ad_position:data.position,
        task_status:vm.task_status,
        desc:vm.data.desc || '',
        begin_time:moment(vm.data.begin_time).format('YYYY-MM-DD HH:mm:ss'),
        end_time:moment(vm.data.end_time).format('YYYY-MM-DD') + ' 23:59:59',
        index:data.index,
        real_occupier:vm.data.real_occupier
      }

      // 开始时间大于昨天
      var yesterday = moment().add(-1,'d').format('YYYY-MM-DD') + ' 23:59:59';
      if (moment(params.begin_time) < moment(yesterday)) {
        toastrService.openToast('error','开始时间应大于今天凌晨');
        return;
      }

      if (moment(params.begin_time) > moment(params.end_time)) {
        toastrService.openToast('error','开始日期不能大于结束日期');
        return;
      }

      if (!params.real_occupier) {
        return toastrService.openToast('error','请填写实际需求人');
      }

      adminApi.advert.modify_soft_occupy_place(params)
        .then(function (response) {
          $uibModalInstance.close();
        }).catch(function (err_res) {
          toastrService.openToast('error',err_res);
        })
    }

    vm.submit = function () {
      if (vm.reason.id == 0) {
        toastrService.openToast('error','请选择释放原因');
        return;
      }

      var params = {
        id:data.day.group_id,
        reason:vm.reason.title
      }

      adminApi.advert.release_soft_occupy_place(params)
        .then(function (response) {
          $uibModalInstance.close();
        }).catch(function (err_res) {
          toastrService.openToast('error',err_res);
        })
    }

  }
})();

/**
 * @author liuyz
 * created on 8.15.2016
 */
(function() {
    'use strict';

    angular.module('CodoonUserAdmin.pages.advert')
        .controller('softOccupyPageCtrl', softOccupyPageCtrl);

    /** @ngInject */
    function softOccupyPageCtrl($scope, $state, $q, $uibModal, $timeout,$sce, toastrService, $window, adBootstrap, adminApi, cacheService) {

      var vm = this;
      var _current;
      //UGC释放占位管理员
      var admins = [
        // '1498458761653@new_codoon.com',
        '1501076442957@new_codoon.com',
        'liuyz@newcodoon.com',
      ]
      //商务人员
      var commerceUser = [
        'liaowl@codoon.com',
        '1463730972861@new_codoon.com',
        '18825646240@codoon_auto_regist.com',
        '1474706911755@new_codoon.com',
        '233@123.com',
        '1492431341493@new_codoon.com',
        'randomaqac9e3w@codoon_auto_regist.com',
        '1494218152242@new_codoon.com',
        '1493354820611@new_codoon.com',
        '1496232521054@new_codoon.com',
        '1439378158745@new_codoon.com',
        '1498458761653@new_codoon.com',
        '1497200112578@new_codoon.com',
        '1501076442957@new_codoon.com',
        '1502244524085@new_codoon.com',
        '1511321740902608479m4vn@new_codoon.com',
        'andong.lin@codoon.com',
        'randomuvufv4cc@codoon_auto_regist.com',
        '1558083518823277314kynj@new_codoon.com',
      ]

      var currentUser = cacheService.getUser();

      // vm.provinces = [];

      vm.adModuleOptions = angular.copy(adBootstrap.getSoftAdModules());
      vm.ad_module = vm.adModuleOptions[0];

      vm.adPostionOptions = angular.copy(adBootstrap.getSoftAdPosition(vm.ad_module.id));
      vm.ad_position = vm.adPostionOptions[0];

      vm.adModuleChange = function() {
        vm.adPostionOptions = angular.copy(adBootstrap.getSoftAdPosition(vm.ad_module.id));
        vm.ad_position = vm.adPostionOptions[0];
        vm.adPositionChange();
      }

      adminApi.advert.get_city_info({})
        .then(function (response) {
            cacheService.setCities(response.list);
            vm.provinces = [];
            var cities = angular.copy(response.list);
            for (var i = 0; i < cities.length; i++) {
              vm.provinces.push(cities[i]);
            }
            vm.province = vm.provinces[0];
            _current = moment();
            vm.query = {
                "year": _current.format('YYYY'),
                "month": _current.format('M'),
                "ad_position": vm.ad_position.id,
                "index": [1]
            };
            vm.monthStart = moment().startOf('month');
            vm.currentMonth = _current.format('MMMM') + ' ' + _current.format('YYYY');
            vm.months = [];
            var _currentMonthLength = moment().daysInMonth();
            var _day;
            var weekend;
            for (var i = 0; i < _currentMonthLength; i++) {
              _day = moment(vm.monthStart).add(i,'d').format('YYYY-MM-DD');
              weekend = moment(_day).isoWeekday();
              vm.months.push({
                id:i+1,
                title:'-',
                day:_day,
                before:!moment(_day).add(1,'d').isAfter(),
                weekend:weekend == 6 || weekend == 7,
                weekday:(i+1) + ' / ' +  moment(_day).format('ddd')
              });
            }

            $timeout(function () {
              var day = _current.format('D')
              angular.element('#scrollTable').scrollLeft(day * 45);
            }, 10);

            vm.adModuleChange();
        }).catch(function (err_res) {
          console.log(err_res)
        })

        vm.adPositionChange = function() {
            //条数为1条
            if ([17,25].indexOf(vm.ad_position.id) >= 0) {
                vm.query.index = [1];
                vm.assembleData = [
                  {id:0,index:1,title:null,num:1}
                ]
            }
            //条数为2条
            if ([7,8,9,11,12,13,14,18,23].indexOf(vm.ad_position.id) >= 0) {
                vm.query.index = [1,2];
                vm.assembleData = [
                  {id:0,index:1,title:null,num:1},
                  {id:1,index:2,title:null,num:2}
                ]
            }
            //条数为3条
            if ([16,24].indexOf(vm.ad_position.id) >= 0) {
                vm.query.index = [1,2,3];
                vm.assembleData = [
                  {id:0,index:1,title:null,num:1},
                  {id:1,index:2,title:null,num:2},
                  {id:2,index:3,title:null,num:3},
                ]
            }
            //条数为4条
            if ([1,2,3,4,5,10,15].indexOf(vm.ad_position.id) >= 0) {
                vm.query.index = [1,2,3,4];
                vm.assembleData = [
                  {id:0,index:1,title:null,num:1},
                  {id:1,index:2,title:null,num:2},
                  {id:2,index:3,title:null,num:3},
                  {id:3,index:4,title:null,num:4}
                ]
            }
            //条数为6条
            if ([6].indexOf(vm.ad_position.id) >= 0) {
                vm.query.index = [1,2,3,4,5,6];
                vm.assembleData = [
                  {id:0,index:1,title:null,num:1},
                  {id:1,index:2,title:null,num:2},
                  {id:2,index:3,title:null,num:3},
                  {id:3,index:4,title:null,num:4},
                  {id:4,index:5,title:null,num:5},
                  {id:5,index:6,title:null,num:6}
                ]
            }
            vm.query.ad_position = vm.ad_position.parent + '-' + vm.ad_position.id;
            getData();
        }

        vm.changeMonth = function (action) {
          if (action == 'next') {
            _current = _current.add(1,'M');
            vm.currentMonth = _current.format('MMMM') + ' ' + _current.format('YYYY');
          }else if (action == 'pre') {
            _current = _current.add(-1,'M');
            vm.currentMonth = _current.format('MMMM') + ' ' + _current.format('YYYY');
          }else {
            _current = moment();
            vm.currentMonth = _current.format('MMMM') + ' ' + _current.format('YYYY');
          }

          vm.months = [];
          vm.query.year = _current.format('YYYY');
          vm.query.month = _current.format('M');
          var _currentMonthLength = _current.daysInMonth();
          vm.monthStart = _current.startOf('month');
          var _day;
          var weekend;
          for (var i = 0; i < _currentMonthLength; i++) {
            _day = moment(vm.monthStart).add(i,'d').format('YYYY-MM-DD');
            weekend = moment(_day).isoWeekday();
            vm.months.push({
              _id:i+1,
              title:'-',
              day:_day,
              before:!moment(_day).add(1,'d').isAfter(),
              weekend:weekend == 6 || weekend == 7,
              weekday:(i+1) + ' / ' +  moment(_day).format('ddd')
            });
          };
          getData();
        }

        /**
         * getTaskList
         * @return {[type]} [description]
         * 9预约占位，10确定占位，  11释放占位
         * task_status ：占位类型，9预留占位排期，10确认占位排期。非商务人员只能为确认占位排期，商务人员位预留
         * 其他已执行（非占用排期方式占位）
         */
        function getData() {

          // vm.query.time = angular.isObject(vm.query.time) ? JSON.stringify(vm.query.time) : vm.query.time;
          vm.query.index = angular.isObject(vm.query.index) ? JSON.stringify(vm.query.index) : vm.query.index;

          adminApi.advert.query_soft_occupy_list(vm.query)
            .then(function (response) {
                assembling(response.list);
            }).catch(function (err_res) {
              console.log(err_res)
          })

        }

        function assembling (list) {
          var _months = [];
          list.sort(function(a,b){
            return a.index - b.index;
          }).map(function(list){
            _months = angular.copy(vm.months);
            for (var i = 0; i < _months.length; i++) {
              for (var j = 0; j < list.day_info.length; j++) {
                if (list.day_info[j].day == _months[i].day) {
                  _months[i].name = list.day_info[j].name;
                  _months[i].submit_auther = list.day_info[j].submit_auther;
                  _months[i].info = '创建人:'+list.day_info[j].submit_auther + "<br>";
                  _months[i].info += '需求人:'+ (list.day_info[j].record ? list.day_info[j].record.real_occupier || '' : '') + "<br>";
                  if (list.day_info[j].desc) {
                    _months[i].info += '说明:'+ list.day_info[j].desc;
                  }
                  _months[i].info = $sce.trustAsHtml(_months[i].info);
                  _months[i].user_type = commerceUser.indexOf(list.day_info[j].submit_auther) >=0 ? 1 : 0;
                  _months[i].group_id = list.day_info[j].id;
                  _months[i].task_status = list.day_info[j].task_status;
                  _months[i].my_self = list.day_info[j].submit_auther == currentUser.email ? true :false;
                  if (list.day_info[j].task_status != 9 && list.day_info[j].task_status != 10) {
                    _months[i].occupy_class = 'done';
                  }
                  if (list.day_info[j].task_status == 10 && _months[i].user_type == 0) {
                    _months[i].occupy_class = 'non-business';
                  }
                  if (list.day_info[j].task_status == 10 && _months[i].user_type == 1) {
                    _months[i].occupy_class = 'business';
                  }
                  if (list.day_info[j].task_status == 9) {
                    _months[i].occupy_class = 'reservation';
                  }
                  _months[i].title = list.day_info[j].desc.substring(0,4);
                  break;
                }
              }
            }

            vm.assembleData.forEach(function(item,key){
              if (item.index == list.index) {
                item.days = _months;
              }
            })

            vm.assembleData.forEach(function(item,key){
              if (!item.days) {
                item.days = angular.copy(vm.months);
              }
            })
          })
        }

        vm.modal = function (item,day) {
          if (day.before) return; //历史日期返回
          if (day.task_status && day.task_status != 10 && day.task_status != 9) return; //已执行 不显示详情
          if (admins.indexOf(currentUser.email) === -1) {
            if (!day.id && day.before) return; //无占位 且 历史日期返回
            if (day.submit_auther && day.submit_auther != currentUser.email) return //不是自己建的返回 | 不是自己但是有创建权限可以点开
          }
          else if (day.submit_auther&&currentUser.email !==day.submit_auther&&commerceUser.indexOf(day.submit_auther) === -1) {
            return; // 非商务人员的占位，不能释放
          }

          var params = {
            admin_release_soft_ad:admins.indexOf(currentUser.email) > -1,
            day:day,
            id:day.group_id || '',
            // province_code:vm.province.code,
            position:vm.ad_position.parent + '-' + vm.ad_position.id,
            index: item.index,
            user_type:1 // 商务人员
          }
          $uibModal.open({
            animation: true,
            resolve: {
              data: function() {
                return params;
              }
            },
            controller: 'softOccupyModalCtrl',
            controllerAs:'vm',
            templateUrl: 'app/pages/soft-advert/modal.html'
          }).result.then(function() {
            getData();
          });
        }

    }
})();

/**
 * @author liujuan
 * created on 2017-2-22
 */
(function () {
  "use strict";

  angular.module("CodoonUserAdmin.pages").service("adminApi", adminApi);

  /** @ngInject */
  function adminApi($http, $q, $rootScope, toastrService) {
    var self = this;
    self.domainUrl = "https://www.codoon.com";

    // 广告
    self.advert = {
      //广告占位
      create_occupy_place: makePost(
        "/ugc/advert/admin/seg/ad_position/create_occupy_place"
      ),
      modify_occupy_place: makePost(
        "/ugc/advert/admin/seg/ad_position/modify_occupy_place"
      ),
      release_occupy_place: makePost(
        "/ugc/advert/admin/gen/release_occupy_place"
      ),
      get_task_info: makeGet("/ugc/advert/admin/gen/get_task_info"),
      query_occupy_list: makeGet("/ugc/advert/admin/gen/query_occupy_list"),
      get_city_info: makeGet("/ugc/advert/admin/gen/get_city_info"),
      //软广告占位
      create_soft_occupy_place: makePostAsForm(
        "/ugc/advert/admin/gen/create_soft_occupy_place"
      ),
      modify_soft_occupy_place: makePostAsForm(
        "/ugc/advert/admin/gen/modify_soft_occupy_place"
      ),
      release_soft_occupy_place: makePostAsForm(
        "/ugc/advert/admin/gen/release_soft_occupy_place"
      ),
      get_soft_task_info: makeGet("/ugc/advert/admin/gen/get_soft_task_info"),
      query_soft_occupy_list: makeGet(
        "/ugc/advert/admin/gen/query_soft_occupy_list"
      ),
      //广告位导出
      get_history_excel_list: makeGet(
        "/ugc/advert/admin/gen/get_history_excel_list"
      ),
      save_excel_task: makePost("/ugc/advert/admin/gen/save_excel_task"),
      get_current_excel_task: makeGet(
        "/ugc/advert/admin/gen/get_current_excel_task"
      ),

      //占位查询
      query_occupy_by_des: makeGet("/ugc/advert/admin/gen/query_occupy_by_des"),
      query_soft_occupy_by_des: makeGet(
        "/ugc/advert/admin/gen/query_soft_occupy_by_des"
      ),
    };

    //发布
    self.publishList = {
      create_feed_upload: makePost("/ugc/feedserver/create_feed_api"),
      create_article: makePost("/ugc/tieba_v2/create_article"),
      get_article_list: makePost("/tieba_v2/ugc/tieba_v2/get_article_list"), // 获取用户ugc列表
      modify_article: makePost("/tieba_v2/ugc/tieba_v2/modify_article"), // 编辑ugc文章
      get_check_status: makePost("/tieba_v2/ugc/tieba_v2/get_check_status"), // 获取文章详情
    };

    //home
    self.userInfo = {
      getAll: makeGet("/ugcserver/index?time=" + new Date().getTime()),
    };

    //live 直播
    self.liveAll = {
      setParam: makePost("/ugc/videolive/set_host_room_basic_param"),
      updateParam: makePost("/ugc/videolive/update_host_room_rtmp_param"),
      getParam: makePost("/ugc/videolive/get_host_room_param"),
    };

    // 实时赛事直播
    self.racelive = {
      get_race_statistic: makeGet("/h5/gps_live/ugc/get_race_statistic"), // 获取赛事统计数据
      race_live_rank: makeGet("/h5/gps_live/ugc/race_live_rank"), // 赛事实时进行中榜单
      get_race_kol_rank: makeGet("/h5/gps_live/ugc/get_race_kol_rank"), // 获取kol的数据
      add_race_kol: makePost("/h5/gps_live/ugc/add_race_kol"), // 添加赛事kol
      get_real_time_backend: makeGet(
        "https://race.codoon.com/www/open/v2/online_race/get_real_time_backend"
      ), // 实时赛事基本数据
      get_real_time_live: makeGet(
        "https://race.codoon.com/www/open/v2/online_race/get_real_time_live"
      ), // 获取所有的实时赛事下拉框
      get_user_area_gender: makeGet(
        "https://race.codoon.com/www/v2/online_race/get_user_area_gender"
      ), // 地域分布 + 年龄分布
      get_history_score: makeGet(
        "https://race.codoon.com/www/v2/online_race/get_history_score"
      ), // 获取历史实时赛最好成绩
      get_match_rank_page: mpAjaxPost(
        "https://race.codoon.com/open/race/get_match_rank_page"
      ), // 获取线上赛完赛排名接口
    };

    //训练直播
    self.training = {
      get_my_class: makeGet("/www/v2/live_class/coach/get_my_class"),
      create_live: makePost("/www/v2/live_class/coach/create_live"),
      get_schedule_detail: makeGet(
        "/www/v2/live_class/coach/get_schedule_detail"
      ),
      get_subscribe_user: makeGet(
        "/www/v2/live_class/coach/get_subscribe_user"
      ),
      get_live_info: makePost("/www/v2/live_class/coach/create_live"),
      start_class: makePost("/www/v2/live_class/coach/start_class"),
      end_class: makePost("/www/v2/live_class/coach/end_class"),
      // 开始、结束直播
      start_video: makePost("/www/v2/live_class/coach/start_video"),
      end_video: makePost("/www/v2/live_class/coach/end_video"),
    };

    //公用接口
    var qinu_post_add = "";
    var ishttps = "https:" == document.location.protocol ? true : false;
    if (ishttps) {
      qinu_post_add = "https://upload-z1.qbox.me";
    } else {
      qinu_post_add = "http://upload-z1.qiniu.com";
    }
    self.public = {
      select_equip: makePost("/ugc/feedserver/search_feed_label"),
      create_feed: makePost("/ugc/feedserver/create_feed_label"),
      upload_token: makeGet("/ugc/console/get_qiniu_upload_token"),
      apply_upload_signature: makePost(
        "/v2/cds/activity/apply_upload_signature"
      ),
      qiniu_live: qinu_post_add,
    };

    self.activity = {
      createCityActive: makeOwnPost(
        "/www/active_city/normal/create_city_active_v2"
      ), // 创建同城活动
      updateCityActive: makeOwnPost(
        "/www/active_city/normal/update_city_active_v2"
      ), // 创建同城活动
      getActiveTypes: makeGet("/www/active_city/normal/get_active_types"), // 获取后台活动类型
      checkUgcAuth: makeGet("/www/active_city/normal/pc_ugc_auth_check"), // 验证是否是发布活动白名单
      get_active_by_order: makeGet(
        "/www/active_city/white_list/normal/get_active_by_order"
      ), // 活动跳转地址
      getUserGroups: makeGet("/www/groupmanage/get_user_groups"), // 获取用户加入的团
      get_city_actives_all: makePost(
        "/www/active_city/normal/get_city_actives_all"
      ), // 获取活动列表
      active_notice_modify: makePost(
        "/www/active_city/normal/active_notice_modify"
      ), // 导出活动参与人
      getActiveID: makePost("/www/active_city/normal/get_active_id"), // 获取活动详情
      checkRaceCommitteeAuth: makeGet(
        "/www/garage_kit_server/organizing_committee_match/check_user_permission"
      ), // 验证是否是赛事委员会
    };

    self.makeGet = makeGet;

    /**
     * @param url
     * @param data
     * @returns {*|Object|Boolean|{emit, on}}
     */
    function makeGet(url) {
      return function (data) {
        return $q(function (resolve, reject) {
          // 实时赛事
          if (
            url.indexOf("gps_live") == -1 &&
            url.indexOf("online_race") == -1
          ) {
            $rootScope.ajaxLoading = true;
          }

          var _url = angular.copy(url);

          if (url.indexOf("http") == -1) {
            _url = self.domainUrl + _url;
          }

          if (_url.indexOf("/ugc/advert/admin") >= 0) {
            _url = _url.replace(/ad_position/, data.ad_position);
          }

          $http
            .get(_url, {
              params: data,
              headers: { "Content-Type": "application/json" },
              withCredentials: true,
            })
            .then(
              function (response) {
                $rootScope.ajaxLoading = false;
                if (response.data.err_code === "0002") {
                  toastrService.clearToasts();
                  toastrService.openToast(
                    "error",
                    "无权限操作，请联系管理员！"
                  );
                } else if (
                  response.data.status === "Error" ||
                  response.data.status === "ERROR"
                ) {
                  toastrService.clearToasts();
                  toastrService.openToast("error", response.data.description);
                } else {
                  resolve(response.data.data);
                }
              },
              function (err) {
                $rootScope.ajaxLoading = false;
                if (err.data) {
                  if (err.data.data) {
                    if (err.data.data.rdurl) {
                      window.location.href =
                        "https://xmall.codoon.com/webmw/pcpassport.html?rurl=" +
                        window.location.href;
                      return;
                    }
                  }
                }
                alert("服务器错误");
              }
            );
        });
      };
    }

    function makeOwnPost(url) {
      return function (data) {
        return $q(function (resolve, reject) {
          $rootScope.ajaxLoading = true;
          var _url = angular.copy(url);

          if (_url.indexOf("http") == -1) {
            _url = self.domainUrl + _url;
          }

          if (_url.indexOf("/ugc/advert/admin") >= 0 && data.ad_position >= 0) {
            _url = _url.replace(/ad_position/, data.ad_position);
          }

          $http
            .post(_url, JSON.stringify(data), {
              headers: { "Content-Type": "application/json" },
              withCredentials: true,
            })
            .then(
              function (response) {
                $rootScope.ajaxLoading = false;
                if (response.data.err_code === "0002") {
                  toastrService.clearToasts();
                  toastrService.openToast(
                    "error",
                    "无权限操作，请联系管理员！"
                  );
                } else if (
                  response.data.status.toString().toLowerCase() === "error"
                ) {
                  toastrService.clearToasts();
                  toastrService.openToast("error", response.data.description);
                }
                resolve(response.data);
              },
              function (err) {
                if (err.data) {
                  if (err.data.data) {
                    if (err.data.data.rdurl) {
                      window.location.href =
                        "https://xmall.codoon.com/webmw/pcpassport.html?rurl=" +
                        window.location.href;
                      return;
                    }
                  }
                }
                alert("服务器错误");
              }
            );
        });
      };
    }

    /**
     * @param url
     * @returns {Function}
     */
    function makePost(url) {
      return function (data) {
        return $q(function (resolve, reject) {
          $rootScope.ajaxLoading = true;
          var _url = angular.copy(url);

          if (_url.indexOf("://") == -1) {
            _url = self.domainUrl + _url;
          }

          if (_url.indexOf("/ugc/advert/admin") >= 0 && data.ad_position >= 0) {
            _url = _url.replace(/ad_position/, data.ad_position);
          }

          $http
            .post(_url, JSON.stringify(data), {
              headers: { "Content-Type": "application/json" },
              withCredentials: true,
            })
            .then(
              function (response) {
                $rootScope.ajaxLoading = false;

                if (response.data.err_code === "0002") {
                  toastrService.clearToasts();
                  toastrService.openToast(
                    "error",
                    "无权限操作，请联系管理员！"
                  );
                } else if (
                  response.data.status.toString().toLowerCase() === "error"
                ) {
                  toastrService.clearToasts();
                  toastrService.openToast("error", response.data.description);
                } else {
                  resolve(response.data.data);
                }
              },
              function (err) {
                if (err.data) {
                  if (err.data.data) {
                    if (err.data.data.rdurl) {
                      window.location.href =
                        "https://xmall.codoon.com/webmw/pcpassport.html?rurl=" +
                        window.location.href;
                      return;
                    }
                  }
                }
                alert("服务器错误");
              }
            );
        });
      };
    }

    // post请求
    function mpAjaxPost(url) {
      return function (data) {
        return $q(function (resolve, reject) {
          $rootScope.ajaxLoading = true;
          var _url = angular.copy(url);

          if (_url.indexOf("://") == -1) {
            _url = self.domainUrl + _url;
          }

          if (_url.indexOf("/ugc/advert/admin") >= 0 && data.ad_position >= 0) {
            _url = _url.replace(/ad_position/, data.ad_position);
          }

          $.ajax(_url, {
            method: "POST",
            data: data,
          })
            .done(function (response) {
              $rootScope.ajaxLoading = false;

              if (response.err_code === "0002") {
                toastrService.clearToasts();
                toastrService.openToast("error", "无权限操作，请联系管理员！");
              } else if (response.status.toString().toLowerCase() === "error") {
                toastrService.clearToasts();
                toastrService.openToast("error", response.data.description);
              } else {
                resolve(response.data);
              }
            })
            .fail(function (xhr, textStatus, errorThrown) {
              console.log(xhr);
              if (xhr.data) {
                if (err.data) {
                  if (err.data.rdurl) {
                    window.location.href =
                      "https://xmall.codoon.com/webmw/pcpassport.html?rurl=" +
                      window.location.href;
                    return;
                  }
                }
              }
              alert("服务器错误");
            });
        });
      };
    }

    /**
     * @param url
     * @returns {Function}
     */
    function makePostAsForm(url) {
      return function (data) {
        return $q(function (resolve, reject) {
          $rootScope.ajaxLoading = true;
          var _url = self.domainUrl + url;
          if (_url.indexOf("/ugc/advert/admin") >= 0 && data.ad_position >= 0) {
            _url = _url.replace(/ad_position/, data.ad_position);
          }

          $http
            .post(_url, data, {
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
              withCredentials: true,
              transformRequest: function (data) {
                var str = [];
                for (var p in data)
                  str.push(
                    encodeURIComponent(p) + "=" + encodeURIComponent(data[p])
                  );
                return str.join("&");
              },
            })
            .then(
              function (response) {
                $rootScope.ajaxLoading = false;

                if (response.data.err_code === "0002") {
                  toastrService.clearToasts();
                  toastrService.openToast(
                    "error",
                    "无权限操作，请联系管理员！"
                  );
                } else if (response.data.status === "Error") {
                  toastrService.clearToasts();
                  toastrService.openToast("error", response.data.description);
                } else {
                  resolve(response.data.data);
                }
              },
              function (err) {
                if (err.data) {
                  if (err.data.data) {
                    if (err.data.data.rdurl) {
                      window.location.href =
                        "https://xmall.codoon.com/webmw/pcpassport.html?rurl=" +
                        window.location.href;
                      return;
                    }
                  }
                }
                alert("服务器错误");
              }
            );
        });
      };
    }

    //上传视频
    self.uploadVideo = function (data, callback) {
      $rootScope.ajaxLoading = true;

      var request = new XMLHttpRequest();

      request.open("POST", self.public.qiniu_live);
      request.onreadystatechange = function ajaxCallback() {
        if (request.readyState == 4 && request.status == 200) {
          var resonse = JSON.parse(request.responseText);

          $rootScope.ajaxLoading = false;
          callback(resonse);
        }
      };
      request.onload = function (e) {
        //console.log(request.response);
      };
      request.send(data);
    };
  }
})();

/**
 * @author liuyz
 * created on 2017-3-23
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.theme')
    .service('cacheService', cacheService);

  /** @ngInject */
  function cacheService() {

    this.cities = null;
    this.user = null;

    return {

      setUser: function (user) {
        this.user = user;
      },

      setUserInfo: function (info) {
        this.user = angular.extend(this.user || {}, info);
      },

      getUser: function () {
        return this.user;
      },

      setCities: function (cities) {
        this.cities = cities.sort(function(a, b) {
          return a.code - b.code;
        });
      },

      getCities: function () {
        return this.cities;
      },

    }
  }

})();

/**
 * @author liuyz
 * created on 2017-3-23
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.theme')
    .service('editService', editService);

  /** @ngInject */
  function editService($uibModal) {
    this.createImgUploadMenu = function(editor) {
      wangEditor.createMenu(function (check) {
        var menuId = 'self_img_upload';
        if (!check(menuId)) {
            return;
        }
  
        var editor = this;
  
        var menu = new wangEditor.Menu({
            editor: editor,  // 编辑器对象
            id: menuId,  // 菜单id
            title: '上传图片', // 菜单标题
  
            // 正常状态和选中状态下的dom对象，样式需要自定义
            $domNormal: $('<a href="#" tabindex="-1"><i class="wangeditor-menu-img-picture"></i></a>'),
            $domSelected: $('<a href="#" tabindex="-1" class="selected"><i class="wangeditor-menu-img-picture"></i></a>')
        });
  
        // 定义click事件
        menu.clickEvent = function (e) {
            var rangeElem = editor.getRangeElem();
            var $rangeElem;
            if (!rangeElem) {
                e.preventDefault();
                return;
            }
  
            $uibModal.open({
              templateUrl: 'app/pages/publish/article/modal/img.html',
              controller: 'uploadImgModalCtrl',
              controllerAs: 'uploadImg',
              animation: true,
            }).result.then(function(data) {
              if(data){
                var img = data.img,
                  urlHref = data.href || "javascript:void(0)";
                var img = "<img src='"+img+"'/>";
                //sel.collapseToEnd();
                //document.execCommand('insertHTML', true, div)
                editor.command(e, 'insertHtml', img);
              }
            })
            // 执行自定义命令
            // editor.customCommand(e, commandFn, callback);
        };
  
        //增加到editor对象中
        editor.menus[menuId] = menu;
      })
    }
  }

})();

/**
 * @author lj
 * created on 2017.2.16
 */
(function() {
    'use strict';

    angular.module('CodoonUserAdmin.pages')
        .service('userApi', userApi);

    /** @ngInject */
    function userApi($http, $q, adminApi, $rootScope, toastrService) {

      var self = this;


        //去除空格
        this.trim = function (str) {
          if(str == undefined) {
            return str;
          }

          return str.replace(/(^\s+)|(\s+$)/g, "");
        }

        //搜索关键词
        this.selectText =function (title,callback) {

          var title = self.trim(title) || "";
          if(title.length < 1) {
            return;
          }

          var data = {"content":title};

          adminApi.public.select_equip(data).then(
            function(response){
              callback(response);
            })
        }


        //创建新的话题
        this.createFeed =function (title,callback) {

          var title = self.trim(title) || "";
          if(title.length < 1) {
            return;
          }

          var data = {'content':title};

          adminApi.public.create_feed(data).then(
            function(response){

              callback(response);

            })
        }


        function shouldUseOssProxy() {
          var port = window.location.port;

          return port && port !== '443' && port !== '80';
        }

        function getOssPutUrl(sign) {
          if (shouldUseOssProxy()) {
            return window.location.origin +
              '/oss-upload-proxy?url=' +
              encodeURIComponent(sign.https_upload_url);
          }

          return sign.https_upload_url;
        }

        function putToOss(sign, file) {
          return $q(function(resolve, reject) {
            var request = new XMLHttpRequest();

            request.open('PUT', getOssPutUrl(sign), true);
            request.setRequestHeader('Authorization', sign.signature);
            request.setRequestHeader('x-oss-date', sign.date);
            request.setRequestHeader('Content-Type', sign.content_type);

            request.onreadystatechange = function() {
              if (request.readyState !== 4) {
                return;
              }

              if (request.status >= 200 && request.status < 300) {
                resolve();
              } else {
                reject({
                  status: request.status,
                  response: request.responseText
                });
              }
            };

            request.onerror = function() {
              reject(new Error('OSS upload network error'));
            };

            request.send(file);
          });
        }

        /**
         * 上传图片（阿里云 OSS 签名直传）
         * @param  {object}   input        { file, url? }
         * @param  {Function} callback     callback({ ref, size })
         */
        this.openUploadImg = function(input, callback) {
          var file = input.file;
          if (!file) return false;

          var filename = file.name || ('image_' + Date.now() + '.jpg');
          var contentType = file.type || 'image/jpeg';
          var uploadSign;

          adminApi.public.apply_upload_signature({
            filename: filename,
            content_type: contentType,
            signature_type: 'oss',
            business: 'user',
            count: 1
          }).then(function(signs) {
            uploadSign = signs && signs[0];
            if (!uploadSign) {
              throw new Error('missing upload sign');
            }

            return putToOss(uploadSign, file);
          }).then(function() {
            callback({
              ref: uploadSign.content_url.origin,
              size: file.size
            });
          }, function(err) {
            toastrService.clearToasts();
            toastrService.openToast('error', '图片上传失败');
            console.log(err);
          });
        }


        /**
         * 监听上传文件 35MB
         */
        this.watchFileMp4 = function (scope, imgModel,filesize,callback) {

          return scope.$watch(imgModel, function (input) {
            var file = input&&input.file;
            if (!file) return false;

            var data = new FormData();

            if (file.type == 'video/mp4') {

              if(file.size <= 1024*1024*filesize) {

                adminApi.public.upload_token({}).then(
                  function(result){

                    data.append('bucket', "codoon-video");
                    data.append('token', result.token);
                    data.append('key', result.path);
                    data.append('file', file);

                    data.append('x:username', result.path);

                    adminApi.uploadVideo(data,function (resonse) {

                      callback(resonse);
                    })

                  })

              }else {
                toastrService.clearToasts();
                toastrService.openToast('error',  '请上传35MB以内的视频')
              }

            }else {
              toastrService.clearToasts();
              toastrService.openToast('error', '视频格式不正确');
            }

          })

        }

        /**
         * 监听上传图片  5M
         */
        this.watchImg = function (scope, imgModel, filesize, callback) {

          return scope.$watch(imgModel, function (input) {

            var reader = new FileReader();
            var file = input&&input.file;

            if (!file) return false;

            if (file.type == 'image/jpeg' || file.type == 'image/png') {

                reader.onload = function(e) {
                  var url = e.target.result;

                  if(file.size <= 1024*1024*filesize) {
                    callback(input,url,file);
                  }else {
                    toastrService.clearToasts();
                    toastrService.openToast('error',  '请上传'+filesize+'M以内的图片')
                  }

                }
                reader.readAsDataURL(file);
            } else {
              toastrService.clearToasts();
              toastrService.openToast('error', '图片格式不正确');
            }
          })
      }


        this.getCityName = function (callback) {


          $http.get("//restapi.amap.com/v3/ip?key=91d44aab0e4da60fcc62eead8e4031d4", {params: {}}).then(
            function(response) {
              if (response.data.status == 1) {
                callback(response.data);
              } else{
               console.log('获取城市失败～');
              }
            },
            function(err) {
              alert('服务器错误')
            }
          );




        }

    }
})();

/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.theme')
    .service('toastrService', toastrService);

  /** @ngInject */
  function toastrService(toastr, toastrConfig) {

    var defaultConfig = angular.copy(toastrConfig);

    var openedToasts = [];

    return {
      openToast:openToast,
      clearAndOpenToast: clearAndOpenToast,
      clearToasts:clearToasts
    }

    function openToast(type, msg, title) {
        openedToasts.push(toastr[type](msg, title  || '提示'));
    };

    function clearAndOpenToast(type, msg, title) {
      toastr.clear();
      openedToasts.push(toastr[type](msg, title || '提示'));
    }

    function clearToasts() {
        toastr.clear();
    };

  }

})();

/**
 * @author liuyz
 * created on 2017-3-22
 */

(function () {
  'use strict';

  angular.module('CodoonUserAdmin.pages.export')
    .controller('exportCtrl', exportCtrl)
    .controller('exportModalCtrl', exportModalCtrl)

  /** @ngInject */
  function exportCtrl($scope, $uibModal, $timeout, toastrService, adBootstrap, adminApi, cacheService) {
    var vm = this;
    vm.begin_time = moment();
    vm.end_time = moment().add('d',182);

    vm.table = {
      datas:[],
      currentPage:1,
      pageSize:10,
      total:0,
    }

    adminApi.advert.get_current_excel_task({})
    .then(function (response) {
      vm.update_time = response.update_time;
      vm.notice_update_time = moment(response.update_time).add('d',1).format('YYYY-MM-DD');
      try {
        var time_range = JSON.parse(response.time_range);
        var position_info = JSON.parse(response.position_info);
        vm.begin_time = moment(time_range.begin_time);
        vm.end_time = moment(time_range.end_time);
        vm.position_info = position_info;
        vm.ad = position_info.mandatory_ad;
        vm.sad = position_info.soft_ad;
        vm.adNum = position_info.mandatory_ad.length;
        vm.sadNum = position_info.soft_ad.length;
      } catch (error) {
        console.log(error);
      }
    }).catch(function (err_res) {
      toastrService.openToast('error',err_res);
    })

    adminApi.advert.get_history_excel_list({
      page:1,
      limit:10
    })
    .then(function (response) {
      vm.table.datas = response.list;
      vm.table.total = response.has_more ? (vm.table.currentPage + 1) * vm.table.pageSize : (vm.table.currentPage) * vm.table.pageSize
    }).catch(function (err_res) {
      toastrService.openToast('error',err_res);
    })

    vm.modal = function(type) {
      var ad;
      if (type == 'advert') {
        ad = vm.ad
      } else {
        ad = vm.sad
      }
      $uibModal.open({
        animation: true,
        resolve: {
          data: function() {
            return {type:type,ad:ad};
          }
        },
        controller: 'exportModalCtrl',
        controllerAs:'vm',
        templateUrl: 'app/pages/export/modal.html'
      }).result.then(function(adList) {
        if (type === 'advert') {
          vm.ad = adList;
          vm.adNum = adList.length;
        } else {
          vm.sad = adList;
          vm.sadNum = adList.length;
        }
      });
    }

    vm.save = function() {

      if (moment(vm.begin_time).year() !== moment(vm.end_time).year()) {
        return toastrService.openToast('error','开始结束时间需在一年内');
      }
      if (moment(vm.begin_time) > moment(vm.end_time)) {
        return toastrService.openToast('error','开始时间应小于结束时间');
      }

      var params = {
        time_range:JSON.stringify({"begin_time":vm.begin_time,"end_time":vm.end_time}),
        position_info:{
          mandatory_ad:[],
          soft_ad:[]
        }
      }

      if (!vm.ad && !vm.sad && !vm.position_info) {
        return toastrService.openToast('error','请选择广告位资源');
      }

      if (vm.ad) {
        params.position_info.mandatory_ad = vm.ad;
      }
      if (vm.sad) {
        params.position_info.soft_ad = vm.sad;
      }

      params.position_info = JSON.stringify(params.position_info);
      console.log(params);
      adminApi.advert.save_excel_task(params)
      .then(function (response) {
        if (response) {
          toastrService.openToast('success','保存成功');
        }
      }).catch(function (err_res) {
        toastrService.openToast('error',err_res);
      })

    }

  }

  /** @ngInject */
  function exportModalCtrl($scope,$uibModalInstance, $timeout, toastrService, adBootstrap, adminApi, cacheService, data) {
    var vm = this;
    var ads;
    vm.checkAll = false;
    vm.data = data;
    vm.ads = []

    if (data.type === 'advert') {
      ads = adBootstrap.getAdPosition();
      ads.map(function(item){
        if (item.id !== 5 && item.id !== 7 && item.id !== 12) {
          if (data.ad && data.ad.indexOf(item.id) > -1) {
            item.checked = true;
          }
          // disable
          if ([1,2,3,4,6,7,8,9,10,15,16,17,19,21,27].indexOf(item.id) > -1) {
            vm.ads.push(item);
          }
        }
      });

    } else {
      ads = adBootstrap.getAllSoftAdPosition();
      var soft_ad = [];
      if (data.ad) {
        data.ad.map(function(item){
          soft_ad.push(item.position);
        });
      }
      ads.map(function(item){
        if (soft_ad.indexOf(item.parent + '-' + item.id) > -1) {
          item.checked = true;
        }
        // disable
        if ([6,7].indexOf(item.id) > -1) {
          vm.ads.push(item);
        }
      });
    }

    vm.toggle = function() {
      vm.checkAll = !vm.checkAll;
      vm.ads = vm.ads.map(function(item){
        item.checked = vm.checkAll
        return item;
      });
    }

    vm.itemToggle = function(checked) {
      if (!checked) {
        vm.checkAll = false;
      }
    }

    vm.submit = function() {
      var params = {
        ads:[]
      }
      vm.ads.map(function(item){
        if (item.checked && data.type == 'advert') {
            params.ads.push(item.id);
        }
        if (item.checked && data.type != 'advert') {
            params.ads.push({position:item.parent + '-' + item.id,index:item.index});
        }
      });
      $uibModalInstance.close(params.ads);
      console.log(params.ads);
    }
  }

})();

/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();

/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();

(function () {
  'use strict';

  angular.module('CodoonUserAdmin.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();

(function () {
  'use strict';

  angular.module('CodoonUserAdmin.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();

(function () {
  'use strict';

  angular.module('CodoonUserAdmin.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();

(function () {
  'use strict';

  angular.module('CodoonUserAdmin.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();

/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.theme')
      .directive('image', image);

  /** @ngInject */
  function image($q) {


    var URL = window.URL || window.webkitURL;

    var getResizeArea = function() {
        var resizeAreaId = 'fileupload-resize-area';

        var resizeArea = document.getElementById(resizeAreaId);

        if (!resizeArea) {
            resizeArea = document.createElement('canvas');
            resizeArea.id = resizeAreaId;
            resizeArea.style.visibility = 'hidden';
            document.body.appendChild(resizeArea);
        }

        return resizeArea;
    };

    /**
     * Receives an Image Object (can be JPG OR PNG) and returns a new Image Object compressed
     * @param {Image} sourceImgObj The source Image Object
     * @param {Integer} quality The output quality of Image Object
     * @return {Image} result_image_obj The compressed Image Object
     */

    var jicCompress = function(sourceImgObj, options) {
        var outputFormat = options.resizeType;
        var quality = options.resizeQuality * 100 || 70;
        var mimeType = 'image/jpeg';
        if (outputFormat !== undefined && outputFormat === 'png') {
            mimeType = 'image/png';
        }


        var maxHeight = options.resizeMaxHeight || 300;
        var maxWidth = options.resizeMaxWidth || 250;

        var height = sourceImgObj.height;
        var width = sourceImgObj.width;

        // calculate the width and height, constraining the proportions
        if (width > height) {
            if (width > maxWidth) {
                height = Math.round(height *= maxWidth / width);
                width = maxWidth;
            }
        }
        else {
            if (height > maxHeight) {
                width = Math.round(width *= maxHeight / height);
                height = maxHeight;
            }
        }

        var cvs = document.createElement('canvas');
        cvs.width = width; //sourceImgObj.naturalWidth;
        cvs.height = height; //sourceImgObj.naturalHeight;
        var ctx = cvs.getContext('2d').drawImage(sourceImgObj, 0, 0, width, height);
        var newImageData = cvs.toDataURL(mimeType, quality / 100);
        var resultImageObj = new Image();
        resultImageObj.src = newImageData;
        return resultImageObj.src;
        // return resultImageObj;
    };

    var resizeImage = function(origImage, options) {
        var maxHeight = options.resizeMaxHeight || 300;
        var maxWidth = options.resizeMaxWidth || 250;
        var quality = options.resizeQuality || 0.7;
        var type = options.resizeType || 'image/jpg';

        var canvas = getResizeArea();

        var height = origImage.height;
        var width = origImage.width;

        // calculate the width and height, constraining the proportions
        if (width > height) {
            if (width > maxWidth) {
                height = Math.round(height *= maxWidth / width);
                width = maxWidth;
            }
        }
        else {
            if (height > maxHeight) {
                width = Math.round(width *= maxHeight / height);
                height = maxHeight;
            }
        }

        canvas.width = width;
        canvas.height = height;

        //draw image on canvas
        var ctx = canvas.getContext('2d');
        ctx.drawImage(origImage, 0, 0, width, height);

        // get the data from canvas as 70% jpg (or specified type).
        return canvas.toDataURL(type, quality);
    };

    var createImage = function(url, callback) {
        var image = new Image();
        image.onload = function() {
            callback(image);
        };
        image.src = url;
    };

    var fileToDataURL = function(file) {
        var deferred = $q.defer();
        var reader = new FileReader();
        reader.onload = function(e) {
            deferred.resolve(e.target.result);
        };
        reader.readAsDataURL(file);
        return deferred.promise;
    };

    return {
        restrict: 'A',
        scope: {
            image: '=',
            resizeMaxHeight: '@?',
            resizeMaxWidth: '@?',
            resizeQuality: '@?',
            resizeType: '@?'
        },
        link: function postLink(scope, element, attrs) {

            var doResizing = function(imageResult, callback) {
                createImage(imageResult.url, function(image) {
                    //var dataURL = resizeImage(image, scope);
                    var dataURLcompressed = jicCompress(image, scope);
                    // imageResult.resized = {
                    //  dataURL: dataURL,
                    //  type: dataURL.match(/:(.+\/.+);/)[1]
                    // };
                    imageResult.compressed = {
                        dataURL: dataURLcompressed,
                        // file: dataURLcompressed,
                        type: dataURLcompressed.match(/:(.+\/.+);/)[1]
                    };
                    callback(imageResult);
                });
            };

            var applyScope = function(imageResult) {
                scope.$apply(function() {
                    //console.log(imageResult);
                    if (attrs.multiple) {
                        scope.image.push(imageResult);
                    }
                    else {
                        scope.image = imageResult;
                    }
                });
            };


            element.bind('change', function(evt) {
                //when multiple always return an array of images
                if (attrs.multiple)
                    {scope.image = [];}

                var files = evt.target.files;
                for (var i = 0; i < files.length; i++) {
                    //create a result object for each file in files
                    var imageResult = {
                        file: files[i],
                        url: URL.createObjectURL(files[i])
                    };

                    fileToDataURL(files[i]).then(function(dataURL) {
                        imageResult.dataURL = dataURL;
                    });

                    if (scope.resizeMaxHeight || scope.resizeMaxWidth) { //resize image
                        doResizing(imageResult, function(imageResult) {
                            applyScope(imageResult);
                        });
                    }
                    else { //no resizing
                        applyScope(imageResult);
                    }
                }
                this.value = '';
            });
        }
    };
  }

})();

/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 5000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();

/**
 * @author liusy
 */
(function() {
  'use strict';

  angular.module('CodoonUserAdmin.theme')
      .service('activityBootstrap', activityBootstrap);

  /** @ngInject */
  function activityBootstrap(baUtil) {
    this.EXAMINE_INFO = [
      {name: '真实姓名', value: 'real_name'},
      {name: '年龄', value: 'age'},
      {name: '手机号', value: 'phone'},
      {name: '身份证号', value: 'identification'},
      {name: '电子邮箱', value: 'email'},
      {name: '性别', value: 'sex'},
      {name: '备注', value: 'desc'}
    ]
  }
})();

/**
 * @author liuyz
 * created on 2017-7-29
 */
(function() {
    'use strict';

    angular.module('CodoonUserAdmin.theme')
        .service('adBootstrap', adBootstrap);

    /** @ngInject */
    function adBootstrap(baUtil) {

        /*广告选择框数据
         * 类型 位置 所属模块
         * 广告所属模块,取值范围为：1.Loading页,2.运动首页,3.运动记录页,4.运动圈feed,5.咕咚吧精选,6.运动圈广场,7.乐活动,
         * 8.官方赛事,9.运动场地,10.俱乐部,11.运动过程模块,12.同城活动,13.装备测评,14.电商,15.直播
         */
        var ADMODULE = [
            //{id: 0, name: '全部'}, //0
            { id: 1, name: 'Loading页' }, //0
            { id: 2, name: '运动首页' }, //1
            { id: 3, name: '运动记录页' }, //2
            { id: 4, name: '运动圈FEED' }, //3
            { id: 5, name: '咕咚吧精选' }, //4
            { id: 6, name: '运动圈广场' }, //5
            { id: 7, name: '乐活动' }, //6
            { id: 12, name: '同城活动' }, //7
            { id: 8, name: '官方赛事' }, //8
            { id: 9, name: '运动场地' }, //9 废弃
            { id: 10, name: '俱乐部' }, //10
            { id: 13, name: '装备测评' }, //11
            { id: 14, name: '电商' }, //12
            { id: 15, name: '直播' }, //13
            { id: 16, name: '我的页面' }, //14
            { id: 17, name: '团' }, //15
            { id: 18, name: '添加跑鞋' }, //16
            { id: 19, name: '训练计划' }, //17
            { id: 20, name: '单车页' }, //18
            { id: 21, name: '运动日历页' },//19
            { id: 22, name: '跑场' },//20
            // { id: 23, name: '彩票' },//21  UGC不显示彩票
            { id: 24, name: '文章' },//21
            { id: 27, name: '其它' },//22
            { id: 28, name: '发现页面' },//23
        ];

        var ADSTATUS = [
            // {id: 0, name: '全部'},
            { id: 1, name: '新增草稿' },
            { id: 2, name: '待审核' },
            { id: 3, name: '审批通过' },
            { id: 4, name: '审批驳回' },
            { id: 5, name: '上架中' },
            { id: 6, name: '人工下架' },
            { id: 7, name: '自动下架' },
            { id: 8, name: '废弃' },
            { id: 9, name: '预约占位' },
            { id: 10, name: '确认占位' },
            { id: 11, name: '释放占位' }
        ];

        // 广告类型,取值范围为：
        // 1.开屏页,2.文字链接,3.弹层广告,4.运动记录广告BUTTON,5.信息流FEED广告,
        // 6.轮播图BANNER广告,7.俱乐部广告
        var ADTYPE = [
            { id: 0, name: '其它广告' },
            { id: 1, name: '开屏页广告' },
            { id: 2, name: '文字链接广告' },
            { id: 3, name: '弹层广告' },
            { id: 4, name: '运动记录广告BOTTON' },
            { id: 5, name: '信息流FEED广告' },
            { id: 6, name: '轮播图BANNER广告' },
            // { id: 7, name: '俱乐部广告' },
            { id: 7, name: '语音播报广告' },
            { id: 8, name: '背景换肤广告' },
            { id: 9, name: '训练计划列表广告' },
        ];

        //ad_position：广告位，取值范围为：
        //1开屏页，2运动首页-链接广告，3.运动首页-弹层广告，
        //4运动记录-button广告，5动态-FEED流-图片+文字广告，6动态-FEED流-图片广告，7咕咚吧-精选-FEED流-图片广告，
        //8广场-顶部轮播banner，9咕咚吧-精选-顶部轮播banner，10咕咚活动-乐活动-顶部轮播banner，
        //11官方赛事-顶部轮播banner，12运动场地-顶部轮播banner，13加入俱乐部前页面，14咕咚活动-同城活动-顶部轮播banner，
        //15赛事-线上赛事顶部轮播banner，16赛事-骑行赛事顶部轮播banner，17赛事-线下赛事顶部轮播banner，
        //18加入俱乐部后页面，19.赛事-赛事照片顶部轮播banner，20装备测评-顶部轮播banner
        //21赛事首页-弹层广告,22电商-首页顶部轮播BANNER,23电商-首页中部轮播BANNER
        //24
        var ADPOSITION = [
            { id: 1, name: '开屏页广告' }, //0
            { id: 2, name: '运动首页-链接广告' }, //1
            { id: 3, name: '运动首页-弹层广告' }, //2
            { id: 4, name: '运动记录-BUTTON广告' }, //3
            { id: 5, name: '动态-FEED流-3号位(旧废弃)' }, //4  5号位广告 映射为27号广告位
            { id: 6, name: '动态-FEED流-6号位' }, //5
            { id: 7, name: '咕咚吧-精选-FEED流-图片广告(4号位)' }, //6 废弃
            { id: 8, name: '运动圈精选首页-顶部轮播BANNER' }, //7
            { id: 9, name: '专栏-顶部轮播BANNER' }, //8
            { id: 10, name: '乐活动-顶部轮播BANNER' }, //9
            { id: 11, name: '官方赛事-顶部轮播BANNER' }, //10
            { id: 12, name: '运动场地-顶部轮播BANNER' }, //11 废弃
            { id: 13, name: '俱乐部-加入前页面BANNER' }, //12
            { id: 14, name: '同城活动-顶部轮播BANNER' }, //13
            { id: 15, name: '赛事-线上赛事顶部轮播BANNER' }, //14
            { id: 16, name: '赛事-骑行赛事顶部轮播BANNER' }, //15
            { id: 17, name: '赛事-线下赛事顶部轮播BANNER' }, //16
            { id: 18, name: '俱乐部-加入后页面BANNER' }, //17
            { id: 19, name: '赛事-赛事照片顶部轮播BANNER' }, //18
            { id: 20, name: '装备测评-顶部轮播BANNER' }, //19
            { id: 21, name: '赛事首页-弹层广告' }, //20
            { id: 22, name: '电商-首页顶部轮播BANNER' }, //21
            { id: 23, name: '电商-首页中部轮播BANNER' }, //22
            { id: 24, name: '直播活动BANNER' }, //23
            { id: 25, name: '个人直播BANNER' }, //24
            { id: 26, name: '我的-底部广告' }, //25
            { id: 27, name: '动态-FEED流-3号位' }, //26  5号位广告 映射为27号广告位
            { id: 28, name: '乐活动-图文链接广告' }, //27
            { id: 29, name: '发现团页面-顶部轮播BANNER' }, //28
            { id: 30, name: '开始运动-后置语音广告' }, //29
            { id: 31, name: '电商-装备资讯页banner' }, //30
            { id: 32, name: '电商首页-弹层广告' }, //31
            { id: 33, name: '计步页-图文链接广告' }, //32 图文链接
            { id: 34, name: '运动首页-背景换肤广告' }, //33 背景换肤
            { id: 35, name: '运动记录页-运动结束图片广告' }, //34 运动记录页
            { id: 36, name: '添加跑鞋页-智能设备广告' }, //35 banner
            { id: 37, name: '训练计划-图文冠名广告' }, //36 训练计划列表广告
            { id: 38, name: '运动结束页-智能设备广告' }, //37 banner
            { id: 39, name: '发现团页面-新版顶部轮播BANNER' }, //38 banner
            { id: 40, name: '单车页-共享单车轮播BANNER' }, //39 banner
            { id: 41, name: '运动日历页-智能装备广告' }, //40 图文链接
            { id: 42, name: '赛事-跑步顶部轮播BANNER' }, //41 banner
            { id: 43, name: '赛事-铁人三项顶部轮播BANNER' }, //42 banner
            { id: 44, name: '赛事-系列赛顶部轮播BANNER' }, //43 banner
            { id: 45, name: '赛事-趣味赛顶部轮播BANNER' }, //44 banner
            { id: 46, name: '运动首页-智能装备广告' }, //45 图文链接
            { id: 47, name: '跑场首页-活动入口广告' }, //46 图文链接
            { id: 49, name: '文章详情-图文链接广告' }, //47 图文链接
            { id: 50, name: '训练课程详情-图文链接广告' }, //48 图文链接
            { id: 51, name: '训练计划-BANNER' }, //50 banner
            { id: 52, name: '小视频TAB页6号位-图文链接广告' }, //51 图文链接
            { id: 53, name: '热门精选-图文链接广告' }, //52 图文链接
            { id: 54, name: '运动首页新用户-弹层广告' }, //53 弹层广告
            { id: 55, name: '动态-新FEED流-11号位' }, //54
            { id: 56, name: '训练计划-视频广告' }, //55 训练计划
            { id: 57, name: '记录身体数据-文字链广告' }, //56 图文链接
            { id: 58, name: '小程序-不跑就出局BANNER' }, //57 banner
            { id: 64, name: '站外浮层-图文链接广告' }, //58 站外浮层-图文链接广告
            { id: 70, name: '发现页三宫格卡片-图文链接广告' }, //59 发现页三宫格-图文链接广告
        ]

        // { id: 1, name: '乐活动-运动竞技' },
        // { id: 2, name: '乐活动-任务打卡' },
        // { id: 3, name: '乐活动-运动累计' },
        // { id: 4, name: '乐活动-综合活动' },
        // { id: 5, name: '乐活动-精选活动' },
        // { id: 6, name: '精选页' },
        // { id: 7, name: '动态页' },
        // { id: 8, name: '话题页' },
        // { id: 9, name: '专栏页' },
        // { id: 10, name: '讨论页' },
        // { id: 11, name: '新媒体' },
        var SOFTADPOSITION = [
          { id: 1, parent:1, name: '运动竞技-列表list置顶位' ,index:[1,2,3,4]},
          { id: 2, parent:2, name: '任务打卡-列表list置顶位',index:[1,2,3,4] },
          { id: 3, parent:3, name: '运动累计-列表list置顶位',index:[1,2,3,4] },
          { id: 4, parent:4, name: '综合活动-列表list置顶位',index:[1,2,3,4] },
          { id: 5, parent:5, name: '精选出品-列表list置顶位',index:[1,2,3,4,5,6] },
          { id: 6, parent:6, name: '活动置顶-列表list置顶位',index:[1,2,3,4,5,6] },
        //   { id: 7, parent:7, name: '精选页-卡片BANNRE(推荐活动)' ,index:[1,2]},
        //   { id: 8, parent:7, name: '精选页-精选话题卡片' ,index:[1,2]},
          { id: 9, parent:7, name: '精选页-讨论专区卡片' ,index:[1,2]},
          { id: 10, parent:8, name: '动态页-官方活动FEED',index:[1,2,3,4] },
          { id: 11, parent:9, name: '话题页-话题置顶(6)',index:[1,2] },
          { id: 12, parent:9, name: '话题页-话题置顶(11)' ,index:[1,2]},
          { id: 13, parent:9, name: '话题页-话题置顶(12)',index:[1,2] },
          { id: 14, parent:10, name: '专栏页-顶部轮播图(2)',index:[1,2] },
          { id: 15, parent:11, name: '讨论页-列表置顶位' ,index:[1,2,3,4]},
          { id: 16, parent:12, name: '新媒体-咕咚网官方微博',index:[1,2,3] },
          { id: 17, parent:12, name: '新媒体-官方微信订阅号',index:[1] },
          { id: 18, parent:12, name: '新媒体-官方微信服务号' ,index:[1,2]},
          { id: 23, parent:13, name: '发现页-精选活动',index:[1,2] }, //
          { id: 24, parent:14, name: '搜索框-热门搜索',index:[1,2,3] },
          { id: 25, parent:14, name: '搜索框-热门内容',index:[1] },
        ]

        this.getPositionLength = function() {
            return ADPOSITION.length;
        }

        this.getPurposeItems = function() {
            return PURPOSE_A;
        }

        this.getPurposeItemsById = function(id) {
            return PURPOSE_A.filter(function(item) {
                return item.id == id;
            });;
        }

        /**
         * 负责人
         */
        var PRINCIPALS = [
            { id: 1, name: '商务组-吴婉莹', positions: [1,2,3,4,27,6,10,28,29,30,33,34,35,37,39,49,50,53,55,56] },
            { id: 2, name: '社区组-张大峰', positions: [8] },
            { id: 3, name: '内容组-严子辛', positions: [9] },
            { id: 5, name: '运营-张晨晨', positions: [19] },
            { id: 5, name: '社区-李霞', positions: [20] },
            { id: 6, name: '市场-唐琴', positions: [21, 11, 15, 16, 17, 42, 43, 44, 45] },
            { id: 7, name: '市场-饶志琦', positions: [12,14] },
            { id: 8, name: '企业咕咚-程灵', positions: [13, 18] },
            { id: 9, name: '电商组-齐巍', positions: [22, 23, 32, 46] },
            { id: 10, name: '内容组-唐舒颖', positions: [24, 25] },
            { id: 11, name: '渠道-王硕', positions: [26] },
            { id: 12, name: '电商组-王晓楠', positions: [31] },
            { id: 13, name: '产品组-郑鑫', positions: [36, 38, 51, 54] },
            { id: 14, name: '运营组-杨洁', positions: [40] },
            { id: 15, name: '产品组-李立刚', positions: [41, 52] },
            { id: 16, name: '运营组-曾媛媛', positions: [47] },
            { id: 17, name: '市场部-赵振宇', positions: [48] },
            { id: 18, name: '产品组-钟欣', positions: [58,64,70] },
            { id: 18, name: '产品组-赵仁康', positions: [57] },
        ]

        this.getPrincipalByPostionId = function(id) {
            for (var i = PRINCIPALS.length - 1; i >= 0; i--) {
                if (PRINCIPALS[i].positions.indexOf(id) >= 0) {
                    return PRINCIPALS[i].name;
                }
            }
        }

        this.getAdInfo = function() {
            return {
                1:['开屏页广告','开屏页广告','开屏页广告'],
                2:['运动首页-链接广告','图文链接广告','图文链接广告'],
                3:['运动首页-弹层广告','弹层广告','弹层广告'],
                4:['运动记录页-BUTTON广告','运动记录页','运动记录页'],
                5:['动态-FEED流-3号位(旧废弃)','信息流FEED广告','信息流FEED广告'],
                6:['动态-FEED流-6号位','信息流FEED广告','信息流FEED广告'],
                7:['咕咚吧-精选-FEED流-图片广告(4号位)','信息流FEED广告','信息流FEED广告'],
                8:['运动圈精选首页-顶部轮播BANNER','轮播图BANNER广告','轮播图BANNER广告'],
                9:['专栏-顶部轮播BANNER','轮播图BANNER广告','轮播图BANNER广告'],
                10:['乐活动-顶部轮播BANNER','轮播图BANNER广告','轮播图BANNER广告'],
                11:['官方赛事-顶部轮播BANNER','轮播图BANNER广告','轮播图BANNER广告'],
                12:['运动场地-顶部轮播BANNER','轮播图BANNER广告','轮播图BANNER广告'],
                13:['俱乐部-加入前页面BANNER','轮播图BANNER广告','轮播图BANNER广告'],
                14:['同城活动-顶部轮播BANNER','轮播图BANNER广告','轮播图BANNER广告'],
                15:['赛事-线上赛事顶部轮播BANNER','轮播图BANNER广告','轮播图BANNER广告'],
                16:['赛事-骑行赛事顶部轮播BANNER','轮播图BANNER广告','轮播图BANNER广告'],
                17:['赛事-线下赛事顶部轮播BANNER','轮播图BANNER广告','轮播图BANNER广告'],
                18:['俱乐部-加入后页面BANNER','轮播图BANNER广告','轮播图BANNER广告'],
                19:['赛事-赛事照片顶部轮播BANNER','轮播图BANNER广告','轮播图BANNER广告'],
                20:['装备测评-顶部轮播BANNER','轮播图BANNER广告','轮播图BANNER广告'],
                21:['赛事首页-弹层广告','弹层广告','弹层广告'],
                22:['电商-首页顶部轮播BANNER','轮播图BANNER广告','轮播图BANNER广告'],
                23:['电商-首页中部轮播BANNER','轮播图BANNER广告','轮播图BANNER广告'],
                24:['直播活动BANNER','轮播图BANNER广告','轮播图BANNER广告'],
                25:['个人直播BANNER','轮播图BANNER广告','轮播图BANNER广告'],
                26:['我的-底部广告','其它广告','其它广告'],
                27:['动态-FEED流-3号位','信息流FEED广告','信息流FEED广告'],
                28:['乐活动-图文链接广告','图文链接广告','图文链接广告'],
                29:['发现团页面-顶部轮播BANNER','轮播图BANNER广告','轮播图BANNER广告'],
                30:['开始运动-后置语音广告','语音播报广告','语音播报广告'],
                31:['电商-装备资讯页BANNER','轮播图BANNER广告','轮播图BANNER广告'],
                32:['电商首页-弹层广告','弹层广告','弹层广告'],
                33:['计步页-图文链接广告','图文链接广告','图文链接广告'],
                34:['运动首页-背景换肤广告','背景换肤广告','背景换肤广告'],
                35:['运动记录页-运动结束图片广告','运动记录页','运动记录页'],
                36:['添加跑鞋页-智能设备广告','轮播图BANNER广告','轮播图BANNER广告'],
                37:['训练计划-图文冠名广告','训练计划列表广告','训练计划列表广告'],
                38:['运动结束页-智能设备广告','轮播图BANNER广告','轮播图BANNER广告'],
                39:['发现团页面-新版顶部轮播BANNER','轮播图BANNER广告','轮播图BANNER广告'],
                40:['单车页-共享单车轮播BANNER','轮播图BANNER广告','轮播图BANNER广告'],
                41:['运动日历页-智能装备广告','图文链接广告','图文链接广告'],
                42:['赛事-跑步顶部轮播BANNER','轮播图BANNER广告','轮播图BANNER广告'],
                43:['赛事-铁人三项顶部轮播BANNER','轮播图BANNER广告','轮播图BANNER广告'],
                44:['赛事-系列赛顶部轮播BANNER','轮播图BANNER广告','轮播图BANNER广告'],
                45:['赛事-趣味赛顶部轮播BANNER','轮播图BANNER广告','轮播图BANNER广告'],
                46:['运动首页-智能装备广告','运动首页','图文链接广告'],
                47:['跑场首页-活动入口广告','跑场','图文链接广告'],
                49:['文章详情-图文链接广告','文章','图文链接广告'],
                50:['训练课程详情-图文链接广告','训练计划','图文链接广告'],
                51:['训练计划-BANNER','训练计划','轮播图BANNER广告'],
                52:['小视频-TAB页6号位','小视频','图文链接广告'],
                53:['热门精选-图文链接广告','运动圈广场','图文链接广告'],
                54:['运动首页新用户-弹层广告','运动首页','弹层广告'],
                55:['动态-新FEED流-11号位','运动圈FEED','信息流FEED广告'],
                56:['训练计划-视频广告','训练计划','视频广告'],
                57:['记录身体数据-文字链广告','运动记录页','运动记录页'],
                58:['小程序-不跑就出局BANNER','小程序','轮播图BANNER广告'],
                59:['站外浮层广告','其它','图文链接广告'],
                70:['发现页三宫格卡片','发现页面','图文链接广告'],
            }
        }

        this.getSoftAdInfo = function() {
            return {
                '1-1':['运动竞技','运动竞技-列表list置顶位'],
                '2-2':['任务打卡','任务打卡-列表list置顶位'],
                '3-3':['运动累计','运动累计-列表list置顶位'],
                '4-4':['综合活动','综合活动-列表list置顶位'],
                '5-5':['精选出品','精选出品-列表list置顶位'],
                '6-6':['精选活动','精选活动-列表list置顶位'],
                '7-7':['精选页','精选页-卡片BANNRE(推荐活动)'],
                '7-8':['精选页','精选页-精选话题卡片'],
                '7-9':['精选页','精选页-讨论专区卡片'],
                '8-10':['动态页','动态页-官方活动FEED'],
                '9-11':['话题页','话题页-话题置顶(6)'],
                '9-12':['话题页','话题页-话题置顶(11)'],
                '9-13':['话题页','话题页-话题置顶(12)'],
                '10-14':['专栏页','专栏页-顶部轮播图(2)'],
                '11-15':['讨论页','讨论页-列表置顶位'],
                '12-16':['新媒体','新媒体-咕咚网官方微博'],
                '12-17':['新媒体','新媒体-官方微信订阅号'],
                '12-18':['新媒体','新媒体-官方微信服务号'],
                '14-23':['搜索框','搜索框-热门搜索'],
                '14-24':['搜索框','搜索框-热门内容'],
            }
        }

        this.getAdType = function() {
            return ADTYPE;
        }

        this.getAdPosition = function() {
            return ADPOSITION;
        }

        this.getAllSoftAdPosition = function(module_id) {
            return SOFTADPOSITION;
        }

        this.getSoftAdPosition = function(module_id) {
            return SOFTADPOSITION.filter(function(item){
              return item.parent == module_id;
            });
        }

        this.getAdPostionOptionByModuleIdInSearch = function(id) {
            var arr = [];
            switch (id) {
                case 1: //Loading页
                    return [{ id: 1, name: '开屏页广告' }];
                    break;
                case 2: //运动首页
                    arr.push({ id: 2, name: '运动首页-链接广告' });
                    arr.push({ id: 3, name: '运动首页-弹层广告' });
                    // arr.push({ id: 30, name: '开始运动-后置语音广告' }); // 取消分众占位 售卖只能邮件打申请
                    arr.push({ id: 33, name: '计步页-图文链接广告' });
                    arr.push({ id: 34, name: '运动首页-背景换肤广告' });
                    arr.push({ id: 46, name: '运动首页-智能装备广告' });
                    return arr;
                    break;
                case 3: //运动记录页
                    arr.push({ id: 4, name: '运动记录页-BUTTON广告' });
                    arr.push({ id: 35, name: '运动记录-运动结束图片广告' });
                    arr.push({ id: 38, name: '运动结束页-智能设备广告' });
                    arr.push({ id: 57, name: '记录身体数据-文字链广告' });
                    return arr;
                    break;
                case 4: //运动圈FEED
                    arr.push({ id: 27, name: '动态-FEED流-3号位' });
                    arr.push({ id: 6, name: '动态-FEED流-6号位' });
                    arr.push({ id: 55, name: '动态-新FEED流-11号位' });
                    return arr;
                case 5: //咕咚吧精选
                    // arr.push({ id: 7, name: '咕咚吧-精选-FEED流-图片广告' });
                    arr.push({ id: 9, name: '专栏-顶部轮播BANNER' });
                    return arr;
                    break;
                case 6: //运动圈广场
                    arr.push({ id: 8, name: '运动圈/热门-顶部轮播BANNER' });
                    arr.push({ id: 53, name: '热门精选-图文链接广告' });
                    return arr;
                    break;
                case 7: //乐活动
                    arr.push({ id: 10, name: '乐活动-顶部轮播BANNER' });
                    arr.push({ id: 28, name: '乐活动-图文链接广告' });
                    return arr;
                    break;
                case 8: //官方赛事
                    arr.push({ id: 21, name: '赛事首页-弹层广告' });
                    arr.push({ id: 11, name: '官方赛事-顶部轮播BANNER' });
                    arr.push({ id: 15, name: '赛事-线上赛事顶部轮播BANNER' });
                    arr.push({ id: 16, name: '赛事-骑行赛事顶部轮播BANNER' });
                    arr.push({ id: 17, name: '赛事-线下赛事顶部轮播BANNER' });
                    arr.push({ id: 19, name: '赛事-赛事照片顶部轮播BANNER' });
                    arr.push({ id: 42, name: '赛事-跑步顶部轮播BANNER' });
                    arr.push({ id: 43, name: '赛事-铁人三项顶部轮播BANNER' });
                    arr.push({ id: 44, name: '赛事-系列赛顶部轮播BANNER' });
                    arr.push({ id: 45, name: '赛事-趣味赛顶部轮播BANNER' });
                    return arr;
                    break;
                case 9: //运动场地
                    return [{ id: 12, name: '运动场地-顶部轮播BANNER' }];
                    break;
                case 12: //同城活动
                    return [{ id: 14, name: '同城活动-顶部轮播BANNER' }];
                    break;
                case 13: //装备测评
                    return [{ id: 20, name: '装备测评-顶部轮播BANNER' }];
                    break;
                case 14: //电商
                    arr.push({ id: 22, name: '电商-首页顶部轮播BANNER' });
                    arr.push({ id: 23, name: '电商-首页中部轮播BANNER' });
                    arr.push({ id: 31, name: '电商-装备资讯页banner' });
                    arr.push({ id: 32, name: '电商-首页弹层广告' });
                    return arr;
                    break;
                case 10: //俱乐部
                    arr.push({ id: 13, name: '加入俱乐部前页面BANNER' });
                    arr.push({ id: 18, name: '加入俱乐部后页面BANNER' });
                    return arr;
                    break;
                case 15: //直播
                    arr.push({ id: 24, name: '直播活动BANNER' });
                    arr.push({ id: 25, name: '个人直播BANNER' });
                    return arr;
                    break;
                case 16: //我的
                    arr.push({ id: 26, name: '我的-底部广告' });
                    return arr;
                    break;
                case 17: //团
                    arr.push({ id: 29, name: '发现团页面-顶部轮播BANNER' });
                    arr.push({ id: 39, name: '发现团页面-新版顶部轮播BANNER' });
                    return arr;
                    break;
                case 18: //添加跑鞋
                    arr.push({ id: 36, name: '添加跑鞋页-智能设备广告' });
                    return arr;
                    break;
                case 19: //训练计划
                    arr.push({ id: 37, name: '训练计划-图文冠名广告' });
                    arr.push({ id: 50, name: '训练课程详情-图文链接广告' });
                    arr.push({ id: 51, name: '训练计划-BANNER' });
                    arr.push({ id: 56, name: '训练计划-视频广告' });
                    return arr;
                    break;
                case 20: //单车页
                    arr.push({ id: 40, name: '单车页-共享单车轮播BANNER' });
                    return arr;
                    break;
                case 21: //运动日历页
                    arr.push({ id: 41, name: '运动日历页-智能装备广告 ' });
                    return arr;
                    break;
                case 22: //跑场
                    arr.push({ id: 47, name: '跑场首页-活动入口广告' });
                    return arr;
                    break;
                case 24: //文章
                    arr.push({ id: 49, name: '文章详情-图文链接广告' });
                    return arr;
                    break;
                case 27: //其它
                    arr.push({ id: 64, name: '站外浮层-图文链接广告' });
                    return arr;
                    break;
                case 28: //发现页面
                    arr.push({ id: 70, name: '发现页三宫格卡片-图文链接广告' });
                    return arr;
                    break;
            }
        };

        this.getAdModules = function() {
            // 废弃运动场地
            return ADMODULE.filter(function(item){
              return item.id != 9;
            });
        }

        this.getSoftAdModules = function() {
            // 软广模块
            return [
            //   { id: 1, name: '运动竞技' },
            //   { id: 2, name: '任务打卡' },
            //   { id: 3, name: '运动累计' },
            //   { id: 4, name: '更多活动' },
            //   { id: 5, name: '咕咚出品' },
              { id: 6, name: '活动置顶' },
              { id: 7, name: '精选页' },
              { id: 8, name: '动态页' },
              { id: 9, name: '话题页' },
            //   { id: 10, name: '专栏页' },
            //   { id: 11, name: '讨论页' },
              { id: 12, name: '新媒体' },
              { id: 13, name: '发现页' },
              { id: 14, name: '搜索框' },
            ]
        }

        /**
         * 获取新建广告防冲突机制
         * @return array
         */
        this.getConflictInfo = function(adTypeId) {
            switch (adTypeId) {
                case 0:
                    return { position: ADTYPE[0].name, num: 1 };
                    break;
                case 1:
                    return { position: ADTYPE[1].name, num: 3 };
                    break;
                case 2:
                    return { position: ADTYPE[2].name, num: '3(乐活动文字链接、计步页、运动日历页、智能装备1条)' };
                    break;
                case 3:
                    return { position: ADTYPE[3].name, num: '3(赛事,电商弹层1条)' };
                    break;
                case 4:
                    return { position: ADTYPE[4].name, num: 1 };
                    break;
                case 5:
                    return { position: ADTYPE[5].name, num: 3 };
                    break;
                case 6:
                    return { position: ADTYPE[6].name, num: 1 };
                    break;
                case 7:
                    return { position: ADTYPE[7].name, num: 1 };
                    break;
            }
        }

    }
})();

/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('CodoonUserAdmin.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function (value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function () {
                return progress;
            },
            open: function() {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/progressModal/progressModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            }
        };
    }

})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    /**
     * 去重数组
     * @param  {[type]} arr [description]
     * @return {[type]}     [description]
     */
    this.unique = function(arr) {
      var result = [],
            hash = {};
      for (var i = 0, elem;(elem = arr[i]) != null; i++) {
          if (!hash[elem.id]) {
              result.push(elem);
              hash[elem.id] = true;
          }
      }
      return result;
    }

    // this.isDescendant = function(parent, child) {
    //   var node = child.parentNode;
    //   while (node != null) {
    //     if (node == parent) {
    //       return true;
    //     }
    //     node = node.parentNode;
    //   }
    //   return false;
    // };
    //
    // this.hexToRGB = function(hex, alpha) {
    //   var r = parseInt( hex.slice(1,3), 16 );
    //   var g = parseInt( hex.slice(3,5), 16 );
    //   var b = parseInt( hex.slice(5,7), 16 );
    //   return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    // };

    this.hasAttr = function (elem, attrName) {
      var attr = $(elem).attr(attrName);
      return (typeof attr !== typeof undefined && attr !== false);
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();

/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      }
    }
  }

})();

/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();

/**
 * @author liuyz
 * created on 2017-3-22
 */

(function () {
  'use strict';

  angular.module('CodoonUserAdmin.pages.advert')
    .controller('activityListCtrl', activityListCtrl)
    .controller('ActivityModalCtrl', ActivityModalCtrl);

  /** @ngInject */
  function activityListCtrl($uibModal, toastrService, adminApi, cacheService) {

    var vm = this;
    
    var user = cacheService.getUser();

    vm.pagenum = 1;
    vm.pagesize = 10;

    vm.page = function(page) {
      adminApi.activity.get_city_actives_all({
        user_id: user.id,
        pagenum: page || vm.pagenum,
        pagesize: vm.pagesize,
        creator_name: user.nick,
      })
      .then(function (res) {
        console.log(res)
        vm.list = res.city_actives_list;
        vm.total = res.record_count;
      }).catch(function (err) {
        console.log(err)
      })
    }

    vm.page(1);

    vm.notify = function (item) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/activity/list/notify-modal.html',
        controller: 'ActivityModalCtrl',
        resolve: {
          data: function() {
            return item;
          }
        },
        controllerAs: 'vm'
      }).result.then(function (val) {

      })
    }

  }

  function ActivityModalCtrl($uibModalInstance, toastrService, adminApi, cacheService, data) {
    var vm = this;

    var user = cacheService.getUser();

    vm.confirm = function () {
      if (vm.title && vm.content) {
        adminApi.activity.active_notice_modify({
          user_id: user.id,
          active_id: data.active_id,
          title: vm.title,
          content: vm.content,
        })
        .then(function (res) {
          toastrService.openToast('success', '上传更新成功');
          $uibModalInstance.close(true);
        }).catch(function (err) {
          console.log(err)
        })
      } else {
        toastrService.openToast('error', '输入通知内容');
      }
    }
  }

})();

/**
 * @author liusy
 * created on 2018-06-11
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.pages.activity')
    .controller('AddInfoModalCtrl', AddInfoModalCtrl)

  /** @ngInject */
  function AddInfoModalCtrl($scope, $uibModalInstance, $timeout, toastrService, adBootstrap, adminApi, cacheService) {
    var vm = this;
    vm.form = {
      value: 'other_user_info'
    }
    vm.save = function () {
      $uibModalInstance.close(vm.form);
    }
  }

})();

/**
 * @author liusy
 * created on 2018-06-11
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.pages.activity')
    .controller('addTypeModalCtrl', addTypeModalCtrl)

  /** @ngInject */
  function addTypeModalCtrl($scope, $uibModalInstance, $timeout, toastrService, adBootstrap, adminApi, cacheService, data) {
    var vm = this;
    vm.active_type_list = data.active_type_list;
    vm.curType = data.active_type || {};

    vm.chooseType = function (item) {
      vm.curType = item;
    }
    vm.save = function() {
      if (vm.curType) {
        $uibModalInstance.close(vm.curType);
      } else {
        toastrService.openToast('info', '请选择活动类型');
      }
    }
  }

})();

/**
 * @author liusy
 * created on 2018-06-11
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.pages.activity')
    .controller('activityPublishCtrl', activityPublishCtrl)

  /** @ngInject */
  function activityPublishCtrl($scope, $stateParams, $rootScope, $uibModal, $timeout, $location, toastrService, adBootstrap, adminApi, userApi, cacheService, editService, activityBootstrap, FileUploader) {
    var vm = this;
    var user_info_fields = angular.copy(activityBootstrap.EXAMINE_INFO);
    vm.custom_info_field_count = 0;
    vm.user_info_fields = user_info_fields;

    vm.step = 0;
    vm.sign_type = 1;
    vm.form = {
      refund_type: 1,
      pay_type: 0,
      need_group_member: 1,
      is_need_approval: 0,
      is_sign_with_location: 1,
      st_time: initPublishTime(3),
      et_time: initPublishTime(10),
      from_type: 2
    };
    vm.join_type = 0;
    vm.userGroups = [];

    createEditor();
    getUserGroups();

    var query = $stateParams.id;
    if (query) {
      var arr = query.split('-');
      var type = arr[0], active_id = arr[1];
      active_id && getActiveID();
      vm.type = type;
      vm.active_id = active_id;
    } else {
      vm.showCitySelect = true;
      getActiveTypes();
    }

    function createEditor() {
      var editor = new wangEditor('arcEditor');
      vm.editor = editor;
      editService.createImgUploadMenu(editor);
      editor.config.menus = ['bold', 'self_img_upload', 'fontsize', 'forecolor'];
      editor.create();
    }

    function getActiveID() {
      adminApi.activity.getActiveID({
        active_id: active_id
      }).then(function (data) {
        vm.form = angular.extend({}, vm.form, data);
        vm.editor.$txt.html(vm.form.details);
        dealActiveData(data);
        getActiveTypes();
      })
    }

    function dealActiveData(data) {
      vm.form.st_time = new Date(vm.form.st_time);
      vm.form.et_time = new Date(vm.form.et_time);
      vm.form.deadline = new Date(vm.form.deadline);
      vm.form.alter_city_code = data.city_code;
      vm.form.city_name = data.city_name;
      loopUserInfoFields(data);

      if (vm.form.pay_type==1) {
        vm.form.pay_fee = vm.form.pay_fee/100;
      }
      if (vm.form.join_num) vm.join_type = 1;
      if (vm.form.deadline.getTime() == vm.form.st_time.getTime()) {
        vm.sign_type = 1;
      } else {  
        vm.sign_type = 2;
      }
      vm.showCitySelect = true;
    }

    function loopUserInfoFields(data) {
      try {
        var checkInfo = JSON.parse(data.user_info_fields);
        for (var key in checkInfo) {
          checkUserInfo(key, checkInfo[key]);
        }
      } catch (err) {
        console.log(err);
      }
      if (data.user_info_fields == '{}') {
        vm.form.is_need_approval = 0;
      } else {
        vm.form.is_need_approval = 1;
      }
    }

    function initPublishTime(hours) {
      var date = new Date();
      date.setHours(date.getHours()+hours);
      return date;
    }

    function checkUserInfo(key, value) {
      var empty = true;
      vm.user_info_fields.map(function (item, index) {
        if (item.value == key) {
          item.checked = true;
          empty = false;
        }
      });
      if (empty) {
        vm.user_info_fields.push({name: value, value: key, checked: true});
      }
    }

    vm.handleActiveCityChange = function (city) {
      vm.form.alter_city_code = city;
    }

    userApi.watchImg($scope, 'vm.img', 2, function (file, url) {
      $rootScope.ajaxLoading = true;
      previewImg(file, url);
    });

    function previewImg(file, url) {
      var img = new Image();
      img.onload = function () {
        if (img.width < 300 || img.height < 400) {
          $rootScope.ajaxLoading = false;
          toastrService.openToast('info', '海报尺寸要≥300*400px')
        } else {
          userApi.openUploadImg(file, function (data, file) {
            $rootScope.ajaxLoading = false;
            vm.form.placard = data.ref;
          })
        }
      }
      img.src = url;
    }

    vm.saveFristStep = function () {
      var html = vm.editor.$txt.html();
      var startHtml = '<html><head><meta charset="UTF-8"></head><body>';
      var endHtml = '</body></html>';

      vm.form.details = startHtml+html+endHtml;
      if (!vm.form.placard) {
        return toastrService.openToast('info', '请上传活动海报图');
      }
      if (!vm.form.name) {
        return toastrService.openToast('info', '请填写活动名称');
      }
      if (html == '<p><br></p>') {
        return toastrService.openToast('info', '请填写活动详情');
      }
      vm.step = vm.step + 1;
      return true;
    }

    vm.openTypeModal = function () {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/activity/modal/add-type.html',
        controller: 'addTypeModalCtrl',
        controllerAs: 'vm',
        resolve: {
          data: {
            active_type_list: vm.active_type_list || [],
            active_type: vm.active_type
          },
        }
      }).result.then(function (res) {
        vm.active_type = res;
        vm.form.tp_id = res.id;
      })
    }

    function getActiveTypes() {
      adminApi.activity.getActiveTypes({
        page_num: 1,
        page_size: 100
      }).then(function (data) {
        vm.active_type_list = data.active_type_list;
        vm.active_type_list.forEach(function (item) {
          if (vm.form.tp_id == item.id) {
            vm.active_type = item;
          }
        })
      });
    }

    vm.saveSecondStep = function (invalid) {
      if (invalid) return;
      var prev = new Date();
      prev.setHours(prev.getHours() + 2);
      if (!vm.active_type) {
        return toastrService.openToast('info', '请添加活动类型');
      }
      if ((vm.form.st_time.getTime() < prev.getTime()) && type != 'edit') {
        return toastrService.openToast('info', '活动开始时间要在当前时间的两小时之后');
      }
      if (vm.form.st_time.getTime() >= vm.form.et_time.getTime()) {
        return toastrService.openToast('info', '活动结束时间要晚于活动开始时间');
      }
      if (vm.sign_type == 2 && vm.form.deadline.getTime() <= (new Date()).getTime()) {
        return toastrService.openToast('info', '截止时间应该晚于当前时间');
      }
      if (vm.sign_type == 2 && vm.form.deadline.getTime() > vm.form.et_time.getTime()) {
        return toastrService.openToast('info', '截止时间应该早于结束时间');
      }
      if (typeof vm.form.is_sign_with_location == "undefined") {
        return toastrService.openToast('info', '请选择签到条件');
      }
      vm.step = vm.step + 1;
      getUserGroups();
      return true;
    }

    vm.openInfoModal = function () {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/activity/modal/add-info.html',
        controller: 'AddInfoModalCtrl',
        controllerAs: 'vm'
      }).result.then(function (form) {
        vm.user_info_fields.push(angular.extend(form, {
          value: form.value + vm.custom_info_field_count
        }));
        vm.custom_info_field_count = vm.custom_info_field_count + 1;
      })
    }


    function getUserGroups() {
      adminApi.activity.getUserGroups({
        type: 3,
        user_id: 'b85cc4ee-2b33-4474-9182-6a1f33413e48'
      }).then(function (data) {
        vm.userGroups = data;
        vm.userGroups.unshift({ name: '无', id: '' });
        vm.group = vm.userGroups[0];
        vm.userGroups.forEach(function (item) {
          if (item.member_type == 2 || item.member_type == 1) {
            vm.is_header = true;
          }
        })
      })
    }

    vm.createCityActive = function (invalid) {
      if (invalid) return;
      var checkValid = vm.saveFristStep() && vm.saveSecondStep() && checkLastStep();
      if (!checkValid) return;
      var postFunc = type == 'edit' ? adminApi.activity.updateCityActive : adminApi.activity.createCityActive;
      postFunc(getCreateParams()).then(function (response) {
        if (response.status == 'OK') {
          toastrService.openToast('success', '发布成功, 可在“我的活动”中查看');
          $location.path('/activity/list');
        } else {
          // toastrService.openToast('info', response.description);
        }
      })
    }

    function checkLastStep() {
      var reg = /^[1-9]\d*$/;
      if (vm.form.pay_type == 1 && !reg.test(vm.form.pay_fee)) {
        toastrService.openToast('info', '请检查活动费用');
        return false;
      }
      if (vm.join_type == 1 && !reg.test(vm.form.join_num)) {
        toastrService.openToast('info', '请填写活动正整数');
        return false;
      }
      if (vm.form.is_need_approval == 1) {
        var user_info_fields = getUserInfoFields();
        if (!user_info_fields.length) {
          toastrService.openToast('info', '请至少添加一个审核选项');
          return false;
        }
      }
      return true;
    }

    function getUserInfoFields() {
      var user_info_fields = [];
      for (var i = 0; i < vm.user_info_fields.length; i++) {
        if (vm.user_info_fields[i].checked) {
          user_info_fields.push(vm.user_info_fields[i]);
        }
      }
      return user_info_fields;
    }

    function mapUserInfoFields() {
      var user_info_fields = getUserInfoFields();
      var user_info_obj = {};
      user_info_fields.forEach(function (item) {
        user_info_obj[item.value] = item.name;
      });
      return JSON.stringify(user_info_obj);
    }

    function getCreateParams() {
      var params = angular.copy(vm.form);

      params.group_id = vm.group.id;
      params.join_num = vm.join_type == 1 ? parseInt(vm.form.join_num) : 0;
      params.pay_type = parseInt(vm.form.pay_type);
      if (params.pay_type == 1) {
        params.pay_fee = parseFloat(vm.form.pay_fee) * 100;
      }
      params.user_info_fields = vm.form.is_need_approval == 1 ? mapUserInfoFields() : {};
      params.st_time = moment(vm.form.st_time).format('YYYY-MM-DD HH:mm');
      params.et_time = moment(vm.form.et_time).format('YYYY-MM-DD HH:mm');
      params.is_sign_with_location = parseInt(vm.form.is_sign_with_location);
      params.is_need_approval = parseInt(vm.form.is_need_approval); 

      if (vm.sign_type == 1) {
        params.deadline = params.st_time;
      } else {
        params.deadline = moment(vm.form.deadline).format('YYYY-MM-DD HH:mm');
      }
      if (type == 'edit') {
        params.active_id = Number(active_id);
      }
      params.city = params.alter_city_code;
      params.from_type = 2;
      return params;
    }

  }

})();

/**
 * @author lj
 */
(function() {
  "use strict";

  angular
    .module("CodoonUserAdmin.pages.training")
    .controller("raceliveListPageCtrl", raceliveListPageCtrl);

  /** @ngInject */
  function raceliveListPageCtrl($scope, cacheService, $state, $stateParams, adminApi, toastrService) {
    var vm = this;
    vm.raceData = null; // 赛事数据
    vm.raceRankData = null; // 实时赛事排行榜
    vm.kolRankData = null; // kol
    vm.raceDataInfo = null;
    vm.timer_str = ''; // 倒计时
    vm.race_enter_len = ''; // 入场时长 20分钟
    vm.race_pk_len = ''; // 比赛时长 20小时
    vm.race_timer_inter = null;
    vm.race_id = $state.params.race_id;
    vm.group_id = '';
    vm.group_name = '';
    vm.race_data_timer = null;  
    vm.race_timer = null;  
    vm.kol_timer = null; 
    vm.timer_str_day = false;
    vm.isShowStar = false; // 是否是主播
    vm.genderArr = [{gender_name: '全部', id: -1}, {gender_name: '男', id: 1}, {gender_name: '女', id: 0}]
    vm.genderArr1 = [{gender_name: '男', id: 1}, {gender_name: '女', id: 0}]
    vm.gender_name = '全部';
    vm.gender_id = -1;
    vm.lenArr = [{len_name: '里程排名', id: 1}, {len_name: '配速排名', id: 0}]
    vm.len_name = '里程排名'
    vm.sort_type = 1;
    vm.gender_name_rank = '男';
    vm.gender_name_rank_id = 1;
    vm.group_rank_id = '';
    vm.group_name_rank = '';
    vm.group_id_statistic = '';
    vm.group_name_statistic = '';
    vm.group_statistic = []; // 组别
    vm.historyScoreData = {};
    vm.userAreaData = {};
    vm.raceRankComData = {}; // 完赛榜单
    vm.color1 = ['#FA6666', '#F98A4F', '#F8AF43', '#F4D529', '#E254B1', '#D454C9']
    vm.color2 = ['#7265E6', '#4DBCF7']

    if(!vm.race_id) {
      return toastrService.openToast('error','race_id为空~');
    }

    init();

    function init() {
      getRaceDataInfo();  // 赛事基本信息
      getRaceKolRankData(); // kol排行榜
      getHistoryScore(); // 获取最好成绩
      getEcheatsData(); // 获取图表数据
    }


    // 获取赛事基本信息
    function getRaceDataInfo() {
      adminApi.racelive
      .get_real_time_backend({match_id: vm.race_id})
      .then(function(res) {
        if(res) {

          if(res.race_group_info) {
            vm.group_statistic = res.race_group_info;
            if (!vm.group_id) {
              vm.group_id = res.race_group_info[0].group_id;
              vm.group_name = res.race_group_info[0].group_name;
              vm.group_rank_id = vm.group_id;
              vm.group_name_rank = vm.group_name;
              vm.group_id_statistic = vm.group_id;
              vm.group_name_statistic = vm.group_name;
            }
          
            // 获取实时赛事榜单
            getRaceRankData();
            // 获取完赛榜单
            getRaceComRankData();
            // 获取赛事分段统计相关数据
            getRaceData(); 
          }

          res.race_starts = res.race_start.replace(/-/g, '.').substring(0, res.race_start.length-3);
          res.race_ends = res.race_end.replace(/-/g, '.').substring(0, res.race_end.length-3);
          vm.raceDataInfo = res;

          // 计算入场时长 分钟
          vm.race_enter_len = countTime(res.enter_time, res.race_start, 'race_enter_len');
          // 比赛总时长
          vm.race_pk_len = countTime(res.race_start, res.race_end, 'race_pk_len');

          if (res.race_state == 0 && !vm.race_data_timer) {
            // 计算 入场时间 == 今天时间 ->距离入场时间xx天   else 距离入场时间 : :
            var days = Math.floor(Math.abs(Date.parse(new Date()) - Date.parse(res.enter_time)) / (24 * 3600 * 1000));

            if(days > 0) {
              vm.timer_str = days;
              vm.timer_str_day = true;
            } else {
              vm.timer_str_day = false;
              // 赛事还未开始 赛事入场时间 - 当前时间 距离入场时间xxx
              vm.race_timer_inter = setInterval(function(){ 
                countTime(new Date(), res.enter_time)
              }, 1000);
            }
          } else if (res.race_state == 3 && !vm.race_data_timer) {
            // 赛事入场中  赛事开始时间 - 当前时间  距离开始xxx
            vm.race_timer_inter = setInterval(function(){ 
              countTime(new Date(), res.race_start)
            }, 1000);
          } else if (res.race_state == 1 && !vm.race_data_timer) {
            // 进行中  当前时间 - 赛事开始时间 赛事已进行xx
            vm.race_timer_inter = setInterval(function(){ 
              countTime(res.race_start, new Date())
            }, 1000);
          } else if (res.race_state == 2) {
            // 已结束
            countTime(res.race_start, res.race_end)
          }

          if (res.interval && !vm.race_data_timer) {
            vm.race_data_timer = setInterval(function() {
              getRaceDataInfo();
            }, res.interval*1000)
          }
        }
      })
      .catch(function(err_res) {
        console.log(err_res);
      })
    }


    // 获取赛事分段统计相关数据
    function getRaceData() {
      adminApi.racelive
      .get_race_statistic({
        race_id: vm.race_id,
        group_id: vm.group_id_statistic
      })
      .then(function(res) {
        vm.raceData = res;

        if(res && res.frequence && !vm.race_timer) {
          vm.race_timer = setInterval(function() {
            getRaceData();
          }, res.frequence*1000)
        } 
      })
      .catch(function(err_res) {
        console.log(err_res);
      })
    }

    // 获取实时赛事榜单
    function getRaceRankData() {
      adminApi.racelive
      .race_live_rank({
        race_id: vm.race_id,
        group_id: vm.group_id,
        gender: vm.gender_id, // -1全部，0女，1男
        sort_type: vm.sort_type, // 0配速，1里程
      })
      .then(function(res) {
        if(res && res.user_list) {
          res.user_list.forEach(function(item) {
            item.avg_pace = calculateAveragePace(item.avg_pace);
          })
        }

        vm.raceRankData = res;
      })
      .catch(function(err_res) {
        console.log(err_res);
      })
    }

    // 获取完赛榜单
    function getRaceComRankData() {
      adminApi.racelive
      .get_match_rank_page({
        id: Number(vm.race_id),
        groupid: vm.group_rank_id,
        gender: vm.gender_name_rank_id, // -1全部，0女，1男
        page: 1,
        count: 20,
      })
      .then(function(res) {
        vm.raceRankComData = res;
      })
    }

    // 获取kol的数据
    function getRaceKolRankData() {
      adminApi.racelive
      .get_race_kol_rank({
        race_id: vm.race_id
      }).then(function(res) {
        if(res && res.list) {
          res.list.forEach(function(item) {
            item.avg_pace = calculateAveragePace(item.avg_pace);
          })
        }

        vm.kolRankData = res;

        if (res.frequence && !vm.kol_timer) {
          vm.kol_timer = setInterval(function() {
            getRaceKolRankData();
          }, res.frequence*1000)
        }
      })
      .catch(function(err_res) {
        console.log(err_res);
      })
    }

    function getHistoryScore() {
      adminApi.racelive
      .get_history_score({})
      .then(function(res) {
        vm.historyScoreData = res;
      })
    }

    // 绘制图表的配置项和数据
    function getEcheatsData() {
      adminApi.racelive
      .get_user_area_gender({
        match_id: vm.race_id
      })
      .then(function(res) {
        vm.userAreaData = res;
        if (res && res.area_info) {
          var data = [];
          res.area_info.forEach(function(item, index) {
            data.push({
              value: item.ratio, 
              name: item.province,
              itemStyle: {
                color: vm.color1[index],
                opacity: 0.98
              }
            })
          })

          console.log('data1:', data)

          var option = {
            title: {
              text: '',
              left: 'center'
            },
            tooltip: {
              trigger: 'item',
              formatter: '{a} <br/>{b}: {c} ({d}%)'
            },
            legend: {
                left: 'center',
                top: 'bottom',
                data: res.area_info.map(function(item) {
                  return item.province
                })
            },
            series: [
                {
                    name: '地域分布',
                    type: 'pie',
                    radius: ['45%', '80%'],
                    avoidLabelOverlap: false,
                    label: {
                      position: 'inner',
                      formatter: '{d}%',
                      fontFamily: 'VeneerCleanSoft',
                      fontSize: 13
                    },
                    data: data
                }
            ]
          };
          
          console.log('data1:', option)
          var myChart = echarts.init(document.querySelector('.echarts_l'));
          myChart.setOption(option);
        }
        console.log('data2:', res.gender_info)
        if (res && res.gender_info) {
          var option = {
            title: {
              text: '',
              left: 'center'
            },
            tooltip: {
              trigger: 'item',
              formatter: '{a} <br/>{b}: {c} ({d}%)'
            },
            legend: {
                left: 'center',
                top: 'bottom',
                data: ['男', '女']
            },
            series: [
                {
                    name: '性别分布',
                    type: 'pie',
                    radius: ['45%', '80%'],
                    avoidLabelOverlap: false,
                    label: {
                      position: 'inner',
                      formatter: '{d}%',
                      fontFamily: 'VeneerCleanSoft',
                      fontSize: 13
                    },
                    data: [
                      {
                        value: vm.userAreaData.gender_info.male, 
                        name: '男',
                        itemStyle: {
                          color: vm.color2[0],
                          opacity: 0.98
                        }
                      },
                      {
                        value: vm.userAreaData.gender_info.female, 
                        name: '女',
                        itemStyle: {
                          color: vm.color2[1],
                          opacity: 0.98
                        }
                      }
                    ]
                }
            ]
          };
          
          var myChartr = echarts.init(document.querySelector('.echarts_r'));
          myChartr.setOption(option);
        }
      })         
    }

    // 记录配速
    function calculateAveragePace(average_pace) {
      if(average_pace) {
        var minutes = Math.floor(average_pace/60);
        var seconds = Math.floor((average_pace-minutes*60));
        return minutes+"'" + seconds + "''";
      }
      return "0'00''"
    }

    // 距离开始 - 倒计时计算
    function countTime(strStart, strEnd, type) {
      if(typeof strStart == 'string') {
        strStart = strStart.replace(/-/g, '/'); // 处理ios兼容
      }
      if(typeof strEnd == 'string') {
        strEnd = strEnd.replace(/-/g, '/'); // 处理ios兼容
      } 

      var startDate = new Date(strStart); // 传入倒计时开始时间
      var start = startDate.getTime();

      var endDate = new Date(strEnd); // 结束时间
      var end = endDate.getTime();

      var leftTime = (end - start)/1000; // 时间差 秒

      if (type == 'race_enter_len') {
        return parseInt(leftTime/60, 10); // 分钟
      }

      if (type == 'race_pk_len') {
        return parseInt(leftTime/60/60, 10); // 小时
      }
      
      var h=0,m=0,s=0;

      if (leftTime > 0) {
        h = checkTime(Math.floor(leftTime/60/60));
        m = checkTime(Math.floor((leftTime % 3600) / 60));
        s = checkTime(Math.floor(leftTime % 60));
      }

      vm.timer_str = h + ":" + m + ":" + s;

      ($scope && $scope.$$phase || $scope.$root && $scope.$root.$$phase) ? '' : $scope.$apply();

      if((end - start) < 0) {
        // 倒计时结束
        vm.race_timer_inter && clearInterval(vm.race_timer_inter);
        // 强制刷新页面
        window.location.reload();
      }
    }

    function checkTime(i) {
      return i < 10 ? '0'+i : i;
    }

    // 切换赛事进行中
    vm.checkGroup = function(item, type) {
      if (type == 1) {
        // 切换男女
        vm.gender_name = item.gender_name;
        vm.gender_id = item.id;
      }

      // 切换组别
      if (type == 2) {
        vm.group_id = item.group_id;
        vm.group_name = item.group_name;
      }

      // 切换里程排名
      if (type == 3) {
        vm.len_name = item.len_name;
        vm.sort_type = item.id;
      }

      getRaceRankData();
    }

    // 切换赛事完赛 
    vm.checkGroupAct = function(item, type) {
      if (type == 1) {
        // 切换男女
        vm.gender_name_rank = item.gender_name;
        vm.gender_name_rank_id = item.id;
      }

      // 切换组别
      if (type == 2) {
        vm.group_rank_id = item.group_id;
        vm.group_name_rank = item.group_name;
      }

      getRaceComRankData();
    }

    // 切换分段统计
    vm.checkGroupStatistic = function(item) {
      console.log(item)
      vm.group_name_statistic = item.group_name;
      vm.group_id_statistic = item.group_id;

      getRaceComRankData();
    }

    vm.addKol = function() {
      if (!vm.kol_id) {
        return toastrService.openToast('error','请输入用户ID~');
      }

      adminApi.racelive
      .add_race_kol({
        race_id: vm.race_id,
        add_user_id: vm.kol_id
      })
      .then(function(res) {
        if (res) {
          getRaceKolRankData();
          toastrService.openToast('success','添加KOL成功~');
        }
      })
      .catch(function(err_res) {
        console.log(err_res);
      })
    };

  }
})();

/**
 * @author lj
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.pages.training')
    .controller('racelivePageCtrl', racelivePageCtrl);

  /** @ngInject */
  function racelivePageCtrl($scope, $state, cacheService,adminApi,toastrService) {
    var vm = this

    getRaceList();

    function getRaceList() {
      adminApi.racelive
      .get_real_time_live({})
      .then(function(res) {
        $scope.options = res;
        $scope.options.unshift({id: -1, match_name: '请选择实时赛事'});
        $scope.option = $scope.options[0]
      })
      .catch(function(err_res) {
        console.log(err_res);
      })
    }

    $scope.submit = function() {
      console.log($scope.option.id);
      if ($scope.option.id == -1) {
        return toastrService.openToast('info',  '请选择实时赛事~')
      }

      $state.go("racelive.list", { race_id: $scope.option.id });

      setTimeout(function() {
        window.location.reload()
      }, 20);
    }
  }
})();

/**
 * @author liujuan
 * created on 2017-2-22
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.pages.publish.picture')
    .controller('picturePageCtrl', picturePageCtrl);

  /** @ngInject */
  function picturePageCtrl($scope,userApi,adminApi,toastrService) {

    $scope.valueLength = 0;       // 监听字数

    // 话题组件可以继承父级的这些scope
    $scope.label_id = 0;
    $scope.checkTitle = "";
    $scope.titleTips = [];   
    $scope.title = "";

    $scope.isStausFb = false;     // 发布按钮状态
    $scope.titleArr = "";         // 创建话题
    $scope.basic = angular.extend({cert_icon: []});  // 上传的封面图

    //监听输入内容多少
    $scope.changeCon = function (value) {
      $scope.valueLength = value.length;    // 监听字数

      if($scope.valueLength > 1000) {
        toastrService.clearToasts();
        return toastrService.openToast('error', '已超过字数限制~');
      }
    }

    //图片删除
    $scope.delIcon = function (index) {
      $scope.basic.cert_icon.splice(index, 1);
    }


    //监听上传图片
    var unWatchImg = userApi.watchImg($scope, 'picture.img', 5, function (file) {

      if ($scope.basic.cert_icon.length >= 9) {
        return toastrService.openToast('error', '最多上传9张');
      }

      userApi.openUploadImg(file, function (data) {

        $scope.basic.cert_icon.push(data);

      })

    });

    //发布提交整个表单
    $scope.save = function () {

      var cert_icon =  $scope.basic.cert_icon,
        content = userApi.trim($scope.content) || "";

      if(cert_icon.length < 1) {
        toastrService.clearToasts();
        return toastrService.openToast('error', '必填项不能为空~');
      }

      var pic = [];
      for(var i=0;i<cert_icon.length;i++) {
        pic.push({'url': cert_icon[i].ref, 'size': cert_icon[i].size, 'pic_type':0});  // 封面图
      }

      var data = {
        'pics':pic,
        'label_id':$scope.label_id,
        'source_type':0,
        'content':content
      }

      if($scope.label_id == undefined) {
        data.label_id = 0;
      }

      adminApi.publishList.create_feed_upload(data)
        .then(function (response) {
          console.log(response);
          if(response && response.feed_id != "") {

            toastrService.openToast('success','发布成功');

            $scope.basic.cert_icon = [];
            $scope.content = "";
            $scope.valueLength = 0;
            $scope.label_id = 0;
            $scope.checkTitle = "";
            $scope.titleArr = "";
            $scope.title = "";
            $scope.titleTips = [];
            return;

          }
          toastrService.openToast('error', '发布失败，请检查发布内容！');
        }).catch(function (err_res) {
          console.log(err_res)
          toastrService.openToast('error', err_res);
      })
    }


    //发布按钮高亮
    $scope.$watch('basic.cert_icon',function () {

      if($scope.basic.cert_icon.length > 0) {
        $scope.isStausFb = true;
      }else {
        $scope.isStausFb = false;
      }

    },true)
  }
})();

(function () {
  'use strict';

  angular.module('CodoonUserAdmin.pages.publish.article')
    .controller('articlePageCtrl', articlePageCtrl);

  /** @ngInject */
  function articlePageCtrl($scope, userApi, $http, $stateParams, toastrService, adminApi, $uibModal) {

    var vm = this;
    var editor = new wangEditor('arcEditor');
    var article_id = $stateParams.id;
    vm.content = '';

    vm.article_name = '';
    vm.article_id = article_id;
    vm.article_id && getCheckStatus();

    //初始化页面标识
    $scope._titleTips = false;
    $scope.despTips = false;
    $scope.uploadimgTipsFr1 = false;
    $scope.uploadimgTipsSc2 = false;
    $scope.uploadimgTipsFr1Hover = false;
    $scope.uploadimgTipsSc2Hover = false;

    // 话题组件可以继承父级的这些scope
    $scope.label_id = 0;
    $scope.checkTitle = "";
    $scope.titleTips = [];
    $scope.title = "";

    //初始化是否成功的上传封面图
    $scope.upimg1_isUp = false;
    $scope.upimg2_isUp = false


    //监听封面图1
    userApi.watchImg($scope, 'cover_url_model.img', 5, function (file, url) {
      previewImg(url, {width: 720, height: 288}, function() {
        userApi.openUploadImg(file, function (data, file) {
          $scope.upimg1_isUp = true;
          $scope.cover_url = data.ref;
          $scope.cover_size = data.size;
        });
      });
    })

    //监听封面图2
    userApi.watchImg($scope, 'square_url_model.img', 5, function (file, url) {
      previewImg(url, {width: 640, height: 640}, function() {
        userApi.openUploadImg(file, function (data, file) {
          $scope.upimg2_isUp = true;
          $scope.square_url = data.ref;
          $scope.square_size = data.size;
        });
      });
    });

    function previewImg(url, size, callback) {
      var img = new Image();
      img.onload = function() {
        if (img.width == size.width && img.height == size.height) {
          callback && callback();
        } else {
          toastrService.openToast('info', '图片尺寸必须是'+size.width+'*'+size.height);
        }
      }
      img.src = url;
    }
    

    // 获取文章详情
    function getCheckStatus() {
      adminApi.publishList.get_check_status({
        old_id: [Number(vm.article_id)]
      }).then(function (data) {
        var obj = data[0].data;
        console.log(obj);
        vm.article_name = obj.article_name;
        vm.digest = obj.digest;
        $scope.square_url = obj.square_url;
        $scope.cover_url = obj.cover_url;
        if (obj.square_url) {
          $scope.upimg2_isUp = true;
        }
        if (obj.cover_url) {
          $scope.upimg1_isUp = true;
        }
        getArticleContent(obj);
      })
    }

    // 获取文章内容
    function getArticleContent(obj) {
      $http.get(obj.content_url, {
        headers: {'Content-Type': 'text/html; charset=utf-8'}
      }).then(function (response) {
        if (response.status == 200) {
          editor.$txt.html(response.data);
        }
      }).catch(function (err) {
        console.log(JSON.stringify(err));
      })
    }


    vm.getContentAndPre = function ($event) {
      vm.content = editor.$txt.html();
      // $('.zw').html(vm.content)

      $uibModal.open({
        templateUrl: 'app/pages/publish/article/modal/preview.html',
        controller: 'previewCtrl',
        controllerAs: 'preview',
        size: 'custom',
        animation: true,
        resolve: {
          data: function () {
            return {
              title: vm.article_name,
              content: vm.content,
            };
          }
        },
      }).result.then(function (data) {
        //
      })
    }

    //提交
    vm.uploadContent = function () {
      var obj = {
        article_name: vm.article_name,
        digest: vm.digest,
        cover_url: $scope.cover_url,
        cover_size: $scope.cover_size,
        square_url: $scope.square_url,
        is_feed: vm.is_feed,
        square_size: $scope.square_size,
        content: editor.$txt.html(),
        label_id: $scope.label_id,
      }
      var postFunc = adminApi.publishList.create_article;


      if (!obj.article_name) {
        toastrService.openToast('error', '请输入标题');
        return;
      }

      if (!obj.digest) {
        toastrService.openToast('error', '请输入摘要');
        return;
      }

      if (editor.$txt.html() == '<p><br></p>') {
        toastrService.openToast('error', '请输入正文');
        return;
      }

      if (!obj.cover_url) {
        toastrService.openToast('error', '请上传封面图');
        return;
      }

      if (!obj.square_url) {
        toastrService.openToast('error', '请上传方图');
        return;
      }
      if (vm.article_id) {
        obj.old_id = Number(vm.article_id);
        postFunc = adminApi.publishList.modify_article;
      }

      postFunc(obj).then(function () {
        toastrService.openToast('success', '发布成功');
        vm.article_name = '';
        vm.digest = '';
        $scope.cover_url = '';
        $scope.square_url = '';
        editor.$txt.html('');
        $scope.label_id = 0;
        $scope.checkTitle = "";
        $scope.titleArr = "";
        $scope.title = "";
        $scope.titleTips = [];
        $scope.upimg1_isUp = false;
        $scope.upimg2_isUp = false

      }).catch(function (err_res) {
        console.log(err_res)
        toastrService.openToast('error', err_res);
      })
    }


    //为编辑器添加插件
    wangEditor.createMenu(function (check) {
      var menuId = 'self_img_upload';
      if (!check(menuId)) {
        return;
      }

      var editor = this;

      var menu = new wangEditor.Menu({
        editor: editor,  // 编辑器对象
        id: menuId,  // 菜单id
        title: '上传图片', // 菜单标题

        // 正常状态和选中状态下的dom对象，样式需要自定义
        $domNormal: $('<a href="#" tabindex="-1"><i class="wangeditor-menu-img-picture"></i></a>'),
        $domSelected: $('<a href="#" tabindex="-1" class="selected"><i class="wangeditor-menu-img-picture"></i></a>')
      });

      // 定义click事件
      menu.clickEvent = function (e) {
        var rangeElem = editor.getRangeElem();
        var $rangeElem;
        if (!rangeElem) {
          e.preventDefault();
          return;
        }

        $uibModal.open({
          templateUrl: 'app/pages/publish/article/modal/img.html',
          controller: 'uploadImgModalCtrl',
          controllerAs: 'uploadImg',
          animation: true,
        }).result.then(function (data) {
          if (data) {
            var img = data.img,
              urlHref = data.href || "javascript:void(0)";
            var img = "<img src='" + img + "'/>";
            //sel.collapseToEnd();
            //document.execCommand('insertHTML', true, div)
            editor.command(e, 'insertHtml', img);
          }
        })
        // 执行自定义命令
        // editor.customCommand(e, commandFn, callback);
      };

      //增加到editor对象中
      editor.menus[menuId] = menu;
    });
    wangEditor.createMenu(function (check) {
      var menuId = 'self_vedio_upload';
      if (!check(menuId)) {
        return;
      }

      var editor = this;

      var menu = new wangEditor.Menu({
        editor: editor,  // 编辑器对象
        id: menuId,  // 菜单id
        title: '上传视频', // 菜单标题

        // 正常状态和选中状态下的dom对象，样式需要自定义
        $domNormal: $('<a href="#" tabindex="-1"><i class="wangeditor-menu-img-video-camera"></i></a>'),
        $domSelected: $('<a href="#" tabindex="-1" class="selected"><i class="wangeditor-menu-img-video-camera"></i></a>')
      });

      // 定义click事件
      menu.clickEvent = function (e) {
        var rangeElem = editor.getRangeElem();
        var $rangeElem;
        if (!rangeElem) {
          e.preventDefault();
          return;
        }
        $uibModal.open({
          templateUrl: 'app/pages/publish/article/modal/vedio.html',
          controller: 'videoUploadCtrl',
          controllerAs: 'videoUpload',
          animation: true,
        }).result.then(function (data) {
          if (data) {
            var videoUrl = data.src,
              imgUrl = data.img,
              video = "<div class='zy_media'><video src=' " + videoUrl + "' poster ='" + imgUrl + "' preload='none' style='width:100%'><source src='" + videoUrl + "' type='video/mp4'></source></video></div><div>&nbsp;</div>";
            editor.command(e, 'insertHtml', video);
          }
        })
        // 执行自定义命令
        // editor.customCommand(e, commandFn, callback);
      };

      //增加到editor对象中
      editor.menus[menuId] = menu;
    })
    wangEditor.createMenu(function (check) {
      var menuId = 'self_gif_upload';
      if (!check(menuId)) {
        return;
      }

      var editor = this;

      var menu = new wangEditor.Menu({
        editor: editor,  // 编辑器对象
        id: menuId,  // 菜单id
        title: '上传GIF动图', // 菜单标题

        // 正常状态和选中状态下的dom对象，样式需要自定义
        $domNormal: $('<a href="#" tabindex="-1"><i class="">GIF</i></a>'),
        $domSelected: $('<a href="#" tabindex="-1"><i class="">GIF</i></a>'),
      });

      // 定义click事件
      menu.clickEvent = function (e) {
        var rangeElem = editor.getRangeElem();
        var $rangeElem;
        if (!rangeElem) {
          e.preventDefault();
          return;
        }
        $uibModal.open({
          templateUrl: 'app/pages/publish/article/modal/gif.html',
          controller: 'gifUploadCtrl',
          controllerAs: 'gifUpload',
          animation: true,
        }).result.then(function (data) {
          if (data) {
            var gif = '';
            if (data.fm_src) {
              gif = '<a style="display: block;width: 100%;" href="' + data.gif_src + '"><img style="display: block;width: 100%;" src="' + data.fm_src + '!640m0"></a>'
            } else {
              gif = '<a style="display: block;width: 100%;" href="' + data.gif_src + '"><img style="display: block;width: 100%;" src="' + data.gif_src + '!640m0"></a>'
            }
            editor.command(e, 'insertHtml', gif);
          }
        })
        // 执行自定义命令
        // editor.customCommand(e, commandFn, callback);
      };

      //增加到editor对象中
      editor.menus[menuId] = menu;
    })
    editor.config.menus = [
      'bold',
      'underline',
      'italic',
      'source',
      // 'unorderlist',
      // 'orderlist',
      'eraser',
      'quote',
      'self_img_upload',
      'fontsize',
      'forecolor',
      //'self_gif_upload',
      'self_vedio_upload',
      'undo',
      'redo',
    ];

    editor.create();

  }

})();

/**
 * @author liujuan
 * created on 2017-2-22
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.pages.publish.video')
    .controller('videoPageCtrl', videoPageCtrl);

  /** @ngInject */
  function videoPageCtrl($scope,userApi,adminApi, toastrService) {

    $scope.valueLength = 0;      // 监听字数
    $scope.isStausFb = false;    // 发布按钮状态
    $scope.video_url = '';       // 视频地址
    $scope.video_size = 0;       // 视频大小
    $scope.content = "";
    $scope.basic = angular.extend({cert_icon: []});   // 上传的封面图

    // 话题组件可以继承父级的这些scope
    $scope.label_id = 0;
    $scope.checkTitle = "";
    $scope.titleTips = [];
    $scope.title = "";

    //监听输入内容多少
    $scope.changeCon = function (value) {
      $scope.valueLength = value.length;    // 监听字数

      if($scope.valueLength > 1000) {
        toastrService.clearToasts();
        return toastrService.openToast('error', '已超过字数限制~');
      }
    }


    //监听上传视频
    var unWatchFileMp4 = userApi.watchFileMp4($scope, 'video.mp4', 35,function (resonse) {

      if (!resonse.key){
        toastrService.clearToasts();
        toastrService.openToast('error',resonse.erro)
        return;
      }

      var video_url = "https://image7s.codoon.com/" + resonse.key;

      $scope.video_url = video_url;
      $scope.video_size = resonse.size;

      $scope.$apply();
    });


    //监听上传图片
    var unWatchImg = userApi.watchImg($scope, 'video.img', 5, function (file) {

      userApi.openUploadImg(file,function (data) {

        $scope.basic.cert_icon = [];
        $scope.basic.cert_icon.push(data);
      })
    });


    //发布提交整个表单
    $scope.save = function () {

      var cert_icon =  $scope.basic.cert_icon,
          content = userApi.trim($scope.content) || "",
          label_id = $scope.label_id;

      if($scope.video_url == '' || cert_icon.length <= 0 ) {
        toastrService.clearToasts();
        return toastrService.openToast('error', '必填项不能为空~');
      }

      var pic = [];
      pic.push({'url': cert_icon[0].ref, 'size': cert_icon[0].size, 'pic_type':0});  // 封面图
      pic.push({'url':$scope.video_url, 'size': $scope.video_size.toString(), 'pic_type':3});

      var data = {
        'pics':pic,
        'label_id':label_id,
        'source_type':3,
        'content':content
      }

      if(label_id == undefined) {
        data.label_id = 0;
      }

      adminApi.publishList.create_feed_upload(data)
        .then(function (response) {
          console.log(response);

          if(response && response.feed_id != "") {

            toastrService.openToast('success','发布成功');

            $scope.basic.cert_icon = [];
            $scope.content = "";
            $scope.valueLength = 0;
            $scope.label_id = 0;
            $scope.checkTitle = "";
            $scope.titleArr = "";
            $scope.title = "";
            $scope.titleTips = [];
            $scope.video_url = "";
            $scope.video_size = 0;
            return;

          }
          toastrService.openToast('error', '发布失败，请检查发布内容！');
        }).catch(function (err_res) {
          console.log(err_res)
          toastrService.openToast('error', err_res);
      })
    }

    //发布按钮高亮
    $scope.$watch('basic.cert_icon + video_url',function () {

      if($scope.basic.cert_icon.length > 0 && $scope.video_url != '') {
        $scope.isStausFb = true;
      }else {
        $scope.isStausFb = false;
      }

    },true)

  }
})();

/**
 * @author lyz
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.pages.training')
    .controller('trainingPageCtrl', trainingPageCtrl);

  /** @ngInject */
  function trainingPageCtrl($scope,cacheService,adminApi,toastrService) {

    var user = cacheService.getUser();

    var clipboard = new Clipboard('.copyId');
    var clipboardH5 = new Clipboard('.copyH5');

    clipboard.on('success', function(e) {
      toastrService.openToast('success','复制成功~');
      e.clearSelection();
    });
    clipboardH5.on('success', function(e) {
      toastrService.openToast('success','复制成功~');
      e.clearSelection();
    });

    clipboard.on('error', function(e) {
      toastrService.clearToasts();
      toastrService.openToast('error',  '复制失败~')
    });
    clipboardH5.on('error', function(e) {
      toastrService.clearToasts();
      toastrService.openToast('error',  '复制失败~')
    });

    adminApi.training.get_my_class({})
    .then(function (res) {
      res = res.filter(function(i) {
        if (new Date() < new Date(i.date + ' ' + i.session) || i.status == 0 || i.status == 1) {
          return i
        }
      }).map(function(i) {
        i._name = i.date + ' ' + i.session + ' ' + i.name
        return i
      })
      $scope.options = res
      $scope.options.unshift({id: -1, _name: '请选择课程'});
      $scope.option = $scope.options[0]
    }).catch(function (err_res) {
      console.log(err_res)
    })

    $scope.submit = function() {

      if ($scope.option.id == -1) {
        return toastrService.openToast('info',  '请选择课程~')
      }

      adminApi.training.create_live({
        user_id: user.id,
        session_id: $scope.option.session_id,
        class_id: $scope.option.id,
      })
      .then(function (res) {
        console.log(res)
        //推流地址拼接：<hosts.publish.key>://<hosts.publish.val>/<hub>/<title>?key=<publishKey>
        //hosts.publish.key: 协议类型，目前只支持rtmp
        //hosts.publish.val: 推流地址域名，如pili-publish.codoon-live-ta.codoon.com
        //hub: 推流服务分类，目前为codoon-live-ta
        //Title: 流ID，根据具体值填写
        //publishKey: 认证key，根据具体字段填写
        
        //示例：
        //rtmp://pili-publish.codoon-live-ta.codoon.com/codoon-live-ta/5b63f39da3d5ec73d201807f?key=40dc6c39bd8c8a0f

        $scope.live_link = 'rtmp://' + res.push_stream.hosts.publish.rtmp + '/' +
        res.push_stream.hub + '/' + res.push_stream.title + '?key=' + res.push_stream.publishKey
        $scope.res = res

        $scope.h5_link = 'https://www.codoon.com/h5/live-train/index.html?class_id=' + $scope.option.id + '&room_id=' + res.room_id + '&session_id=' + $scope.option.session_id;

      }).catch(function (err_res) {
        console.log(err_res)
      })
    }

  }
})();

/**
 * @author lyz
 */
(function () {
  "use strict";

  angular
    .module("CodoonUserAdmin.pages.training")
    .controller("trainingListPageCtrl", trainingListPageCtrl);

  /** @ngInject */
  function trainingListPageCtrl($scope, cacheService, adminApi, toastrService) {
    var vm = this;
    vm.page = 1;

    adminApi.training
      .get_my_class({})
      .then(function (res) {
        // res = res.map(function(i) {
        //   if (new Date(i.date + ' ' + i.session) > new Date()) {
        //     i.status = 1
        //   } else {
        //     i.status = 2
        //   }
        //   return i
        // })
        console.log(res);
        vm.list = res;
      })
      .catch(function (err_res) {
        console.log(err_res);
      });

    function getDetail(c) {
      adminApi.training
        .get_schedule_detail({
          class_id: c.id || 13,
          session_id: c.session_id || 37,
        })
        .then(function (res) {
          console.log(res);
          vm.detail = res;
        })
        .catch(function (err_res) {
          console.log(err_res);
        });
    }

    // getDetail({})

    function getUser(c) {
      adminApi.training
        .get_subscribe_user({
          class_id: vm.c.id || 13,
          session_id: vm.c.session_id || 37,
        })
        .then(function (res) {
          console.log(res);
          vm.user_list = res.user_list;
        })
        .catch(function (err_res) {
          console.log(err_res);
        });
    }
    vm.click = function (c) {
      vm.page = 2;
      vm.c = c;
      getDetail(c);
      // 拉取用户的直播状态
      getLiveInfo(c);
    };

    vm.students = function () {
      vm.page = 3;
      getUser({});
    };

    // 开始直播
    vm.startLive = function () {
      if (!vm.isLoginWs) {
        return alert("您还未登录或登录未成功,请稍等或者刷新重试");
      }
      if (
        vm.training_state.live_status === 1 &&
        vm.training_state.live_status !== 2
      ) {
        return alert("你已经开始直播啦~");
      }

      var liveType = "live_start";
      var conText = "确定要开始直播吗？";
      var con = confirm(conText);

      if (!con) return;

      var obj = {
        ver: vm.newWs.ver,
        op: vm.newWs.UploadType,
        seq: 10,
        business: 1, // 需求：https://www.tapd.cn/20041161/prong/stories/view/1120041161001042686
        body: {
          service: "videolive", // 固定值
          class_id: vm.c.session_id,
          // "session_id": this.session_id,
          type: liveType,
          room_id: vm.c.roomId, // 房间ID
          sender: {},
        },
      };

      // 改用http接口
      // var sendData = JSON.stringify(obj)
      // vm.newWs.ws.send(sendData)
      var url = "start_video";
      adminApi.training[url]({
        room_id: vm.c.roomId,
        msg: obj.body,
      }).then(function (res) {
        // 修改状态
        vm.training_state.isStartLive = true;
        getLiveInfo(vm.c);
        getBtnStatus();
      });
    };
    // 结束直播
    vm.endLive = function () {
      if (!vm.isLoginWs) {
        return alert("您还未登录或登录未成功,请稍等或者刷新重试");
      }

      var liveType = "live_ended";
      var conText = "确定要结束直播吗";
      var con = confirm(conText);

      if (!con) return;

      var obj = {
        ver: vm.newWs.ver,
        op: vm.newWs.UploadType,
        seq: 10,
        business: 1, // 需求：https://www.tapd.cn/20041161/prong/stories/view/1120041161001042686
        body: {
          service: "videolive", // 固定值
          class_id: vm.c.session_id,
          // "session_id": this.session_id,
          type: liveType,
          room_id: vm.c.roomId, // 房间ID
          sender: {},
        },
      };

      // 改用http接口
      // var sendData = JSON.stringify(obj)
      // vm.newWs.ws.send(sendData)
      var url = "end_video";
      adminApi.training[url]({
        room_id: vm.c.roomId,
        msg: obj.body,
      }).then(function (res) {
        // 修改状态
        vm.training_state.isStartLive = false;
        getLiveInfo(vm.c);
        getBtnStatus();
      });
    };

    // 开始课程
    vm.startClass = function () {
      if (
        vm.training_state.isStartClass === 1 &&
        vm.training_state.isStartClass !== 2
      ) {
        return alert("你已经开始课程啦~");
      }
      var class_id = vm.c.id;
      var session_id = vm.c.session_id;
      // 给一个提示
      var con = confirm("确定开始课程吗？");

      if (!con) return;

      adminApi.training
        .start_class({
          class_id: class_id,
          session_id: session_id,
        })
        .then(function (res) {
          console.log("开始课程");
          getLiveInfo(vm.c);
          getBtnStatus();
          vm.training_state.isStartClass = 1;
        });
    };
    // 结束课程
    vm.closeClass = function () {
      if (vm.training_state.isStartClass !== 1) {
        return alert("课程已经结束");
      }

      var class_id = vm.c.id;
      var session_id = vm.c.session_id;

      // 给一个提示
      var con = confirm("确定结束课程吗？");
      if (!con) return;

      adminApi.training
        .end_class({
          class_id: class_id,
          session_id: session_id,
        })
        .then(function (res) {
          console.log("结束课程");
          getLiveInfo(vm.c);
          getBtnStatus();
          vm.training_state.isStartClass = 2;
        });
    };

    // 记录的登陆状态
    vm.isLoginWs = false;

    // 拉取用户的直播状态
    function getLiveInfo(c) {
      adminApi.training
        .get_live_info({
          class_id: c.id || 13,
          session_id: c.session_id || 37,
        })
        .then(function (res) {
          vm.c.roomId = res.room_id;
          if (res.live_status === 0) {
            res.isStartLive = false;
          } else {
            res.isStartLive = true;
          }
          res.isStartClass = res.class_status;
          vm.training_state = res;
          // 赋值给vm的原因是在其他地方会使用，目前不支持es6，所以只能在回调里面
          vm.newWs = new wsService(res);
          vm.newWs.createWebSocket();
          vm.btnClass = {
            startLive: "current",
            startClass: "next",
            closeClass: "next",
            endLive: "next",
          };
          vm.btnDisabled = {
            startLive: false,
            startClass: true,
            closeClass: true,
            endLive: true,
          };
          getBtnStatus();
        });
    }
    // 判断按钮class
    function getBtnStatus() {
      var liveStatus = vm.training_state.live_status;
      var classStatus = vm.training_state.class_status;
      if (liveStatus === 0) {
        vm.btnClass.startLive = "current";
        vm.btnDisabled.startLive = false;
      } else {
        vm.btnClass.startLive = "pre";
        vm.btnDisabled.startLive = true;
      }

      if (liveStatus === 1) {
        if (classStatus === 0) {
          vm.btnClass.startClass = "current";
          vm.btnClass.closeClass = "next";
          vm.btnClass.endLive = "next";

          vm.btnDisabled.startClass = false;
          vm.btnDisabled.closeClass = true;
          vm.btnDisabled.endLive = true;
        } else if (classStatus === 1) {
          vm.btnClass.startClass = "pre";
          vm.btnClass.closeClass = "current";
          vm.btnClass.endLive = "next";

          vm.btnDisabled.startClass = true;
          vm.btnDisabled.closeClass = false;
          vm.btnDisabled.endLive = true;
        } else if (classStatus === 2) {
          vm.btnClass.startClass = "pre";
          vm.btnClass.closeClass = "pre";
          vm.btnClass.endLive = "current";

          vm.btnDisabled.startClass = true;
          vm.btnDisabled.closeClass = true;
          vm.btnDisabled.endLive = false;
        }
      } else {
      }
    }
    function wsService(res) {
      /*
       * 这里是关于ws的设置
       */
      this.ws;
      //避免重复连接
      this.lockReconnect = false;
      this.wsUrl = res.im.ws_uri;
      this.userId = res.host_info.user_id;
      this.roomId = vm.c.roomId;
      this.session_id = vm.c.session_id;
      // 默认版本号
      this.ver = 1;
      // 认证指令
      this.op = 7;
      // 这个是咕咚设定的登陆成功返回的值
      this.AuthCallbckType = 8;
      // 正常上传指令
      this.UploadType = 4;

      var url = window.location.href;
      if (location.protocol === "https:") {
        this.wsUrl = res.im.wss_uri;
      }
    }

    wsService.prototype.createWebSocket = function () {
      try {
        this.ws = new WebSocket(this.wsUrl);
        window.ws = this.ws;
        this.initEventHandle(this.ws);
      } catch (e) {
        this.reconnect(this.wsUrl);
      }
    };
    wsService.prototype.initEventHandle = function (ws) {
      var self = this;
      ws.onclose = function () {
        self.reconnect(this.wsUrl);
      };
      ws.onerror = function () {
        console.log("onerror....");
        self.reconnect(this.wsUrl);
      };
      ws.onopen = function () {
        console.log("opening....");
        var auth = {
          ver: self.ver,
          op: self.op,
          seq: 10,
          business: 1, // 需求：https://www.tapd.cn/20041161/prong/stories/view/1120041161001042686
          body: {
            user_id: self.userId, // 咕咚token
            room_id: self.roomId,
            class_id: self.session_id,
          },
        };

        var authObj = JSON.stringify(auth);
        ws.send(authObj);

        ws.onmessage = function (event) {
          console.log(JSON.parse(event.data));
          self.messageData(event.data);
        };
      };
    };

    wsService.prototype.messageData = function (eventData) {
      var _data = JSON.parse(eventData);
      var self = this;
      // 这里循环的原因是因为返回值里面可能是多个值
      for (var i = 0; i < _data.length; i++) {
        var _dataIndex = _data[i];
        if (
          _dataIndex.body.status &&
          _dataIndex.body.status === "OK" &&
          _dataIndex.op === this.AuthCallbckType
        ) {
          // 这里代表登录成功
          console.log("登录成功");
          // 记录一个登陆状态
          vm.isLoginWs = true;
          // 登录成功之后开始连接训练和聊天
        }
      }
    };

    // 重连机制
    wsService.prototype.reconnect = function () {
      var self = this;
      if (this.lockReconnect) return;
      this.lockReconnect = true;
      //没连接上会一直重连，设置延迟避免请求过多
      setTimeout(function () {
        self.createWebSocket(this.wsUrl);
        self.lockReconnect = false;
      }, 1000);
    };
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();

/**
 * @author jserh
 * created on 2017-3-1
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.theme.components')
    .directive('browserCheck', browserCheck);

  /** @ngInject */
  function browserCheck() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/browserCheck/browserCheck.html',
      controller: 'browserCtrl'
    };
  }

})();

/**
 * @author liujuan
 * created on 2017-2-22
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.theme.components')
    .controller('browserCtrl', browserCtrl);

  /** @ngInject */
  function browserCtrl($scope,userApi) {

    $scope.isLowVesionBrowser = false;

    function IETester(userAgent){
      var UA =  userAgent || navigator.userAgent;
      if(/msie/i.test(UA)){
        return UA.match(/msie (\d+\.\d+)/i)[1];
      }else if(~UA.toLowerCase().indexOf('trident') && ~UA.indexOf('rv')){
        return UA.match(/rv:(\d+\.\d+)/)[1];
      }
      return false;
    }

    var isIe = IETester();
    if(isIe && isIe<9){
     $scope.isLowVesionBrowser = true;
    }
  }
})();

/**
 * @author liujuan
 * created on 2017-2-22
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.theme.components')
      .directive('checkTopic', checkTopic);

  /** @ngInject */
  function checkTopic() {
    return {
      restrict: 'E',
      scope:{
        label_id:'=?labelId',
        checkTitle:'=?labelTitle',
        titleTips:'=?titleTips',
        title:'=?thisTitle'
      },
      templateUrl: 'app/theme/components/checkTopic/checkTopic.html',
      controller: 'checkTopicCtrl'
    };
  }

})();

/**
 * @author liujuan
 * created on 2017-2-22
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.theme.components')
    .controller('checkTopicCtrl', checkTopicCtrl);

  /** @ngInject */
  function checkTopicCtrl($scope,userApi) {

    //$scope.label_id = 0;       // 选择的话题id    父级共享出来的
    //$scope.checkTitle = "";    // 选择的话题      父级共享出来的
    //$scope.titleTips = [];   
    //$scope.title = "";

    $scope.titleArr = "";        // 创建新话题
    $scope.isNewTitle = false;   // 是否新创建新的话题
    $scope.titleTips = [];   // 搜索的话题列表

    var isFlag = null;

    //关键字搜索
    $scope.changeTitle = function (title) {

      $scope.titleTips = [];

      var titles = userApi.trim(title) || "";

      if(titles == "") {
        $scope.titleTips = [];
        $scope.label_id = 0;
        $scope.checkTitle = '';
        $scope.titleArr = "";
        return;
      }


      var _newTitle = [];

      clearTimeout(isFlag);
      isFlag = setTimeout(function () {
        userApi.selectText(titles,function (data) {

          if(data.data.length == 0) {
            $scope.titleArr = title;
            $scope.titleTips = [];
          }else {
            $scope.titleArr = "";
            $scope.titleTips = data.data;

            for(var i=0; i<data.data.length;i++) {
              _newTitle.push(data.data[i].label_content);
            }

            // 判断是否有相同的100%匹配的话题
            if(_newTitle.indexOf(title) != -1) {
              $scope.isNewTitle = true;
            }else {
              $scope.isNewTitle = false;
            }

          }

        })
      },500)

      }


    //创建新的话题
    /*
     type:1 新建话题   2 已有话题
     */
    $scope.createFeed = function (title,label_id,type) {

      if(type == 1) {
        userApi.createFeed(title,function (data) {

          $scope.label_id = data;

          $scope.checkTitle = title;
        })
      }else {
        $scope.label_id = label_id;
        $scope.checkTitle = title;
      }

    }


    //取消当前选择的话题
    $scope.closeTitle = function () {
      $scope.label_id = 0;
      $scope.checkTitle = '';
    }
  }
})();

/**
 * @author liusy
 * 输入框字符限制
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.theme.components')
    .directive('citySelect', citySelect);

  /** @ngInject */
  function citySelect($location, $state) {
    return {
      restrict: 'AE',
      scope: {
        baLocation: '=',
        baAddress: '=',
        baShowAddress: '@',
        baCityChange: '&',
        baLocal: '@',
        baProvince: '=',
        baCityName: '=',
        baCity: '='
      },
      templateUrl: 'app/theme/components/citySelect/citySelect.html',
      controller: "citySelectCtrl",
      controllerAs: 'vm',
      bindToController: true
    };
  }

})();

(function () {
  "use strict";

  angular
    .module("CodoonUserAdmin.theme.components")
    .controller("citySelectCtrl", citySelectCtrl);

  /** @ngInject */
  function citySelectCtrl($scope, $timeout, $http, toastrService) {
    var vm = this;
    var key = "3afbc616a58b0c8ffc960d47a3f9f326";
    vm.provinceArr = [];
    vm.cityArr = [];
    vm.tips = [];

    vm.getAMapDistrict = getAMapDistrict;
    vm.setProvinceAndCity = setProvinceAndCity;
    vm.getAMapDistrict();

    vm.selectAddress = function (item) {
      var re = /(\d+.?\d*),(\d+.?\d*)/;
      vm.address_detail = item.name;
      vm.baLocation = item.location.replace(re, "$2,$1");
      vm.baAddress = item.name;
      vm.showAddress = false;
      highlightMarker();
    };

    function setProvinceAndCity(init) {
      if (vm.province.citycode.toString()) {
        vm.cityArr = [];
        vm.cityArr.push(vm.province);
      } else {
        vm.cityArr = vm.province.districts;
      }
      if (!init || !vm.city) {
        vm.city = vm.cityArr[0];
        vm.handleCitySelect();
      }
    }

    $scope.$watch(
      function () {
        return vm.baCity;
      },
      function () {
        initBaCity();
      }
    );

    function highlightMarker() {
      var iconImage = "//vdata.amap.com/icons/b18/1/2.png";
      var icon = new AMap.Icon({
        image: iconImage,
        size: new AMap.Size(50, 50),
      });
      var location = revertLngAndLat();
      window.map.clearMap();
      var marker = new AMap.Marker({
        icon: icon,
        position: location.split(","),
        offset: new AMap.Pixel(0, 0),
        map: window.map,
      });
      window.map.setZoomAndCenter(20, location.split(","));
    }

    function revertLngAndLat() {
      var re = /(\d+.?\d*),(\d+.?\d*)/;
      return vm.baLocation.replace(re, "$2,$1");
    }

    function renderMap() {
      var map = new AMap.Map("amap-container", {
        features: ["bg", "road", "building", "point"],
        resizeEnable: true,
        zoomEnable: true,
      });
      window.map = map;
      if (vm.baLocal && vm.baLocal.toString() == "true") {
        geolocationMap(map);
      }
      $timeout(function () {
        initAddress();
      }, 1000);
    }

    function geolocationMap(map) {
      map.plugin("AMap.Geolocation", function () {
        var geolocation = new AMap.Geolocation({
          enableHighAccuracy: true, //是否使用高精度定位，默认:true
          timeout: 10000, //超过10秒后停止定位，默认：无穷大
          maximumAge: 0, //定位结果缓存0毫秒，默认：0
          convert: true, //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
          showButton: true, //显示定位按钮，默认：true
          buttonPosition: "LB", //定位按钮停靠位置，默认：'LB'，左下角
          buttonOffset: new AMap.Pixel(10, 20), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
          showMarker: true, //定位成功后在定位到的位置显示点标记，默认：true
          showCircle: true, //定位成功后用圆圈表示定位精度范围，默认：true
          panToLocation: true, //定位成功后将定位到的位置作为地图中心点，默认：true
          zoomToAccuracy: true, //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
        });
        map.addControl(geolocation);
        geolocation.getCurrentPosition();
        AMap.event.addListener(geolocation, "complete", onComplete); //返回定位信息
      });
    }

    function onComplete(data) {
      vm.address_detail = data.formattedAddress;
      vm.baAddress = data.formattedAddress;
      vm.baLocation = [data.position.lat, data.position.lng].join(",");
      vm.baCity = data.addressComponent.adcode.substr(0, 4);
      vm.baCityChange({ city: vm.baCity });
      highlightMarker();
      initBaCity();
    }

    function initAddress() {
      if (vm.baAddress) {
        vm.address_detail = vm.baAddress;
      }
      if (vm.baLocation) {
        highlightMarker();
      }
    }

    vm.handleCitySelect = function () {
      vm.baCity = vm.city.adcode.substr(0, 4);
      vm.baCityChange({ city: vm.baCity });
    };

    vm.searchAddress = function () {
      var fetch_url = "//restapi.amap.com/v3/assistant/inputtips";
      var data = {
        key: key,
        keywords: vm.address_detail,
        citylimit: true,
        city: vm.city.adcode,
      };
      $http.get(fetch_url, { params: data }).then(function (response) {
        if (response.status == 200 && response.data.info == "OK") {
          vm.tips = response.data.tips;
          vm.showAddress = true;
        } else {
          vm.showAddress = false;
        }
      });
    };

    function initBaCity() {
      vm.provinceArr.forEach(function (province) {
        var districts = [];
        if (province.citycode.toString()) {
          districts.push(province);
        } else {
          districts = province.districts;
        }
        districts.forEach(function (city) {
          if (city.adcode.indexOf(vm.baCity) != -1) {
            vm.province = province;
            vm.cityArr = districts;
            vm.city = city;
          }
        });
      });
    }

    function getAMapDistrict() {
      var fetch_url = "//restapi.amap.com/v3/config/district";
      var params = { key: key, subdistrict: 2 };
      $http.get(fetch_url, { params: params }).then(function (response) {
        if (response.status == 200 && response.data.info == "OK") {
          vm.provinceArr = response.data.districts[0].districts;
          vm.province = vm.provinceArr[0];
          initBaCity();
          setProvinceAndCity(true);
          renderMap();
        } else {
          toastrService.openToast("info", "获取城市信息失败");
        }
      });
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $state.current.title;
        });
      }
    };
  }

})();

/**
 * @author liusy
 * 输入框字符限制
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.theme.components')
      .directive('inputCount', inputCount);

  /** @ngInject */
  function inputCount($location, $state) {
    return {
      restrict: 'AE',
      scope: {
        maxLength: '@',
        placeholder: '@',
        ngModel: '='
      },
      templateUrl: 'app/theme/components/inputCount/index.html',
      controller: inputCountCtrl,
      controllerAs: 'vm',
      bindToController: true,
      link: function($scope) {}
    };
  }

  function inputCountCtrl($scope) {
    var vm = this;
    vm.count = 0;
    vm.ngModel = '';
    vm.textCounter = function ($event) {
      var count = calWord();
      if (count > vm.maxLength) {
        vm.count = vm.maxLength;
        vm.ngModel = substrNgModel();
        vm.count = calWord();
      } else {
        vm.count = count;
      }
    }

    function substrNgModel() {
      var reg = /[\u4e00-\u9fa5]/;
      var count = 0;
      for (var i = 0; i < vm.ngModel.length; i++) {
        if (count >= vm.maxLength-1) {
          // 判断最后一个字是汉字还是字母
          return vm.ngModel.slice(0, i);
        } else {
          if (reg.test(vm.ngModel.charAt(i))) {
            count += 2;
          } else {
            count += 1;
          }
        }
      }   
    }
    
    function calWord() {
      var reg = /[\u4e00-\u9fa5]/;
      var count = 0;
      var arr = vm.ngModel.split('');
      
      for (var i = 0; i < arr.length; i++) {
        if (reg.test(arr[i])) {
          count = count + 2;
        } else {
          count = count + 1;
        }
      }
      return count;
    }

 
   }

})();

/**
 * @author lj
 * created on 22.02.2017
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.theme.components')
      .directive('loadIng', loadIng);

  /** @ngInject */
  function loadIng() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/loading/loading.html'
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.theme.components')
      .directive('pageTop', pageTop);

  /** @ngInject */
  function pageTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/pageTop/pageTop.html',
      controller: 'PageTopCtrl'
    };
  }

})();

(function () {
  "use strict";

  angular
    .module("CodoonUserAdmin.theme.components")
    .controller("PageTopCtrl", PageTopCtrl);

  /** @ngInject */
  function PageTopCtrl(
    $scope,
    $state,
    $stateParams,
    $location,
    $timeout,
    adminApi,
    cacheService
  ) {
    $scope.homeInfo = {};
    var vm = this;

    this.getMenuItems = function () {
      var states = defineMenuItemStates();
      var menuItems = states.filter(function (item) {
        return item.level == 0;
      });

      //判断手机还是pc
      if (window.innerWidth > 750) {
        $scope.isPc = true;
      } else {
        $scope.isPc = false;
      }

      var rmIndex = null;
      menuItems.forEach(function (item, index) {
        if (item.title == "动态发布" && !$scope.isPc) rmIndex = index;
        var children = states.filter(function (child) {
          return child.level == 1 && child.name.indexOf(item.name) === 0;
        });
        item.subMenu = children.length ? children : null;
      });
      if (rmIndex !== null) menuItems.splice(rmIndex, 1);
      return menuItems;
    };

    $scope.goCodoon = function () {
      window.location.href = "http://www.codoon.com";
    };
    var initStateName = ($location.$$url + "").split("/")[1];

    $scope.faterNavCur = initStateName;
    $scope.curSubMenu = [];

    vm.getUserInfo = function () {
      var user = cacheService.getUser();
      // if(!user.brand_user && !user.live_host && !user.advert_user){
      //   window.location.href = 'https://www.codoon.com/home'
      //   return;
      // }

      $scope.homeInfo.brand_user = user.brand_user; // 是否显示品牌号
      $scope.homeInfo.advert_user = user.advert_user; // 是否显示广告用户
      $scope.homeInfo.portrait = user.portrait; // 用户头像
      $scope.homeInfo.nick = user.nick;

      window.user_premisson = user.menus;
      $scope.menuItems = vm.getMenuItems();

      if (user.host_coach) {
        $scope.homeInfo.host_coach = user.host_coach;
        $scope.menuItems.forEach(function (item, index) {
          item.isShow = findIsHavePremTitle(item.title, window.user_premisson);
          if (item.name === "training") {
            item.isShow = true;
          }
          if (item.name == "activity") {
            item.isShow = true;
          }

          if (item.name.indexOf("home") > -1) {
            item.isShow = true;
          }
        });
      } else if (user.advert_user) {
        //广告号用户
        $scope.homeInfo.advert_user = user.advert_user;
        $scope.menuItems.forEach(function (item, index) {
          if (item.name === "advert") {
            item.isShow = true;
          }
          if (item.name === "soft-advert") {
            item.isShow = true;
          }
          if (item.name === "export") {
            item.isShow = true;
          }
          if (item.name === "search") {
            item.isShow = true;
          }
          if (item.name.indexOf("home") > -1) {
            item.isShow = true;
          }
        });
      } else {
        var _url = $location.$$url.indexOf("racelive/list");
        $scope.menuItems.forEach(function (item, index) {
          if (item.name == initStateName && _url == -1) {
            $scope.curSubMenu = item.subMenu;
            if ($scope.curSubMenu != null) {
              dealCurMenuPrem($scope.curSubMenu, window.user_premisson);
            }
          }
          item.isShow = findIsHavePremTitle(item.title, window.user_premisson);
          if (item.name == "activity") {
            item.isShow = true;
          }
        });
      }

      if (user.class_maker_update || user.class_maker_get) {
        // "class_maker_update": 6, // 视频课程制作人 - 制作权限
        // "class_maker_get":    7, // 视频课程制作人 - 查看权限
        //  @zhanyi
        // TODO 后面权限严格控制了，这个地方要处理一下，现在展示一个跳转链接
        $scope.menuItems.unshift({
          icon: undefined,
          isShow: true,
          level: 0,
          order: -1,
          name: "course",
          href: "https://www.codoon.com/new-ugc/",
          title: "课程投稿",
        });
      }
      if (user.is_white_user === 1) {
        $scope.menuItems.unshift({
          icon: undefined,
          isShow: true,
          level: 0,
          order: -1,
          name: "race-committee-figure",
          href: "https://www.codoon.com/race-committee-figure",
          title: "组委会AI手办",
        });
      }
    };

    $scope.showSubMenu = function (menuItem) {
      $scope.faterNavCur = menuItem.name;
      $scope.curSubMenu = menuItem.subMenu;

      if (menuItem.subMenu) {
        dealCurMenuPrem($scope.curSubMenu, window.user_premisson);
      } else {
        $scope.curSubMenu = [];
      }
    };

    // this.getUserInfo();
    $timeout(function () {
      vm.getUserInfo();
    }, 2000);

    function defineMenuItemStates() {
      return $state
        .get()
        .filter(function (s) {
          return s.sidebarMeta;
        })
        .map(function (s) {
          var meta = s.sidebarMeta;
          return {
            name: s.name,
            title: s.title,
            level: (s.name.match(/\./g) || []).length,
            order: meta.order,
            icon: meta.icon,
            stateRef: s.name,
          };
        })
        .sort(function (a, b) {
          return (a.level - b.level) * 100 + a.order - b.order;
        });
    }
    function finIsHavePrem(url, prem) {
      var isHave = false;
      prem.forEach(function (it) {
        if (it.url == url) isHave = true;
      });
      return isHave;
    }
    function findIsHavePremTitle(title, prem) {
      var isHave = false;
      prem.forEach(function (it) {
        if (it.name == title) isHave = true;
      });
      return isHave;
    }
    function dealCurMenuPrem(curSubMenu, user_premisson) {
      curSubMenu.forEach(function (item) {
        item.isShow = false;
        if (
          item.name.indexOf("training") >= 0 ||
          item.name.indexOf("home") >= 0
        ) {
          item.isShow = true;
        } else if (
          item.name.indexOf("activity") == -1 ||
          item.name.indexOf("racelive") != -1
        ) {
          item.isShow = findCurIsHavePrem(item.name);
        } else {
          item.isShow = true;
        }
      });

      function findCurIsHavePrem(cur) {
        var isHave = false;

        user_premisson.forEach(function (it) {
          if (cur == it.url.replace("/", ".") || cur == "racelive.select")
            isHave = true;
        });
        return isHave;
      }
    }
  }
})();

/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function () {
    'use strict';

    angular.module('CodoonUserAdmin.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link:function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function () {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('CodoonUserAdmin.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

(function(){
  'use strict';

  angular.module('CodoonUserAdmin.pages.publish.article')
    .controller('gifUploadCtrl', gifUploadCtrl);

  /** @ngInject */
  function gifUploadCtrl($scope,$uibModalInstance,userApi,toastrService){
    var vm = this;
    //vm.token = data.data;

    vm.upload = function(){
      var data = {
        fm_src:vm.fm_src,
        gif_src:vm.gif_src
      }

      if(!data.gif_src){
        return toastrService.openToast("error","请上传GIF图");
      }
      $uibModalInstance.close(data);
    }

    //上传封面图片
    $scope.$watch('vm.fm', function(input) {
      if (!input) return false;
      var file = input.file;
      if (file.type == 'image/jpeg' || file.type == "image/png") {
        var image = new Image();
        image.onload = function() {
          if (   file.size > 1024*1024*5) {
            toastrService.openToast('error',  '请上传小于5M的图片')
          }else {
            uploadImage(input, function(data) {
              console.log(data)
              vm.fm_src = data;
            });
          }
        }
        image.src = input.url
      } else {
        toastrService.openToast('error','图片格式不正确');
        return false;
      }
    })

    //上传GIF
    $scope.$watch('vm.gif', function(input) {
      if (!input) return false;
      var file = input.file;
      if (file.type == 'image/gif') {
        var image = new Image();
        image.onload = function() {
          if (   file.size > 1024*1024*5) {
            toastrService.openToast('error',  '请上传小于5M的图片')
          }else {
            uploadImage(input, function(data) {
              vm.gif_src = data;
            });
          }
        }
        image.src = input.url
      } else {
        toastrService.openToast('error','图片格式不正确');
        return false;
      }
    })


    function uploadImage(file, callback) {
      vm.imageLoading = true;
      userApi.openUploadImg(file,function(response) {
        vm.imageLoading = false;
        var data = response.ref;
        callback(data)
      })
    }

  }

})();

(function(){
  'use strict';

  var url = null;

  angular.module('CodoonUserAdmin.pages.publish.article')
    .controller('uploadImgModalCtrl', uploadImgModalCtrl);

  /** @ngInject */
  function uploadImgModalCtrl($scope,$uibModalInstance,userApi,toastrService){
    var vm = this;



    //设置完成
    vm.setting = function(){

      var data = {
        img:vm.imgurl,
      }

      if(!data.img){
        return toastrService.openToast('error','请上传图片');
      }
      $uibModalInstance.close(data)
    }


    //上传图片
    $scope.$watch('vm.logoImg', function(input) {
      if (!input) return false;
      var file = input.file;
      if (file.type == 'image/jpeg' || file.type == "image/png" || file.type == 'image/gif' ) {
        if(file.size > 1024*1024*5){
          toastrService.openToast('error','请上传小于5M的图片');
          return false;
        }
        var image = new Image();
        image.onload = function() {
          uploadImage(input, function(data) {
            vm.imgurl = data;
          });
        }
        image.src = input.url;
      } else {
        toastrService.openToast('error','图片格式不正确');
        return false;
      }
    })



    function uploadImage(input, callback) {
      vm.imageLoading = true;
      userApi.openUploadImg(input, function(response) {
           vm.imageLoading = false;
          var data = response.ref;
          callback(data)
      })
    }


    //关闭弹出层
    vm.closeUrl = function(){
      $uibModalInstance.close("");
    }
  };

})();

(function(){
  'use strict';

  angular.module('CodoonUserAdmin.pages.publish.article')
    .controller('previewCtrl', previewCtrl);

  /** @ngInject */
  function previewCtrl($scope,$uibModalInstance,$sce,data){
    var vm = this;
    vm.title = data.title;
    $scope.content = $sce.trustAsHtml(data.content);



  }

})();

(function(){
  'use strict';

  angular.module('CodoonUserAdmin.pages.publish.article')
    .controller('videoUploadCtrl', videoUploadCtrl);

  /** @ngInject */
  function videoUploadCtrl($scope,$uibModalInstance,userApi,toastrService){
    var vm = this;
    //vm.token = data.data;

    vm.upload = function(){
      var data = {
        src:vm.src,
        img:vm.img
      }


      if(!data.src){
        return toastrService.openToast("error","请填写视频地址");
      }

      if(!data.img){
        return toastrService.openToast("error","请上传封面视频");
      }

      $uibModalInstance.close(data);
    }

    //上传图片
    $scope.$watch('vm.logoImg', function(input) {
      if (!input) return false;
      var file = input.file;
      if (file.type == 'image/jpeg' || file.type == "image/png") {
        var image = new Image();
        image.onload = function() {
          if (   file.size > 1024*1024*5) {
            toastrService.openToast('error',  '请上传小于5M的图片')
          }else {
            uploadImage(input, function(data) {
              vm.img = data;
            });
          }
        }
        image.src = input.url
      } else {
        toastrService.openToast('error','图片格式不正确');
        return false;
      }
    })



    function uploadImage(file, callback) {
      vm.imageLoading = true;
      userApi.openUploadImg(file,function(response) {
        vm.imageLoading = false;
        var data = response.ref;
        callback(data)
      })
    }


    //上传视频
    // $scope.$watch('', function(input) {
    //   if (!input) return false;
    //   var file = input.file;
    //   toastrService.openToast('success', "视频上传中····")
    //   uploadImage(input.file, $scope.imageLoading, function(data) {
    //     vm.src = data.url;
    //     angular.element("#video").attr("src",data.url)
    //   });
    // })



    userApi.watchFileMp4($scope, 'vm.video', 35,function (resonse) {

      console.log(resonse)
      if (!resonse.key){
        toastrService.clearToasts();
        toastrService.openToast('error',resonse.erro)
        return;
    }

      var video_url = "https://image7s.codoon.com/" + resonse.key;

      vm.src = video_url;
      vm.video_size = resonse.size;

      $scope.$apply();
    });



  }

})();

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
angular.module('CodoonUserAdmin').run(['$templateCache', function($templateCache) {$templateCache.put('app/pages/export/index.html','<div class="main_with"><uib-accordion><uib-accordion-group is-open="true" panel-class="bootstrap-panel accordion-panel panel-heading-export"><uib-accordion-heading style="background-color:#ddd">\u5BFC\u51FA\u8BBE\u7F6E</uib-accordion-heading><div class="form-horizontal"><div class="row"><div class="form-group"><div class="col-sm-offset-2 col-sm-8"><h4>\u53EA\u4FDD\u7559\u6700\u540E\u4E00\u6B21\u4FEE\u6539\u7684\u6570\u636E</h4></div></div><div class="form-group"><label class="col-sm-2 control-label">\u65F6\u95F4:</label><div class="col-sm-3 moment-picker-plugin"><div class="input-group moment-picker" moment-picker="export.begin_time" format="YYYY-MM-DD" locale="zh-cn" max-view="month"><input class="form-control" placeholder="\u7ED3\u675F\u65E5\u671F" ng-model="export.begin_time"> <span class="input-group-addon"><i class="fa fa-calendar"></i></span></div></div><div class="col-sm-3 moment-picker-plugin"><div class="input-group moment-picker" moment-picker="export.end_time" format="YYYY-MM-DD" locale="zh-cn" max-view="month"><input class="form-control" placeholder="\u7ED3\u675F\u65E5\u671F" ng-model="export.end_time"> <span class="input-group-addon"><i class="fa fa-calendar"></i></span></div></div></div><div class="form-group"><label class="col-sm-2 control-label">\u9009\u62E9\u8D44\u6E90:</label><div class="col-sm-3"><button type="button" class="btn btn-default btn-block" ng-click="export.modal(\'advert\')">\u5E7F\u544A\u5360\u4F4D\u8D44\u6E90 <span ng-show="export.adNum">\u5DF2\u9009{{export.adNum}}\u4E2A</span></button></div><div class="col-sm-3"><button type="button" class="btn btn-default btn-block" ng-click="export.modal(\'soft-advert\')">\u8F6F\u5E7F\u544A\u5360\u4F4D\u8D44\u6E90 <span ng-show="export.sadNum">\u5DF2\u9009{{export.sadNum}}\u4E2A</span></button></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-2"><button type="button" class="btn btn-primary btn-block" ng-click="export.save()">\u4FDD\u5B58</button></div></div><div class="form-group" ng-show="export.position_info"><div class="col-sm-offset-2 col-sm-8"><p><samll>\u6700\u540E\u4E00\u6B21\u4FDD\u5B58\u65F6\u95F4\uFF1A{{export.update_time | date: \'yyyy-MM-dd : HH:mm:ss\'}}</samll></p><p><samll>\u8BF7\u4E8E{{export.notice_update_time}}\u65E98\u70B9\u540E\u6765\u4E0B\u8F7D\u6570\u636E\u8868\u683C</samll></p></div></div></div></div></uib-accordion-group></uib-accordion><uib-accordion><uib-accordion-group is-open="true" panel-class="bootstrap-panel accordion-panel panel-heading-export"><uib-accordion-heading style="background-color:#ddd">\u5386\u53F2\u5217\u8868</uib-accordion-heading><div class="form-horizontal"><div class="row"><div class="form-group"><label class="col-sm-2 control-label">\u8BF4\u660E:</label><div class="col-sm-10"><h4 style="line-height: 34px;" class="exprot-page-tooltip"><span tooltip-is-open="true" tooltip-placement="top" uib-tooltip="\u9009\u62E9\u7684\u5F00\u59CB\u65F6\u95F4">2017.01.03_</span> <span tooltip-is-open="true" tooltip-placement="top" uib-tooltip="\u9009\u62E9\u7684\u7ED3\u675F\u65F6\u95F4">2017.03.04_</span> <span tooltip-is-open="true" tooltip-placement="top" uib-tooltip="\u5BFC\u51FA\u7684\u65F6\u95F4">2017.06.15.xlsx</span></h4></div></div></div></div><table class="table table-bordered table-hover table-condensed table-striped"><thead><tr><th>Excel\u6587\u4EF6</th><th class="text-center">\u64CD\u4F5C</th></tr></thead><tbody><tr ng-repeat="(key, value) in export.table.datas"><td width="70" style="background-color:white">{{ value.id}} <i style="color:#ef7d07" class="fa fa-file-excel-o" aria-hidden="true"></i> {{value.name}}</td><td width="30%" class="text-center" style="background-color:white"><a ng-href="{{value.url}}" style="" target="_blank"><i class="fa fa-cloud-download" aria-hidden="true"></i> \u4E0B\u8F7D</a></td></tr><tr ng-if="export.table.datas.length==0"><td colspan="2">\u6682\u65E0\u6570\u636E</td></tr></tbody></table><paging page="export.table.currentPage" page-size="export.table.pageSize" total="export.table.count" paging-action="export.queryRecord(page)" show-prev-next="true" show-first-last="true"></paging></uib-accordion-group></uib-accordion></div>');
$templateCache.put('app/pages/export/modal.html','<div class="modal-content" style="z-index:999"><div class="modal-header" ng-init="vm.showForm=1"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="fa fa-close sn-link-close"></em></button><h4 class="modal-title" ng-if="vm.data.type == \'advert\'">\u9009\u62E9\u5E7F\u544A\u5360\u4F4D\u8D44\u6E90</h4><h4 class="modal-title" ng-if="vm.data.type == \'soft-advert\'">\u9009\u62E9\u8F6F\u5E7F\u544A\u5360\u4F4D\u8D44\u6E90</h4></div><form class="form-horizontal" style="margin:0 15px"><div class="form-group"><label for="title" class="col-sm-2 control-label">\u641C\u7D22</label><div class="col-sm-8"><input type="text" class="form-control" ng-model="vm.name" placeholder="\u6839\u636E\u5E7F\u544A\u5360\u4F4D\u540D\u79F0\u641C\u7D22" maxlength="10"></div></div><div class="form-group"><div class="col-sm-12" ng-show="!vm.name"><div class="checkbox"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-checked="vm.checkAll" ng-click="vm.toggle()"> <span>\u5168\u9009</span></label></div></div><div class="col-sm-6" ng-repeat="(key,val) in vm.ads | filter: vm.name track by $index"><div class="checkbox"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="val.checked" ng-click="vm.itemToggle(val.checked)"> <span>{{val.name}}</span></label></div></div></div></form><form class="form-horizontal"><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.submit()">\u786E\u8BA4</button> <button type="button" class="btn btn-primary pull-left" ng-click="$dismiss()">\u53D6\u6D88</button></div></form></div>');
$templateCache.put('app/pages/advert/index.html','<div class="main_with"><div class="advert-occupy"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-title="" ba-panel-class=""><div class="row"><div class="col-md-3 text-center"><h2 class="text-center">{{occupy.currentMonth}}</h2></div><div class="col-md-3 text-center"><div class="btn-group"><button class="btn btn-primary" ng-click="occupy.changeMonth(\'pre\')">\u4E0A\u6708</button> <button class="btn btn-default" ng-click="occupy.changeMonth(\'\')">\u5F53\u6708</button> <button class="btn btn-primary" ng-click="occupy.changeMonth(\'next\')">\u4E0B\u6708</button></div></div><div class="col-md-6 text-center"><div class="btn-group color-tip" tooltip-placement="bottom" uib-tooltip="\u80CC\u666F\u8272\u5BF9\u5E94\u76F8\u5BF9\u7684\u5360\u4F4D\u72B6\u6001"><button class="btn done">\u5DF2\u6267\u884C</button> <button class="btn non-business">\u975E\u5546\u5360</button> <button class="btn business">\u5546\u5360</button> <button class="btn reservation">\u9884\u7559</button></div><div class="form-control-static" style="color:#f25252">\u9884\u755910\u65E5\u5185\u8BF7\u4FEE\u6539\u4E3A\u786E\u8BA4\u5360\u4F4D,\u5426\u5219\u9884\u7559\u4F4D\u7F6E\u4F1A\u88AB\u91CA\u653E</div></div></div><br><div class="add-row-editable-table"><form class="form-inline"><div class="form-group"><label for="module">\u6240\u5C5E\u6A21\u5757</label><select class="form-control" title="\u6240\u5C5E\u6A21\u5757" ng-model="occupy.ad_module" ng-change="occupy.adModuleChange()" ng-options="type.name for type in occupy.adModuleOptions"></select></div><div class="form-group"><label for="type">\u5E7F\u544A\u4F4D</label><select class="form-control" ng-model="occupy.ad_position" ng-change="occupy.adPositionChange()" ng-options="type.name for type in occupy.adPostionOptions"></select></div><div class="form-group"><label for="status">\u7701\u4EFD</label><select class="form-control" ng-model="occupy.province" ng-change="occupy.provinceChange()" ng-options="province.name for province in occupy.provinces"></select></div><div class="form-group"><label for="status">\u8BE5\u5E7F\u544A\u4F4D\u8D1F\u8D23\u4EBA</label><div class="form-control-static">{{occupy.principal}}</div></div></form></div><div class="col-sm-1 no-padding advert-search-scroll-table-header"><table class="table table-bordered table-condensed"><thead><tr><td class="nowrap text-center" ng-if="occupy.assembleData[0].title">\u5E8F\u53F7</td><td class="nowrap text-center">\u6761\u6570</td></tr></thead><tbody><tr ng-repeat="(key,item) in occupy.assembleData"><td class="nowrap text-center" ng-if="item.title">{{item.title}}</td><td class="nowrap text-center">{{item.num}}</td></tr></tbody></table></div><div class="col-sm-11 no-padding advert-search-scroll-table" id="scrollTable"><table class="table table-bordered table-condensed"><thead><tr><td ng-class="{\'weekend\':val.weekend,\'before\':val.before}" ng-repeat="(key,val) in occupy.months">{{val.weekday}}</td></tr></thead><tbody><tr ng-repeat="(key,item) in occupy.assembleData"><td ng-repeat="(k,day) in item.days" ng-click="occupy.modal(item,day)" class="{{day.occupy_class}}"><div ng-show="!$parent.$last&&$first&&!$last" tooltip-placement="bottom-left" uib-tooltip-html="day.info" style="width:75px;" class="text-overflow"><i class="fa" ng-class="{\'fa-circle\':day.my_self}"></i> {{day.title}}</div><div ng-show="!$parent.$last&&!$first&&!$last" tooltip-placement="bottom-left" uib-tooltip-html="day.info" style="width:75px;" class="text-overflow"><i class="fa" ng-class="{\'fa-circle\':day.my_self}"></i> {{day.title}}</div><div ng-show="!$parent.$last&&!$first&&$last" tooltip-placement="bottom-right" uib-tooltip-html="day.info" style="width:75px;" class="text-overflow"><i class="fa" ng-class="{\'fa-circle\':day.my_self}"></i> {{day.title}}</div><div ng-show="$parent.$last&&$first&&!$last" tooltip-placement="right-top" uib-tooltip-html="day.info" style="width:75px;" class="text-overflow"><i class="fa" ng-class="{\'fa-circle\':day.my_self}"></i> {{day.title}}</div><div ng-show="$parent.$last&&!$first&&!$last" tooltip-placement="bottom-left" uib-tooltip-html="day.info" style="width:75px;" class="text-overflow"><i class="fa" ng-class="{\'fa-circle\':day.my_self}"></i> {{day.title}}</div><div ng-show="$parent.$last&&!$first&&$last" tooltip-placement="bottom-right" uib-tooltip-html="day.info" style="width:75px;" class="text-overflow"><i class="fa" ng-class="{\'fa-circle\':day.my_self}"></i> {{day.title}}</div></td></tr></tbody></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/advert/modal.html','<div class="modal-content"><div class="modal-header" ng-init="vm.showForm=1"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="fa fa-close sn-link-close"></em></button><h4 class="modal-title" ng-if="!vm.data.group_id">\u521B\u5EFA\u5E7F\u544A\u5360\u4F4D</h4><h4 class="modal-title" ng-if="vm.data.group_id">\u67E5\u770B\u5E7F\u544A</h4></div><form class="form-horizontal" ng-if="vm.showForm==1"><br><p class="col-sm-12" ng-if="vm.data.group_id">\u8BE5\u5E7F\u544A\u539F\u59CB\u5360\u4F4D\u65F6\u95F4 {{vm._data.begin_time}} - {{vm._data.end_time}}</p><div class="form-group" ng-if="vm.user_type==1"><label for="title" class="col-sm-3 control-label">\u5360\u7528\u7C7B\u578B</label><div class="col-sm-2" ng-if="vm._data.task_status==9"><div class="checkbox"><label class="checkbox-inline custom-checkbox nowrap"><input type="radio" ng-checked="vm.task_status == 9" ng-click="vm.taskStatusChange(9)"> <span>\u9884\u7559\u6392\u671F</span></label></div></div><div class="col-sm-2"><div class="checkbox"><label class="checkbox-inline custom-checkbox nowrap"><input type="radio" ng-checked="vm.task_status == 10" ng-click="vm.taskStatusChange(10)"> <span>\u786E\u8BA4\u6392\u671F</span></label></div></div><div class="col-sm-offset-3 col-sm-8 form-control-static" style="color:#f25252">\u9884\u755910\u65E5\u5185\u8BF7\u4FEE\u6539\u4E3A\u786E\u8BA4\u5360\u4F4D,\u5426\u5219\u9884\u7559\u4F4D\u7F6E\u4F1A\u88AB\u91CA\u653E</div></div><div class="form-group"><label for="title" class="col-sm-3 control-label">\u8BF4\u660E</label><div class="col-sm-5"><input type="text" ng-readonly="vm.viewModal" class="form-control" ng-model="vm.data.desc" placeholder="\u5185\u90E8\u4F7F\u7528\uFF0C\u4E0D\u5BF9\u5916\u5C55\u793A" maxlength="30"></div><div class="col-sm-2 form-control-static">30\u5B57\u4EE5\u5185</div></div><div class="form-group"><label for="title" class="col-sm-3 control-label">\u5F00\u59CB\u65E5\u671F</label><div class="col-sm-5"><div class="input-group moment-picker" moment-picker="vm.data.begin_time" format="YYYY-MM-DD" locale="zh-cn" start-view="day" change="new.onChange(newValue, oldValue, index, key)"><input class="form-control" placeholder="\u5F00\u59CB\u65E5\u671F" ng-model="vm.data.begin_time"> <span class="input-group-addon"><i class="fa fa-calendar"></i></span></div></div></div><div class="form-group"><label for="title" class="col-sm-3 control-label">\u7ED3\u675F\u65E5\u671F</label><div class="col-sm-5"><div class="input-group moment-picker" moment-picker="vm.data.end_time" format="YYYY-MM-DD" locale="zh-cn" start-view="day" change="new.onChange(newValue, oldValue, index, key)"><input class="form-control" placeholder="\u7ED3\u675F\u65E5\u671F" ng-model="vm.data.end_time"> <span class="input-group-addon"><i class="fa fa-calendar"></i></span></div></div></div><div class="form-group"><label for="title" class="col-sm-3 control-label required">\u5B9E\u9645\u9700\u6C42\u4EBA</label><div class="col-sm-5"><input type="text" ng-readonly="vm.viewModal" class="form-control" ng-model="vm.data.real_occupier" placeholder="\u586B\u5199\u59D3\u540D\uFF0C\u90AE\u7BB1"></div></div><div class="modal-footer" ng-if="!vm.data.group_id"><button type="button" class="btn btn-primary" ng-click="vm.save()">\u786E\u5B9A</button> <button type="button" class="btn btn-primary pull-left" ng-click="$dismiss()">\u53D6\u6D88</button></div><div class="modal-footer" ng-if="vm.data.group_id"><button type="button" ng-if="vm.admin_release_ad||(!vm.data.before&&vm.data.my_self)" class="btn btn-primary" ng-click="vm.showForm=2">\u91CA\u653E</button> <button type="button" ng-if="!vm.data.before&&vm.data.my_self" class="btn btn-primary pull-left" ng-click="vm.modify()">\u4FEE\u6539</button> <button type="button" ng-if="vm.data.before" class="btn btn-primary" ng-click="$dismiss()">\u5173\u95ED</button></div></form><form class="form-horizontal" ng-if="vm.showForm==2"><br><div class="form-group"><label for="title" class="col-sm-2 control-label">\u91CA\u653E\u539F\u56E0</label><div class="col-sm-5"><select class="form-control" ng-model="vm.reason" ng-options="type.title for type in vm.reasons"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.submit()">\u786E\u8BA4</button> <button type="button" class="btn btn-primary pull-left" ng-click="vm.showForm=1">\u8FD4\u56DE</button></div></form><form class="form-horizontal" ng-if="vm.showForm==3"><br><p class="col-sm-12">\u662F\u5426\u53BB\u4E0A\u4F20\u7269\u6599</p><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.go()">\u786E\u8BA4</button> <button type="button" class="btn btn-primary pull-left" ng-click="vm.showForm=1">\u8FD4\u56DE</button></div></form></div>');
$templateCache.put('app/pages/live/live.html','<div class="main_with"><div class="live_main"><div class="menu_list"><span ng-class="{\'active\':isMenu==1}">\u2460 \u57FA\u7840\u8BBE\u7F6E</span> <span ng-class="{\'active\':isMenu==2}">\u2461 \u751F\u6210 RTMP \u4FE1\u606F</span></div><form class="form-horizontal" name="formScore" ng-show="isMenu==1"><div style="margin-bottom:10px;"><input style="padding: 5px; color: #7c7c83; font-size: 16px; font-weight: normal; text-align:center; width: 90%; height: 40px; border: solid 1px #e2e2e4;" class="input" placeholder="\u5199\u4E2A\u6807\u9898\u5438\u5F15\u66F4\u591A\u4EBA\u6C14\u5427~" ng-model="live_title"></div><div class="upload_main"><div class="uploadBtn_main" ng-if="cover_img == \'\'"><div class="uploadBtns"><img ng-src="{{\'addLive.png\' | appImage}}" class="img"> <img ng-src="{{\'addLive_hover.png\' | appImage}}" class="imghover"> <input type="file" class="btn-file" accept="image/png,image/jpeg" image="vm.img"></div><span class="tip">\u5EFA\u8BAE\u5C3A\u5BF8 400*400px</span><p>\u5B9A\u4F4D\u57CE\u5E02: {{location}}</p></div><div class="uploadBtn_main_active" ng-if="cover_img != 0"><div class="icon_mob"><img ng-src="{{cover_img}}" alt="" class="pc_img"> <input type="file" class="mob_img" accept="image/png,image/jpeg" image="vm.img"></div><div class="button_active">\u4E0A\u4F20\u65B0\u5C01\u9762 <input type="file" class="btn-file" accept="image/png,image/jpeg" image="vm.img"></div><div class="mob_tip">\u70B9\u51FB\u56FE\u7247\u53EF\u66F4\u6362\u5C01\u9762</div><p>\u5B9A\u4F4D\u57CE\u5E02:{{location}}</p></div></div><check-topic label-id="label_id" label-title="checkTitle"></check-topic><div class="btn_main"><div class="btns fb" ng-class="{\'load\':isStausFb}" ng-click="save()" ng-disabled="!isStausFb">\u4E0B\u4E00\u6B65</div></div></form><div class="setting_main" ng-show="isMenu==2"><h5>\u8BF7\u5C06\u4EE5\u4E0B\u4FE1\u606F\u586B\u5165\u60A8\u7684\u786C\u4EF6\u8BBE\u5907</h5><div class="rtmp"><div class="link">RTMP\u5730\u5740\uFF1A<span class="bm" id="copyUrl">{{url}}</span></div><p class="copyUrl" data-clipboard-target="#copyUrl">\u590D\u5236</p></div><div class="livekey"><div class="link">\u76F4\u64AD\u7801\uFF1A<span class="bm" id="copyKey">{{key}}</span><span class="cz" ng-click="update_room()">\u91CD\u7F6E\u76F4\u64AD\u7801</span></div><p data-clipboard-target="#copyKey" class="copyUrl">\u590D\u5236</p></div><div class="btn_main"><div class="btns load" ng-click="clickMenu(1)">\u8FD4\u56DE\u57FA\u7840\u8BBE\u7F6E</div></div></div></div></div>');
$templateCache.put('app/pages/search/index.html','<div class="main_with"><div class="widgets" cg-busy="myPromise"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-title="" ba-panel-class=""><div class="add-row-editable-table" style="margin-bottom:20px"><div class="btn-group btn-tabs"><button class="btn" ng-class="{\'btn-default\': vm.navActive != \'search\',\'btn-primary\':vm.navActive === \'search\'}" ng-click="vm.nav(\'search\')">\u5E7F\u544A\u5360\u4F4D</button> <button class="btn" ng-class="{\'btn-default\': vm.navActive != \'soft-search\',\'btn-primary\':vm.navActive === \'soft-search\'}" ng-click="vm.nav(\'soft-search\')">\u8F6F\u5E7F\u5360\u4F4D</button></div></div><div class="row"><div class="col-md-3 text-center"><h2 class="text-center">{{vm.currentMonth}}</h2></div><div class="col-md-3 text-center"><div class="btn-group"><button class="btn btn-primary" ng-click="vm.changeMonth(\'pre\')">\u4E0A\u6708</button> <button class="btn btn-default" ng-click="vm.changeMonth(\'\')">\u5F53\u6708</button> <button class="btn btn-primary" ng-click="vm.changeMonth(\'next\')">\u4E0B\u6708</button></div></div><form class="form-inline"><div class="form-group pull-right"><input type="text" class="form-control input-search" placeholder="\u8BF4\u660E(\u9879\u76EE\u540D\u79F0)" ng-model="vm.query.des" style="width: auto; border-top-right-radius: 0; border-bottom-right-radius: 0; margin-right: -5px;"> <button type="button" class="btn btn-primary btn-search" ng-click="vm.getData()" style="border-top-left-radius: 0; border-bottom-left-radius: 0;"><i class="fa" ng-class="{\'fa-search\':!vm.loading,\'fa-spinner fa-spin\':vm.loading}"></i></button></div></form></div><br><h2 ng-if="vm.datas.length===0" class="text-center">\u6309\u8BF4\u660E(\u9879\u76EE\u540D\u79F0)\u641C\u7D22\u5E7F\u544A\u5360\u4F4D...</h2><section ng-repeat="(key, data) in vm.datas"><div class="add-row-editable-table"><form class="form-inline"><div class="form-group"><label for="module">\u6240\u5C5E\u6A21\u5757</label><div class="form-control-static">{{data.module_name}}</div></div><div class="form-group"><label for="type">\u5E7F\u544A\u4F4D</label><div class="form-control-static">{{data.position_name}}</div></div><div class="form-group" ng-if="vm.navActive == \'search\'"><label for="status">\u7701\u4EFD</label><div class="form-control-static">\u5168\u56FD</div></div><div class="form-group" ng-if="vm.navActive == \'search\'"><label for="status">\u8BE5\u5E7F\u544A\u4F4D\u8D1F\u8D23\u4EBA</label><div class="form-control-static">{{data.principal}}</div></div></form></div><div class="col-sm-1 no-padding advert-search-scroll-table-header"><table class="table table-bordered table-condensed"><thead><tr><td class="nowrap text-center" ng-if="data.assembleData[0].title">\u5E8F\u53F7</td><td class="nowrap text-center">\u6761\u6570</td></tr></thead><tbody><tr ng-repeat="(key,item) in data.assembleData"><td class="nowrap text-center" ng-if="item.title">{{item.title}}</td><td class="nowrap text-center">{{item.num}}</td></tr></tbody></table></div><div class="col-sm-11 no-padding advert-search-scroll-table" id="scrollTable" style="min-height: 200px;"><table class="table table-bordered table-condensed"><thead><tr><td ng-class="{\'weekend\':val.weekend,\'before\':val.before}" ng-repeat="(key,val) in vm.months">{{val.weekday}}</td></tr></thead><tbody><tr ng-repeat="(key,item) in data.assembleData"><td ng-repeat="(k,day) in item.days" ng-click="vm.modal(data.ad_position,item,day)" class="{{day.occupy_class}}"><div ng-show="!$parent.$last&&$first&&!$last" tooltip-placement="bottom-left" uib-tooltip-html="day.info" style="width:75px;" class="text-overflow">{{day.title}}</div><div ng-show="!$parent.$last&&!$first&&!$last" tooltip-placement="bottom-left" uib-tooltip-html="day.info" style="width:75px;" class="text-overflow">{{day.title}}</div><div ng-show="!$parent.$last&&!$first&&$last" tooltip-placement="bottom-right" uib-tooltip-html="day.info" style="width:75px;" class="text-overflow">{{day.title}}</div><div ng-show="$parent.$last&&$first&&!$last" tooltip-placement="right-top" uib-tooltip-html="day.info" style="width:75px;" class="text-overflow">{{day.title}}</div><div ng-show="$parent.$last&&!$first&&!$last" tooltip-placement="bottom-left" uib-tooltip-html="day.info" style="width:75px;" class="text-overflow">{{day.title}}</div><div ng-show="$parent.$last&&!$first&&$last" tooltip-placement="bottom-right" uib-tooltip-html="day.info" style="width:75px;" class="text-overflow">{{day.title}}</div></td></tr></tbody></table></div></section></div></div></div></div></div>');
$templateCache.put('app/pages/soft-advert/index.html','<div class="soft-advert-occupy"><div class="row"><div class="col-lg-12 col-md-12"><div ba-panel="" ba-panel-title="" ba-panel-class=""><div class="row"><div class="col-md-3 text-center"><h2 class="text-center">{{occupy.currentMonth}}</h2></div><div class="col-md-3 text-center"><div class="btn-group"><button class="btn btn-primary" ng-click="occupy.changeMonth(\'pre\')">\u4E0A\u6708</button> <button class="btn btn-default" ng-click="occupy.changeMonth(\'\')">\u5F53\u6708</button> <button class="btn btn-primary" ng-click="occupy.changeMonth(\'next\')">\u4E0B\u6708</button></div></div><div class="col-md-6 text-center"><div class="btn-group color-tip" tooltip-placement="bottom" uib-tooltip="\u80CC\u666F\u8272\u5BF9\u5E94\u76F8\u5BF9\u7684\u5360\u4F4D\u72B6\u6001"><button class="btn done">\u5DF2\u6267\u884C</button> <button class="btn non-business">\u975E\u5546\u5360</button> <button class="btn business">\u5546\u5360</button> <button class="btn reservation">\u9884\u7559</button></div><div class="form-control-static" style="color:#f25252">\u9884\u755910\u65E5\u5185\u8BF7\u4FEE\u6539\u4E3A\u786E\u8BA4\u5360\u4F4D,\u5426\u5219\u9884\u7559\u4F4D\u7F6E\u4F1A\u88AB\u91CA\u653E</div></div></div><br><div class="add-row-editable-table"><form class="form-inline"><div class="form-group"><label for="module">\u6240\u5C5E\u6A21\u5757</label><select class="form-control" title="\u6240\u5C5E\u6A21\u5757" ng-model="occupy.ad_module" ng-change="occupy.adModuleChange()" ng-options="type.name for type in occupy.adModuleOptions"></select></div><div class="form-group"><label for="type">\u5E7F\u544A\u4F4D</label><select class="form-control" ng-model="occupy.ad_position" ng-change="occupy.adPositionChange()" ng-options="type.name for type in occupy.adPostionOptions"></select></div></form></div><div class="col-sm-1 no-padding advert-search-scroll-table-header"><table class="table table-bordered table-condensed"><thead><tr><td class="nowrap text-center" ng-if="occupy.assembleData[0].title">\u5E8F\u53F7</td><td class="nowrap text-center">\u6761\u6570</td></tr></thead><tbody><tr ng-repeat="(key,item) in occupy.assembleData"><td class="nowrap text-center" ng-if="item.title">{{item.title}}</td><td class="nowrap text-center">{{item.num}}</td></tr></tbody></table></div><div class="col-sm-11 no-padding advert-search-scroll-table" id="scrollTable"><table class="table table-bordered table-condensed"><thead><tr><td ng-class="{\'weekend\':val.weekend,\'before\':val.before}" ng-repeat="(key,val) in occupy.months">{{val.weekday}}</td></tr></thead><tbody><tr ng-repeat="(key,item) in occupy.assembleData"><td ng-repeat="(k,day) in item.days" ng-click="occupy.modal(item,day)" class="{{day.occupy_class}}"><div ng-show="!$parent.$last&&$first&&!$last" tooltip-placement="bottom-left" uib-tooltip-html="day.info" style="width:75px;" class="text-overflow"><i class="fa" ng-class="{\'fa-circle\':day.my_self}"></i> {{day.title}}</div><div ng-show="!$parent.$last&&!$first&&!$last" tooltip-placement="bottom-left" uib-tooltip-html="day.info" style="width:75px;" class="text-overflow"><i class="fa" ng-class="{\'fa-circle\':day.my_self}"></i> {{day.title}}</div><div ng-show="!$parent.$last&&!$first&&$last" tooltip-placement="bottom-right" uib-tooltip-html="day.info" style="width:75px;" class="text-overflow"><i class="fa" ng-class="{\'fa-circle\':day.my_self}"></i> {{day.title}}</div><div ng-show="$parent.$last&&$first&&!$last" tooltip-placement="right-top" uib-tooltip-html="day.info" style="width:75px;" class="text-overflow"><i class="fa" ng-class="{\'fa-circle\':day.my_self}"></i> {{day.title}}</div><div ng-show="$parent.$last&&!$first&&!$last" tooltip-placement="bottom-left" uib-tooltip-html="day.info" style="width:75px;" class="text-overflow"><i class="fa" ng-class="{\'fa-circle\':day.my_self}"></i> {{day.title}}</div><div ng-show="$parent.$last&&!$first&&$last" tooltip-placement="bottom-right" uib-tooltip-html="day.info" style="width:75px;" class="text-overflow"><i class="fa" ng-class="{\'fa-circle\':day.my_self}"></i> {{day.title}}</div></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/pages/soft-advert/modal.html','<div class="modal-content"><div class="modal-header" ng-init="vm.showForm=1"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="fa fa-close sn-link-close"></em></button><h4 class="modal-title" ng-if="!vm.data.id">\u521B\u5EFA\u5E7F\u544A\u5360\u4F4D</h4><h4 class="modal-title" ng-if="vm.data.id">\u67E5\u770B\u5E7F\u544A</h4></div><form class="form-horizontal" ng-if="vm.showForm==1" style="margin-right:15px;margin-left:15px;"><br><p class="col-sm-12" ng-if="vm.data.id">\u8BE5\u5E7F\u544A\u539F\u59CB\u5360\u4F4D\u65F6\u95F4 {{vm._data.begin_time}} - {{vm._data.end_time}}</p><p class="col-sm-offset-3 col-sm-10 invalid" ng-if="vm.time">\u8BED\u97F3\u5E7F\u544A\u51B2\u7A81\u65E5\u671F:{{vm.time}}</p><div class="form-group" ng-if="vm.user_type==1"><label for="title" class="col-sm-3 control-label">\u5360\u7528\u7C7B\u578B</label><div class="col-sm-2" ng-if="vm._data.task_status==9"><div class="checkbox"><label class="checkbox-inline custom-checkbox nowrap"><input type="radio" ng-checked="vm.task_status == 9" ng-click="vm.taskStatusChange(9)"> <span>\u9884\u7559\u6392\u671F</span></label></div></div><div class="col-sm-2"><div class="checkbox"><label class="checkbox-inline custom-checkbox nowrap"><input type="radio" ng-checked="vm.task_status == 10" ng-click="vm.taskStatusChange(10)"> <span>\u786E\u8BA4\u6392\u671F</span></label></div></div><div class="col-sm-offset-3 col-sm-8 form-control-static" style="color:#f25252">\u9884\u755910\u65E5\u5185\u8BF7\u4FEE\u6539\u4E3A\u786E\u8BA4\u5360\u4F4D,\u5426\u5219\u9884\u7559\u4F4D\u7F6E\u4F1A\u88AB\u91CA\u653E</div></div><div class="form-group"><label for="title" class="col-sm-3 control-label">\u8BF4\u660E</label><div class="col-sm-5"><input type="text" ng-readonly="vm.viewModal" class="form-control" ng-model="vm.data.desc" placeholder="\u5185\u90E8\u4F7F\u7528\uFF0C\u4E0D\u5BF9\u5916\u5C55\u793A" maxlength="30"></div><div class="col-sm-2 form-control-static">30\u5B57\u4EE5\u5185</div></div><section><div class="form-group"><label for="title" class="col-sm-3 control-label">\u5F00\u59CB\u65E5\u671F</label><div class="col-sm-5"><div class="input-group moment-picker" moment-picker="vm.data.begin_time" format="YYYY-MM-DD" locale="zh-cn" start-view="day" change="new.onChange(newValue, oldValue, index, key)"><input class="form-control" placeholder="\u5F00\u59CB\u65E5\u671F" ng-model="vm.data.begin_time"> <span class="input-group-addon"><i class="fa fa-calendar"></i></span></div></div></div><div class="form-group"><label for="title" class="col-sm-3 control-label">\u7ED3\u675F\u65E5\u671F</label><div class="col-sm-5"><div class="input-group moment-picker" moment-picker="vm.data.end_time" format="YYYY-MM-DD" locale="zh-cn" start-view="day" change="new.onChange(newValue, oldValue, index, key)"><input class="form-control" placeholder="\u7ED3\u675F\u65E5\u671F" ng-model="vm.data.end_time"> <span class="input-group-addon"><i class="fa fa-calendar"></i></span></div></div></div><div class="form-group"><label for="title" class="col-sm-3 control-label required">\u5B9E\u9645\u9700\u6C42\u4EBA</label><div class="col-sm-5"><input type="text" ng-readonly="vm.viewModal" class="form-control" ng-model="vm.data.real_occupier" placeholder="\u586B\u5199\u59D3\u540D\uFF0C\u90AE\u7BB1"></div></div></section><div class="modal-footer" ng-if="!vm.data.id"><button type="button" class="btn btn-primary" ng-click="vm.save()">\u786E\u5B9A</button> <button type="button" class="btn btn-primary pull-left" ng-click="$dismiss()">\u53D6\u6D88</button></div><div class="modal-footer" ng-if="vm.data.id"><button type="button" ng-if="vm.admin_release_soft_ad||(!vm.data.before&&vm.data.my_self)" class="btn btn-primary" ng-click="vm.showForm=2">\u91CA\u653E</button> <button type="button" ng-if="!vm.data.before&&vm.data.my_self" class="btn btn-primary pull-left" ng-click="vm.modify()">\u4FEE\u6539</button> <button type="button" ng-if="vm.data.before" class="btn btn-primary" ng-click="$dismiss()">\u5173\u95ED</button></div></form><form class="form-horizontal" ng-if="vm.showForm==2"><br><div class="form-group"><label for="title" class="col-sm-2 control-label">\u91CA\u653E\u539F\u56E0</label><div class="col-sm-5"><select class="form-control" ng-model="vm.reason" ng-options="type.title for type in vm.reasons"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.submit()">\u786E\u8BA4</button> <button type="button" class="btn btn-primary pull-left" ng-click="vm.showForm=1">\u8FD4\u56DE</button></div></form></div>');
$templateCache.put('app/pages/home/article.html','<div class="main_with"><div class="widgets home-arctile"><div class="no-data" ng-if="!vm.data.length && vm.fetched"><img src="assets/img/ic_common_nodata@3x.png"><p>\u6682\u65F6\u8FD8\u6CA1\u6709\u53D1\u8868\u6587\u7AE0\u54E6</p></div><div class="relative"><span uib-dropdown="" on-toggle="toggled(open)" ng-if="vm.data.length"><span id="simple-dropdown" uib-dropdown-toggle="" class="drop-text">{{vm.query.is_time ? \'\u65F6\u95F4\u987A\u5E8F\' : \'\u6D4F\u89C8\u91CF\u6392\u5E8F\'}} <span class="fold-icons"><img src="assets/img/ic_common_fold@2x.png" class="select-icon"> <img src="assets/img/ic_common_unfold@2x.png" class="select-icon"></span></span><ul class="dropdown-menu" uib-dropdown-menu="" aria-labelledby="simple-dropdown"><li ng-repeat="item in vm.orderBy"><a href="javascript:void(0)" ng-click="vm.handleDropMenu(item)">{{item.label}}</a></li></ul></span></div><div class="clearfix"></div><div class="article-list"><div class="article-item" ng-repeat="item in vm.data"><div class="clearfix article-box"><img ng-src="{{item.square_url}}" class="square-icon"><div class="article-content"><p class="content">{{item.title}}</p><p class="date">{{item.create_time | date : \'yyyy-MM-dd\'}}</p><div class="tip-container" ng-if="item.status"><div class="tip-box" ng-if="item.showTip">{{item.status}} <span class="angle"></span> <span class="angle2"></span></div><img src="assets/img/tip.png" class="tip-icon" ng-mouseenter="item.showTip=true" ng-mouseleave="item.showTip=false"></div></div><div class="btn-groups"><a href="{{item.contenturl}}" target="_blank" class="btn">\u67E5\u770B</a> <a ui-sref="publish.article({id: item.id})" class="btn">\u7F16\u8F91</a></div></div></div></div><div class="clearfix"></div><paging style="float: right;" page="vm.query.page" page-size="vm.query.limit" total="vm.totalItems" paging-action="vm.getArticleList(page)" show-prev-next="true" show-first-last="true"></paging></div></div>');
$templateCache.put('app/pages/home/home.html','<div class="main_with"><div class="widgets home_info"><div class="Mask_main"><img class="Mask" ng-src="{{homeInfo.portrait}}"><div class="title">{{homeInfo.nick}}<br><span ng-if="homeInfo.brand_user">\u54C1\u724C\u53F7</span></div><div class="follow">{{homeInfo.following_count}}<span>\u5173\u6CE8</span></div><div class="layer">{{homeInfo.follower_count}}<span>\u7C89\u4E1D</span></div></div><div class="signature" ng-if="homeInfo.descroption != \'\'"><div>\u7B7E\u540D</div><span>{{homeInfo.descroption}}</span></div><div class="explain" ng-if="homeInfo.viplabel_desc != \'\'"><div>\u8BA4\u8BC1\u8BF4\u660E</div><span>{{homeInfo.official_note}}</span></div></div></div>');
$templateCache.put('app/pages/activity/list/index.html','<div class="main_with"><div class="page-activity-list"><div class="itemWarper" ng-repeat="(key,item) in vm.list"><div class="leftFlex"><img class="image" ng-src="{{item.placard}}" alt="."><div class="status"><span ng-show="item.statue == 1">\u6B63\u5728\u62A5\u540D</span> <span ng-show="item.statue == 2">\u62A5\u540D\u5DF2\u6EE1</span> <span ng-show="item.statue == 3">\u62A5\u540D\u622A\u6B62</span> <span ng-show="item.statue == 4">\u6B63\u5728\u8FDB\u884C</span> <span ng-show="item.statue == 5">\u5DF2\u7ED3\u675F</span> <span ng-show="item.statue == 6">\u5DF2\u53D6\u6D88</span> <span ng-show="item.statue == 7">\u5DF2\u5220\u9664</span></div></div><div class="rightFlex"><div class="name">{{item.name}}</div><div class="type"><div class="type-name">{{item.type_name}}</div><div class="num">{{item.actual_join_num}}\u4EBA\u62A5\u540D</div></div><div class="info">\u65F6\u95F4: {{item.st_time}} - {{item.et_time}}</div><div class="info">\u5730\u70B9: {{item.address}}</div><div class="info">\u8D39\u7528: \uFFE5{{item.pay_fee/100}}</div><div class="btns"><a class="btn" target="_blank" href="https://www.codoon.com/www/active_city/export_active_paticipant?active_id={{item.active_id}}">\u62A5\u540D\u8868\u4E0B\u8F7D</a> <button class="btn" ng-class="{btn_gray: item.statue == 5}" ng-click="vm.notify(item)" ng-disabled="item.statue==5">\u901A\u77E5</button> <button class="btn btn_gray" ng-if="item.statue==5" disabled="">\u7F16\u8F91</button> <a class="btn" ui-sref="activity.publish({ id: \'edit-\'+item.active_id })" ng-if="item.statue!=5">\u7F16\u8F91</a> <a class="btn" ui-sref="activity.publish({ id: \'copy-\'+item.active_id })">\u590D\u5236</a></div></div></div><paging style="float: right;" page="vm.pagenum" page-size="vm.pagesize" total="vm.total" paging-action="vm.page(page)" show-prev-next="true" show-first-last="true"></paging></div></div>');
$templateCache.put('app/pages/activity/list/notify-modal.html','<div class="modal-content equip-modal creatList"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">\u53D1\u9001\u6D3B\u52A8\u901A\u77E5</h4></div><div class="modal-body"><form class="form-horizontal"><div class="form-group"><div class="col-sm-12"><input type="text" class="form-control" placeholder="\u6D88\u606F\u6807\u9898" ng-model="vm.title"></div></div><div class="form-group"><div class="col-sm-12"><input type="text" class="form-control" placeholder="\u6D88\u606F\u5185\u5BB9" ng-model="vm.content"></div></div></form></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.confirm()">\u786E\u8BA4</button> <button type="button" class="btn btn-primary pull-left" ng-click="$dismiss()">\u53D6\u6D88</button></div></div>');
$templateCache.put('app/pages/activity/publish/publish.html','<div class="main_with"><div class="page-activity"><form class="form-horizontal" novalidate=""><div class="form-group"><div class="placard-container inline-block vertical-align-top" ng-if="vm.form.placard"><img ng-src="{{vm.form.placard}}" alt=""></div><div class="upload-img-container inline-block vertical-align-top"><span class="placeholder">\u6D3B\u52A8\u6D77\u62A5\u56FE</span> <input type="file" class="btn-file" image="vm.img" filters="customFilter" accept="image/jpeg;image/png;"></div><p class="tip">\u4E00\u5F20\u7CBE\u7F8E\u7684\u6D77\u62A5\uFF0C\u66F4\u5BB9\u6613\u5438\u5F15\u7528\u6237\u62A5\u540D\u3002\u56FE\u7247\u5C0F\u4E8E2M\uFF0C\u5C3A\u5BF8\u2265300*400px\uFF1B\u652F\u6301jpg\u3001png</p></div><div class="form-group"><input-count max-length="50" ng-model="vm.form.name" placeholder="\u6D3B\u52A8\u540D\u79F0,\u6C49\u5B5725\u5B57\u4EE5\u5185,\u4E00\u4E2A\u6C49\u5B57\u4E24\u4E2A\u5B57\u7B26"></input-count></div><div class="form-group"><h5>\u6D3B\u52A8\u8BE6\u60C5</h5><div id="arcEditor" class="arcEditor"></div><p class="tip">\u6D3B\u52A8\u8BE6\u60C5\u6700\u591A3000\u5B57\u54E6~~</p></div></form><form class="form-horizontal" name="publishForm" novalidate=""><div class="form-group"><span>{{ vm.active_type.type_name }}</span> <button class="btn btn-primary" ng-click="vm.openTypeModal()">+\u9009\u62E9\u6D3B\u52A8\u7C7B\u578B</button></div><div class="form-group clearfix"><div class="mb10"><span>\u6D3B\u52A8\u65F6\u95F4:</span></div><div class="clearfix"><div class="col-sm-5 no-padding"><p class="input-group"><input type="text" class="form-control" datetime-picker="yyyy-MM-dd HH:mm" ng-click="open_start=true" ng-model="vm.form.st_time" enable-date="true" enable-time="true" is-open="open_start" placeholder="\u6D3B\u52A8\u5F00\u59CB\u65F6\u95F4" timepicker-options="{showSeconds:false, showMeridian: false}" name="st_time" required=""> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open_start=true"><i class="fa fa-calendar"></i></button></span></p></div><div class="col-sm-1 align-center">-</div><div class="col-sm-5 no-padding"><p class="input-group"><input type="text" class="form-control" datetime-picker="yyyy-MM-dd HH:mm" ng-click="open_end=true" ng-model="vm.form.et_time" enable-date="true" enable-time="true" is-open="open_end" placeholder="\u6D3B\u52A8\u7ED3\u675F\u65F6\u95F4" timepicker-options="{showSeconds:false, showMeridian: false}" name="et_time" required=""> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open_end=true"><i class="fa fa-calendar"></i></button></span></p></div></div></div><div class="form-group clearfix"><div class="mb10">\u62A5\u540D\u622A\u6B62\u65F6\u95F4:</div><div class="clearfix"><label class="custom-checkbox mr20"><input type="radio" name="sign_type" value="1" ng-model="vm.sign_type"> <span>\u6D3B\u52A8\u5F00\u59CB\u524D\u5747\u53EF\u62A5\u540D</span></label> <label class="custom-checkbox mr20"><input type="radio" name="sign_type" value="2" ng-model="vm.sign_type"> <span>\u81EA\u5B9A\u4E49</span></label></div><div class="mt10 col-sm-11 no-padding" ng-if="vm.sign_type==2"><p class="input-group"><input type="text" class="form-control" datetime-picker="yyyy-MM-dd HH:mm" ng-click="open_deadline=true" ng-model="vm.form.deadline" enable-date="true" enable-time="true" is-open="open_deadline" placeholder="\u62A5\u540D\u622A\u6B62\u65F6\u95F4" timepicker-options="{showSeconds:false, showMeridian: false}" name="deadline" required=""> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open_deadline=true"><i class="fa fa-calendar"></i></button></span></p></div></div><div class="form-group clearfix"><div class="mb10">\u81EA\u52A8\u7B7E\u5230:</div><div class="clearfix"><label class="custom-checkbox mr20"><input type="radio" value="1" ng-model="vm.form.is_sign_with_location"> <span>\u7B7E\u5230\u53D7\u5730\u7406\u4F4D\u7F6E\u9650\u5236</span></label> <label class="custom-checkbox mr20"><input type="radio" value="0" ng-model="vm.form.is_sign_with_location"> <span>\u7B7E\u5230\u4E0D\u53D7\u5730\u7406\u4F4D\u7F6E\u9650\u5236</span></label></div></div><div class="form-group clearfix"><div class="mb10">\u6D3B\u52A8\u5730\u70B9:</div><div><city-select ba-location="vm.form.lng_and_lat" ba-city="vm.form.active_city_code" ba-city-change="vm.handleActiveCityChange(city)" ba-address="vm.form.address" ba-show-address="true" ba-local=\'{{vm.type=="edit" ? false : true}}\' ng-if="vm.showCitySelect"></city-select></div></div><div class="form-group clearfix"><div class="mb10">\u6D3B\u52A8\u53EF\u89C1\u57CE\u5E02:</div><div><city-select ba-city="vm.form.alter_city_code" ba-city-name="vm.form.city_name" ba-show-address="false" ng-if="vm.showCitySelect"></city-select></div></div></form><form class="form-horizontal" name="activityForm" novalidate=""><div class="form-group" ng-if="vm.is_header"><div class="mb10">\u8FD0\u52A8\u56E2:</div><div class="clearfix"><div class="col-sm-5 no-padding"><select class="form-control" ng-options="option.name for option in vm.userGroups" ng-model="vm.group" ng-disabled="vm.type==\'edit\'"></select></div><div class="col-sm-5" ng-if="vm.group.id"><label class="custom-checkbox"><input type="checkbox" ng-true-value="1" ng-false-value="0" ng-model="vm.form.need_group_member" ng-disabled="vm.type==\'edit\'"> <span>\u4EC5\u9650\u56E2\u6210\u5458\u53C2\u52A0</span></label></div></div></div><div class="form-group"><div class="mb10">\u6D3B\u52A8\u8D39\u7528:</div><div class="form-inline"><label class="custom-checkbox mr20"><input type="radio" value="0" ng-model="vm.form.pay_type" ng-disabled="vm.type==\'edit\'"> <span>\u514D\u8D39</span></label> <label class="custom-checkbox mr20"><input type="radio" value="1" ng-model="vm.form.pay_type" ng-disabled="vm.type==\'edit\'"> <span>\u6536\u8D39</span></label><div class="block mt20" ng-if="vm.form.pay_type==1"><input type="text" class="form-control" placeholder="\u6B63\u6574\u6570" ng-model="vm.form.pay_fee" required="" ng-disabled="vm.type==\'edit\'"> <span class="ml10 mr20">\u5143/\u4EBA</span><select class="form-control" ng-model="vm.form.refund_type" ng-disabled="vm.type==\'edit\'"><option value="0" ng-selected="vm.form.refund_type==0">\u4E0D\u9000\u6B3E</option><option value="1" ng-selected="vm.form.refund_type==1">\u652F\u6301\u9000\u6B3E(\u6D3B\u52A8\u5F00\u59CB2\u5C0F\u65F6\u524D)</option></select></div><div ng-if="vm.form.pay_type==1"><div class="mt20 mb10">\u6D3B\u52A8\u7ED3\u675F\u540E72h, \u53EF\u5728\u3010\u6211\u7684-\u94B1\u5305-\u73B0\u91D1\u4F59\u989D\u3011\u4E2D\u53D1\u8D77\u63D0\u73B0\uFF0C\u76EE\u524D\uFF0C\u6D3B\u52A8\u53D1\u8D77\u4EBA\u6536\u53D6\u7684\u62A5\u540D\u8D39\u4E0D\u8D85\u8FC75\u4E07\u5143\u7684\u90E8\u5206\u4EA7\u751F\u7684\u6E20\u9053\u8D39\u7528\uFF0C\u6682\u65F6\u7531\u5495\u549A\u627F\u62C5</div><div class="mt10 mb10"><label class="custom-checkbox"><input type="checkbox" ng-model="vm.degree"> <span>\u6211\u5DF2\u9605\u8BFB\u5E76\u540C\u610F</span></label> <a href="https://tms.codoon.com/cms/pro/fufeihuodong.html" target="_blank">&lt;&lt;\u4ED8\u8D39\u6D3B\u52A8\u534F\u8BAE&gt;&gt;</a></div></div></div></div><div class="form-group"><div class="mb10">\u6D3B\u52A8\u4EBA\u6570:</div><div class="form-inline"><label class="custom-checkbox mr20"><input type="radio" value="0" ng-model="vm.join_type"> <span>\u4E0D\u9650\u5236</span></label> <label class="custom-checkbox mr20"><input type="radio" value="1" ng-model="vm.join_type"> <span>\u9650\u5236\u6700\u591A</span></label><div class="inline-block ml10" ng-if="vm.join_type==1"><input type="text" class="form-control" placeholder="\u6B63\u6574\u6570" required="" ng-model="vm.form.join_num"> <span class="ml10">\u4EBA</span></div></div></div><div class="form-group"><div class="mb10">\u6D3B\u52A8\u5BA1\u6838:</div><div class="mb10"><label class="custom-checkbox mr20"><input type="radio" value="0" ng-model="vm.form.is_need_approval" ng-disabled="vm.type==\'edit\'"> <span>\u4E0D\u9700\u8981\u5BA1\u6838</span></label> <label class="custom-checkbox mr20"><input type="radio" value="1" ng-model="vm.form.is_need_approval" ng-disabled="vm.type==\'edit\'"> <span>\u9700\u8981\u5BA1\u6838</span></label></div><div class="mb10" ng-if="vm.form.is_need_approval==1"><label class="custom-checkbox mr20" ng-repeat="item in vm.user_info_fields"><input type="checkbox" ng-model="item.checked" ng-disabled="vm.type==\'edit\'"> <span>{{ item.name }}</span></label> <button class="btn btn-default" ng-click="vm.openInfoModal()" ng-if="vm.custom_info_field_count<8">\u6DFB\u52A0\u5BA1\u6838\u9879</button></div></div><div class="form-group align-center"><button class="btn-default-codoon mr20" ng-click="vm.step=vm.step-1">\u4E0A\u4E00\u6B65</button> <button class="btn-codoon" ng-click="vm.createCityActive(activityForm.$invalid)">\u53D1\u5E03\u6D3B\u52A8</button></div></form></div></div>');
$templateCache.put('app/pages/racelive/list/index.html','<div class="page-racelive-list" ng-if="vm.race_id"><div class="leftFlex"><div class="content1_box"><div class="label">\u8D5B\u4E8B\u540D\u79F0<span>{{vm.raceDataInfo.race_name}}</span></div><div class="label">\u6BD4\u8D5B\u65F6\u95F4<span>{{vm.raceDataInfo.race_starts}} - {{vm.raceDataInfo.race_ends}}</span></div><div class="progress_box"><div class="item act1"><div class="pro"></div><span>\u8D5B\u4E8B\u672A\u5F00\u59CB</span></div><div class="item" ng-class="{\'act2\': vm.raceDataInfo.race_state != 0}"><div class="pro"></div><span>\u8D5B\u4E8B\u5165\u573A\u4E2D</span></div><div class="item" ng-class="{\'act3\': vm.raceDataInfo.race_state == 1 || vm.raceDataInfo.race_state == 2 }"><div class="pro"></div><span>\u8D5B\u4E8B\u8FDB\u884C\u4E2D</span></div><div class="item" ng-class="{\'act4\': vm.raceDataInfo.race_state == 2}"><div class="pro"></div><span>\u8D5B\u4E8B\u5DF2\u7ED3\u675F</span></div></div><div class="info_box" n-if="vm.timer_str"><div class="item"><div class="title" ng-if="vm.raceDataInfo.race_state == 1 || vm.raceDataInfo.race_state == 2">\u8D5B\u4E8B\u5DF2\u8FDB\u884C</div><div class="title" ng-if="vm.raceDataInfo.race_state == 0">\u8DDD\u79BB\u5165\u573A\u65F6\u95F4\u8FD8\u6709</div><div class="title" ng-if="vm.raceDataInfo.race_state == 3">\u8DDD\u79BB\u8D5B\u4E8B\u5F00\u59CB\u8FD8\u6709</div><div class="val"><span>{{vm.timer_str}}</span>{{ vm.timer_str_day ? \'\u5929\' : \'\'}}</div></div><div class="item"><div class="title">\u5165\u573A\u65F6\u95F4</div><div class="val"><span>{{vm.race_enter_len}}</span>\u5206\u949F</div></div><div class="item"><div class="title">\u6BD4\u8D5B\u65F6\u957F</div><div class="val"><span>{{vm.race_pk_len}}</span>\u5C0F\u65F6</div></div></div><div class="history_box"><div class="title_box"><h3>\u5386\u53F2\u6700\u597D\u6210\u7EE9</h3></div><div class="list_box"><div class="item"><div class="name">\u5168\u7A0B\u9A6C\u62C9\u677E</div><div class="val">{{vm.historyScoreData.full || \'00:00:00\'}}</div></div><div class="item"><div class="name">\u534A\u7A0B\u9A6C\u62C9\u677E</div><div class="val">{{vm.historyScoreData.half ||\' 00:00:00\'}}</div></div><div class="item"><div class="name">10KM</div><div class="val">{{vm.historyScoreData.ten_kilo || \'00:00:00\'}}</div></div><div class="item"><div class="name">5KM</div><div class="val">{{vm.historyScoreData.five_kilo}}</div></div></div></div></div><div class="content2_box"><div class="l"><div class="title">\u7528\u6237\u5730\u57DF\u5206\u5E03</div><div class="echarts_l" style="width: 100%;height:450px;"></div></div><div class="r"><div class="title">\u7528\u6237\u6027\u522B\u5206\u5E03</div><div class="echarts_r" style="width: 100%;height:450px;"></div></div></div></div><div class="centerFlex"><div class="content1_box"><div class="item_box"><div class="item"><div class="label">\u8D5B\u4E8B\u62A5\u540D\u603B\u4EBA\u6570</div><div class="num"><span>{{vm.raceData.total_apply_num}}</span>\u4EBA</div></div></div><div class="item_box"><div class="item"><div class="label">\u8D5B\u4E8B\u5B9E\u65F6\u7D2F\u8BA1\u53C2\u4E0E\u603B\u4EBA\u6570</div><div class="num"><span>{{vm.raceData.total_join_num}}</span>\u4EBA</div></div></div><div class="item_box"><div class="item"><div class="label">\u8D5B\u4E8B\u5B8C\u8D5B\u603B\u4EBA\u6570</div><div class="num"><span>{{vm.raceData.total_complete_num}}</span>\u4EBA</div></div></div></div><div class="content2_box"><div class="item_box {{\'item_box\' + (index+1)}}" ng-repeat="(index, item) in vm.raceData.group_statistic"><div class="title_box"><h3>{{item.group_name}}</h3></div><div class="cont_box"><div class="item"><p>\u8D5B\u4E8B\u62A5\u540D\u603B\u4EBA\u6570</p><div class="val"><div ng-style="{width: \'100%\'}" class="pro"></div><div class="num">{{item.apply_num}}<span>\u4EBA</span></div></div></div><div class="item"><p>\u8D5B\u4E8B\u5B9E\u65F6\u7D2F\u8BA1\u53C2\u4E0E\u603B\u4EBA\u6570</p><div class="val"><div class="pro" ng-style="{width: (item.join_num / item.apply_num * 100) + \'%\'}"></div><div class="num">{{item.join_num}}<span>\u4EBA</span></div></div></div><div class="item"><p>\u8D5B\u4E8B\u5B8C\u8D5B\u603B\u4EBA\u6570</p><div class="val"><div class="pro" ng-style="{width: (item.complete_num / item.apply_num * 100) + \'%\'}"></div><div class="num">{{item.complete_num}}<span>\u4EBA</span></div></div></div></div></div></div><div class="content3_box"><div class="title_box"><h3>\u5206\u6BB5\u5B8C\u6210\u7EDF\u8BA1</h3><div class="menu_main_box"><div class="menu_box" uib-dropdown=""><div uib-dropdown-toggle="" class="menu_boxs menu_boxs_group"><div>{{vm.group_name_statistic}}</div><span class="icon"></span></div><div class="menu_list" uib-dropdown-menu=""><div class="info"><div class="name" ng-click="vm.checkGroupStatistic(item)" ng-class="{\'act\': vm.group_id_statistic == item.group_id}" ng-repeat="item in vm.group_statistic">{{item.group_name}}</div></div></div></div></div></div><div class="list_box" ng-if="vm.raceData.section_statistic"><div class="item" ng-repeat="item in vm.raceData.section_statistic"><div class="item_box"><div class="l"><div class="index">{{item.distance/1000}}KM</div><div class="name">\u62B5\u8FBE\u4EBA\u6570\uFF1A<div class="num">{{item.user_num}}<span>\u4EBA</span></div></div></div><div class="r">\u53C2\u8D5B\u4EBA\u6570\u5360\u6BD4\uFF1A <span>{{item.rate}}</span></div></div><div class="line"></div></div></div><div class="list_box" ng-if="!vm.raceData.section_statistic"><span class="no-data">\u6682\u65E0\u6570\u636E</span></div></div></div><div class="rightFlex"><div class="content1_box"><div class="title_box"><h3>\u8D5B\u4E8B\u5B9E\u65F6\u8FDB\u884C\u4E2D\u699C\u5355</h3><div class="menu_main_box"><div class="menu_box" uib-dropdown=""><div uib-dropdown-toggle="" class="menu_boxs"><div>{{vm.gender_name}}</div><span class="icon"></span></div><div class="menu_list" uib-dropdown-menu=""><div class="info"><div class="name" ng-click="vm.checkGroup(item, 1)" ng-class="{\'act\': vm.gender_id == item.id}" ng-repeat="item in vm.genderArr">{{item.gender_name}}</div></div></div></div><div class="menu_box" uib-dropdown=""><div uib-dropdown-toggle="" class="menu_boxs menu_boxs_group"><div>{{vm.group_name}}</div><span class="icon"></span></div><div class="menu_list" uib-dropdown-menu=""><div class="info"><div class="name" ng-click="vm.checkGroup(item, 2)" ng-class="{\'act\': vm.group_id == item.group_id}" ng-repeat="item in vm.group_statistic">{{item.group_name}}</div></div></div></div><div class="menu_box" uib-dropdown=""><div uib-dropdown-toggle="" class="menu_boxs menu_boxs_len"><div>{{vm.len_name}}</div><span class="icon"></span></div><div class="menu_list" uib-dropdown-menu=""><div class="info"><div class="name" ng-click="vm.checkGroup(item, 3)" ng-class="{\'act\': vm.sort_type == item.id}" ng-repeat="item in vm.lenArr">{{item.len_name}}</div></div></div></div></div></div><div class="list_box"><div class="item" ng-repeat="item in vm.raceRankData.user_list" ng-if="vm.raceRankData.user_list.length"><div class="item_box"><div class="l"><div class="index" ng-class="\'index\' + item.rank_id">{{item.rank_id}}</div><div class="name">{{item.user_info.nick}}</div></div><div class="r"><div class="num" ng-if="item.gender == 0">\u5973</div><div class="num" ng-if="item.gender == 1">\u7537</div><div class="num">{{(item.distance/1000).toFixed(2)}}<span>KM</span></div><div class="avg">{{item.avg_pace}}</div></div></div><div class="line"></div></div><div class="desc" ng-if="!vm.raceRankData.user_list.length">\u6682\u65E0\u6570\u636E</div></div></div><div class="content1_box"><div class="title_box"><h3>\u8D5B\u4E8B\u5B9E\u65F6\u5B8C\u8D5B\u699C\u5355</h3><div class="menu_main_box"><div class="menu_box" uib-dropdown=""><div uib-dropdown-toggle="" class="menu_boxs"><div>{{vm.gender_name_rank}}</div><span class="icon"></span></div><div class="menu_list" uib-dropdown-menu=""><div class="info"><div class="name" ng-click="vm.checkGroupAct(item, 1)" ng-class="{\'act\': vm.gender_name_rank_id == item.id}" ng-repeat="item in vm.genderArr1">{{item.gender_name}}</div></div></div></div><div class="menu_box" uib-dropdown=""><div uib-dropdown-toggle="" class="menu_boxs menu_boxs_group"><div>{{vm.group_name_rank}}</div><span class="icon"></span></div><div class="menu_list" uib-dropdown-menu=""><div class="info"><div class="name" ng-click="vm.checkGroupAct(item, 2)" ng-class="{\'act\': vm.group_rank_id == item.group_id}" ng-repeat="item in vm.group_statistic">{{item.group_name}}</div></div></div></div></div></div><div class="list_box"><div class="item" ng-repeat="item in vm.raceRankComData.ranks" ng-if="vm.raceRankComData.ranks.length"><div class="item_box"><div class="l"><div class="index" ng-class="\'index\' + item.rank_id">{{item.named_rank}}</div><div class="name">{{item.nick}}</div></div><div class="r"><div class="num">{{vm.gender_name_rank}}</div><div class="avg">{{item.rank_time}}</div></div></div><div class="line"></div></div><div class="desc" ng-if="!vm.raceRankComData.ranks">\u6682\u65E0\u6570\u636E</div></div></div><div class="content2_box"><div class="title_box"><h3>KOL</h3><div class="kol_box"><input type="text" placeholder="\u8F93\u5165\u7528\u6237ID" ng-model="vm.kol_id"><div class="btn" ng-click="vm.addKol()">\u6DFB\u52A0KOL</div></div></div><div class="list_box"><div class="item" ng-repeat="item in vm.kolRankData.list" ng-if="vm.kolRankData && vm.kolRankData.list"><div class="item_box"><div class="l"><div class="index" ng-if="item.rank_id == 0">-</div><div class="index" ng-if="item.rank_id != 0">{{item.rank_id}}</div><div class="name">{{item.user_info.nick}}</div></div><div class="r"><div class="num">{{(item.distance/1000).toFixed(2)}}<span>KM</span></div><div class="avg">{{item.avg_pace}}</div><div class="avgs">{{item.group.group_name}}</div></div></div><div class="line"></div></div><div class="desc" ng-if="!vm.kolRankData.list">\u6682\u65E0\u6570\u636E</div></div></div></div></div>');
$templateCache.put('app/pages/publish/article/article.html','<div class="main_with"><div class="publish\u2014article"><div class="ar_title">\u6807\u9898 <img ng-src="{{\'ic_hint@2x.png\' | appImage}}" ng-mouseenter="_titleTips=true" ng-mouseleave="_titleTips = false" alt="" class="ico"><div class="tips_box" ng-show="_titleTips"><img ng-src="{{\'ic_hint_title@2x.jpg\' | appImage}}" alt="" class=""></div></div><input class="input_box" ng-model="article.article_name" type="text" maxlength="20" placeholder="20\u5B57\u5185"><div class="ar_title">\u6458\u8981 <img ng-src="{{\'ic_hint@2x.png\' | appImage}}" ng-mouseenter="despTips=true" ng-mouseleave="despTips = false" alt="" class="ico"><div class="tips_box" ng-show="despTips"><img ng-src="{{\'ic_hint_summary@2x.jpg\' | appImage}}" alt="" class=""></div></div><textarea class="input_box" ng-model="article.digest" type="text" maxlength="50" placeholder="50\u5B57\u5185"></textarea><div class="ar_title">\u6B63\u6587</div><div id="arcEditor"></div><p>\u63A8\u8350\u7F16\u8F91\u5730\u5740: <a href="http://www.135editor.com/#/" target="_blank">http://www.135editor.com/#/</a> \u7F16\u8F91\u540E\u53EF\u76F4\u63A5\u590D\u5236\u5230\u6B64\u5904</p><div class="topic_box" ng-if="!article.article_id"><check-topic label-id="label_id" label-title="checkTitle" title-tips="titleTips" this-title="title"></check-topic></div><div class="tips_box" ng-if="!article.article_id"><label class="custom-checkbox"><input type="checkbox" ng-model="article.is_feed"> <span>\u540C\u65F6\u6587\u7AE0\u5206\u4EAB\u5230feed</span></label></div><div class="upload_img clearfix"><div class="upload_box pull-left"><div class="imgbox" ng-show="!upimg1_isUp" ng-mouseenter="uploadimgTipsFr1Hover = true" ng-mouseleave="uploadimgTipsFr1Hover = false"><img ng-src="{{\'ic_addcover_big@2x.png\'| appImage}}" ng-show="uploadimgTipsFr1Hover==false" alt="" class="up_fm"> <img ng-src="{{\'ic_addcover_big_hover@2x.png\'| appImage}}" ng-show="uploadimgTipsFr1Hover==true" alt="" class="up_fm"> <img ng-src="{{\'ic_hint@2x.png\' | appImage}}" ng-mouseenter="uploadimgTipsFr1=true" ng-mouseleave="uploadimgTipsFr1 = false" alt="" class="ico"> <input class="file_" type="file" accept="image/png,image/jpeg" image="cover_url_model.img"><div class="tips_box" ng-show="uploadimgTipsFr1"><img ng-src="{{\'ic_hint_cover@2x.jpg\'| appImage}}" alt="" class=""></div></div><div class="imgbox_yl" ng-show="upimg1_isUp"><div class="tit_">\u5927\u56FE\u5C01\u9762<img ng-src="{{\'ic_hint@2x.png\' | appImage}}" ng-mouseenter="uploadimgTipsFr1=true" ng-mouseleave="uploadimgTipsFr1 = false" alt="" class="ico"></div><img ng-src="{{cover_url}}" alt="" class="yl"><div class="new_file">\u4E0A\u4F20\u65B0\u5C01\u9762 <input class="file_ abc" type="file" accept="image/png,image/jpeg" image="cover_url_model.img"></div><div class="tips_box" ng-show="uploadimgTipsFr1"><img ng-src="{{\'ic_hint_cover@2x.jpg\'| appImage}}" alt="" class=""></div></div><div class="tips">\u56FE\u7247\u5C3A\u5BF8\uFF1A720*288 px</div></div><div class="upload_box pull-left left_margin"><div class="imgbox" ng-show="!upimg2_isUp" ng-mouseenter="uploadimgTipsSc2Hover=true" ng-mouseleave="uploadimgTipsSc2Hover = false"><img ng-src="{{\'ic_addcover_square@2x.png\'| appImage}}" ng-show="uploadimgTipsSc2Hover==false" alt="" class="up_fm"> <img ng-src="{{\'ic_addcover_square_hover@2x.png\'| appImage}}" ng-show="uploadimgTipsSc2Hover==true" alt="" class="up_fm"> <img ng-src="{{\'ic_hint@2x.png\' | appImage}}" ng-mouseenter="uploadimgTipsSc2=true" ng-mouseleave="uploadimgTipsSc2 = false" alt="" class="ico"> <input class="file_" type="file" accept="image/png,image/jpeg" image="square_url_model.img"><div class="tips_box" ng-show="uploadimgTipsSc2"><img ng-src="{{\'ic_hint_cover_square@2x.jpg\'| appImage}}" alt="" class=""></div></div><div class="imgbox_yl" ng-show="upimg2_isUp"><div class="tit_">\u65B9\u56FE\u5C01\u9762<img ng-src="{{\'ic_hint@2x.png\' | appImage}}" ng-mouseenter="uploadimgTipsSc2=true" ng-mouseleave="uploadimgTipsSc2 = false" alt="" class="ico"></div><img ng-src="{{square_url}}" alt="" class="yr"><div class="new_file">\u4E0A\u4F20\u65B0\u5C01\u9762 <input class="file_" type="file" accept="image/png,image/jpeg" image="square_url_model.img"></div><div class="tips_box" ng-show="uploadimgTipsSc2"><img ng-src="{{\'ic_hint_cover_square@2x.jpg\'| appImage}}" alt="" class=""></div></div><div class="tips">\u56FE\u7247\u5C3A\u5BF8\uFF1A640*640 px</div></div></div><div class="bot_btns"><div class="yulan _btn" ng-click="article.getContentAndPre()">\u9884\u89C8</div><div class="publish _btn" ng-click="article.uploadContent()">\u53D1\u5E03</div></div></div></div>');
$templateCache.put('app/pages/publish/picture/picture.html','<div class="main_with"><div class="picture_main"><form class="form-horizontal" name="formScore"><div ng-if="basic.cert_icon.length == 0"><div class="uploadBtn"><img ng-src="{{\'addphoto.png\' | appImage}}" class="img"> <img ng-src="{{\'addphoto_hover.png\' | appImage}}" class="imghover"> <input type="file" class="btn-file" accept="image/png,image/jpeg" image="picture.img"></div><span class="tip">\u6700\u591A\u53EF\u4E0A\u4F209\u5F20</span></div><div class="clearfix upload-img" ng-if="basic.cert_icon.length > 0"><div class="upload_box" ng-repeat="icon in basic.cert_icon track by $index"><img ng-src="{{ icon.ref }}" alt="" class="pull-left"> <button class="btn-dangers" ng-if="icon.ref" ng-click="delIcon($index)" style="text-align: center">\u5220\u9664</button></div><div class="upload_box upload_adds"><img class="upload_add" ng-src="{{\'ic_add.png\' | appImage}}"> <input type="file" accept="image/png,image/jpeg" image="picture.img"></div></div><div class="textarea"><textarea maxlength="1000" placeholder="\u8F93\u5165\u6587\u5B57\u5185\u5BB9,\u9009\u9898" value="" ng-model="content" ng-change="changeCon(content)" rows="10"></textarea><div class="align-right"><span>{{valueLength}}/1000</span></div></div><check-topic label-id="label_id" label-title="checkTitle" title-tips="titleTips" this-title="title"></check-topic><div class="btn_main"><div class="btns fb" ng-class="{\'load\':isStausFb}" ng-click="save()" ng-disabled="!isStausFb">\u53D1\u5E03</div></div></form></div></div>');
$templateCache.put('app/pages/racelive/select/index.html','<div class="main_with"><div class="live_main"><form class="form-horizontal" name="formScore"><div class="form-group"><div class="col-sm-offset-2 col-sm-4"><select name="" class="form-control" ng-model="option" ng-options="option.match_name for option in options"></select></div><div class="col-sm-4"><button type="button" class="btn btn-block btn-success" ng-click="submit()">\u8FDB\u5165\u76F4\u64AD\u95F4</button></div></div></form></div></div>');
$templateCache.put('app/pages/activity/modal/add-info.html','<div class="modal-content equip-modal creatList"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">\u6DFB\u52A0\u5BA1\u6838\u9879</h4></div><div class="modal-body"><form class="form-horizontal"><div class="form-group"><div class="col-sm-12"><input type="text" class="form-control" placeholder="\u5BA1\u6838\u9879\u540D\u79F0" ng-model="vm.form.name"></div></div></form></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.save()">\u786E\u8BA4</button> <button type="button" class="btn btn-primary pull-left" ng-click="$dismiss()">\u53D6\u6D88</button></div></div>');
$templateCache.put('app/pages/activity/modal/add-type.html','<div class="modal-content equip-modal creatList"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">\u9009\u62E9\u6D3B\u52A8\u7C7B\u578B</h4></div><div class="modal-body"><form class="form-horizontal"><button class="btn mr10 mb10" ng-class="{\'btn-primary\': vm.curType.id == item.id, \' btn-default\': vm.curType.id != item.id}" ng-repeat="item in vm.active_type_list" ng-click="vm.chooseType(item)">{{item.type_name}}</button></form></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.save()">\u786E\u8BA4</button> <button type="button" class="btn btn-primary pull-left" ng-click="$dismiss()">\u53D6\u6D88</button></div></div>');
$templateCache.put('app/pages/publish/video/video.html','<div class="main_with"><div class="video_main"><form class="form-horizontal"><div class="upload_main"><div class="left"><div class="uploadBtn_main" ng-if="video_url==\'\'"><div class="uploadBtn"><img ng-src="{{\'addvideo.png\' | appImage}}" class="img"> <img ng-src="{{\'addvideo_hover.png\' | appImage}}" class="imghover"> <input type="file" class="btn-file" image="video.mp4" accept="video/mp4"></div><span class="tip">\u4E0D\u8D85\u8FC7 35MB\uFF0C\u652F\u6301 MP4 \u683C\u5F0F</span></div><div class="uploadBtn_main_active" ng-if="video_url!=\'\'"><span>\u89C6\u9891</span><div class="video_url"><video ng-src="{{video_url}}" controls="controls" style="width:100%; height:100%; object-fit: fill"><source ng-src="{{video_url}}" type="video/mp4"></video></div><div class="button_active">\u4E0A\u4F20\u65B0\u89C6\u9891 <input type="file" class="btn-file" image="video.mp4" accept="video/mp4"></div><span class="tip">\u4E0D\u8D85\u8FC7 35MB\uFF0C\u652F\u6301 MP4 \u683C\u5F0F</span></div></div><div class="right"><div class="uploadBtn_main" ng-if="basic.cert_icon.length == 0"><div class="uploadBtns"><img ng-src="{{\'cover.png\' | appImage}}" class="img"> <img ng-src="{{\'cover_hover.png\' | appImage}}" class="imghover"> <input type="file" class="btn-file" accept="image/png,image/jpeg" image="video.img"></div><span class="tip">\u5EFA\u8BAE\u4E0A\u4F20\u5C3A\u5BF8 800x450px \u7684\u56FE\u7247</span></div><div class="uploadBtn_main_active" ng-if="basic.cert_icon.length > 0" ng-repeat="icon in basic.cert_icon track by $index"><span>\u5C01\u9762\u56FE\u7247</span><div class="video_url"><img ng-src="{{ icon.ref }}"></div><div class="button_active">\u4E0A\u4F20\u65B0\u5C01\u9762 <input type="file" class="btn-file" accept="image/png,image/jpeg" image="video.img"></div><span class="tip">\u5EFA\u8BAE\u4E0A\u4F20\u5C3A\u5BF8 800x450px \u7684\u56FE\u7247</span></div></div></div><div class="textarea"><textarea maxlength="1000" placeholder="\u8F93\u5165\u6587\u5B57\u5185\u5BB9,\u9009\u9898" value="" ng-model="content" ng-change="changeCon(content)" rows="10"></textarea><div class="align-right"><span>{{valueLength}}/1000</span></div></div><check-topic label-id="label_id" label-title="checkTitle" title-tips="titleTips" this-title="title"></check-topic><div class="btn_main"><div class="btns fb" ng-class="{\'load\':isStausFb}" ng-click="save()" ng-disabled="!isStausFb">\u53D1\u5E03</div></div></form></div></div>');
$templateCache.put('app/pages/training/create/index.html','<div class="main_with"><div class="live_main"><div class="menu_list"><span class="active">\u2460 \u9009\u62E9\u8BFE\u7A0B</span></div><form class="form-horizontal" name="formScore"><div class="form-group"><div class="col-sm-offset-2 col-sm-4"><select name="" class="form-control" ng-model="option" ng-options="option._name for option in options"></select></div><div class="col-sm-4"><button type="button" class="btn btn-block btn-success" ng-click="submit()">\u521B\u5EFA</button></div></div><div style="height: 30px;"></div><section ng-show="res"><div class="form-group"><label class="col-sm-offset-1 col-sm-2 control-label">\u76F4\u64AD\u63A8\u6D41\u5730\u5740\uFF1A</label> <label class="col-sm-9 control-label" style="text-align: left" id="copyId">{{live_link}} <button class="btn btn-sm btn-warning copyId" data-clipboard-target="#copyId">\u590D\u5236</button></label></div><div class="form-group"><label class="col-sm-offset-1 col-sm-2 control-label">H5\u76F4\u64AD\u5730\u5740\uFF1A</label> <label class="col-sm-9 control-label" style="text-align: left" id="copyH5">{{h5_link}} <button class="btn btn-sm btn-warning copyH5" data-clipboard-target="#copyH5">\u590D\u5236</button></label></div></section></form></div></div>');
$templateCache.put('app/pages/training/list/index.html','<div class="page-training-list"><a ng-if="vm.page==1" href="javascript:;" ng-click="vm.click(item)" class="itemWarper" ng-repeat="(key,item) in vm.list"><div class="leftFlex"><img class="image" ng-src="{{item.image}}" alt="."><div class="rightFlex"><div class="name">{{item.name}} {{item.session}}\u573A</div><div class="info">{{item.date}}</div><div ng-show="item.status==0" class="status0"><span>\u672A\u5F00\u59CB</span></div><div ng-show="item.status==1" class="status1"><span>\u8FDB\u884C\u4E2D</span></div><div ng-show="item.status==2" class="status2"><span>\u5DF2\u7ED3\u675F</span></div><div ng-show="item.status==3" class="status2"><span>\u5DF2\u53D6\u6D88</span></div></div></div><div><img class="coach_photo" ng-src="{{item.coach_photo}}" alt="."></div></a><div ng-if="vm.page==2" class="training-detail"><a href="javascript:;" class="btn back" ng-click="vm.page=1">\u8FD4\u56DE</a><div class="bannerContainer"><img class="banner" ng-src="{{vm.detail.class_image}}" alt="."><div class="class-name">{{vm.detail.class_name}}</div></div><div class="info"><div class="session">{{vm.detail.session}} <span class="des">{{vm.detail.date}} \u5168\u573A\u8BFE\u7A0B{{vm.detail.class_time}}\u5206\u949F</span></div></div><div><h3>\u9884\u7EA6\u8BFE\u7A0B</h3><div class="warpper" ng-repeat="item in vm.detail.session_info"><div class="left"><img class="image" ng-src="{{item.coach_photo}}" alt="."><div class="nick">{{item.coach_nick}}</div><div class="nick">{{item.join_num}} / {{item.max_join_num}} <span ng-show="{{item.join_num == item.max_join_num}}">\u5DF2\u6EE1</span></div></div><div class="btn" ng-show="{{item.join_num}}" ng-click="vm.students()">\u67E5\u770B\u5B66\u5458</div></div></div><div class="training-state-button"><button ng-disabled="vm.btnDisabled.startLive" class="{{vm.btnClass.startLive}}" ng-click="vm.startLive()">\u5F00\u59CB\u76F4\u64AD</button> <img class="arrow" src="https://s1.codooncdn.com/operation-tools/internal-user/2020-08-20T13.05.22/50x44x565xqAxx0nqbBHq4iOVAOO.png"> <button ng-disabled="vm.btnDisabled.startClass" class="{{vm.btnClass.startClass}}" ng-click="vm.startClass()">\u5F00\u59CB\u8BFE\u7A0B</button> <img class="arrow" src="https://s1.codooncdn.com/operation-tools/internal-user/2020-08-20T13.05.22/50x44x565xqAxx0nqbBHq4iOVAOO.png"> <button ng-disabled="vm.btnDisabled.closeClass" class="{{vm.btnClass.closeClass}}" ng-click="vm.closeClass()">\u7ED3\u675F\u8BFE\u7A0B</button> <img class="arrow" src="https://s1.codooncdn.com/operation-tools/internal-user/2020-08-20T13.05.22/50x44x565xqAxx0nqbBHq4iOVAOO.png"> <button ng-disabled="vm.btnDisabled.endLive" class="{{vm.btnClass.endLive}}" ng-click="vm.endLive()">\u7ED3\u675F\u76F4\u64AD</button></div><div class="training-state-text"><p ng-if="vm.training_state.live_status === 0">\u76F4\u64AD\u72B6\u6001\uFF1A\u6682\u672A\u76F4\u64AD</p><p class="living" ng-if="vm.training_state.live_status === 1">\u76F4\u64AD\u72B6\u6001\uFF1A\u76F4\u64AD\u4E2D</p><p ng-if="vm.training_state.live_status === 2">\u76F4\u64AD\u72B6\u6001\uFF1A\u5DF2\u7ED3\u675F</p><p ng-if="vm.training_state.isStartClass == 0">\u8BFE\u7A0B\u72B6\u6001\uFF1A\u672A\u5F00\u59CB</p><p class="living" ng-if="vm.training_state.isStartClass == 1">\u8BFE\u7A0B\u72B6\u6001\uFF1A\u8FDB\u884C\u4E2D</p><p ng-if="vm.training_state.isStartClass == 2">\u8BFE\u7A0B\u72B6\u6001\uFF1A\u5DF2\u7ED3\u675F</p></div></div><div ng-if="vm.page==3" class="training-detail"><a href="javascript:;" class="btn back" ng-click="vm.page=2">\u8FD4\u56DE</a><div class="bannerContainer"><img class="banner" ng-src="{{vm.detail.class_image}}" alt="."><div class="class-name">{{vm.detail.class_name}}</div></div><div class="info"><div class="session">{{vm.detail.session}} <span class="des">{{vm.detail.date}} \u5168\u573A\u8BFE\u7A0B{{vm.detail.class_time}}\u5206\u949F</span></div></div><div><h3>\u5B66\u5458\u8BFE\u7A0B</h3><div class="warpper" ng-repeat="item in vm.user_list"><div class="left"><img class="image" ng-src="{{item.user_photo}}" alt="."><div class="nick">{{item.user_nick}}</div></div><div>\u4E0A\u8BFE{{item.class_count}}\u6B21</div></div></div></div></div>');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="fa fa-angle-up back-top" id="backTop" title="Back to Top"></i>');
$templateCache.put('app/theme/components/browserCheck/browserCheck.html','<div class="browser_check" ng-show="isLowVesionBrowser"><div class="close" ng-click="isLowVesionBrowser=false">\u2573</div><div class="tips">\u60A8\u7684\u6D4F\u89C8\u5668\u7248\u672C\u8F83\u4F4E\uFF0C\u53EF\u80FD\u65E0\u6CD5\u6B63\u5E38\u4F7F\u7528\u5495\u549A\u540E\u53F0\u7684\u6240\u6709\u529F\u80FD\u3002</div><div class="tips tp2">\u6211\u4EEC\u5EFA\u8BAE\u60A8\u5B89\u88C5\u6700\u65B0\u7248\u672C\u7684\u6D4F\u89C8\u5668\u4EE5\u4FDD\u8BC1\u80FD\u6B63\u5E38\u4F7F\u7528\u6211\u4EEC\u7684\u540E\u53F0\u3002</div><div class="f_l clearfix"><div class="line_"></div><div class="desp">\u9009\u62E9\u4E00\u4E2A\u6D4F\u89C8\u5668\u6765\u5B89\u88C5</div><div class="line_"></div></div><div class="browser_list"><a href="https://www.baidu.com/s?wd=chrome"><img ng-src="{{\'CR@2x.jpg\' | appImage}}" alt=""></a> <a href="http://www.mozilla.org/en-US/firefox/new/"><img ng-src="{{\'FF@2x.jpg\' | appImage}}" alt=""></a> <a href="https://support.microsoft.com/zh-cn/help/17621/internet-explorer-downloads"><img ng-src="{{\'IE@2x.jpg\' | appImage}}" alt=""></a> <a href="http://www.apple.com/safari/download/"><img ng-src="{{\'SF@2x.jpg\' | appImage}}" alt=""></a> <a href="http://www.opera.com/download/"><img ng-src="{{\'OP@2x.jpg\' | appImage}}" alt=""></a></div></div>');
$templateCache.put('app/theme/components/checkTopic/checkTopic.html','<div class="checkTopic"><input class="input" placeholder="\u8F93\u5165\u5173\u952E\u8BCD\u9009\u62E9\u8BDD\u9898" ng-model="title" ng-change="changeTitle(title)" value=""><div class="gjc_text" ng-show="label_id != 0">#{{checkTitle}}<img ng-src="{{\'detel.png\' | appImage}}" ng-click="closeTitle()"></div><p class="dataTitle" ng-if="titleArr!=\'\' && label_id == 0" ng-click="createFeed(title,0,1)">\u521B\u5EFA "#{{titleArr}}" \u8BDD\u9898</p><div class="selectArr" ng-if="titleTips.length != 0 && label_id == 0"><p class="dataTitle" ng-if="!isNewTitle" ng-click="createFeed(title,0,1)">\u521B\u5EFA "#{{title}}" \u8BDD\u9898</p><p class="dataTitle" ng-repeat="item in titleTips track by $index" ng-click="createFeed(item.label_content,item.label_id,2)"># {{item.label_content}}</p></div></div>');
$templateCache.put('app/theme/components/citySelect/citySelect.html','<div class="city-select-container"><div class="clearfix"><div class="col-sm-3 no-padding"><select class="form-control" ng-model="vm.province" ng-options="option.name for option in vm.provinceArr" ng-change="vm.setProvinceAndCity()"></select></div><div class="col-sm-4"><select class="form-control" ng-model="vm.city" ng-options="city.name for city in vm.cityArr" ng-change="vm.handleCitySelect()"></select></div><div class="col-sm-4 address-list-container" ng-if="vm.baShowAddress==\'true\'"><input type="text" class="form-control" placeholder="\u8BE6\u7EC6\u5730\u70B9" ng-model="vm.address_detail" required="" ng-change="vm.searchAddress()"><ul class="address-list" ng-if="vm.showAddress && vm.tips.length"><li ng-repeat="item in vm.tips" ng-click="vm.selectAddress(item)" ng-if="item.location.length"><span>{{item.name}}</span></li></ul></div></div><div id="amap-container" class="amap-container" ng-show="vm.baShowAddress==\'true\'"></div></div>');
$templateCache.put('app/theme/components/inputCount/index.html','<div class="input-count-container"><input type="text" placeholder="{{vm.placeholder}}" class="input" ng-model="vm.ngModel" ng-change="vm.textCounter($event)"><div class="tip">{{ vm.count || 0 }}/{{ vm.maxLength }}\u5B57\u7B26</div></div>');
$templateCache.put('app/theme/components/loading/loading.html','<div id="loadding"><div class="wid"><div class="three-quarters-loader"></div></div></div>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<div class="page-top clearfix" scroll-position="scrolled" ng-class="{\'scrolled\': scrolled}"><div class="top-nav main_with"><img class="logo pull-left" ng-click="goCodoon()" ng-src="{{::( \'ic_title_logo@2x.png\' | appImage )}}" alt=""><ul class="nav_father"><li ng-repeat="item in menuItems" ng-if="item.name != \'home\' && item.isShow == true"><a ng-if="!!item.href" target="_blank" ng-href="{{item.href}}">{{item.title}}</a> <span ng-if="!item.href"><a ui-state="item.stateRef || \'\'" ng-class="{\'selected\':faterNavCur == item.name}" ui-sref-active="selected" href="" ng-if="::!item.subMenu" ng-click="showSubMenu(item)">{{item.title}}</a> <a ui-state="item.subMenu[0].stateRef" href="" ng-class="{\'selected\':faterNavCur == item.name}" ng-if="::item.subMenu" ng-click="showSubMenu(item)">{{item.title}}</a></span></li></ul><div class="clearfix pull-right clearfix"><div class="user-msg clearfix pull-right" uib-dropdown=""><div class="nick-lable pull-left"><div class="nick">{{homeInfo.nick}}</div><div ng-show="homeInfo.brand_user" class="lable">\u8BA4\u8BC1\u7528\u6237</div><div ng-show="homeInfo.advert_user" class="lable">\u8BA4\u8BC1\u7528\u6237</div></div><a uib-dropdown-toggle="" class="profile-toggle-link pull-right"><img ng-src="{{homeInfo.portrait}}"></a><ul class="top-dropdown-menu profile-dropdown" uib-dropdown-menu=""><li><i class="dropdown-arr"></i></li><li><a ng-click="showSubMenu(menuItems[0])" ui-sref="home.user"><i class="fa fa-user"></i>\u4E2A\u4EBA\u4FE1\u606F</a></li><li><a ng-click="showSubMenu(menuItems[0])" ui-sref="home.article"><i class="fa fa-user"></i>\u6211\u7684\u6587\u7AE0</a></li><li><a href="http://sso.codoon.com/logout" class="signout"><i class="fa fa-power-off"></i>\u9000\u51FA\u767B\u5F55</a></li></ul></div></div></div><div class="nav_subr" ng-show="curSubMenu.length > 0"><div class="main_with"><ul id="myTab" class="nav"><li ng-repeat="item in curSubMenu" ui-sref-active="active" ui-state="item.stateRef || \'\'" ng-if="item.isShow"><a href="">{{item.title}}</a></li></ul></div></div></div>');
$templateCache.put('app/theme/components/progressBarRound/progressBarRound.html','<svg class="center-block progress-bar-round" width="200" height="200"><circle cx="100" cy="100" r="90" fill="none" stroke="#F8F8FF" stroke-width="8"></circle><circle cx="100" cy="100" r="90" fill="none" id="loader" class="" stroke="#209e91" stroke-width="8" stroke-dasharray="0,20000" transform="rotate(-90,100,100)" stroke-linecap="round"></circle><text text-anchor="middle" class="loading" x="100" y="90">Loading...</text><text class="percentage" text-anchor="middle" x="100" y="130">{{progress}}%</text></svg>');
$templateCache.put('app/theme/components/contentTop/contentTop.html','');
$templateCache.put('app/pages/publish/article/modal/gif.html','<div class="modal-content equip-modal creatList"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">\u4E0A\u4F20GIF</h4></div><div class="modal-body"><form class="form-horizontal"><div class="form-group"><label class="col-sm-4 control-label">\u4E0A\u4F20\u5C01\u9762\u56FE:\uFF08\u975E\u5FC5\u4F20\uFF09</label><div class="col-sm-6"><input type="file" class="btn-file" image="vm.fm" accept="image/jpeg,image/png" style="height: 40px; left: 10px; top: 0px;"> <input type="button" value="\u4E0A\u4F20GIF\u5C01\u9762\u56FE" class="btn btn-default"></div></div><div class="form-group" ng-show="gifUpload.fm_src"><label class="col-sm-4 control-label"></label><div class="col-sm-6"><img style="width:70px;height:70px" ng-src="{{gifUpload.fm_src}}" alt="" class=""></div></div><div class="form-group"><label class="col-sm-4 control-label">\u4E0A\u4F20GIF\u52A8\u56FE:</label><div class="col-sm-6"><input type="file" class="btn-file" accept="image/gif" image="vm.gif" style="height: 40px; left: 10px; top: 0px;"> <input type="button" value="\u4E0A\u4F20GIF" class="btn btn-default"></div></div><div class="form-group" ng-show="gifUpload.gif_src"><label class="col-sm-4 control-label"></label><div class="col-sm-6"><img class="width:70px;height:70px" ng-src="{{gifUpload.gif_src}}" width="100"></div></div></form></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="gifUpload.upload()">\u786E\u8BA4</button> <button type="button" class="btn btn-primary pull-left" ng-click="$dismiss()">\u53D6\u6D88</button></div></div>');
$templateCache.put('app/pages/publish/article/modal/img.html','<div class="modal-content equip-modal creatList"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">\u4E0A\u4F20\u56FE\u7247</h4></div><div class="modal-body"><form class="form-horizontal"><div class="form-group"><label class="col-sm-2 control-label">\u4E0A\u4F20\u56FE\u7247</label><div class="col-sm-6"><input type="file" class="btn-file" accept="image/jpeg,image/png,image/gif" image="vm.logoImg" style="height: 40px; left: 10px; top: -5px;"> <input type="button" value="\u4E0A\u4F20\u56FE\u7247" class="btn btn-default"></div></div><div class="form-group" ng-show="uploadImg.imgurl"><label class="col-sm-2 control-label"></label><div class="col-sm-6"><img ng-src="{{uploadImg.imgurl}}" style="width:70px;height:70px"></div></div></form></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="uploadImg.setting()">\u786E\u8BA4</button> <button type="button" class="btn btn-primary pull-left" ng-click="$dismiss()">\u53D6\u6D88</button></div></div>');
$templateCache.put('app/pages/publish/article/modal/preview.html','<div class="article_preview"><div class="title">\u9884\u89C8<div class="btun" ng-click="$dismiss()">\u5173\u95ED</div></div><div class="content_zw"><div class="pre_tit">{{ preview.title }}</div><div class="zw" ng-bind-html="content"></div></div></div>');
$templateCache.put('app/pages/publish/article/modal/vedio.html','<div class="modal-content equip-modal creatList"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">\u4E0A\u4F20\u89C6\u9891</h4></div><div class="modal-body"><form class="form-horizontal"><div class="form-group"><label class="col-sm-4 control-label">\u4E0A\u4F20\u89C6\u9891:</label><div class="col-sm-6"><input type="file" class="btn-file" image="vm.video" accept="video/mp4" style="height: 40px; left: 10px; top: 0px;" ng-disabled="videoUpload.video"> <input type="button" value="\u4E0A\u4F20\u89C6\u9891" class="btn btn-default"></div></div><div class="form-group" ng-show="videoUpload.src"><label class="col-sm-4 control-label">\u89C6\u9891\u9884\u89C8</label><div class="col-sm-6"><video width="100%" controls="" id="video" ng-src="{{videoUpload.src}}"></video></div></div><div class="form-group"><label class="col-sm-4 control-label">\u89C6\u9891\u5C01\u9762:</label><div class="col-sm-6"><input type="file" class="btn-file" accept="image/jpeg,image/png" image="vm.logoImg" style="height: 40px; left: 10px; top: 0px;" ng-disabled="videoUpload.logoImg"> <input type="button" value="\u4E0A\u4F20\u56FE\u7247" class="btn btn-default"></div><div class="col-sm-2"><small class="red">\u5EFA\u8BAE\u5C3A\u5BF8750*420</small> <i class="glyphicon glyphicon-refresh rotating" ng-if="videoUpload.imageLoading"></i></div></div><div class="form-group" ng-show="videoUpload.img"><label class="col-sm-4 control-label"></label><div class="col-sm-6"><img ng-src="{{videoUpload.img}}" width="100"></div></div></form></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="videoUpload.upload()">\u786E\u8BA4</button> <button type="button" class="btn btn-primary pull-left" ng-click="$dismiss()">\u53D6\u6D88</button></div></div>');}]);